/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.AdminInvitationProto = (function() {

    /**
     * Properties of an AdminInvitationProto.
     * @exports IAdminInvitationProto
     * @interface IAdminInvitationProto
     * @property {string|null} [inviteCode] AdminInvitationProto inviteCode
     * @property {number|Long|null} [generationTime] AdminInvitationProto generationTime
     * @property {boolean|null} [redeemed] AdminInvitationProto redeemed
     */

    /**
     * Constructs a new AdminInvitationProto.
     * @exports AdminInvitationProto
     * @classdesc Represents an AdminInvitationProto.
     * @implements IAdminInvitationProto
     * @constructor
     * @param {IAdminInvitationProto=} [properties] Properties to set
     */
    function AdminInvitationProto(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * AdminInvitationProto inviteCode.
     * @member {string} inviteCode
     * @memberof AdminInvitationProto
     * @instance
     */
    AdminInvitationProto.prototype.inviteCode = "";

    /**
     * AdminInvitationProto generationTime.
     * @member {number|Long} generationTime
     * @memberof AdminInvitationProto
     * @instance
     */
    AdminInvitationProto.prototype.generationTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * AdminInvitationProto redeemed.
     * @member {boolean} redeemed
     * @memberof AdminInvitationProto
     * @instance
     */
    AdminInvitationProto.prototype.redeemed = false;

    /**
     * Creates a new AdminInvitationProto instance using the specified properties.
     * @function create
     * @memberof AdminInvitationProto
     * @static
     * @param {IAdminInvitationProto=} [properties] Properties to set
     * @returns {AdminInvitationProto} AdminInvitationProto instance
     */
    AdminInvitationProto.create = function create(properties) {
        return new AdminInvitationProto(properties);
    };

    /**
     * Encodes the specified AdminInvitationProto message. Does not implicitly {@link AdminInvitationProto.verify|verify} messages.
     * @function encode
     * @memberof AdminInvitationProto
     * @static
     * @param {IAdminInvitationProto} message AdminInvitationProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AdminInvitationProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.inviteCode != null && Object.hasOwnProperty.call(message, "inviteCode"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.inviteCode);
        if (message.generationTime != null && Object.hasOwnProperty.call(message, "generationTime"))
            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.generationTime);
        if (message.redeemed != null && Object.hasOwnProperty.call(message, "redeemed"))
            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.redeemed);
        return writer;
    };

    /**
     * Encodes the specified AdminInvitationProto message, length delimited. Does not implicitly {@link AdminInvitationProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof AdminInvitationProto
     * @static
     * @param {IAdminInvitationProto} message AdminInvitationProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AdminInvitationProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an AdminInvitationProto message from the specified reader or buffer.
     * @function decode
     * @memberof AdminInvitationProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AdminInvitationProto} AdminInvitationProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AdminInvitationProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AdminInvitationProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.inviteCode = reader.string();
                    break;
                }
            case 2: {
                    message.generationTime = reader.int64();
                    break;
                }
            case 3: {
                    message.redeemed = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an AdminInvitationProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof AdminInvitationProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {AdminInvitationProto} AdminInvitationProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AdminInvitationProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AdminInvitationProto message.
     * @function verify
     * @memberof AdminInvitationProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AdminInvitationProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.inviteCode != null && message.hasOwnProperty("inviteCode"))
            if (!$util.isString(message.inviteCode))
                return "inviteCode: string expected";
        if (message.generationTime != null && message.hasOwnProperty("generationTime"))
            if (!$util.isInteger(message.generationTime) && !(message.generationTime && $util.isInteger(message.generationTime.low) && $util.isInteger(message.generationTime.high)))
                return "generationTime: integer|Long expected";
        if (message.redeemed != null && message.hasOwnProperty("redeemed"))
            if (typeof message.redeemed !== "boolean")
                return "redeemed: boolean expected";
        return null;
    };

    /**
     * Creates an AdminInvitationProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AdminInvitationProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AdminInvitationProto} AdminInvitationProto
     */
    AdminInvitationProto.fromObject = function fromObject(object) {
        if (object instanceof $root.AdminInvitationProto)
            return object;
        var message = new $root.AdminInvitationProto();
        if (object.inviteCode != null)
            message.inviteCode = String(object.inviteCode);
        if (object.generationTime != null)
            if ($util.Long)
                (message.generationTime = $util.Long.fromValue(object.generationTime)).unsigned = false;
            else if (typeof object.generationTime === "string")
                message.generationTime = parseInt(object.generationTime, 10);
            else if (typeof object.generationTime === "number")
                message.generationTime = object.generationTime;
            else if (typeof object.generationTime === "object")
                message.generationTime = new $util.LongBits(object.generationTime.low >>> 0, object.generationTime.high >>> 0).toNumber();
        if (object.redeemed != null)
            message.redeemed = Boolean(object.redeemed);
        return message;
    };

    /**
     * Creates a plain object from an AdminInvitationProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AdminInvitationProto
     * @static
     * @param {AdminInvitationProto} message AdminInvitationProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AdminInvitationProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.inviteCode = "";
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.generationTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.generationTime = options.longs === String ? "0" : 0;
            object.redeemed = false;
        }
        if (message.inviteCode != null && message.hasOwnProperty("inviteCode"))
            object.inviteCode = message.inviteCode;
        if (message.generationTime != null && message.hasOwnProperty("generationTime"))
            if (typeof message.generationTime === "number")
                object.generationTime = options.longs === String ? String(message.generationTime) : message.generationTime;
            else
                object.generationTime = options.longs === String ? $util.Long.prototype.toString.call(message.generationTime) : options.longs === Number ? new $util.LongBits(message.generationTime.low >>> 0, message.generationTime.high >>> 0).toNumber() : message.generationTime;
        if (message.redeemed != null && message.hasOwnProperty("redeemed"))
            object.redeemed = message.redeemed;
        return object;
    };

    /**
     * Converts this AdminInvitationProto to JSON.
     * @function toJSON
     * @memberof AdminInvitationProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AdminInvitationProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for AdminInvitationProto
     * @function getTypeUrl
     * @memberof AdminInvitationProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    AdminInvitationProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/AdminInvitationProto";
    };

    return AdminInvitationProto;
})();

$root.CheckAdminRoleRequest = (function() {

    /**
     * Properties of a CheckAdminRoleRequest.
     * @exports ICheckAdminRoleRequest
     * @interface ICheckAdminRoleRequest
     */

    /**
     * Constructs a new CheckAdminRoleRequest.
     * @exports CheckAdminRoleRequest
     * @classdesc Represents a CheckAdminRoleRequest.
     * @implements ICheckAdminRoleRequest
     * @constructor
     * @param {ICheckAdminRoleRequest=} [properties] Properties to set
     */
    function CheckAdminRoleRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new CheckAdminRoleRequest instance using the specified properties.
     * @function create
     * @memberof CheckAdminRoleRequest
     * @static
     * @param {ICheckAdminRoleRequest=} [properties] Properties to set
     * @returns {CheckAdminRoleRequest} CheckAdminRoleRequest instance
     */
    CheckAdminRoleRequest.create = function create(properties) {
        return new CheckAdminRoleRequest(properties);
    };

    /**
     * Encodes the specified CheckAdminRoleRequest message. Does not implicitly {@link CheckAdminRoleRequest.verify|verify} messages.
     * @function encode
     * @memberof CheckAdminRoleRequest
     * @static
     * @param {ICheckAdminRoleRequest} message CheckAdminRoleRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CheckAdminRoleRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified CheckAdminRoleRequest message, length delimited. Does not implicitly {@link CheckAdminRoleRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CheckAdminRoleRequest
     * @static
     * @param {ICheckAdminRoleRequest} message CheckAdminRoleRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CheckAdminRoleRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CheckAdminRoleRequest message from the specified reader or buffer.
     * @function decode
     * @memberof CheckAdminRoleRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CheckAdminRoleRequest} CheckAdminRoleRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CheckAdminRoleRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CheckAdminRoleRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CheckAdminRoleRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CheckAdminRoleRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CheckAdminRoleRequest} CheckAdminRoleRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CheckAdminRoleRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CheckAdminRoleRequest message.
     * @function verify
     * @memberof CheckAdminRoleRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CheckAdminRoleRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a CheckAdminRoleRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CheckAdminRoleRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CheckAdminRoleRequest} CheckAdminRoleRequest
     */
    CheckAdminRoleRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.CheckAdminRoleRequest)
            return object;
        return new $root.CheckAdminRoleRequest();
    };

    /**
     * Creates a plain object from a CheckAdminRoleRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CheckAdminRoleRequest
     * @static
     * @param {CheckAdminRoleRequest} message CheckAdminRoleRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CheckAdminRoleRequest.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this CheckAdminRoleRequest to JSON.
     * @function toJSON
     * @memberof CheckAdminRoleRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CheckAdminRoleRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for CheckAdminRoleRequest
     * @function getTypeUrl
     * @memberof CheckAdminRoleRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    CheckAdminRoleRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CheckAdminRoleRequest";
    };

    return CheckAdminRoleRequest;
})();

$root.CheckAdminRoleResponse = (function() {

    /**
     * Properties of a CheckAdminRoleResponse.
     * @exports ICheckAdminRoleResponse
     * @interface ICheckAdminRoleResponse
     * @property {boolean|null} [okay] CheckAdminRoleResponse okay
     * @property {boolean|null} [isAdmin] CheckAdminRoleResponse isAdmin
     */

    /**
     * Constructs a new CheckAdminRoleResponse.
     * @exports CheckAdminRoleResponse
     * @classdesc Represents a CheckAdminRoleResponse.
     * @implements ICheckAdminRoleResponse
     * @constructor
     * @param {ICheckAdminRoleResponse=} [properties] Properties to set
     */
    function CheckAdminRoleResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CheckAdminRoleResponse okay.
     * @member {boolean} okay
     * @memberof CheckAdminRoleResponse
     * @instance
     */
    CheckAdminRoleResponse.prototype.okay = false;

    /**
     * CheckAdminRoleResponse isAdmin.
     * @member {boolean} isAdmin
     * @memberof CheckAdminRoleResponse
     * @instance
     */
    CheckAdminRoleResponse.prototype.isAdmin = false;

    /**
     * Creates a new CheckAdminRoleResponse instance using the specified properties.
     * @function create
     * @memberof CheckAdminRoleResponse
     * @static
     * @param {ICheckAdminRoleResponse=} [properties] Properties to set
     * @returns {CheckAdminRoleResponse} CheckAdminRoleResponse instance
     */
    CheckAdminRoleResponse.create = function create(properties) {
        return new CheckAdminRoleResponse(properties);
    };

    /**
     * Encodes the specified CheckAdminRoleResponse message. Does not implicitly {@link CheckAdminRoleResponse.verify|verify} messages.
     * @function encode
     * @memberof CheckAdminRoleResponse
     * @static
     * @param {ICheckAdminRoleResponse} message CheckAdminRoleResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CheckAdminRoleResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        if (message.isAdmin != null && Object.hasOwnProperty.call(message, "isAdmin"))
            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.isAdmin);
        return writer;
    };

    /**
     * Encodes the specified CheckAdminRoleResponse message, length delimited. Does not implicitly {@link CheckAdminRoleResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CheckAdminRoleResponse
     * @static
     * @param {ICheckAdminRoleResponse} message CheckAdminRoleResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CheckAdminRoleResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CheckAdminRoleResponse message from the specified reader or buffer.
     * @function decode
     * @memberof CheckAdminRoleResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CheckAdminRoleResponse} CheckAdminRoleResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CheckAdminRoleResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CheckAdminRoleResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            case 2: {
                    message.isAdmin = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CheckAdminRoleResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CheckAdminRoleResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CheckAdminRoleResponse} CheckAdminRoleResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CheckAdminRoleResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CheckAdminRoleResponse message.
     * @function verify
     * @memberof CheckAdminRoleResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CheckAdminRoleResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        if (message.isAdmin != null && message.hasOwnProperty("isAdmin"))
            if (typeof message.isAdmin !== "boolean")
                return "isAdmin: boolean expected";
        return null;
    };

    /**
     * Creates a CheckAdminRoleResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CheckAdminRoleResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CheckAdminRoleResponse} CheckAdminRoleResponse
     */
    CheckAdminRoleResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.CheckAdminRoleResponse)
            return object;
        var message = new $root.CheckAdminRoleResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        if (object.isAdmin != null)
            message.isAdmin = Boolean(object.isAdmin);
        return message;
    };

    /**
     * Creates a plain object from a CheckAdminRoleResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CheckAdminRoleResponse
     * @static
     * @param {CheckAdminRoleResponse} message CheckAdminRoleResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CheckAdminRoleResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.okay = false;
            object.isAdmin = false;
        }
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        if (message.isAdmin != null && message.hasOwnProperty("isAdmin"))
            object.isAdmin = message.isAdmin;
        return object;
    };

    /**
     * Converts this CheckAdminRoleResponse to JSON.
     * @function toJSON
     * @memberof CheckAdminRoleResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CheckAdminRoleResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for CheckAdminRoleResponse
     * @function getTypeUrl
     * @memberof CheckAdminRoleResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    CheckAdminRoleResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CheckAdminRoleResponse";
    };

    return CheckAdminRoleResponse;
})();

$root.GenerateInvitationRequest = (function() {

    /**
     * Properties of a GenerateInvitationRequest.
     * @exports IGenerateInvitationRequest
     * @interface IGenerateInvitationRequest
     * @property {number|null} [num] GenerateInvitationRequest num
     * @property {boolean|null} [autoApprove] GenerateInvitationRequest autoApprove
     */

    /**
     * Constructs a new GenerateInvitationRequest.
     * @exports GenerateInvitationRequest
     * @classdesc Represents a GenerateInvitationRequest.
     * @implements IGenerateInvitationRequest
     * @constructor
     * @param {IGenerateInvitationRequest=} [properties] Properties to set
     */
    function GenerateInvitationRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GenerateInvitationRequest num.
     * @member {number} num
     * @memberof GenerateInvitationRequest
     * @instance
     */
    GenerateInvitationRequest.prototype.num = 0;

    /**
     * GenerateInvitationRequest autoApprove.
     * @member {boolean} autoApprove
     * @memberof GenerateInvitationRequest
     * @instance
     */
    GenerateInvitationRequest.prototype.autoApprove = false;

    /**
     * Creates a new GenerateInvitationRequest instance using the specified properties.
     * @function create
     * @memberof GenerateInvitationRequest
     * @static
     * @param {IGenerateInvitationRequest=} [properties] Properties to set
     * @returns {GenerateInvitationRequest} GenerateInvitationRequest instance
     */
    GenerateInvitationRequest.create = function create(properties) {
        return new GenerateInvitationRequest(properties);
    };

    /**
     * Encodes the specified GenerateInvitationRequest message. Does not implicitly {@link GenerateInvitationRequest.verify|verify} messages.
     * @function encode
     * @memberof GenerateInvitationRequest
     * @static
     * @param {IGenerateInvitationRequest} message GenerateInvitationRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GenerateInvitationRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.num != null && Object.hasOwnProperty.call(message, "num"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.num);
        if (message.autoApprove != null && Object.hasOwnProperty.call(message, "autoApprove"))
            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.autoApprove);
        return writer;
    };

    /**
     * Encodes the specified GenerateInvitationRequest message, length delimited. Does not implicitly {@link GenerateInvitationRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GenerateInvitationRequest
     * @static
     * @param {IGenerateInvitationRequest} message GenerateInvitationRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GenerateInvitationRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GenerateInvitationRequest message from the specified reader or buffer.
     * @function decode
     * @memberof GenerateInvitationRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GenerateInvitationRequest} GenerateInvitationRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GenerateInvitationRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GenerateInvitationRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.num = reader.int32();
                    break;
                }
            case 2: {
                    message.autoApprove = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GenerateInvitationRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GenerateInvitationRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GenerateInvitationRequest} GenerateInvitationRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GenerateInvitationRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GenerateInvitationRequest message.
     * @function verify
     * @memberof GenerateInvitationRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GenerateInvitationRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.num != null && message.hasOwnProperty("num"))
            if (!$util.isInteger(message.num))
                return "num: integer expected";
        if (message.autoApprove != null && message.hasOwnProperty("autoApprove"))
            if (typeof message.autoApprove !== "boolean")
                return "autoApprove: boolean expected";
        return null;
    };

    /**
     * Creates a GenerateInvitationRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GenerateInvitationRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GenerateInvitationRequest} GenerateInvitationRequest
     */
    GenerateInvitationRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.GenerateInvitationRequest)
            return object;
        var message = new $root.GenerateInvitationRequest();
        if (object.num != null)
            message.num = object.num | 0;
        if (object.autoApprove != null)
            message.autoApprove = Boolean(object.autoApprove);
        return message;
    };

    /**
     * Creates a plain object from a GenerateInvitationRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GenerateInvitationRequest
     * @static
     * @param {GenerateInvitationRequest} message GenerateInvitationRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GenerateInvitationRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.num = 0;
            object.autoApprove = false;
        }
        if (message.num != null && message.hasOwnProperty("num"))
            object.num = message.num;
        if (message.autoApprove != null && message.hasOwnProperty("autoApprove"))
            object.autoApprove = message.autoApprove;
        return object;
    };

    /**
     * Converts this GenerateInvitationRequest to JSON.
     * @function toJSON
     * @memberof GenerateInvitationRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GenerateInvitationRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GenerateInvitationRequest
     * @function getTypeUrl
     * @memberof GenerateInvitationRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GenerateInvitationRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GenerateInvitationRequest";
    };

    return GenerateInvitationRequest;
})();

$root.GenerateInvitationResponse = (function() {

    /**
     * Properties of a GenerateInvitationResponse.
     * @exports IGenerateInvitationResponse
     * @interface IGenerateInvitationResponse
     * @property {boolean|null} [okay] GenerateInvitationResponse okay
     * @property {Array.<string>|null} [inviteCodes] GenerateInvitationResponse inviteCodes
     */

    /**
     * Constructs a new GenerateInvitationResponse.
     * @exports GenerateInvitationResponse
     * @classdesc Represents a GenerateInvitationResponse.
     * @implements IGenerateInvitationResponse
     * @constructor
     * @param {IGenerateInvitationResponse=} [properties] Properties to set
     */
    function GenerateInvitationResponse(properties) {
        this.inviteCodes = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GenerateInvitationResponse okay.
     * @member {boolean} okay
     * @memberof GenerateInvitationResponse
     * @instance
     */
    GenerateInvitationResponse.prototype.okay = false;

    /**
     * GenerateInvitationResponse inviteCodes.
     * @member {Array.<string>} inviteCodes
     * @memberof GenerateInvitationResponse
     * @instance
     */
    GenerateInvitationResponse.prototype.inviteCodes = $util.emptyArray;

    /**
     * Creates a new GenerateInvitationResponse instance using the specified properties.
     * @function create
     * @memberof GenerateInvitationResponse
     * @static
     * @param {IGenerateInvitationResponse=} [properties] Properties to set
     * @returns {GenerateInvitationResponse} GenerateInvitationResponse instance
     */
    GenerateInvitationResponse.create = function create(properties) {
        return new GenerateInvitationResponse(properties);
    };

    /**
     * Encodes the specified GenerateInvitationResponse message. Does not implicitly {@link GenerateInvitationResponse.verify|verify} messages.
     * @function encode
     * @memberof GenerateInvitationResponse
     * @static
     * @param {IGenerateInvitationResponse} message GenerateInvitationResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GenerateInvitationResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        if (message.inviteCodes != null && message.inviteCodes.length)
            for (var i = 0; i < message.inviteCodes.length; ++i)
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.inviteCodes[i]);
        return writer;
    };

    /**
     * Encodes the specified GenerateInvitationResponse message, length delimited. Does not implicitly {@link GenerateInvitationResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GenerateInvitationResponse
     * @static
     * @param {IGenerateInvitationResponse} message GenerateInvitationResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GenerateInvitationResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GenerateInvitationResponse message from the specified reader or buffer.
     * @function decode
     * @memberof GenerateInvitationResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GenerateInvitationResponse} GenerateInvitationResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GenerateInvitationResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GenerateInvitationResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            case 2: {
                    if (!(message.inviteCodes && message.inviteCodes.length))
                        message.inviteCodes = [];
                    message.inviteCodes.push(reader.string());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GenerateInvitationResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GenerateInvitationResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GenerateInvitationResponse} GenerateInvitationResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GenerateInvitationResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GenerateInvitationResponse message.
     * @function verify
     * @memberof GenerateInvitationResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GenerateInvitationResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        if (message.inviteCodes != null && message.hasOwnProperty("inviteCodes")) {
            if (!Array.isArray(message.inviteCodes))
                return "inviteCodes: array expected";
            for (var i = 0; i < message.inviteCodes.length; ++i)
                if (!$util.isString(message.inviteCodes[i]))
                    return "inviteCodes: string[] expected";
        }
        return null;
    };

    /**
     * Creates a GenerateInvitationResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GenerateInvitationResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GenerateInvitationResponse} GenerateInvitationResponse
     */
    GenerateInvitationResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.GenerateInvitationResponse)
            return object;
        var message = new $root.GenerateInvitationResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        if (object.inviteCodes) {
            if (!Array.isArray(object.inviteCodes))
                throw TypeError(".GenerateInvitationResponse.inviteCodes: array expected");
            message.inviteCodes = [];
            for (var i = 0; i < object.inviteCodes.length; ++i)
                message.inviteCodes[i] = String(object.inviteCodes[i]);
        }
        return message;
    };

    /**
     * Creates a plain object from a GenerateInvitationResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GenerateInvitationResponse
     * @static
     * @param {GenerateInvitationResponse} message GenerateInvitationResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GenerateInvitationResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.inviteCodes = [];
        if (options.defaults)
            object.okay = false;
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        if (message.inviteCodes && message.inviteCodes.length) {
            object.inviteCodes = [];
            for (var j = 0; j < message.inviteCodes.length; ++j)
                object.inviteCodes[j] = message.inviteCodes[j];
        }
        return object;
    };

    /**
     * Converts this GenerateInvitationResponse to JSON.
     * @function toJSON
     * @memberof GenerateInvitationResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GenerateInvitationResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GenerateInvitationResponse
     * @function getTypeUrl
     * @memberof GenerateInvitationResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GenerateInvitationResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GenerateInvitationResponse";
    };

    return GenerateInvitationResponse;
})();

$root.GetExistingInvitationsRequest = (function() {

    /**
     * Properties of a GetExistingInvitationsRequest.
     * @exports IGetExistingInvitationsRequest
     * @interface IGetExistingInvitationsRequest
     * @property {string|null} [networkId] GetExistingInvitationsRequest networkId
     */

    /**
     * Constructs a new GetExistingInvitationsRequest.
     * @exports GetExistingInvitationsRequest
     * @classdesc Represents a GetExistingInvitationsRequest.
     * @implements IGetExistingInvitationsRequest
     * @constructor
     * @param {IGetExistingInvitationsRequest=} [properties] Properties to set
     */
    function GetExistingInvitationsRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetExistingInvitationsRequest networkId.
     * @member {string} networkId
     * @memberof GetExistingInvitationsRequest
     * @instance
     */
    GetExistingInvitationsRequest.prototype.networkId = "";

    /**
     * Creates a new GetExistingInvitationsRequest instance using the specified properties.
     * @function create
     * @memberof GetExistingInvitationsRequest
     * @static
     * @param {IGetExistingInvitationsRequest=} [properties] Properties to set
     * @returns {GetExistingInvitationsRequest} GetExistingInvitationsRequest instance
     */
    GetExistingInvitationsRequest.create = function create(properties) {
        return new GetExistingInvitationsRequest(properties);
    };

    /**
     * Encodes the specified GetExistingInvitationsRequest message. Does not implicitly {@link GetExistingInvitationsRequest.verify|verify} messages.
     * @function encode
     * @memberof GetExistingInvitationsRequest
     * @static
     * @param {IGetExistingInvitationsRequest} message GetExistingInvitationsRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetExistingInvitationsRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.networkId != null && Object.hasOwnProperty.call(message, "networkId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.networkId);
        return writer;
    };

    /**
     * Encodes the specified GetExistingInvitationsRequest message, length delimited. Does not implicitly {@link GetExistingInvitationsRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GetExistingInvitationsRequest
     * @static
     * @param {IGetExistingInvitationsRequest} message GetExistingInvitationsRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetExistingInvitationsRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetExistingInvitationsRequest message from the specified reader or buffer.
     * @function decode
     * @memberof GetExistingInvitationsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GetExistingInvitationsRequest} GetExistingInvitationsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetExistingInvitationsRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetExistingInvitationsRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.networkId = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GetExistingInvitationsRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GetExistingInvitationsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GetExistingInvitationsRequest} GetExistingInvitationsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetExistingInvitationsRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetExistingInvitationsRequest message.
     * @function verify
     * @memberof GetExistingInvitationsRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetExistingInvitationsRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.networkId != null && message.hasOwnProperty("networkId"))
            if (!$util.isString(message.networkId))
                return "networkId: string expected";
        return null;
    };

    /**
     * Creates a GetExistingInvitationsRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GetExistingInvitationsRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GetExistingInvitationsRequest} GetExistingInvitationsRequest
     */
    GetExistingInvitationsRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.GetExistingInvitationsRequest)
            return object;
        var message = new $root.GetExistingInvitationsRequest();
        if (object.networkId != null)
            message.networkId = String(object.networkId);
        return message;
    };

    /**
     * Creates a plain object from a GetExistingInvitationsRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GetExistingInvitationsRequest
     * @static
     * @param {GetExistingInvitationsRequest} message GetExistingInvitationsRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetExistingInvitationsRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.networkId = "";
        if (message.networkId != null && message.hasOwnProperty("networkId"))
            object.networkId = message.networkId;
        return object;
    };

    /**
     * Converts this GetExistingInvitationsRequest to JSON.
     * @function toJSON
     * @memberof GetExistingInvitationsRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetExistingInvitationsRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GetExistingInvitationsRequest
     * @function getTypeUrl
     * @memberof GetExistingInvitationsRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GetExistingInvitationsRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GetExistingInvitationsRequest";
    };

    return GetExistingInvitationsRequest;
})();

$root.GetExistingInvitationsResponse = (function() {

    /**
     * Properties of a GetExistingInvitationsResponse.
     * @exports IGetExistingInvitationsResponse
     * @interface IGetExistingInvitationsResponse
     * @property {boolean|null} [okay] GetExistingInvitationsResponse okay
     * @property {IAdminInvitationProto|null} [invitation] GetExistingInvitationsResponse invitation
     */

    /**
     * Constructs a new GetExistingInvitationsResponse.
     * @exports GetExistingInvitationsResponse
     * @classdesc Represents a GetExistingInvitationsResponse.
     * @implements IGetExistingInvitationsResponse
     * @constructor
     * @param {IGetExistingInvitationsResponse=} [properties] Properties to set
     */
    function GetExistingInvitationsResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetExistingInvitationsResponse okay.
     * @member {boolean} okay
     * @memberof GetExistingInvitationsResponse
     * @instance
     */
    GetExistingInvitationsResponse.prototype.okay = false;

    /**
     * GetExistingInvitationsResponse invitation.
     * @member {IAdminInvitationProto|null|undefined} invitation
     * @memberof GetExistingInvitationsResponse
     * @instance
     */
    GetExistingInvitationsResponse.prototype.invitation = null;

    /**
     * Creates a new GetExistingInvitationsResponse instance using the specified properties.
     * @function create
     * @memberof GetExistingInvitationsResponse
     * @static
     * @param {IGetExistingInvitationsResponse=} [properties] Properties to set
     * @returns {GetExistingInvitationsResponse} GetExistingInvitationsResponse instance
     */
    GetExistingInvitationsResponse.create = function create(properties) {
        return new GetExistingInvitationsResponse(properties);
    };

    /**
     * Encodes the specified GetExistingInvitationsResponse message. Does not implicitly {@link GetExistingInvitationsResponse.verify|verify} messages.
     * @function encode
     * @memberof GetExistingInvitationsResponse
     * @static
     * @param {IGetExistingInvitationsResponse} message GetExistingInvitationsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetExistingInvitationsResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        if (message.invitation != null && Object.hasOwnProperty.call(message, "invitation"))
            $root.AdminInvitationProto.encode(message.invitation, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified GetExistingInvitationsResponse message, length delimited. Does not implicitly {@link GetExistingInvitationsResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GetExistingInvitationsResponse
     * @static
     * @param {IGetExistingInvitationsResponse} message GetExistingInvitationsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetExistingInvitationsResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetExistingInvitationsResponse message from the specified reader or buffer.
     * @function decode
     * @memberof GetExistingInvitationsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GetExistingInvitationsResponse} GetExistingInvitationsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetExistingInvitationsResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetExistingInvitationsResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            case 2: {
                    message.invitation = $root.AdminInvitationProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GetExistingInvitationsResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GetExistingInvitationsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GetExistingInvitationsResponse} GetExistingInvitationsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetExistingInvitationsResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetExistingInvitationsResponse message.
     * @function verify
     * @memberof GetExistingInvitationsResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetExistingInvitationsResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        if (message.invitation != null && message.hasOwnProperty("invitation")) {
            var error = $root.AdminInvitationProto.verify(message.invitation);
            if (error)
                return "invitation." + error;
        }
        return null;
    };

    /**
     * Creates a GetExistingInvitationsResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GetExistingInvitationsResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GetExistingInvitationsResponse} GetExistingInvitationsResponse
     */
    GetExistingInvitationsResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.GetExistingInvitationsResponse)
            return object;
        var message = new $root.GetExistingInvitationsResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        if (object.invitation != null) {
            if (typeof object.invitation !== "object")
                throw TypeError(".GetExistingInvitationsResponse.invitation: object expected");
            message.invitation = $root.AdminInvitationProto.fromObject(object.invitation);
        }
        return message;
    };

    /**
     * Creates a plain object from a GetExistingInvitationsResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GetExistingInvitationsResponse
     * @static
     * @param {GetExistingInvitationsResponse} message GetExistingInvitationsResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetExistingInvitationsResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.okay = false;
            object.invitation = null;
        }
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        if (message.invitation != null && message.hasOwnProperty("invitation"))
            object.invitation = $root.AdminInvitationProto.toObject(message.invitation, options);
        return object;
    };

    /**
     * Converts this GetExistingInvitationsResponse to JSON.
     * @function toJSON
     * @memberof GetExistingInvitationsResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetExistingInvitationsResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GetExistingInvitationsResponse
     * @function getTypeUrl
     * @memberof GetExistingInvitationsResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GetExistingInvitationsResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GetExistingInvitationsResponse";
    };

    return GetExistingInvitationsResponse;
})();

$root.UpdateSettingsRequest = (function() {

    /**
     * Properties of an UpdateSettingsRequest.
     * @exports IUpdateSettingsRequest
     * @interface IUpdateSettingsRequest
     * @property {space.kenko.proto.ISettingsProto|null} [settings] UpdateSettingsRequest settings
     */

    /**
     * Constructs a new UpdateSettingsRequest.
     * @exports UpdateSettingsRequest
     * @classdesc Represents an UpdateSettingsRequest.
     * @implements IUpdateSettingsRequest
     * @constructor
     * @param {IUpdateSettingsRequest=} [properties] Properties to set
     */
    function UpdateSettingsRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * UpdateSettingsRequest settings.
     * @member {space.kenko.proto.ISettingsProto|null|undefined} settings
     * @memberof UpdateSettingsRequest
     * @instance
     */
    UpdateSettingsRequest.prototype.settings = null;

    /**
     * Creates a new UpdateSettingsRequest instance using the specified properties.
     * @function create
     * @memberof UpdateSettingsRequest
     * @static
     * @param {IUpdateSettingsRequest=} [properties] Properties to set
     * @returns {UpdateSettingsRequest} UpdateSettingsRequest instance
     */
    UpdateSettingsRequest.create = function create(properties) {
        return new UpdateSettingsRequest(properties);
    };

    /**
     * Encodes the specified UpdateSettingsRequest message. Does not implicitly {@link UpdateSettingsRequest.verify|verify} messages.
     * @function encode
     * @memberof UpdateSettingsRequest
     * @static
     * @param {IUpdateSettingsRequest} message UpdateSettingsRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UpdateSettingsRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.settings != null && Object.hasOwnProperty.call(message, "settings"))
            $root.space.kenko.proto.SettingsProto.encode(message.settings, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified UpdateSettingsRequest message, length delimited. Does not implicitly {@link UpdateSettingsRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof UpdateSettingsRequest
     * @static
     * @param {IUpdateSettingsRequest} message UpdateSettingsRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UpdateSettingsRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an UpdateSettingsRequest message from the specified reader or buffer.
     * @function decode
     * @memberof UpdateSettingsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {UpdateSettingsRequest} UpdateSettingsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UpdateSettingsRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.UpdateSettingsRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.settings = $root.space.kenko.proto.SettingsProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an UpdateSettingsRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof UpdateSettingsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {UpdateSettingsRequest} UpdateSettingsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UpdateSettingsRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an UpdateSettingsRequest message.
     * @function verify
     * @memberof UpdateSettingsRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    UpdateSettingsRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.settings != null && message.hasOwnProperty("settings")) {
            var error = $root.space.kenko.proto.SettingsProto.verify(message.settings);
            if (error)
                return "settings." + error;
        }
        return null;
    };

    /**
     * Creates an UpdateSettingsRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof UpdateSettingsRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {UpdateSettingsRequest} UpdateSettingsRequest
     */
    UpdateSettingsRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.UpdateSettingsRequest)
            return object;
        var message = new $root.UpdateSettingsRequest();
        if (object.settings != null) {
            if (typeof object.settings !== "object")
                throw TypeError(".UpdateSettingsRequest.settings: object expected");
            message.settings = $root.space.kenko.proto.SettingsProto.fromObject(object.settings);
        }
        return message;
    };

    /**
     * Creates a plain object from an UpdateSettingsRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof UpdateSettingsRequest
     * @static
     * @param {UpdateSettingsRequest} message UpdateSettingsRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UpdateSettingsRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.settings = null;
        if (message.settings != null && message.hasOwnProperty("settings"))
            object.settings = $root.space.kenko.proto.SettingsProto.toObject(message.settings, options);
        return object;
    };

    /**
     * Converts this UpdateSettingsRequest to JSON.
     * @function toJSON
     * @memberof UpdateSettingsRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UpdateSettingsRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for UpdateSettingsRequest
     * @function getTypeUrl
     * @memberof UpdateSettingsRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    UpdateSettingsRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/UpdateSettingsRequest";
    };

    return UpdateSettingsRequest;
})();

$root.UpdateSettingsResponse = (function() {

    /**
     * Properties of an UpdateSettingsResponse.
     * @exports IUpdateSettingsResponse
     * @interface IUpdateSettingsResponse
     * @property {boolean|null} [okay] UpdateSettingsResponse okay
     * @property {space.kenko.proto.ISettingsProto|null} [newSettings] UpdateSettingsResponse newSettings
     */

    /**
     * Constructs a new UpdateSettingsResponse.
     * @exports UpdateSettingsResponse
     * @classdesc Represents an UpdateSettingsResponse.
     * @implements IUpdateSettingsResponse
     * @constructor
     * @param {IUpdateSettingsResponse=} [properties] Properties to set
     */
    function UpdateSettingsResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * UpdateSettingsResponse okay.
     * @member {boolean} okay
     * @memberof UpdateSettingsResponse
     * @instance
     */
    UpdateSettingsResponse.prototype.okay = false;

    /**
     * UpdateSettingsResponse newSettings.
     * @member {space.kenko.proto.ISettingsProto|null|undefined} newSettings
     * @memberof UpdateSettingsResponse
     * @instance
     */
    UpdateSettingsResponse.prototype.newSettings = null;

    /**
     * Creates a new UpdateSettingsResponse instance using the specified properties.
     * @function create
     * @memberof UpdateSettingsResponse
     * @static
     * @param {IUpdateSettingsResponse=} [properties] Properties to set
     * @returns {UpdateSettingsResponse} UpdateSettingsResponse instance
     */
    UpdateSettingsResponse.create = function create(properties) {
        return new UpdateSettingsResponse(properties);
    };

    /**
     * Encodes the specified UpdateSettingsResponse message. Does not implicitly {@link UpdateSettingsResponse.verify|verify} messages.
     * @function encode
     * @memberof UpdateSettingsResponse
     * @static
     * @param {IUpdateSettingsResponse} message UpdateSettingsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UpdateSettingsResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        if (message.newSettings != null && Object.hasOwnProperty.call(message, "newSettings"))
            $root.space.kenko.proto.SettingsProto.encode(message.newSettings, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified UpdateSettingsResponse message, length delimited. Does not implicitly {@link UpdateSettingsResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof UpdateSettingsResponse
     * @static
     * @param {IUpdateSettingsResponse} message UpdateSettingsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UpdateSettingsResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an UpdateSettingsResponse message from the specified reader or buffer.
     * @function decode
     * @memberof UpdateSettingsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {UpdateSettingsResponse} UpdateSettingsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UpdateSettingsResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.UpdateSettingsResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            case 2: {
                    message.newSettings = $root.space.kenko.proto.SettingsProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an UpdateSettingsResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof UpdateSettingsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {UpdateSettingsResponse} UpdateSettingsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UpdateSettingsResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an UpdateSettingsResponse message.
     * @function verify
     * @memberof UpdateSettingsResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    UpdateSettingsResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        if (message.newSettings != null && message.hasOwnProperty("newSettings")) {
            var error = $root.space.kenko.proto.SettingsProto.verify(message.newSettings);
            if (error)
                return "newSettings." + error;
        }
        return null;
    };

    /**
     * Creates an UpdateSettingsResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof UpdateSettingsResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {UpdateSettingsResponse} UpdateSettingsResponse
     */
    UpdateSettingsResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.UpdateSettingsResponse)
            return object;
        var message = new $root.UpdateSettingsResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        if (object.newSettings != null) {
            if (typeof object.newSettings !== "object")
                throw TypeError(".UpdateSettingsResponse.newSettings: object expected");
            message.newSettings = $root.space.kenko.proto.SettingsProto.fromObject(object.newSettings);
        }
        return message;
    };

    /**
     * Creates a plain object from an UpdateSettingsResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof UpdateSettingsResponse
     * @static
     * @param {UpdateSettingsResponse} message UpdateSettingsResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UpdateSettingsResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.okay = false;
            object.newSettings = null;
        }
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        if (message.newSettings != null && message.hasOwnProperty("newSettings"))
            object.newSettings = $root.space.kenko.proto.SettingsProto.toObject(message.newSettings, options);
        return object;
    };

    /**
     * Converts this UpdateSettingsResponse to JSON.
     * @function toJSON
     * @memberof UpdateSettingsResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UpdateSettingsResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for UpdateSettingsResponse
     * @function getTypeUrl
     * @memberof UpdateSettingsResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    UpdateSettingsResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/UpdateSettingsResponse";
    };

    return UpdateSettingsResponse;
})();

$root.GetSettingsRequest = (function() {

    /**
     * Properties of a GetSettingsRequest.
     * @exports IGetSettingsRequest
     * @interface IGetSettingsRequest
     */

    /**
     * Constructs a new GetSettingsRequest.
     * @exports GetSettingsRequest
     * @classdesc Represents a GetSettingsRequest.
     * @implements IGetSettingsRequest
     * @constructor
     * @param {IGetSettingsRequest=} [properties] Properties to set
     */
    function GetSettingsRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new GetSettingsRequest instance using the specified properties.
     * @function create
     * @memberof GetSettingsRequest
     * @static
     * @param {IGetSettingsRequest=} [properties] Properties to set
     * @returns {GetSettingsRequest} GetSettingsRequest instance
     */
    GetSettingsRequest.create = function create(properties) {
        return new GetSettingsRequest(properties);
    };

    /**
     * Encodes the specified GetSettingsRequest message. Does not implicitly {@link GetSettingsRequest.verify|verify} messages.
     * @function encode
     * @memberof GetSettingsRequest
     * @static
     * @param {IGetSettingsRequest} message GetSettingsRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetSettingsRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified GetSettingsRequest message, length delimited. Does not implicitly {@link GetSettingsRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GetSettingsRequest
     * @static
     * @param {IGetSettingsRequest} message GetSettingsRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetSettingsRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetSettingsRequest message from the specified reader or buffer.
     * @function decode
     * @memberof GetSettingsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GetSettingsRequest} GetSettingsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetSettingsRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetSettingsRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GetSettingsRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GetSettingsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GetSettingsRequest} GetSettingsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetSettingsRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetSettingsRequest message.
     * @function verify
     * @memberof GetSettingsRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetSettingsRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a GetSettingsRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GetSettingsRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GetSettingsRequest} GetSettingsRequest
     */
    GetSettingsRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.GetSettingsRequest)
            return object;
        return new $root.GetSettingsRequest();
    };

    /**
     * Creates a plain object from a GetSettingsRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GetSettingsRequest
     * @static
     * @param {GetSettingsRequest} message GetSettingsRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetSettingsRequest.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this GetSettingsRequest to JSON.
     * @function toJSON
     * @memberof GetSettingsRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetSettingsRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GetSettingsRequest
     * @function getTypeUrl
     * @memberof GetSettingsRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GetSettingsRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GetSettingsRequest";
    };

    return GetSettingsRequest;
})();

$root.GetSettingsResponse = (function() {

    /**
     * Properties of a GetSettingsResponse.
     * @exports IGetSettingsResponse
     * @interface IGetSettingsResponse
     * @property {boolean|null} [okay] GetSettingsResponse okay
     * @property {space.kenko.proto.ISettingsProto|null} [newSettings] GetSettingsResponse newSettings
     */

    /**
     * Constructs a new GetSettingsResponse.
     * @exports GetSettingsResponse
     * @classdesc Represents a GetSettingsResponse.
     * @implements IGetSettingsResponse
     * @constructor
     * @param {IGetSettingsResponse=} [properties] Properties to set
     */
    function GetSettingsResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetSettingsResponse okay.
     * @member {boolean} okay
     * @memberof GetSettingsResponse
     * @instance
     */
    GetSettingsResponse.prototype.okay = false;

    /**
     * GetSettingsResponse newSettings.
     * @member {space.kenko.proto.ISettingsProto|null|undefined} newSettings
     * @memberof GetSettingsResponse
     * @instance
     */
    GetSettingsResponse.prototype.newSettings = null;

    /**
     * Creates a new GetSettingsResponse instance using the specified properties.
     * @function create
     * @memberof GetSettingsResponse
     * @static
     * @param {IGetSettingsResponse=} [properties] Properties to set
     * @returns {GetSettingsResponse} GetSettingsResponse instance
     */
    GetSettingsResponse.create = function create(properties) {
        return new GetSettingsResponse(properties);
    };

    /**
     * Encodes the specified GetSettingsResponse message. Does not implicitly {@link GetSettingsResponse.verify|verify} messages.
     * @function encode
     * @memberof GetSettingsResponse
     * @static
     * @param {IGetSettingsResponse} message GetSettingsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetSettingsResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        if (message.newSettings != null && Object.hasOwnProperty.call(message, "newSettings"))
            $root.space.kenko.proto.SettingsProto.encode(message.newSettings, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified GetSettingsResponse message, length delimited. Does not implicitly {@link GetSettingsResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GetSettingsResponse
     * @static
     * @param {IGetSettingsResponse} message GetSettingsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetSettingsResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetSettingsResponse message from the specified reader or buffer.
     * @function decode
     * @memberof GetSettingsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GetSettingsResponse} GetSettingsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetSettingsResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetSettingsResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            case 2: {
                    message.newSettings = $root.space.kenko.proto.SettingsProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GetSettingsResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GetSettingsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GetSettingsResponse} GetSettingsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetSettingsResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetSettingsResponse message.
     * @function verify
     * @memberof GetSettingsResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetSettingsResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        if (message.newSettings != null && message.hasOwnProperty("newSettings")) {
            var error = $root.space.kenko.proto.SettingsProto.verify(message.newSettings);
            if (error)
                return "newSettings." + error;
        }
        return null;
    };

    /**
     * Creates a GetSettingsResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GetSettingsResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GetSettingsResponse} GetSettingsResponse
     */
    GetSettingsResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.GetSettingsResponse)
            return object;
        var message = new $root.GetSettingsResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        if (object.newSettings != null) {
            if (typeof object.newSettings !== "object")
                throw TypeError(".GetSettingsResponse.newSettings: object expected");
            message.newSettings = $root.space.kenko.proto.SettingsProto.fromObject(object.newSettings);
        }
        return message;
    };

    /**
     * Creates a plain object from a GetSettingsResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GetSettingsResponse
     * @static
     * @param {GetSettingsResponse} message GetSettingsResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetSettingsResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.okay = false;
            object.newSettings = null;
        }
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        if (message.newSettings != null && message.hasOwnProperty("newSettings"))
            object.newSettings = $root.space.kenko.proto.SettingsProto.toObject(message.newSettings, options);
        return object;
    };

    /**
     * Converts this GetSettingsResponse to JSON.
     * @function toJSON
     * @memberof GetSettingsResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetSettingsResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GetSettingsResponse
     * @function getTypeUrl
     * @memberof GetSettingsResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GetSettingsResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GetSettingsResponse";
    };

    return GetSettingsResponse;
})();

$root.AdminBusinessProto = (function() {

    /**
     * Properties of an AdminBusinessProto.
     * @exports IAdminBusinessProto
     * @interface IAdminBusinessProto
     * @property {string|null} [businessId] AdminBusinessProto businessId
     * @property {space.kenko.proto.ProviderApprovalState|null} [approvalState] AdminBusinessProto approvalState
     * @property {space.kenko.proto.IProviderSurveyProto|null} [surveyProto] AdminBusinessProto surveyProto
     * @property {number|Long|null} [approvalReviewTimestamp] AdminBusinessProto approvalReviewTimestamp
     */

    /**
     * Constructs a new AdminBusinessProto.
     * @exports AdminBusinessProto
     * @classdesc Represents an AdminBusinessProto.
     * @implements IAdminBusinessProto
     * @constructor
     * @param {IAdminBusinessProto=} [properties] Properties to set
     */
    function AdminBusinessProto(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * AdminBusinessProto businessId.
     * @member {string} businessId
     * @memberof AdminBusinessProto
     * @instance
     */
    AdminBusinessProto.prototype.businessId = "";

    /**
     * AdminBusinessProto approvalState.
     * @member {space.kenko.proto.ProviderApprovalState} approvalState
     * @memberof AdminBusinessProto
     * @instance
     */
    AdminBusinessProto.prototype.approvalState = 0;

    /**
     * AdminBusinessProto surveyProto.
     * @member {space.kenko.proto.IProviderSurveyProto|null|undefined} surveyProto
     * @memberof AdminBusinessProto
     * @instance
     */
    AdminBusinessProto.prototype.surveyProto = null;

    /**
     * AdminBusinessProto approvalReviewTimestamp.
     * @member {number|Long} approvalReviewTimestamp
     * @memberof AdminBusinessProto
     * @instance
     */
    AdminBusinessProto.prototype.approvalReviewTimestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * Creates a new AdminBusinessProto instance using the specified properties.
     * @function create
     * @memberof AdminBusinessProto
     * @static
     * @param {IAdminBusinessProto=} [properties] Properties to set
     * @returns {AdminBusinessProto} AdminBusinessProto instance
     */
    AdminBusinessProto.create = function create(properties) {
        return new AdminBusinessProto(properties);
    };

    /**
     * Encodes the specified AdminBusinessProto message. Does not implicitly {@link AdminBusinessProto.verify|verify} messages.
     * @function encode
     * @memberof AdminBusinessProto
     * @static
     * @param {IAdminBusinessProto} message AdminBusinessProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AdminBusinessProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessId);
        if (message.approvalState != null && Object.hasOwnProperty.call(message, "approvalState"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.approvalState);
        if (message.surveyProto != null && Object.hasOwnProperty.call(message, "surveyProto"))
            $root.space.kenko.proto.ProviderSurveyProto.encode(message.surveyProto, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.approvalReviewTimestamp != null && Object.hasOwnProperty.call(message, "approvalReviewTimestamp"))
            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.approvalReviewTimestamp);
        return writer;
    };

    /**
     * Encodes the specified AdminBusinessProto message, length delimited. Does not implicitly {@link AdminBusinessProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof AdminBusinessProto
     * @static
     * @param {IAdminBusinessProto} message AdminBusinessProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AdminBusinessProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an AdminBusinessProto message from the specified reader or buffer.
     * @function decode
     * @memberof AdminBusinessProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AdminBusinessProto} AdminBusinessProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AdminBusinessProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AdminBusinessProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.businessId = reader.string();
                    break;
                }
            case 2: {
                    message.approvalState = reader.int32();
                    break;
                }
            case 3: {
                    message.surveyProto = $root.space.kenko.proto.ProviderSurveyProto.decode(reader, reader.uint32());
                    break;
                }
            case 6: {
                    message.approvalReviewTimestamp = reader.int64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an AdminBusinessProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof AdminBusinessProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {AdminBusinessProto} AdminBusinessProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AdminBusinessProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AdminBusinessProto message.
     * @function verify
     * @memberof AdminBusinessProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AdminBusinessProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.businessId != null && message.hasOwnProperty("businessId"))
            if (!$util.isString(message.businessId))
                return "businessId: string expected";
        if (message.approvalState != null && message.hasOwnProperty("approvalState"))
            switch (message.approvalState) {
            default:
                return "approvalState: enum value expected";
            case 0:
            case 10:
            case 11:
            case 20:
            case 30:
            case 40:
                break;
            }
        if (message.surveyProto != null && message.hasOwnProperty("surveyProto")) {
            var error = $root.space.kenko.proto.ProviderSurveyProto.verify(message.surveyProto);
            if (error)
                return "surveyProto." + error;
        }
        if (message.approvalReviewTimestamp != null && message.hasOwnProperty("approvalReviewTimestamp"))
            if (!$util.isInteger(message.approvalReviewTimestamp) && !(message.approvalReviewTimestamp && $util.isInteger(message.approvalReviewTimestamp.low) && $util.isInteger(message.approvalReviewTimestamp.high)))
                return "approvalReviewTimestamp: integer|Long expected";
        return null;
    };

    /**
     * Creates an AdminBusinessProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AdminBusinessProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AdminBusinessProto} AdminBusinessProto
     */
    AdminBusinessProto.fromObject = function fromObject(object) {
        if (object instanceof $root.AdminBusinessProto)
            return object;
        var message = new $root.AdminBusinessProto();
        if (object.businessId != null)
            message.businessId = String(object.businessId);
        switch (object.approvalState) {
        default:
            if (typeof object.approvalState === "number") {
                message.approvalState = object.approvalState;
                break;
            }
            break;
        case "APPROVAL_STATE_UNKNOWN":
        case 0:
            message.approvalState = 0;
            break;
        case "NEW_PROVIDER_MANUAL_APPROVE":
        case 10:
            message.approvalState = 10;
            break;
        case "NEW_PROVIDER_AUTO_APPROVE":
        case 11:
            message.approvalState = 11;
            break;
        case "AWAITING_REVIEW":
        case 20:
            message.approvalState = 20;
            break;
        case "PROVIDER_APPROVED":
        case 30:
            message.approvalState = 30;
            break;
        case "PROVIDER_REJECTED":
        case 40:
            message.approvalState = 40;
            break;
        }
        if (object.surveyProto != null) {
            if (typeof object.surveyProto !== "object")
                throw TypeError(".AdminBusinessProto.surveyProto: object expected");
            message.surveyProto = $root.space.kenko.proto.ProviderSurveyProto.fromObject(object.surveyProto);
        }
        if (object.approvalReviewTimestamp != null)
            if ($util.Long)
                (message.approvalReviewTimestamp = $util.Long.fromValue(object.approvalReviewTimestamp)).unsigned = false;
            else if (typeof object.approvalReviewTimestamp === "string")
                message.approvalReviewTimestamp = parseInt(object.approvalReviewTimestamp, 10);
            else if (typeof object.approvalReviewTimestamp === "number")
                message.approvalReviewTimestamp = object.approvalReviewTimestamp;
            else if (typeof object.approvalReviewTimestamp === "object")
                message.approvalReviewTimestamp = new $util.LongBits(object.approvalReviewTimestamp.low >>> 0, object.approvalReviewTimestamp.high >>> 0).toNumber();
        return message;
    };

    /**
     * Creates a plain object from an AdminBusinessProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AdminBusinessProto
     * @static
     * @param {AdminBusinessProto} message AdminBusinessProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AdminBusinessProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.businessId = "";
            object.approvalState = options.enums === String ? "APPROVAL_STATE_UNKNOWN" : 0;
            object.surveyProto = null;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.approvalReviewTimestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.approvalReviewTimestamp = options.longs === String ? "0" : 0;
        }
        if (message.businessId != null && message.hasOwnProperty("businessId"))
            object.businessId = message.businessId;
        if (message.approvalState != null && message.hasOwnProperty("approvalState"))
            object.approvalState = options.enums === String ? $root.space.kenko.proto.ProviderApprovalState[message.approvalState] === undefined ? message.approvalState : $root.space.kenko.proto.ProviderApprovalState[message.approvalState] : message.approvalState;
        if (message.surveyProto != null && message.hasOwnProperty("surveyProto"))
            object.surveyProto = $root.space.kenko.proto.ProviderSurveyProto.toObject(message.surveyProto, options);
        if (message.approvalReviewTimestamp != null && message.hasOwnProperty("approvalReviewTimestamp"))
            if (typeof message.approvalReviewTimestamp === "number")
                object.approvalReviewTimestamp = options.longs === String ? String(message.approvalReviewTimestamp) : message.approvalReviewTimestamp;
            else
                object.approvalReviewTimestamp = options.longs === String ? $util.Long.prototype.toString.call(message.approvalReviewTimestamp) : options.longs === Number ? new $util.LongBits(message.approvalReviewTimestamp.low >>> 0, message.approvalReviewTimestamp.high >>> 0).toNumber() : message.approvalReviewTimestamp;
        return object;
    };

    /**
     * Converts this AdminBusinessProto to JSON.
     * @function toJSON
     * @memberof AdminBusinessProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AdminBusinessProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for AdminBusinessProto
     * @function getTypeUrl
     * @memberof AdminBusinessProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    AdminBusinessProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/AdminBusinessProto";
    };

    return AdminBusinessProto;
})();

$root.AdminProviderLoginProto = (function() {

    /**
     * Properties of an AdminProviderLoginProto.
     * @exports IAdminProviderLoginProto
     * @interface IAdminProviderLoginProto
     * @property {string|null} [providerId] AdminProviderLoginProto providerId
     * @property {string|null} [businessId] AdminProviderLoginProto businessId
     * @property {string|null} [loginId] AdminProviderLoginProto loginId
     * @property {Array.<string>|null} [roles] AdminProviderLoginProto roles
     * @property {string|null} [lastLoginEmail] AdminProviderLoginProto lastLoginEmail
     * @property {number|Long|null} [lastLoginTimestamp] AdminProviderLoginProto lastLoginTimestamp
     * @property {space.kenko.proto.IProviderProfileProto|null} [profile] AdminProviderLoginProto profile
     */

    /**
     * Constructs a new AdminProviderLoginProto.
     * @exports AdminProviderLoginProto
     * @classdesc Represents an AdminProviderLoginProto.
     * @implements IAdminProviderLoginProto
     * @constructor
     * @param {IAdminProviderLoginProto=} [properties] Properties to set
     */
    function AdminProviderLoginProto(properties) {
        this.roles = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * AdminProviderLoginProto providerId.
     * @member {string} providerId
     * @memberof AdminProviderLoginProto
     * @instance
     */
    AdminProviderLoginProto.prototype.providerId = "";

    /**
     * AdminProviderLoginProto businessId.
     * @member {string} businessId
     * @memberof AdminProviderLoginProto
     * @instance
     */
    AdminProviderLoginProto.prototype.businessId = "";

    /**
     * AdminProviderLoginProto loginId.
     * @member {string} loginId
     * @memberof AdminProviderLoginProto
     * @instance
     */
    AdminProviderLoginProto.prototype.loginId = "";

    /**
     * AdminProviderLoginProto roles.
     * @member {Array.<string>} roles
     * @memberof AdminProviderLoginProto
     * @instance
     */
    AdminProviderLoginProto.prototype.roles = $util.emptyArray;

    /**
     * AdminProviderLoginProto lastLoginEmail.
     * @member {string} lastLoginEmail
     * @memberof AdminProviderLoginProto
     * @instance
     */
    AdminProviderLoginProto.prototype.lastLoginEmail = "";

    /**
     * AdminProviderLoginProto lastLoginTimestamp.
     * @member {number|Long} lastLoginTimestamp
     * @memberof AdminProviderLoginProto
     * @instance
     */
    AdminProviderLoginProto.prototype.lastLoginTimestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * AdminProviderLoginProto profile.
     * @member {space.kenko.proto.IProviderProfileProto|null|undefined} profile
     * @memberof AdminProviderLoginProto
     * @instance
     */
    AdminProviderLoginProto.prototype.profile = null;

    /**
     * Creates a new AdminProviderLoginProto instance using the specified properties.
     * @function create
     * @memberof AdminProviderLoginProto
     * @static
     * @param {IAdminProviderLoginProto=} [properties] Properties to set
     * @returns {AdminProviderLoginProto} AdminProviderLoginProto instance
     */
    AdminProviderLoginProto.create = function create(properties) {
        return new AdminProviderLoginProto(properties);
    };

    /**
     * Encodes the specified AdminProviderLoginProto message. Does not implicitly {@link AdminProviderLoginProto.verify|verify} messages.
     * @function encode
     * @memberof AdminProviderLoginProto
     * @static
     * @param {IAdminProviderLoginProto} message AdminProviderLoginProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AdminProviderLoginProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.providerId != null && Object.hasOwnProperty.call(message, "providerId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.providerId);
        if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.businessId);
        if (message.loginId != null && Object.hasOwnProperty.call(message, "loginId"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.loginId);
        if (message.roles != null && message.roles.length)
            for (var i = 0; i < message.roles.length; ++i)
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.roles[i]);
        if (message.lastLoginEmail != null && Object.hasOwnProperty.call(message, "lastLoginEmail"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.lastLoginEmail);
        if (message.lastLoginTimestamp != null && Object.hasOwnProperty.call(message, "lastLoginTimestamp"))
            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.lastLoginTimestamp);
        if (message.profile != null && Object.hasOwnProperty.call(message, "profile"))
            $root.space.kenko.proto.ProviderProfileProto.encode(message.profile, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified AdminProviderLoginProto message, length delimited. Does not implicitly {@link AdminProviderLoginProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof AdminProviderLoginProto
     * @static
     * @param {IAdminProviderLoginProto} message AdminProviderLoginProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AdminProviderLoginProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an AdminProviderLoginProto message from the specified reader or buffer.
     * @function decode
     * @memberof AdminProviderLoginProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AdminProviderLoginProto} AdminProviderLoginProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AdminProviderLoginProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AdminProviderLoginProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.providerId = reader.string();
                    break;
                }
            case 2: {
                    message.businessId = reader.string();
                    break;
                }
            case 3: {
                    message.loginId = reader.string();
                    break;
                }
            case 4: {
                    if (!(message.roles && message.roles.length))
                        message.roles = [];
                    message.roles.push(reader.string());
                    break;
                }
            case 5: {
                    message.lastLoginEmail = reader.string();
                    break;
                }
            case 6: {
                    message.lastLoginTimestamp = reader.int64();
                    break;
                }
            case 7: {
                    message.profile = $root.space.kenko.proto.ProviderProfileProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an AdminProviderLoginProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof AdminProviderLoginProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {AdminProviderLoginProto} AdminProviderLoginProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AdminProviderLoginProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AdminProviderLoginProto message.
     * @function verify
     * @memberof AdminProviderLoginProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AdminProviderLoginProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.providerId != null && message.hasOwnProperty("providerId"))
            if (!$util.isString(message.providerId))
                return "providerId: string expected";
        if (message.businessId != null && message.hasOwnProperty("businessId"))
            if (!$util.isString(message.businessId))
                return "businessId: string expected";
        if (message.loginId != null && message.hasOwnProperty("loginId"))
            if (!$util.isString(message.loginId))
                return "loginId: string expected";
        if (message.roles != null && message.hasOwnProperty("roles")) {
            if (!Array.isArray(message.roles))
                return "roles: array expected";
            for (var i = 0; i < message.roles.length; ++i)
                if (!$util.isString(message.roles[i]))
                    return "roles: string[] expected";
        }
        if (message.lastLoginEmail != null && message.hasOwnProperty("lastLoginEmail"))
            if (!$util.isString(message.lastLoginEmail))
                return "lastLoginEmail: string expected";
        if (message.lastLoginTimestamp != null && message.hasOwnProperty("lastLoginTimestamp"))
            if (!$util.isInteger(message.lastLoginTimestamp) && !(message.lastLoginTimestamp && $util.isInteger(message.lastLoginTimestamp.low) && $util.isInteger(message.lastLoginTimestamp.high)))
                return "lastLoginTimestamp: integer|Long expected";
        if (message.profile != null && message.hasOwnProperty("profile")) {
            var error = $root.space.kenko.proto.ProviderProfileProto.verify(message.profile);
            if (error)
                return "profile." + error;
        }
        return null;
    };

    /**
     * Creates an AdminProviderLoginProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AdminProviderLoginProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AdminProviderLoginProto} AdminProviderLoginProto
     */
    AdminProviderLoginProto.fromObject = function fromObject(object) {
        if (object instanceof $root.AdminProviderLoginProto)
            return object;
        var message = new $root.AdminProviderLoginProto();
        if (object.providerId != null)
            message.providerId = String(object.providerId);
        if (object.businessId != null)
            message.businessId = String(object.businessId);
        if (object.loginId != null)
            message.loginId = String(object.loginId);
        if (object.roles) {
            if (!Array.isArray(object.roles))
                throw TypeError(".AdminProviderLoginProto.roles: array expected");
            message.roles = [];
            for (var i = 0; i < object.roles.length; ++i)
                message.roles[i] = String(object.roles[i]);
        }
        if (object.lastLoginEmail != null)
            message.lastLoginEmail = String(object.lastLoginEmail);
        if (object.lastLoginTimestamp != null)
            if ($util.Long)
                (message.lastLoginTimestamp = $util.Long.fromValue(object.lastLoginTimestamp)).unsigned = false;
            else if (typeof object.lastLoginTimestamp === "string")
                message.lastLoginTimestamp = parseInt(object.lastLoginTimestamp, 10);
            else if (typeof object.lastLoginTimestamp === "number")
                message.lastLoginTimestamp = object.lastLoginTimestamp;
            else if (typeof object.lastLoginTimestamp === "object")
                message.lastLoginTimestamp = new $util.LongBits(object.lastLoginTimestamp.low >>> 0, object.lastLoginTimestamp.high >>> 0).toNumber();
        if (object.profile != null) {
            if (typeof object.profile !== "object")
                throw TypeError(".AdminProviderLoginProto.profile: object expected");
            message.profile = $root.space.kenko.proto.ProviderProfileProto.fromObject(object.profile);
        }
        return message;
    };

    /**
     * Creates a plain object from an AdminProviderLoginProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AdminProviderLoginProto
     * @static
     * @param {AdminProviderLoginProto} message AdminProviderLoginProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AdminProviderLoginProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.roles = [];
        if (options.defaults) {
            object.providerId = "";
            object.businessId = "";
            object.loginId = "";
            object.lastLoginEmail = "";
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.lastLoginTimestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.lastLoginTimestamp = options.longs === String ? "0" : 0;
            object.profile = null;
        }
        if (message.providerId != null && message.hasOwnProperty("providerId"))
            object.providerId = message.providerId;
        if (message.businessId != null && message.hasOwnProperty("businessId"))
            object.businessId = message.businessId;
        if (message.loginId != null && message.hasOwnProperty("loginId"))
            object.loginId = message.loginId;
        if (message.roles && message.roles.length) {
            object.roles = [];
            for (var j = 0; j < message.roles.length; ++j)
                object.roles[j] = message.roles[j];
        }
        if (message.lastLoginEmail != null && message.hasOwnProperty("lastLoginEmail"))
            object.lastLoginEmail = message.lastLoginEmail;
        if (message.lastLoginTimestamp != null && message.hasOwnProperty("lastLoginTimestamp"))
            if (typeof message.lastLoginTimestamp === "number")
                object.lastLoginTimestamp = options.longs === String ? String(message.lastLoginTimestamp) : message.lastLoginTimestamp;
            else
                object.lastLoginTimestamp = options.longs === String ? $util.Long.prototype.toString.call(message.lastLoginTimestamp) : options.longs === Number ? new $util.LongBits(message.lastLoginTimestamp.low >>> 0, message.lastLoginTimestamp.high >>> 0).toNumber() : message.lastLoginTimestamp;
        if (message.profile != null && message.hasOwnProperty("profile"))
            object.profile = $root.space.kenko.proto.ProviderProfileProto.toObject(message.profile, options);
        return object;
    };

    /**
     * Converts this AdminProviderLoginProto to JSON.
     * @function toJSON
     * @memberof AdminProviderLoginProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AdminProviderLoginProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for AdminProviderLoginProto
     * @function getTypeUrl
     * @memberof AdminProviderLoginProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    AdminProviderLoginProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/AdminProviderLoginProto";
    };

    return AdminProviderLoginProto;
})();

$root.ProviderReviewInfo = (function() {

    /**
     * Properties of a ProviderReviewInfo.
     * @exports IProviderReviewInfo
     * @interface IProviderReviewInfo
     * @property {IAdminBusinessProto|null} [business] ProviderReviewInfo business
     * @property {IAdminProviderLoginProto|null} [provider] ProviderReviewInfo provider
     */

    /**
     * Constructs a new ProviderReviewInfo.
     * @exports ProviderReviewInfo
     * @classdesc Represents a ProviderReviewInfo.
     * @implements IProviderReviewInfo
     * @constructor
     * @param {IProviderReviewInfo=} [properties] Properties to set
     */
    function ProviderReviewInfo(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ProviderReviewInfo business.
     * @member {IAdminBusinessProto|null|undefined} business
     * @memberof ProviderReviewInfo
     * @instance
     */
    ProviderReviewInfo.prototype.business = null;

    /**
     * ProviderReviewInfo provider.
     * @member {IAdminProviderLoginProto|null|undefined} provider
     * @memberof ProviderReviewInfo
     * @instance
     */
    ProviderReviewInfo.prototype.provider = null;

    /**
     * Creates a new ProviderReviewInfo instance using the specified properties.
     * @function create
     * @memberof ProviderReviewInfo
     * @static
     * @param {IProviderReviewInfo=} [properties] Properties to set
     * @returns {ProviderReviewInfo} ProviderReviewInfo instance
     */
    ProviderReviewInfo.create = function create(properties) {
        return new ProviderReviewInfo(properties);
    };

    /**
     * Encodes the specified ProviderReviewInfo message. Does not implicitly {@link ProviderReviewInfo.verify|verify} messages.
     * @function encode
     * @memberof ProviderReviewInfo
     * @static
     * @param {IProviderReviewInfo} message ProviderReviewInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ProviderReviewInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.business != null && Object.hasOwnProperty.call(message, "business"))
            $root.AdminBusinessProto.encode(message.business, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.provider != null && Object.hasOwnProperty.call(message, "provider"))
            $root.AdminProviderLoginProto.encode(message.provider, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ProviderReviewInfo message, length delimited. Does not implicitly {@link ProviderReviewInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ProviderReviewInfo
     * @static
     * @param {IProviderReviewInfo} message ProviderReviewInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ProviderReviewInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ProviderReviewInfo message from the specified reader or buffer.
     * @function decode
     * @memberof ProviderReviewInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ProviderReviewInfo} ProviderReviewInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ProviderReviewInfo.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ProviderReviewInfo();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.business = $root.AdminBusinessProto.decode(reader, reader.uint32());
                    break;
                }
            case 2: {
                    message.provider = $root.AdminProviderLoginProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ProviderReviewInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ProviderReviewInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ProviderReviewInfo} ProviderReviewInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ProviderReviewInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ProviderReviewInfo message.
     * @function verify
     * @memberof ProviderReviewInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ProviderReviewInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.business != null && message.hasOwnProperty("business")) {
            var error = $root.AdminBusinessProto.verify(message.business);
            if (error)
                return "business." + error;
        }
        if (message.provider != null && message.hasOwnProperty("provider")) {
            var error = $root.AdminProviderLoginProto.verify(message.provider);
            if (error)
                return "provider." + error;
        }
        return null;
    };

    /**
     * Creates a ProviderReviewInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ProviderReviewInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ProviderReviewInfo} ProviderReviewInfo
     */
    ProviderReviewInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.ProviderReviewInfo)
            return object;
        var message = new $root.ProviderReviewInfo();
        if (object.business != null) {
            if (typeof object.business !== "object")
                throw TypeError(".ProviderReviewInfo.business: object expected");
            message.business = $root.AdminBusinessProto.fromObject(object.business);
        }
        if (object.provider != null) {
            if (typeof object.provider !== "object")
                throw TypeError(".ProviderReviewInfo.provider: object expected");
            message.provider = $root.AdminProviderLoginProto.fromObject(object.provider);
        }
        return message;
    };

    /**
     * Creates a plain object from a ProviderReviewInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ProviderReviewInfo
     * @static
     * @param {ProviderReviewInfo} message ProviderReviewInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ProviderReviewInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.business = null;
            object.provider = null;
        }
        if (message.business != null && message.hasOwnProperty("business"))
            object.business = $root.AdminBusinessProto.toObject(message.business, options);
        if (message.provider != null && message.hasOwnProperty("provider"))
            object.provider = $root.AdminProviderLoginProto.toObject(message.provider, options);
        return object;
    };

    /**
     * Converts this ProviderReviewInfo to JSON.
     * @function toJSON
     * @memberof ProviderReviewInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ProviderReviewInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ProviderReviewInfo
     * @function getTypeUrl
     * @memberof ProviderReviewInfo
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ProviderReviewInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ProviderReviewInfo";
    };

    return ProviderReviewInfo;
})();

$root.GetPendingBusinessApprovalsRequest = (function() {

    /**
     * Properties of a GetPendingBusinessApprovalsRequest.
     * @exports IGetPendingBusinessApprovalsRequest
     * @interface IGetPendingBusinessApprovalsRequest
     * @property {string|null} [startIndex] GetPendingBusinessApprovalsRequest startIndex
     */

    /**
     * Constructs a new GetPendingBusinessApprovalsRequest.
     * @exports GetPendingBusinessApprovalsRequest
     * @classdesc Represents a GetPendingBusinessApprovalsRequest.
     * @implements IGetPendingBusinessApprovalsRequest
     * @constructor
     * @param {IGetPendingBusinessApprovalsRequest=} [properties] Properties to set
     */
    function GetPendingBusinessApprovalsRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetPendingBusinessApprovalsRequest startIndex.
     * @member {string} startIndex
     * @memberof GetPendingBusinessApprovalsRequest
     * @instance
     */
    GetPendingBusinessApprovalsRequest.prototype.startIndex = "";

    /**
     * Creates a new GetPendingBusinessApprovalsRequest instance using the specified properties.
     * @function create
     * @memberof GetPendingBusinessApprovalsRequest
     * @static
     * @param {IGetPendingBusinessApprovalsRequest=} [properties] Properties to set
     * @returns {GetPendingBusinessApprovalsRequest} GetPendingBusinessApprovalsRequest instance
     */
    GetPendingBusinessApprovalsRequest.create = function create(properties) {
        return new GetPendingBusinessApprovalsRequest(properties);
    };

    /**
     * Encodes the specified GetPendingBusinessApprovalsRequest message. Does not implicitly {@link GetPendingBusinessApprovalsRequest.verify|verify} messages.
     * @function encode
     * @memberof GetPendingBusinessApprovalsRequest
     * @static
     * @param {IGetPendingBusinessApprovalsRequest} message GetPendingBusinessApprovalsRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetPendingBusinessApprovalsRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.startIndex != null && Object.hasOwnProperty.call(message, "startIndex"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.startIndex);
        return writer;
    };

    /**
     * Encodes the specified GetPendingBusinessApprovalsRequest message, length delimited. Does not implicitly {@link GetPendingBusinessApprovalsRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GetPendingBusinessApprovalsRequest
     * @static
     * @param {IGetPendingBusinessApprovalsRequest} message GetPendingBusinessApprovalsRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetPendingBusinessApprovalsRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetPendingBusinessApprovalsRequest message from the specified reader or buffer.
     * @function decode
     * @memberof GetPendingBusinessApprovalsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GetPendingBusinessApprovalsRequest} GetPendingBusinessApprovalsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetPendingBusinessApprovalsRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetPendingBusinessApprovalsRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.startIndex = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GetPendingBusinessApprovalsRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GetPendingBusinessApprovalsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GetPendingBusinessApprovalsRequest} GetPendingBusinessApprovalsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetPendingBusinessApprovalsRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetPendingBusinessApprovalsRequest message.
     * @function verify
     * @memberof GetPendingBusinessApprovalsRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetPendingBusinessApprovalsRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.startIndex != null && message.hasOwnProperty("startIndex"))
            if (!$util.isString(message.startIndex))
                return "startIndex: string expected";
        return null;
    };

    /**
     * Creates a GetPendingBusinessApprovalsRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GetPendingBusinessApprovalsRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GetPendingBusinessApprovalsRequest} GetPendingBusinessApprovalsRequest
     */
    GetPendingBusinessApprovalsRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.GetPendingBusinessApprovalsRequest)
            return object;
        var message = new $root.GetPendingBusinessApprovalsRequest();
        if (object.startIndex != null)
            message.startIndex = String(object.startIndex);
        return message;
    };

    /**
     * Creates a plain object from a GetPendingBusinessApprovalsRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GetPendingBusinessApprovalsRequest
     * @static
     * @param {GetPendingBusinessApprovalsRequest} message GetPendingBusinessApprovalsRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetPendingBusinessApprovalsRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.startIndex = "";
        if (message.startIndex != null && message.hasOwnProperty("startIndex"))
            object.startIndex = message.startIndex;
        return object;
    };

    /**
     * Converts this GetPendingBusinessApprovalsRequest to JSON.
     * @function toJSON
     * @memberof GetPendingBusinessApprovalsRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetPendingBusinessApprovalsRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GetPendingBusinessApprovalsRequest
     * @function getTypeUrl
     * @memberof GetPendingBusinessApprovalsRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GetPendingBusinessApprovalsRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GetPendingBusinessApprovalsRequest";
    };

    return GetPendingBusinessApprovalsRequest;
})();

$root.GetPendingBusinessApprovalsResponse = (function() {

    /**
     * Properties of a GetPendingBusinessApprovalsResponse.
     * @exports IGetPendingBusinessApprovalsResponse
     * @interface IGetPendingBusinessApprovalsResponse
     * @property {boolean|null} [okay] GetPendingBusinessApprovalsResponse okay
     * @property {string|null} [error] GetPendingBusinessApprovalsResponse error
     * @property {Array.<IProviderReviewInfo>|null} [business] GetPendingBusinessApprovalsResponse business
     */

    /**
     * Constructs a new GetPendingBusinessApprovalsResponse.
     * @exports GetPendingBusinessApprovalsResponse
     * @classdesc Represents a GetPendingBusinessApprovalsResponse.
     * @implements IGetPendingBusinessApprovalsResponse
     * @constructor
     * @param {IGetPendingBusinessApprovalsResponse=} [properties] Properties to set
     */
    function GetPendingBusinessApprovalsResponse(properties) {
        this.business = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetPendingBusinessApprovalsResponse okay.
     * @member {boolean} okay
     * @memberof GetPendingBusinessApprovalsResponse
     * @instance
     */
    GetPendingBusinessApprovalsResponse.prototype.okay = false;

    /**
     * GetPendingBusinessApprovalsResponse error.
     * @member {string} error
     * @memberof GetPendingBusinessApprovalsResponse
     * @instance
     */
    GetPendingBusinessApprovalsResponse.prototype.error = "";

    /**
     * GetPendingBusinessApprovalsResponse business.
     * @member {Array.<IProviderReviewInfo>} business
     * @memberof GetPendingBusinessApprovalsResponse
     * @instance
     */
    GetPendingBusinessApprovalsResponse.prototype.business = $util.emptyArray;

    /**
     * Creates a new GetPendingBusinessApprovalsResponse instance using the specified properties.
     * @function create
     * @memberof GetPendingBusinessApprovalsResponse
     * @static
     * @param {IGetPendingBusinessApprovalsResponse=} [properties] Properties to set
     * @returns {GetPendingBusinessApprovalsResponse} GetPendingBusinessApprovalsResponse instance
     */
    GetPendingBusinessApprovalsResponse.create = function create(properties) {
        return new GetPendingBusinessApprovalsResponse(properties);
    };

    /**
     * Encodes the specified GetPendingBusinessApprovalsResponse message. Does not implicitly {@link GetPendingBusinessApprovalsResponse.verify|verify} messages.
     * @function encode
     * @memberof GetPendingBusinessApprovalsResponse
     * @static
     * @param {IGetPendingBusinessApprovalsResponse} message GetPendingBusinessApprovalsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetPendingBusinessApprovalsResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        if (message.error != null && Object.hasOwnProperty.call(message, "error"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.error);
        if (message.business != null && message.business.length)
            for (var i = 0; i < message.business.length; ++i)
                $root.ProviderReviewInfo.encode(message.business[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified GetPendingBusinessApprovalsResponse message, length delimited. Does not implicitly {@link GetPendingBusinessApprovalsResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GetPendingBusinessApprovalsResponse
     * @static
     * @param {IGetPendingBusinessApprovalsResponse} message GetPendingBusinessApprovalsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetPendingBusinessApprovalsResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetPendingBusinessApprovalsResponse message from the specified reader or buffer.
     * @function decode
     * @memberof GetPendingBusinessApprovalsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GetPendingBusinessApprovalsResponse} GetPendingBusinessApprovalsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetPendingBusinessApprovalsResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetPendingBusinessApprovalsResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            case 2: {
                    message.error = reader.string();
                    break;
                }
            case 3: {
                    if (!(message.business && message.business.length))
                        message.business = [];
                    message.business.push($root.ProviderReviewInfo.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GetPendingBusinessApprovalsResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GetPendingBusinessApprovalsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GetPendingBusinessApprovalsResponse} GetPendingBusinessApprovalsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetPendingBusinessApprovalsResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetPendingBusinessApprovalsResponse message.
     * @function verify
     * @memberof GetPendingBusinessApprovalsResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetPendingBusinessApprovalsResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        if (message.error != null && message.hasOwnProperty("error"))
            if (!$util.isString(message.error))
                return "error: string expected";
        if (message.business != null && message.hasOwnProperty("business")) {
            if (!Array.isArray(message.business))
                return "business: array expected";
            for (var i = 0; i < message.business.length; ++i) {
                var error = $root.ProviderReviewInfo.verify(message.business[i]);
                if (error)
                    return "business." + error;
            }
        }
        return null;
    };

    /**
     * Creates a GetPendingBusinessApprovalsResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GetPendingBusinessApprovalsResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GetPendingBusinessApprovalsResponse} GetPendingBusinessApprovalsResponse
     */
    GetPendingBusinessApprovalsResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.GetPendingBusinessApprovalsResponse)
            return object;
        var message = new $root.GetPendingBusinessApprovalsResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        if (object.error != null)
            message.error = String(object.error);
        if (object.business) {
            if (!Array.isArray(object.business))
                throw TypeError(".GetPendingBusinessApprovalsResponse.business: array expected");
            message.business = [];
            for (var i = 0; i < object.business.length; ++i) {
                if (typeof object.business[i] !== "object")
                    throw TypeError(".GetPendingBusinessApprovalsResponse.business: object expected");
                message.business[i] = $root.ProviderReviewInfo.fromObject(object.business[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a GetPendingBusinessApprovalsResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GetPendingBusinessApprovalsResponse
     * @static
     * @param {GetPendingBusinessApprovalsResponse} message GetPendingBusinessApprovalsResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetPendingBusinessApprovalsResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.business = [];
        if (options.defaults) {
            object.okay = false;
            object.error = "";
        }
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        if (message.error != null && message.hasOwnProperty("error"))
            object.error = message.error;
        if (message.business && message.business.length) {
            object.business = [];
            for (var j = 0; j < message.business.length; ++j)
                object.business[j] = $root.ProviderReviewInfo.toObject(message.business[j], options);
        }
        return object;
    };

    /**
     * Converts this GetPendingBusinessApprovalsResponse to JSON.
     * @function toJSON
     * @memberof GetPendingBusinessApprovalsResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetPendingBusinessApprovalsResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GetPendingBusinessApprovalsResponse
     * @function getTypeUrl
     * @memberof GetPendingBusinessApprovalsResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GetPendingBusinessApprovalsResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GetPendingBusinessApprovalsResponse";
    };

    return GetPendingBusinessApprovalsResponse;
})();

$root.ApproveBusinessRequest = (function() {

    /**
     * Properties of an ApproveBusinessRequest.
     * @exports IApproveBusinessRequest
     * @interface IApproveBusinessRequest
     * @property {string|null} [businessId] ApproveBusinessRequest businessId
     * @property {space.kenko.proto.ProviderApprovalState|null} [status] ApproveBusinessRequest status
     * @property {string|null} [reviewMessage] ApproveBusinessRequest reviewMessage
     */

    /**
     * Constructs a new ApproveBusinessRequest.
     * @exports ApproveBusinessRequest
     * @classdesc Represents an ApproveBusinessRequest.
     * @implements IApproveBusinessRequest
     * @constructor
     * @param {IApproveBusinessRequest=} [properties] Properties to set
     */
    function ApproveBusinessRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ApproveBusinessRequest businessId.
     * @member {string} businessId
     * @memberof ApproveBusinessRequest
     * @instance
     */
    ApproveBusinessRequest.prototype.businessId = "";

    /**
     * ApproveBusinessRequest status.
     * @member {space.kenko.proto.ProviderApprovalState} status
     * @memberof ApproveBusinessRequest
     * @instance
     */
    ApproveBusinessRequest.prototype.status = 0;

    /**
     * ApproveBusinessRequest reviewMessage.
     * @member {string} reviewMessage
     * @memberof ApproveBusinessRequest
     * @instance
     */
    ApproveBusinessRequest.prototype.reviewMessage = "";

    /**
     * Creates a new ApproveBusinessRequest instance using the specified properties.
     * @function create
     * @memberof ApproveBusinessRequest
     * @static
     * @param {IApproveBusinessRequest=} [properties] Properties to set
     * @returns {ApproveBusinessRequest} ApproveBusinessRequest instance
     */
    ApproveBusinessRequest.create = function create(properties) {
        return new ApproveBusinessRequest(properties);
    };

    /**
     * Encodes the specified ApproveBusinessRequest message. Does not implicitly {@link ApproveBusinessRequest.verify|verify} messages.
     * @function encode
     * @memberof ApproveBusinessRequest
     * @static
     * @param {IApproveBusinessRequest} message ApproveBusinessRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ApproveBusinessRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessId);
        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.status);
        if (message.reviewMessage != null && Object.hasOwnProperty.call(message, "reviewMessage"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.reviewMessage);
        return writer;
    };

    /**
     * Encodes the specified ApproveBusinessRequest message, length delimited. Does not implicitly {@link ApproveBusinessRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ApproveBusinessRequest
     * @static
     * @param {IApproveBusinessRequest} message ApproveBusinessRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ApproveBusinessRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an ApproveBusinessRequest message from the specified reader or buffer.
     * @function decode
     * @memberof ApproveBusinessRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ApproveBusinessRequest} ApproveBusinessRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ApproveBusinessRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ApproveBusinessRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.businessId = reader.string();
                    break;
                }
            case 2: {
                    message.status = reader.int32();
                    break;
                }
            case 3: {
                    message.reviewMessage = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an ApproveBusinessRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ApproveBusinessRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ApproveBusinessRequest} ApproveBusinessRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ApproveBusinessRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an ApproveBusinessRequest message.
     * @function verify
     * @memberof ApproveBusinessRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ApproveBusinessRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.businessId != null && message.hasOwnProperty("businessId"))
            if (!$util.isString(message.businessId))
                return "businessId: string expected";
        if (message.status != null && message.hasOwnProperty("status"))
            switch (message.status) {
            default:
                return "status: enum value expected";
            case 0:
            case 10:
            case 11:
            case 20:
            case 30:
            case 40:
                break;
            }
        if (message.reviewMessage != null && message.hasOwnProperty("reviewMessage"))
            if (!$util.isString(message.reviewMessage))
                return "reviewMessage: string expected";
        return null;
    };

    /**
     * Creates an ApproveBusinessRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ApproveBusinessRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ApproveBusinessRequest} ApproveBusinessRequest
     */
    ApproveBusinessRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.ApproveBusinessRequest)
            return object;
        var message = new $root.ApproveBusinessRequest();
        if (object.businessId != null)
            message.businessId = String(object.businessId);
        switch (object.status) {
        default:
            if (typeof object.status === "number") {
                message.status = object.status;
                break;
            }
            break;
        case "APPROVAL_STATE_UNKNOWN":
        case 0:
            message.status = 0;
            break;
        case "NEW_PROVIDER_MANUAL_APPROVE":
        case 10:
            message.status = 10;
            break;
        case "NEW_PROVIDER_AUTO_APPROVE":
        case 11:
            message.status = 11;
            break;
        case "AWAITING_REVIEW":
        case 20:
            message.status = 20;
            break;
        case "PROVIDER_APPROVED":
        case 30:
            message.status = 30;
            break;
        case "PROVIDER_REJECTED":
        case 40:
            message.status = 40;
            break;
        }
        if (object.reviewMessage != null)
            message.reviewMessage = String(object.reviewMessage);
        return message;
    };

    /**
     * Creates a plain object from an ApproveBusinessRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ApproveBusinessRequest
     * @static
     * @param {ApproveBusinessRequest} message ApproveBusinessRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ApproveBusinessRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.businessId = "";
            object.status = options.enums === String ? "APPROVAL_STATE_UNKNOWN" : 0;
            object.reviewMessage = "";
        }
        if (message.businessId != null && message.hasOwnProperty("businessId"))
            object.businessId = message.businessId;
        if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.space.kenko.proto.ProviderApprovalState[message.status] === undefined ? message.status : $root.space.kenko.proto.ProviderApprovalState[message.status] : message.status;
        if (message.reviewMessage != null && message.hasOwnProperty("reviewMessage"))
            object.reviewMessage = message.reviewMessage;
        return object;
    };

    /**
     * Converts this ApproveBusinessRequest to JSON.
     * @function toJSON
     * @memberof ApproveBusinessRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ApproveBusinessRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ApproveBusinessRequest
     * @function getTypeUrl
     * @memberof ApproveBusinessRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ApproveBusinessRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ApproveBusinessRequest";
    };

    return ApproveBusinessRequest;
})();

$root.ApproveBusinessResponse = (function() {

    /**
     * Properties of an ApproveBusinessResponse.
     * @exports IApproveBusinessResponse
     * @interface IApproveBusinessResponse
     * @property {boolean|null} [okay] ApproveBusinessResponse okay
     * @property {IAdminBusinessProto|null} [updated] ApproveBusinessResponse updated
     */

    /**
     * Constructs a new ApproveBusinessResponse.
     * @exports ApproveBusinessResponse
     * @classdesc Represents an ApproveBusinessResponse.
     * @implements IApproveBusinessResponse
     * @constructor
     * @param {IApproveBusinessResponse=} [properties] Properties to set
     */
    function ApproveBusinessResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ApproveBusinessResponse okay.
     * @member {boolean} okay
     * @memberof ApproveBusinessResponse
     * @instance
     */
    ApproveBusinessResponse.prototype.okay = false;

    /**
     * ApproveBusinessResponse updated.
     * @member {IAdminBusinessProto|null|undefined} updated
     * @memberof ApproveBusinessResponse
     * @instance
     */
    ApproveBusinessResponse.prototype.updated = null;

    /**
     * Creates a new ApproveBusinessResponse instance using the specified properties.
     * @function create
     * @memberof ApproveBusinessResponse
     * @static
     * @param {IApproveBusinessResponse=} [properties] Properties to set
     * @returns {ApproveBusinessResponse} ApproveBusinessResponse instance
     */
    ApproveBusinessResponse.create = function create(properties) {
        return new ApproveBusinessResponse(properties);
    };

    /**
     * Encodes the specified ApproveBusinessResponse message. Does not implicitly {@link ApproveBusinessResponse.verify|verify} messages.
     * @function encode
     * @memberof ApproveBusinessResponse
     * @static
     * @param {IApproveBusinessResponse} message ApproveBusinessResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ApproveBusinessResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        if (message.updated != null && Object.hasOwnProperty.call(message, "updated"))
            $root.AdminBusinessProto.encode(message.updated, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ApproveBusinessResponse message, length delimited. Does not implicitly {@link ApproveBusinessResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ApproveBusinessResponse
     * @static
     * @param {IApproveBusinessResponse} message ApproveBusinessResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ApproveBusinessResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an ApproveBusinessResponse message from the specified reader or buffer.
     * @function decode
     * @memberof ApproveBusinessResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ApproveBusinessResponse} ApproveBusinessResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ApproveBusinessResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ApproveBusinessResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            case 2: {
                    message.updated = $root.AdminBusinessProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an ApproveBusinessResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ApproveBusinessResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ApproveBusinessResponse} ApproveBusinessResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ApproveBusinessResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an ApproveBusinessResponse message.
     * @function verify
     * @memberof ApproveBusinessResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ApproveBusinessResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        if (message.updated != null && message.hasOwnProperty("updated")) {
            var error = $root.AdminBusinessProto.verify(message.updated);
            if (error)
                return "updated." + error;
        }
        return null;
    };

    /**
     * Creates an ApproveBusinessResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ApproveBusinessResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ApproveBusinessResponse} ApproveBusinessResponse
     */
    ApproveBusinessResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.ApproveBusinessResponse)
            return object;
        var message = new $root.ApproveBusinessResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        if (object.updated != null) {
            if (typeof object.updated !== "object")
                throw TypeError(".ApproveBusinessResponse.updated: object expected");
            message.updated = $root.AdminBusinessProto.fromObject(object.updated);
        }
        return message;
    };

    /**
     * Creates a plain object from an ApproveBusinessResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ApproveBusinessResponse
     * @static
     * @param {ApproveBusinessResponse} message ApproveBusinessResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ApproveBusinessResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.okay = false;
            object.updated = null;
        }
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        if (message.updated != null && message.hasOwnProperty("updated"))
            object.updated = $root.AdminBusinessProto.toObject(message.updated, options);
        return object;
    };

    /**
     * Converts this ApproveBusinessResponse to JSON.
     * @function toJSON
     * @memberof ApproveBusinessResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ApproveBusinessResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ApproveBusinessResponse
     * @function getTypeUrl
     * @memberof ApproveBusinessResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ApproveBusinessResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ApproveBusinessResponse";
    };

    return ApproveBusinessResponse;
})();

$root.space = (function() {

    /**
     * Namespace space.
     * @exports space
     * @namespace
     */
    var space = {};

    space.kenko = (function() {

        /**
         * Namespace kenko.
         * @memberof space
         * @namespace
         */
        var kenko = {};

        kenko.proto = (function() {

            /**
             * Namespace proto.
             * @memberof space.kenko
             * @namespace
             */
            var proto = {};

            proto.LocalTimeProto = (function() {

                /**
                 * Properties of a LocalTimeProto.
                 * @memberof space.kenko.proto
                 * @interface ILocalTimeProto
                 * @property {number|null} [hour] LocalTimeProto hour
                 * @property {number|null} [minute] LocalTimeProto minute
                 */

                /**
                 * Constructs a new LocalTimeProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a LocalTimeProto.
                 * @implements ILocalTimeProto
                 * @constructor
                 * @param {space.kenko.proto.ILocalTimeProto=} [properties] Properties to set
                 */
                function LocalTimeProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * LocalTimeProto hour.
                 * @member {number} hour
                 * @memberof space.kenko.proto.LocalTimeProto
                 * @instance
                 */
                LocalTimeProto.prototype.hour = 0;

                /**
                 * LocalTimeProto minute.
                 * @member {number} minute
                 * @memberof space.kenko.proto.LocalTimeProto
                 * @instance
                 */
                LocalTimeProto.prototype.minute = 0;

                /**
                 * Creates a new LocalTimeProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.LocalTimeProto
                 * @static
                 * @param {space.kenko.proto.ILocalTimeProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.LocalTimeProto} LocalTimeProto instance
                 */
                LocalTimeProto.create = function create(properties) {
                    return new LocalTimeProto(properties);
                };

                /**
                 * Encodes the specified LocalTimeProto message. Does not implicitly {@link space.kenko.proto.LocalTimeProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.LocalTimeProto
                 * @static
                 * @param {space.kenko.proto.ILocalTimeProto} message LocalTimeProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LocalTimeProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.hour != null && Object.hasOwnProperty.call(message, "hour"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.hour);
                    if (message.minute != null && Object.hasOwnProperty.call(message, "minute"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.minute);
                    return writer;
                };

                /**
                 * Encodes the specified LocalTimeProto message, length delimited. Does not implicitly {@link space.kenko.proto.LocalTimeProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.LocalTimeProto
                 * @static
                 * @param {space.kenko.proto.ILocalTimeProto} message LocalTimeProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LocalTimeProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a LocalTimeProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.LocalTimeProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.LocalTimeProto} LocalTimeProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LocalTimeProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.LocalTimeProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.hour = reader.int32();
                                break;
                            }
                        case 2: {
                                message.minute = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a LocalTimeProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.LocalTimeProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.LocalTimeProto} LocalTimeProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LocalTimeProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a LocalTimeProto message.
                 * @function verify
                 * @memberof space.kenko.proto.LocalTimeProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                LocalTimeProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.hour != null && message.hasOwnProperty("hour"))
                        if (!$util.isInteger(message.hour))
                            return "hour: integer expected";
                    if (message.minute != null && message.hasOwnProperty("minute"))
                        if (!$util.isInteger(message.minute))
                            return "minute: integer expected";
                    return null;
                };

                /**
                 * Creates a LocalTimeProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.LocalTimeProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.LocalTimeProto} LocalTimeProto
                 */
                LocalTimeProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.LocalTimeProto)
                        return object;
                    var message = new $root.space.kenko.proto.LocalTimeProto();
                    if (object.hour != null)
                        message.hour = object.hour | 0;
                    if (object.minute != null)
                        message.minute = object.minute | 0;
                    return message;
                };

                /**
                 * Creates a plain object from a LocalTimeProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.LocalTimeProto
                 * @static
                 * @param {space.kenko.proto.LocalTimeProto} message LocalTimeProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                LocalTimeProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.hour = 0;
                        object.minute = 0;
                    }
                    if (message.hour != null && message.hasOwnProperty("hour"))
                        object.hour = message.hour;
                    if (message.minute != null && message.hasOwnProperty("minute"))
                        object.minute = message.minute;
                    return object;
                };

                /**
                 * Converts this LocalTimeProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.LocalTimeProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                LocalTimeProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for LocalTimeProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.LocalTimeProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                LocalTimeProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.LocalTimeProto";
                };

                return LocalTimeProto;
            })();

            proto.LocalDateProto = (function() {

                /**
                 * Properties of a LocalDateProto.
                 * @memberof space.kenko.proto
                 * @interface ILocalDateProto
                 * @property {number|null} [year] LocalDateProto year
                 * @property {number|null} [month] LocalDateProto month
                 * @property {number|null} [date] LocalDateProto date
                 */

                /**
                 * Constructs a new LocalDateProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a LocalDateProto.
                 * @implements ILocalDateProto
                 * @constructor
                 * @param {space.kenko.proto.ILocalDateProto=} [properties] Properties to set
                 */
                function LocalDateProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * LocalDateProto year.
                 * @member {number} year
                 * @memberof space.kenko.proto.LocalDateProto
                 * @instance
                 */
                LocalDateProto.prototype.year = 0;

                /**
                 * LocalDateProto month.
                 * @member {number} month
                 * @memberof space.kenko.proto.LocalDateProto
                 * @instance
                 */
                LocalDateProto.prototype.month = 0;

                /**
                 * LocalDateProto date.
                 * @member {number} date
                 * @memberof space.kenko.proto.LocalDateProto
                 * @instance
                 */
                LocalDateProto.prototype.date = 0;

                /**
                 * Creates a new LocalDateProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.LocalDateProto
                 * @static
                 * @param {space.kenko.proto.ILocalDateProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.LocalDateProto} LocalDateProto instance
                 */
                LocalDateProto.create = function create(properties) {
                    return new LocalDateProto(properties);
                };

                /**
                 * Encodes the specified LocalDateProto message. Does not implicitly {@link space.kenko.proto.LocalDateProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.LocalDateProto
                 * @static
                 * @param {space.kenko.proto.ILocalDateProto} message LocalDateProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LocalDateProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.year != null && Object.hasOwnProperty.call(message, "year"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.year);
                    if (message.month != null && Object.hasOwnProperty.call(message, "month"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.month);
                    if (message.date != null && Object.hasOwnProperty.call(message, "date"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.date);
                    return writer;
                };

                /**
                 * Encodes the specified LocalDateProto message, length delimited. Does not implicitly {@link space.kenko.proto.LocalDateProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.LocalDateProto
                 * @static
                 * @param {space.kenko.proto.ILocalDateProto} message LocalDateProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LocalDateProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a LocalDateProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.LocalDateProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.LocalDateProto} LocalDateProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LocalDateProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.LocalDateProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.year = reader.int32();
                                break;
                            }
                        case 2: {
                                message.month = reader.int32();
                                break;
                            }
                        case 3: {
                                message.date = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a LocalDateProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.LocalDateProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.LocalDateProto} LocalDateProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LocalDateProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a LocalDateProto message.
                 * @function verify
                 * @memberof space.kenko.proto.LocalDateProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                LocalDateProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.year != null && message.hasOwnProperty("year"))
                        if (!$util.isInteger(message.year))
                            return "year: integer expected";
                    if (message.month != null && message.hasOwnProperty("month"))
                        if (!$util.isInteger(message.month))
                            return "month: integer expected";
                    if (message.date != null && message.hasOwnProperty("date"))
                        if (!$util.isInteger(message.date))
                            return "date: integer expected";
                    return null;
                };

                /**
                 * Creates a LocalDateProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.LocalDateProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.LocalDateProto} LocalDateProto
                 */
                LocalDateProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.LocalDateProto)
                        return object;
                    var message = new $root.space.kenko.proto.LocalDateProto();
                    if (object.year != null)
                        message.year = object.year | 0;
                    if (object.month != null)
                        message.month = object.month | 0;
                    if (object.date != null)
                        message.date = object.date | 0;
                    return message;
                };

                /**
                 * Creates a plain object from a LocalDateProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.LocalDateProto
                 * @static
                 * @param {space.kenko.proto.LocalDateProto} message LocalDateProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                LocalDateProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.year = 0;
                        object.month = 0;
                        object.date = 0;
                    }
                    if (message.year != null && message.hasOwnProperty("year"))
                        object.year = message.year;
                    if (message.month != null && message.hasOwnProperty("month"))
                        object.month = message.month;
                    if (message.date != null && message.hasOwnProperty("date"))
                        object.date = message.date;
                    return object;
                };

                /**
                 * Converts this LocalDateProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.LocalDateProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                LocalDateProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for LocalDateProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.LocalDateProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                LocalDateProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.LocalDateProto";
                };

                return LocalDateProto;
            })();

            proto.PriceProto = (function() {

                /**
                 * Properties of a PriceProto.
                 * @memberof space.kenko.proto
                 * @interface IPriceProto
                 * @property {number|Long|null} [amount] PriceProto amount
                 * @property {string|null} [currencyCode] PriceProto currencyCode
                 */

                /**
                 * Constructs a new PriceProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a PriceProto.
                 * @implements IPriceProto
                 * @constructor
                 * @param {space.kenko.proto.IPriceProto=} [properties] Properties to set
                 */
                function PriceProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PriceProto amount.
                 * @member {number|Long} amount
                 * @memberof space.kenko.proto.PriceProto
                 * @instance
                 */
                PriceProto.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * PriceProto currencyCode.
                 * @member {string} currencyCode
                 * @memberof space.kenko.proto.PriceProto
                 * @instance
                 */
                PriceProto.prototype.currencyCode = "";

                /**
                 * Creates a new PriceProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.PriceProto
                 * @static
                 * @param {space.kenko.proto.IPriceProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.PriceProto} PriceProto instance
                 */
                PriceProto.create = function create(properties) {
                    return new PriceProto(properties);
                };

                /**
                 * Encodes the specified PriceProto message. Does not implicitly {@link space.kenko.proto.PriceProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.PriceProto
                 * @static
                 * @param {space.kenko.proto.IPriceProto} message PriceProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PriceProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.amount);
                    if (message.currencyCode != null && Object.hasOwnProperty.call(message, "currencyCode"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.currencyCode);
                    return writer;
                };

                /**
                 * Encodes the specified PriceProto message, length delimited. Does not implicitly {@link space.kenko.proto.PriceProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.PriceProto
                 * @static
                 * @param {space.kenko.proto.IPriceProto} message PriceProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PriceProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PriceProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.PriceProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.PriceProto} PriceProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PriceProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.PriceProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.amount = reader.int64();
                                break;
                            }
                        case 2: {
                                message.currencyCode = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PriceProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.PriceProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.PriceProto} PriceProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PriceProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PriceProto message.
                 * @function verify
                 * @memberof space.kenko.proto.PriceProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PriceProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.amount != null && message.hasOwnProperty("amount"))
                        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
                            return "amount: integer|Long expected";
                    if (message.currencyCode != null && message.hasOwnProperty("currencyCode"))
                        if (!$util.isString(message.currencyCode))
                            return "currencyCode: string expected";
                    return null;
                };

                /**
                 * Creates a PriceProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.PriceProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.PriceProto} PriceProto
                 */
                PriceProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.PriceProto)
                        return object;
                    var message = new $root.space.kenko.proto.PriceProto();
                    if (object.amount != null)
                        if ($util.Long)
                            (message.amount = $util.Long.fromValue(object.amount)).unsigned = false;
                        else if (typeof object.amount === "string")
                            message.amount = parseInt(object.amount, 10);
                        else if (typeof object.amount === "number")
                            message.amount = object.amount;
                        else if (typeof object.amount === "object")
                            message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber();
                    if (object.currencyCode != null)
                        message.currencyCode = String(object.currencyCode);
                    return message;
                };

                /**
                 * Creates a plain object from a PriceProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.PriceProto
                 * @static
                 * @param {space.kenko.proto.PriceProto} message PriceProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PriceProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.amount = options.longs === String ? "0" : 0;
                        object.currencyCode = "";
                    }
                    if (message.amount != null && message.hasOwnProperty("amount"))
                        if (typeof message.amount === "number")
                            object.amount = options.longs === String ? String(message.amount) : message.amount;
                        else
                            object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber() : message.amount;
                    if (message.currencyCode != null && message.hasOwnProperty("currencyCode"))
                        object.currencyCode = message.currencyCode;
                    return object;
                };

                /**
                 * Converts this PriceProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.PriceProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PriceProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for PriceProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.PriceProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                PriceProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.PriceProto";
                };

                return PriceProto;
            })();

            proto.ErrorProto = (function() {

                /**
                 * Properties of an ErrorProto.
                 * @memberof space.kenko.proto
                 * @interface IErrorProto
                 * @property {string|null} [path] ErrorProto path
                 * @property {string|null} [error] ErrorProto error
                 */

                /**
                 * Constructs a new ErrorProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents an ErrorProto.
                 * @implements IErrorProto
                 * @constructor
                 * @param {space.kenko.proto.IErrorProto=} [properties] Properties to set
                 */
                function ErrorProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ErrorProto path.
                 * @member {string} path
                 * @memberof space.kenko.proto.ErrorProto
                 * @instance
                 */
                ErrorProto.prototype.path = "";

                /**
                 * ErrorProto error.
                 * @member {string} error
                 * @memberof space.kenko.proto.ErrorProto
                 * @instance
                 */
                ErrorProto.prototype.error = "";

                /**
                 * Creates a new ErrorProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.ErrorProto
                 * @static
                 * @param {space.kenko.proto.IErrorProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.ErrorProto} ErrorProto instance
                 */
                ErrorProto.create = function create(properties) {
                    return new ErrorProto(properties);
                };

                /**
                 * Encodes the specified ErrorProto message. Does not implicitly {@link space.kenko.proto.ErrorProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.ErrorProto
                 * @static
                 * @param {space.kenko.proto.IErrorProto} message ErrorProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ErrorProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.path != null && Object.hasOwnProperty.call(message, "path"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.path);
                    if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.error);
                    return writer;
                };

                /**
                 * Encodes the specified ErrorProto message, length delimited. Does not implicitly {@link space.kenko.proto.ErrorProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.ErrorProto
                 * @static
                 * @param {space.kenko.proto.IErrorProto} message ErrorProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ErrorProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an ErrorProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.ErrorProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.ErrorProto} ErrorProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ErrorProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.ErrorProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.path = reader.string();
                                break;
                            }
                        case 2: {
                                message.error = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an ErrorProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.ErrorProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.ErrorProto} ErrorProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ErrorProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an ErrorProto message.
                 * @function verify
                 * @memberof space.kenko.proto.ErrorProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ErrorProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.path != null && message.hasOwnProperty("path"))
                        if (!$util.isString(message.path))
                            return "path: string expected";
                    if (message.error != null && message.hasOwnProperty("error"))
                        if (!$util.isString(message.error))
                            return "error: string expected";
                    return null;
                };

                /**
                 * Creates an ErrorProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.ErrorProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.ErrorProto} ErrorProto
                 */
                ErrorProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.ErrorProto)
                        return object;
                    var message = new $root.space.kenko.proto.ErrorProto();
                    if (object.path != null)
                        message.path = String(object.path);
                    if (object.error != null)
                        message.error = String(object.error);
                    return message;
                };

                /**
                 * Creates a plain object from an ErrorProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.ErrorProto
                 * @static
                 * @param {space.kenko.proto.ErrorProto} message ErrorProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ErrorProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.path = "";
                        object.error = "";
                    }
                    if (message.path != null && message.hasOwnProperty("path"))
                        object.path = message.path;
                    if (message.error != null && message.hasOwnProperty("error"))
                        object.error = message.error;
                    return object;
                };

                /**
                 * Converts this ErrorProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.ErrorProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ErrorProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ErrorProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.ErrorProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ErrorProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.ErrorProto";
                };

                return ErrorProto;
            })();

            proto.SystemNoteProto = (function() {

                /**
                 * Properties of a SystemNoteProto.
                 * @memberof space.kenko.proto
                 * @interface ISystemNoteProto
                 * @property {string|null} [note] SystemNoteProto note
                 * @property {number|Long|null} [timestamp] SystemNoteProto timestamp
                 * @property {space.kenko.proto.ILoginProto|null} [loggedInUser] SystemNoteProto loggedInUser
                 */

                /**
                 * Constructs a new SystemNoteProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a SystemNoteProto.
                 * @implements ISystemNoteProto
                 * @constructor
                 * @param {space.kenko.proto.ISystemNoteProto=} [properties] Properties to set
                 */
                function SystemNoteProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SystemNoteProto note.
                 * @member {string} note
                 * @memberof space.kenko.proto.SystemNoteProto
                 * @instance
                 */
                SystemNoteProto.prototype.note = "";

                /**
                 * SystemNoteProto timestamp.
                 * @member {number|Long} timestamp
                 * @memberof space.kenko.proto.SystemNoteProto
                 * @instance
                 */
                SystemNoteProto.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * SystemNoteProto loggedInUser.
                 * @member {space.kenko.proto.ILoginProto|null|undefined} loggedInUser
                 * @memberof space.kenko.proto.SystemNoteProto
                 * @instance
                 */
                SystemNoteProto.prototype.loggedInUser = null;

                /**
                 * Creates a new SystemNoteProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.SystemNoteProto
                 * @static
                 * @param {space.kenko.proto.ISystemNoteProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.SystemNoteProto} SystemNoteProto instance
                 */
                SystemNoteProto.create = function create(properties) {
                    return new SystemNoteProto(properties);
                };

                /**
                 * Encodes the specified SystemNoteProto message. Does not implicitly {@link space.kenko.proto.SystemNoteProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.SystemNoteProto
                 * @static
                 * @param {space.kenko.proto.ISystemNoteProto} message SystemNoteProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SystemNoteProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.note != null && Object.hasOwnProperty.call(message, "note"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.note);
                    if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int64(message.timestamp);
                    if (message.loggedInUser != null && Object.hasOwnProperty.call(message, "loggedInUser"))
                        $root.space.kenko.proto.LoginProto.encode(message.loggedInUser, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SystemNoteProto message, length delimited. Does not implicitly {@link space.kenko.proto.SystemNoteProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.SystemNoteProto
                 * @static
                 * @param {space.kenko.proto.ISystemNoteProto} message SystemNoteProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SystemNoteProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SystemNoteProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.SystemNoteProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.SystemNoteProto} SystemNoteProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SystemNoteProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.SystemNoteProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.note = reader.string();
                                break;
                            }
                        case 2: {
                                message.timestamp = reader.int64();
                                break;
                            }
                        case 3: {
                                message.loggedInUser = $root.space.kenko.proto.LoginProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SystemNoteProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.SystemNoteProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.SystemNoteProto} SystemNoteProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SystemNoteProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SystemNoteProto message.
                 * @function verify
                 * @memberof space.kenko.proto.SystemNoteProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SystemNoteProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.note != null && message.hasOwnProperty("note"))
                        if (!$util.isString(message.note))
                            return "note: string expected";
                    if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                        if (!$util.isInteger(message.timestamp) && !(message.timestamp && $util.isInteger(message.timestamp.low) && $util.isInteger(message.timestamp.high)))
                            return "timestamp: integer|Long expected";
                    if (message.loggedInUser != null && message.hasOwnProperty("loggedInUser")) {
                        var error = $root.space.kenko.proto.LoginProto.verify(message.loggedInUser);
                        if (error)
                            return "loggedInUser." + error;
                    }
                    return null;
                };

                /**
                 * Creates a SystemNoteProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.SystemNoteProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.SystemNoteProto} SystemNoteProto
                 */
                SystemNoteProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.SystemNoteProto)
                        return object;
                    var message = new $root.space.kenko.proto.SystemNoteProto();
                    if (object.note != null)
                        message.note = String(object.note);
                    if (object.timestamp != null)
                        if ($util.Long)
                            (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = false;
                        else if (typeof object.timestamp === "string")
                            message.timestamp = parseInt(object.timestamp, 10);
                        else if (typeof object.timestamp === "number")
                            message.timestamp = object.timestamp;
                        else if (typeof object.timestamp === "object")
                            message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber();
                    if (object.loggedInUser != null) {
                        if (typeof object.loggedInUser !== "object")
                            throw TypeError(".space.kenko.proto.SystemNoteProto.loggedInUser: object expected");
                        message.loggedInUser = $root.space.kenko.proto.LoginProto.fromObject(object.loggedInUser);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SystemNoteProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.SystemNoteProto
                 * @static
                 * @param {space.kenko.proto.SystemNoteProto} message SystemNoteProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SystemNoteProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.note = "";
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.timestamp = options.longs === String ? "0" : 0;
                        object.loggedInUser = null;
                    }
                    if (message.note != null && message.hasOwnProperty("note"))
                        object.note = message.note;
                    if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                        if (typeof message.timestamp === "number")
                            object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
                        else
                            object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber() : message.timestamp;
                    if (message.loggedInUser != null && message.hasOwnProperty("loggedInUser"))
                        object.loggedInUser = $root.space.kenko.proto.LoginProto.toObject(message.loggedInUser, options);
                    return object;
                };

                /**
                 * Converts this SystemNoteProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.SystemNoteProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SystemNoteProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for SystemNoteProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.SystemNoteProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                SystemNoteProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.SystemNoteProto";
                };

                return SystemNoteProto;
            })();

            proto.LoginProto = (function() {

                /**
                 * Properties of a LoginProto.
                 * @memberof space.kenko.proto
                 * @interface ILoginProto
                 * @property {string|null} [loginId] LoginProto loginId
                 * @property {string|null} [loginName] LoginProto loginName
                 * @property {string|null} [loginEmail] LoginProto loginEmail
                 */

                /**
                 * Constructs a new LoginProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a LoginProto.
                 * @implements ILoginProto
                 * @constructor
                 * @param {space.kenko.proto.ILoginProto=} [properties] Properties to set
                 */
                function LoginProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * LoginProto loginId.
                 * @member {string} loginId
                 * @memberof space.kenko.proto.LoginProto
                 * @instance
                 */
                LoginProto.prototype.loginId = "";

                /**
                 * LoginProto loginName.
                 * @member {string} loginName
                 * @memberof space.kenko.proto.LoginProto
                 * @instance
                 */
                LoginProto.prototype.loginName = "";

                /**
                 * LoginProto loginEmail.
                 * @member {string} loginEmail
                 * @memberof space.kenko.proto.LoginProto
                 * @instance
                 */
                LoginProto.prototype.loginEmail = "";

                /**
                 * Creates a new LoginProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.LoginProto
                 * @static
                 * @param {space.kenko.proto.ILoginProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.LoginProto} LoginProto instance
                 */
                LoginProto.create = function create(properties) {
                    return new LoginProto(properties);
                };

                /**
                 * Encodes the specified LoginProto message. Does not implicitly {@link space.kenko.proto.LoginProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.LoginProto
                 * @static
                 * @param {space.kenko.proto.ILoginProto} message LoginProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LoginProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.loginId != null && Object.hasOwnProperty.call(message, "loginId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.loginId);
                    if (message.loginName != null && Object.hasOwnProperty.call(message, "loginName"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.loginName);
                    if (message.loginEmail != null && Object.hasOwnProperty.call(message, "loginEmail"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.loginEmail);
                    return writer;
                };

                /**
                 * Encodes the specified LoginProto message, length delimited. Does not implicitly {@link space.kenko.proto.LoginProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.LoginProto
                 * @static
                 * @param {space.kenko.proto.ILoginProto} message LoginProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LoginProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a LoginProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.LoginProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.LoginProto} LoginProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LoginProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.LoginProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.loginId = reader.string();
                                break;
                            }
                        case 2: {
                                message.loginName = reader.string();
                                break;
                            }
                        case 3: {
                                message.loginEmail = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a LoginProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.LoginProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.LoginProto} LoginProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LoginProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a LoginProto message.
                 * @function verify
                 * @memberof space.kenko.proto.LoginProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                LoginProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.loginId != null && message.hasOwnProperty("loginId"))
                        if (!$util.isString(message.loginId))
                            return "loginId: string expected";
                    if (message.loginName != null && message.hasOwnProperty("loginName"))
                        if (!$util.isString(message.loginName))
                            return "loginName: string expected";
                    if (message.loginEmail != null && message.hasOwnProperty("loginEmail"))
                        if (!$util.isString(message.loginEmail))
                            return "loginEmail: string expected";
                    return null;
                };

                /**
                 * Creates a LoginProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.LoginProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.LoginProto} LoginProto
                 */
                LoginProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.LoginProto)
                        return object;
                    var message = new $root.space.kenko.proto.LoginProto();
                    if (object.loginId != null)
                        message.loginId = String(object.loginId);
                    if (object.loginName != null)
                        message.loginName = String(object.loginName);
                    if (object.loginEmail != null)
                        message.loginEmail = String(object.loginEmail);
                    return message;
                };

                /**
                 * Creates a plain object from a LoginProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.LoginProto
                 * @static
                 * @param {space.kenko.proto.LoginProto} message LoginProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                LoginProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.loginId = "";
                        object.loginName = "";
                        object.loginEmail = "";
                    }
                    if (message.loginId != null && message.hasOwnProperty("loginId"))
                        object.loginId = message.loginId;
                    if (message.loginName != null && message.hasOwnProperty("loginName"))
                        object.loginName = message.loginName;
                    if (message.loginEmail != null && message.hasOwnProperty("loginEmail"))
                        object.loginEmail = message.loginEmail;
                    return object;
                };

                /**
                 * Converts this LoginProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.LoginProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                LoginProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for LoginProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.LoginProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                LoginProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.LoginProto";
                };

                return LoginProto;
            })();

            proto.EmailProto = (function() {

                /**
                 * Properties of an EmailProto.
                 * @memberof space.kenko.proto
                 * @interface IEmailProto
                 * @property {string|null} [email] EmailProto email
                 * @property {boolean|null} [isVerified] EmailProto isVerified
                 */

                /**
                 * Constructs a new EmailProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents an EmailProto.
                 * @implements IEmailProto
                 * @constructor
                 * @param {space.kenko.proto.IEmailProto=} [properties] Properties to set
                 */
                function EmailProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * EmailProto email.
                 * @member {string} email
                 * @memberof space.kenko.proto.EmailProto
                 * @instance
                 */
                EmailProto.prototype.email = "";

                /**
                 * EmailProto isVerified.
                 * @member {boolean} isVerified
                 * @memberof space.kenko.proto.EmailProto
                 * @instance
                 */
                EmailProto.prototype.isVerified = false;

                /**
                 * Creates a new EmailProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.EmailProto
                 * @static
                 * @param {space.kenko.proto.IEmailProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.EmailProto} EmailProto instance
                 */
                EmailProto.create = function create(properties) {
                    return new EmailProto(properties);
                };

                /**
                 * Encodes the specified EmailProto message. Does not implicitly {@link space.kenko.proto.EmailProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.EmailProto
                 * @static
                 * @param {space.kenko.proto.IEmailProto} message EmailProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EmailProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
                    if (message.isVerified != null && Object.hasOwnProperty.call(message, "isVerified"))
                        writer.uint32(/* id 2, wireType 0 =*/16).bool(message.isVerified);
                    return writer;
                };

                /**
                 * Encodes the specified EmailProto message, length delimited. Does not implicitly {@link space.kenko.proto.EmailProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.EmailProto
                 * @static
                 * @param {space.kenko.proto.IEmailProto} message EmailProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EmailProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an EmailProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.EmailProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.EmailProto} EmailProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EmailProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.EmailProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.email = reader.string();
                                break;
                            }
                        case 2: {
                                message.isVerified = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an EmailProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.EmailProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.EmailProto} EmailProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EmailProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an EmailProto message.
                 * @function verify
                 * @memberof space.kenko.proto.EmailProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                EmailProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.email != null && message.hasOwnProperty("email"))
                        if (!$util.isString(message.email))
                            return "email: string expected";
                    if (message.isVerified != null && message.hasOwnProperty("isVerified"))
                        if (typeof message.isVerified !== "boolean")
                            return "isVerified: boolean expected";
                    return null;
                };

                /**
                 * Creates an EmailProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.EmailProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.EmailProto} EmailProto
                 */
                EmailProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.EmailProto)
                        return object;
                    var message = new $root.space.kenko.proto.EmailProto();
                    if (object.email != null)
                        message.email = String(object.email);
                    if (object.isVerified != null)
                        message.isVerified = Boolean(object.isVerified);
                    return message;
                };

                /**
                 * Creates a plain object from an EmailProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.EmailProto
                 * @static
                 * @param {space.kenko.proto.EmailProto} message EmailProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                EmailProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.email = "";
                        object.isVerified = false;
                    }
                    if (message.email != null && message.hasOwnProperty("email"))
                        object.email = message.email;
                    if (message.isVerified != null && message.hasOwnProperty("isVerified"))
                        object.isVerified = message.isVerified;
                    return object;
                };

                /**
                 * Converts this EmailProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.EmailProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                EmailProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for EmailProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.EmailProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                EmailProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.EmailProto";
                };

                return EmailProto;
            })();

            proto.PhoneProto = (function() {

                /**
                 * Properties of a PhoneProto.
                 * @memberof space.kenko.proto
                 * @interface IPhoneProto
                 * @property {string|null} [number] PhoneProto number
                 * @property {boolean|null} [isVerified] PhoneProto isVerified
                 */

                /**
                 * Constructs a new PhoneProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a PhoneProto.
                 * @implements IPhoneProto
                 * @constructor
                 * @param {space.kenko.proto.IPhoneProto=} [properties] Properties to set
                 */
                function PhoneProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PhoneProto number.
                 * @member {string} number
                 * @memberof space.kenko.proto.PhoneProto
                 * @instance
                 */
                PhoneProto.prototype.number = "";

                /**
                 * PhoneProto isVerified.
                 * @member {boolean} isVerified
                 * @memberof space.kenko.proto.PhoneProto
                 * @instance
                 */
                PhoneProto.prototype.isVerified = false;

                /**
                 * Creates a new PhoneProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.PhoneProto
                 * @static
                 * @param {space.kenko.proto.IPhoneProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.PhoneProto} PhoneProto instance
                 */
                PhoneProto.create = function create(properties) {
                    return new PhoneProto(properties);
                };

                /**
                 * Encodes the specified PhoneProto message. Does not implicitly {@link space.kenko.proto.PhoneProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.PhoneProto
                 * @static
                 * @param {space.kenko.proto.IPhoneProto} message PhoneProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PhoneProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.number != null && Object.hasOwnProperty.call(message, "number"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.number);
                    if (message.isVerified != null && Object.hasOwnProperty.call(message, "isVerified"))
                        writer.uint32(/* id 2, wireType 0 =*/16).bool(message.isVerified);
                    return writer;
                };

                /**
                 * Encodes the specified PhoneProto message, length delimited. Does not implicitly {@link space.kenko.proto.PhoneProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.PhoneProto
                 * @static
                 * @param {space.kenko.proto.IPhoneProto} message PhoneProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PhoneProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PhoneProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.PhoneProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.PhoneProto} PhoneProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PhoneProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.PhoneProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.number = reader.string();
                                break;
                            }
                        case 2: {
                                message.isVerified = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PhoneProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.PhoneProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.PhoneProto} PhoneProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PhoneProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PhoneProto message.
                 * @function verify
                 * @memberof space.kenko.proto.PhoneProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PhoneProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.number != null && message.hasOwnProperty("number"))
                        if (!$util.isString(message.number))
                            return "number: string expected";
                    if (message.isVerified != null && message.hasOwnProperty("isVerified"))
                        if (typeof message.isVerified !== "boolean")
                            return "isVerified: boolean expected";
                    return null;
                };

                /**
                 * Creates a PhoneProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.PhoneProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.PhoneProto} PhoneProto
                 */
                PhoneProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.PhoneProto)
                        return object;
                    var message = new $root.space.kenko.proto.PhoneProto();
                    if (object.number != null)
                        message.number = String(object.number);
                    if (object.isVerified != null)
                        message.isVerified = Boolean(object.isVerified);
                    return message;
                };

                /**
                 * Creates a plain object from a PhoneProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.PhoneProto
                 * @static
                 * @param {space.kenko.proto.PhoneProto} message PhoneProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PhoneProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.number = "";
                        object.isVerified = false;
                    }
                    if (message.number != null && message.hasOwnProperty("number"))
                        object.number = message.number;
                    if (message.isVerified != null && message.hasOwnProperty("isVerified"))
                        object.isVerified = message.isVerified;
                    return object;
                };

                /**
                 * Converts this PhoneProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.PhoneProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PhoneProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for PhoneProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.PhoneProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                PhoneProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.PhoneProto";
                };

                return PhoneProto;
            })();

            proto.KensuExceptionProto = (function() {

                /**
                 * Properties of a KensuExceptionProto.
                 * @memberof space.kenko.proto
                 * @interface IKensuExceptionProto
                 * @property {string|null} [message] KensuExceptionProto message
                 * @property {Array.<space.kenko.proto.IErrorProto>|null} [fieldErrors] KensuExceptionProto fieldErrors
                 */

                /**
                 * Constructs a new KensuExceptionProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a KensuExceptionProto.
                 * @implements IKensuExceptionProto
                 * @constructor
                 * @param {space.kenko.proto.IKensuExceptionProto=} [properties] Properties to set
                 */
                function KensuExceptionProto(properties) {
                    this.fieldErrors = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * KensuExceptionProto message.
                 * @member {string} message
                 * @memberof space.kenko.proto.KensuExceptionProto
                 * @instance
                 */
                KensuExceptionProto.prototype.message = "";

                /**
                 * KensuExceptionProto fieldErrors.
                 * @member {Array.<space.kenko.proto.IErrorProto>} fieldErrors
                 * @memberof space.kenko.proto.KensuExceptionProto
                 * @instance
                 */
                KensuExceptionProto.prototype.fieldErrors = $util.emptyArray;

                /**
                 * Creates a new KensuExceptionProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.KensuExceptionProto
                 * @static
                 * @param {space.kenko.proto.IKensuExceptionProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.KensuExceptionProto} KensuExceptionProto instance
                 */
                KensuExceptionProto.create = function create(properties) {
                    return new KensuExceptionProto(properties);
                };

                /**
                 * Encodes the specified KensuExceptionProto message. Does not implicitly {@link space.kenko.proto.KensuExceptionProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.KensuExceptionProto
                 * @static
                 * @param {space.kenko.proto.IKensuExceptionProto} message KensuExceptionProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                KensuExceptionProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.message);
                    if (message.fieldErrors != null && message.fieldErrors.length)
                        for (var i = 0; i < message.fieldErrors.length; ++i)
                            $root.space.kenko.proto.ErrorProto.encode(message.fieldErrors[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified KensuExceptionProto message, length delimited. Does not implicitly {@link space.kenko.proto.KensuExceptionProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.KensuExceptionProto
                 * @static
                 * @param {space.kenko.proto.IKensuExceptionProto} message KensuExceptionProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                KensuExceptionProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a KensuExceptionProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.KensuExceptionProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.KensuExceptionProto} KensuExceptionProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                KensuExceptionProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.KensuExceptionProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.message = reader.string();
                                break;
                            }
                        case 2: {
                                if (!(message.fieldErrors && message.fieldErrors.length))
                                    message.fieldErrors = [];
                                message.fieldErrors.push($root.space.kenko.proto.ErrorProto.decode(reader, reader.uint32()));
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a KensuExceptionProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.KensuExceptionProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.KensuExceptionProto} KensuExceptionProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                KensuExceptionProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a KensuExceptionProto message.
                 * @function verify
                 * @memberof space.kenko.proto.KensuExceptionProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                KensuExceptionProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.message != null && message.hasOwnProperty("message"))
                        if (!$util.isString(message.message))
                            return "message: string expected";
                    if (message.fieldErrors != null && message.hasOwnProperty("fieldErrors")) {
                        if (!Array.isArray(message.fieldErrors))
                            return "fieldErrors: array expected";
                        for (var i = 0; i < message.fieldErrors.length; ++i) {
                            var error = $root.space.kenko.proto.ErrorProto.verify(message.fieldErrors[i]);
                            if (error)
                                return "fieldErrors." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a KensuExceptionProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.KensuExceptionProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.KensuExceptionProto} KensuExceptionProto
                 */
                KensuExceptionProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.KensuExceptionProto)
                        return object;
                    var message = new $root.space.kenko.proto.KensuExceptionProto();
                    if (object.message != null)
                        message.message = String(object.message);
                    if (object.fieldErrors) {
                        if (!Array.isArray(object.fieldErrors))
                            throw TypeError(".space.kenko.proto.KensuExceptionProto.fieldErrors: array expected");
                        message.fieldErrors = [];
                        for (var i = 0; i < object.fieldErrors.length; ++i) {
                            if (typeof object.fieldErrors[i] !== "object")
                                throw TypeError(".space.kenko.proto.KensuExceptionProto.fieldErrors: object expected");
                            message.fieldErrors[i] = $root.space.kenko.proto.ErrorProto.fromObject(object.fieldErrors[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a KensuExceptionProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.KensuExceptionProto
                 * @static
                 * @param {space.kenko.proto.KensuExceptionProto} message KensuExceptionProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                KensuExceptionProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.fieldErrors = [];
                    if (options.defaults)
                        object.message = "";
                    if (message.message != null && message.hasOwnProperty("message"))
                        object.message = message.message;
                    if (message.fieldErrors && message.fieldErrors.length) {
                        object.fieldErrors = [];
                        for (var j = 0; j < message.fieldErrors.length; ++j)
                            object.fieldErrors[j] = $root.space.kenko.proto.ErrorProto.toObject(message.fieldErrors[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this KensuExceptionProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.KensuExceptionProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                KensuExceptionProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for KensuExceptionProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.KensuExceptionProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                KensuExceptionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.KensuExceptionProto";
                };

                return KensuExceptionProto;
            })();

            /**
             * ContactMethodType enum.
             * @name space.kenko.proto.ContactMethodType
             * @enum {number}
             * @property {number} UNKNOWN=0 UNKNOWN value
             * @property {number} EMAIL=1 EMAIL value
             * @property {number} MOBILE_PHONE=2 MOBILE_PHONE value
             */
            proto.ContactMethodType = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "UNKNOWN"] = 0;
                values[valuesById[1] = "EMAIL"] = 1;
                values[valuesById[2] = "MOBILE_PHONE"] = 2;
                return values;
            })();

            proto.ContactMethodProto = (function() {

                /**
                 * Properties of a ContactMethodProto.
                 * @memberof space.kenko.proto
                 * @interface IContactMethodProto
                 * @property {space.kenko.proto.ContactMethodType|null} [type] ContactMethodProto type
                 * @property {string|null} [address] ContactMethodProto address
                 */

                /**
                 * Constructs a new ContactMethodProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a ContactMethodProto.
                 * @implements IContactMethodProto
                 * @constructor
                 * @param {space.kenko.proto.IContactMethodProto=} [properties] Properties to set
                 */
                function ContactMethodProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ContactMethodProto type.
                 * @member {space.kenko.proto.ContactMethodType} type
                 * @memberof space.kenko.proto.ContactMethodProto
                 * @instance
                 */
                ContactMethodProto.prototype.type = 0;

                /**
                 * ContactMethodProto address.
                 * @member {string} address
                 * @memberof space.kenko.proto.ContactMethodProto
                 * @instance
                 */
                ContactMethodProto.prototype.address = "";

                /**
                 * Creates a new ContactMethodProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.ContactMethodProto
                 * @static
                 * @param {space.kenko.proto.IContactMethodProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.ContactMethodProto} ContactMethodProto instance
                 */
                ContactMethodProto.create = function create(properties) {
                    return new ContactMethodProto(properties);
                };

                /**
                 * Encodes the specified ContactMethodProto message. Does not implicitly {@link space.kenko.proto.ContactMethodProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.ContactMethodProto
                 * @static
                 * @param {space.kenko.proto.IContactMethodProto} message ContactMethodProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ContactMethodProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
                    if (message.address != null && Object.hasOwnProperty.call(message, "address"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.address);
                    return writer;
                };

                /**
                 * Encodes the specified ContactMethodProto message, length delimited. Does not implicitly {@link space.kenko.proto.ContactMethodProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.ContactMethodProto
                 * @static
                 * @param {space.kenko.proto.IContactMethodProto} message ContactMethodProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ContactMethodProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ContactMethodProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.ContactMethodProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.ContactMethodProto} ContactMethodProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ContactMethodProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.ContactMethodProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.type = reader.int32();
                                break;
                            }
                        case 2: {
                                message.address = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ContactMethodProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.ContactMethodProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.ContactMethodProto} ContactMethodProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ContactMethodProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ContactMethodProto message.
                 * @function verify
                 * @memberof space.kenko.proto.ContactMethodProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ContactMethodProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.type != null && message.hasOwnProperty("type"))
                        switch (message.type) {
                        default:
                            return "type: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.address != null && message.hasOwnProperty("address"))
                        if (!$util.isString(message.address))
                            return "address: string expected";
                    return null;
                };

                /**
                 * Creates a ContactMethodProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.ContactMethodProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.ContactMethodProto} ContactMethodProto
                 */
                ContactMethodProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.ContactMethodProto)
                        return object;
                    var message = new $root.space.kenko.proto.ContactMethodProto();
                    switch (object.type) {
                    default:
                        if (typeof object.type === "number") {
                            message.type = object.type;
                            break;
                        }
                        break;
                    case "UNKNOWN":
                    case 0:
                        message.type = 0;
                        break;
                    case "EMAIL":
                    case 1:
                        message.type = 1;
                        break;
                    case "MOBILE_PHONE":
                    case 2:
                        message.type = 2;
                        break;
                    }
                    if (object.address != null)
                        message.address = String(object.address);
                    return message;
                };

                /**
                 * Creates a plain object from a ContactMethodProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.ContactMethodProto
                 * @static
                 * @param {space.kenko.proto.ContactMethodProto} message ContactMethodProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ContactMethodProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.type = options.enums === String ? "UNKNOWN" : 0;
                        object.address = "";
                    }
                    if (message.type != null && message.hasOwnProperty("type"))
                        object.type = options.enums === String ? $root.space.kenko.proto.ContactMethodType[message.type] === undefined ? message.type : $root.space.kenko.proto.ContactMethodType[message.type] : message.type;
                    if (message.address != null && message.hasOwnProperty("address"))
                        object.address = message.address;
                    return object;
                };

                /**
                 * Converts this ContactMethodProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.ContactMethodProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ContactMethodProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ContactMethodProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.ContactMethodProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ContactMethodProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.ContactMethodProto";
                };

                return ContactMethodProto;
            })();

            proto.VerifiedContactMethodProto = (function() {

                /**
                 * Properties of a VerifiedContactMethodProto.
                 * @memberof space.kenko.proto
                 * @interface IVerifiedContactMethodProto
                 * @property {space.kenko.proto.IContactMethodProto|null} [contactMethod] VerifiedContactMethodProto contactMethod
                 * @property {number|Long|null} [verificationTimeMs] VerifiedContactMethodProto verificationTimeMs
                 */

                /**
                 * Constructs a new VerifiedContactMethodProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a VerifiedContactMethodProto.
                 * @implements IVerifiedContactMethodProto
                 * @constructor
                 * @param {space.kenko.proto.IVerifiedContactMethodProto=} [properties] Properties to set
                 */
                function VerifiedContactMethodProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * VerifiedContactMethodProto contactMethod.
                 * @member {space.kenko.proto.IContactMethodProto|null|undefined} contactMethod
                 * @memberof space.kenko.proto.VerifiedContactMethodProto
                 * @instance
                 */
                VerifiedContactMethodProto.prototype.contactMethod = null;

                /**
                 * VerifiedContactMethodProto verificationTimeMs.
                 * @member {number|Long} verificationTimeMs
                 * @memberof space.kenko.proto.VerifiedContactMethodProto
                 * @instance
                 */
                VerifiedContactMethodProto.prototype.verificationTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Creates a new VerifiedContactMethodProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.VerifiedContactMethodProto
                 * @static
                 * @param {space.kenko.proto.IVerifiedContactMethodProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.VerifiedContactMethodProto} VerifiedContactMethodProto instance
                 */
                VerifiedContactMethodProto.create = function create(properties) {
                    return new VerifiedContactMethodProto(properties);
                };

                /**
                 * Encodes the specified VerifiedContactMethodProto message. Does not implicitly {@link space.kenko.proto.VerifiedContactMethodProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.VerifiedContactMethodProto
                 * @static
                 * @param {space.kenko.proto.IVerifiedContactMethodProto} message VerifiedContactMethodProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                VerifiedContactMethodProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.contactMethod != null && Object.hasOwnProperty.call(message, "contactMethod"))
                        $root.space.kenko.proto.ContactMethodProto.encode(message.contactMethod, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.verificationTimeMs != null && Object.hasOwnProperty.call(message, "verificationTimeMs"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int64(message.verificationTimeMs);
                    return writer;
                };

                /**
                 * Encodes the specified VerifiedContactMethodProto message, length delimited. Does not implicitly {@link space.kenko.proto.VerifiedContactMethodProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.VerifiedContactMethodProto
                 * @static
                 * @param {space.kenko.proto.IVerifiedContactMethodProto} message VerifiedContactMethodProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                VerifiedContactMethodProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a VerifiedContactMethodProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.VerifiedContactMethodProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.VerifiedContactMethodProto} VerifiedContactMethodProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                VerifiedContactMethodProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.VerifiedContactMethodProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.contactMethod = $root.space.kenko.proto.ContactMethodProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.verificationTimeMs = reader.int64();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a VerifiedContactMethodProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.VerifiedContactMethodProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.VerifiedContactMethodProto} VerifiedContactMethodProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                VerifiedContactMethodProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a VerifiedContactMethodProto message.
                 * @function verify
                 * @memberof space.kenko.proto.VerifiedContactMethodProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                VerifiedContactMethodProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.contactMethod != null && message.hasOwnProperty("contactMethod")) {
                        var error = $root.space.kenko.proto.ContactMethodProto.verify(message.contactMethod);
                        if (error)
                            return "contactMethod." + error;
                    }
                    if (message.verificationTimeMs != null && message.hasOwnProperty("verificationTimeMs"))
                        if (!$util.isInteger(message.verificationTimeMs) && !(message.verificationTimeMs && $util.isInteger(message.verificationTimeMs.low) && $util.isInteger(message.verificationTimeMs.high)))
                            return "verificationTimeMs: integer|Long expected";
                    return null;
                };

                /**
                 * Creates a VerifiedContactMethodProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.VerifiedContactMethodProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.VerifiedContactMethodProto} VerifiedContactMethodProto
                 */
                VerifiedContactMethodProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.VerifiedContactMethodProto)
                        return object;
                    var message = new $root.space.kenko.proto.VerifiedContactMethodProto();
                    if (object.contactMethod != null) {
                        if (typeof object.contactMethod !== "object")
                            throw TypeError(".space.kenko.proto.VerifiedContactMethodProto.contactMethod: object expected");
                        message.contactMethod = $root.space.kenko.proto.ContactMethodProto.fromObject(object.contactMethod);
                    }
                    if (object.verificationTimeMs != null)
                        if ($util.Long)
                            (message.verificationTimeMs = $util.Long.fromValue(object.verificationTimeMs)).unsigned = false;
                        else if (typeof object.verificationTimeMs === "string")
                            message.verificationTimeMs = parseInt(object.verificationTimeMs, 10);
                        else if (typeof object.verificationTimeMs === "number")
                            message.verificationTimeMs = object.verificationTimeMs;
                        else if (typeof object.verificationTimeMs === "object")
                            message.verificationTimeMs = new $util.LongBits(object.verificationTimeMs.low >>> 0, object.verificationTimeMs.high >>> 0).toNumber();
                    return message;
                };

                /**
                 * Creates a plain object from a VerifiedContactMethodProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.VerifiedContactMethodProto
                 * @static
                 * @param {space.kenko.proto.VerifiedContactMethodProto} message VerifiedContactMethodProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                VerifiedContactMethodProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.contactMethod = null;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.verificationTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.verificationTimeMs = options.longs === String ? "0" : 0;
                    }
                    if (message.contactMethod != null && message.hasOwnProperty("contactMethod"))
                        object.contactMethod = $root.space.kenko.proto.ContactMethodProto.toObject(message.contactMethod, options);
                    if (message.verificationTimeMs != null && message.hasOwnProperty("verificationTimeMs"))
                        if (typeof message.verificationTimeMs === "number")
                            object.verificationTimeMs = options.longs === String ? String(message.verificationTimeMs) : message.verificationTimeMs;
                        else
                            object.verificationTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.verificationTimeMs) : options.longs === Number ? new $util.LongBits(message.verificationTimeMs.low >>> 0, message.verificationTimeMs.high >>> 0).toNumber() : message.verificationTimeMs;
                    return object;
                };

                /**
                 * Converts this VerifiedContactMethodProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.VerifiedContactMethodProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                VerifiedContactMethodProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for VerifiedContactMethodProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.VerifiedContactMethodProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                VerifiedContactMethodProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.VerifiedContactMethodProto";
                };

                return VerifiedContactMethodProto;
            })();

            proto.VerifiedContactMethodsProto = (function() {

                /**
                 * Properties of a VerifiedContactMethodsProto.
                 * @memberof space.kenko.proto
                 * @interface IVerifiedContactMethodsProto
                 * @property {Array.<space.kenko.proto.IVerifiedContactMethodProto>|null} [contactMethods] VerifiedContactMethodsProto contactMethods
                 */

                /**
                 * Constructs a new VerifiedContactMethodsProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a VerifiedContactMethodsProto.
                 * @implements IVerifiedContactMethodsProto
                 * @constructor
                 * @param {space.kenko.proto.IVerifiedContactMethodsProto=} [properties] Properties to set
                 */
                function VerifiedContactMethodsProto(properties) {
                    this.contactMethods = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * VerifiedContactMethodsProto contactMethods.
                 * @member {Array.<space.kenko.proto.IVerifiedContactMethodProto>} contactMethods
                 * @memberof space.kenko.proto.VerifiedContactMethodsProto
                 * @instance
                 */
                VerifiedContactMethodsProto.prototype.contactMethods = $util.emptyArray;

                /**
                 * Creates a new VerifiedContactMethodsProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.VerifiedContactMethodsProto
                 * @static
                 * @param {space.kenko.proto.IVerifiedContactMethodsProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.VerifiedContactMethodsProto} VerifiedContactMethodsProto instance
                 */
                VerifiedContactMethodsProto.create = function create(properties) {
                    return new VerifiedContactMethodsProto(properties);
                };

                /**
                 * Encodes the specified VerifiedContactMethodsProto message. Does not implicitly {@link space.kenko.proto.VerifiedContactMethodsProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.VerifiedContactMethodsProto
                 * @static
                 * @param {space.kenko.proto.IVerifiedContactMethodsProto} message VerifiedContactMethodsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                VerifiedContactMethodsProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.contactMethods != null && message.contactMethods.length)
                        for (var i = 0; i < message.contactMethods.length; ++i)
                            $root.space.kenko.proto.VerifiedContactMethodProto.encode(message.contactMethods[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified VerifiedContactMethodsProto message, length delimited. Does not implicitly {@link space.kenko.proto.VerifiedContactMethodsProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.VerifiedContactMethodsProto
                 * @static
                 * @param {space.kenko.proto.IVerifiedContactMethodsProto} message VerifiedContactMethodsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                VerifiedContactMethodsProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a VerifiedContactMethodsProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.VerifiedContactMethodsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.VerifiedContactMethodsProto} VerifiedContactMethodsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                VerifiedContactMethodsProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.VerifiedContactMethodsProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                if (!(message.contactMethods && message.contactMethods.length))
                                    message.contactMethods = [];
                                message.contactMethods.push($root.space.kenko.proto.VerifiedContactMethodProto.decode(reader, reader.uint32()));
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a VerifiedContactMethodsProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.VerifiedContactMethodsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.VerifiedContactMethodsProto} VerifiedContactMethodsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                VerifiedContactMethodsProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a VerifiedContactMethodsProto message.
                 * @function verify
                 * @memberof space.kenko.proto.VerifiedContactMethodsProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                VerifiedContactMethodsProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.contactMethods != null && message.hasOwnProperty("contactMethods")) {
                        if (!Array.isArray(message.contactMethods))
                            return "contactMethods: array expected";
                        for (var i = 0; i < message.contactMethods.length; ++i) {
                            var error = $root.space.kenko.proto.VerifiedContactMethodProto.verify(message.contactMethods[i]);
                            if (error)
                                return "contactMethods." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a VerifiedContactMethodsProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.VerifiedContactMethodsProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.VerifiedContactMethodsProto} VerifiedContactMethodsProto
                 */
                VerifiedContactMethodsProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.VerifiedContactMethodsProto)
                        return object;
                    var message = new $root.space.kenko.proto.VerifiedContactMethodsProto();
                    if (object.contactMethods) {
                        if (!Array.isArray(object.contactMethods))
                            throw TypeError(".space.kenko.proto.VerifiedContactMethodsProto.contactMethods: array expected");
                        message.contactMethods = [];
                        for (var i = 0; i < object.contactMethods.length; ++i) {
                            if (typeof object.contactMethods[i] !== "object")
                                throw TypeError(".space.kenko.proto.VerifiedContactMethodsProto.contactMethods: object expected");
                            message.contactMethods[i] = $root.space.kenko.proto.VerifiedContactMethodProto.fromObject(object.contactMethods[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a VerifiedContactMethodsProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.VerifiedContactMethodsProto
                 * @static
                 * @param {space.kenko.proto.VerifiedContactMethodsProto} message VerifiedContactMethodsProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                VerifiedContactMethodsProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.contactMethods = [];
                    if (message.contactMethods && message.contactMethods.length) {
                        object.contactMethods = [];
                        for (var j = 0; j < message.contactMethods.length; ++j)
                            object.contactMethods[j] = $root.space.kenko.proto.VerifiedContactMethodProto.toObject(message.contactMethods[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this VerifiedContactMethodsProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.VerifiedContactMethodsProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                VerifiedContactMethodsProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for VerifiedContactMethodsProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.VerifiedContactMethodsProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                VerifiedContactMethodsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.VerifiedContactMethodsProto";
                };

                return VerifiedContactMethodsProto;
            })();

            proto.BusinessProfileProto = (function() {

                /**
                 * Properties of a BusinessProfileProto.
                 * @memberof space.kenko.proto
                 * @interface IBusinessProfileProto
                 * @property {string|null} [businessName] BusinessProfileProto businessName
                 * @property {string|null} [businessDescription] BusinessProfileProto businessDescription
                 * @property {string|null} [websiteUrl] BusinessProfileProto websiteUrl
                 * @property {string|null} [phoneNumber] BusinessProfileProto phoneNumber
                 * @property {string|null} [email] BusinessProfileProto email
                 * @property {string|null} [imageUrl] BusinessProfileProto imageUrl
                 * @property {Array.<string>|null} [servicesOffered] BusinessProfileProto servicesOffered
                 */

                /**
                 * Constructs a new BusinessProfileProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a BusinessProfileProto.
                 * @implements IBusinessProfileProto
                 * @constructor
                 * @param {space.kenko.proto.IBusinessProfileProto=} [properties] Properties to set
                 */
                function BusinessProfileProto(properties) {
                    this.servicesOffered = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * BusinessProfileProto businessName.
                 * @member {string} businessName
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @instance
                 */
                BusinessProfileProto.prototype.businessName = "";

                /**
                 * BusinessProfileProto businessDescription.
                 * @member {string} businessDescription
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @instance
                 */
                BusinessProfileProto.prototype.businessDescription = "";

                /**
                 * BusinessProfileProto websiteUrl.
                 * @member {string} websiteUrl
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @instance
                 */
                BusinessProfileProto.prototype.websiteUrl = "";

                /**
                 * BusinessProfileProto phoneNumber.
                 * @member {string} phoneNumber
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @instance
                 */
                BusinessProfileProto.prototype.phoneNumber = "";

                /**
                 * BusinessProfileProto email.
                 * @member {string} email
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @instance
                 */
                BusinessProfileProto.prototype.email = "";

                /**
                 * BusinessProfileProto imageUrl.
                 * @member {string} imageUrl
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @instance
                 */
                BusinessProfileProto.prototype.imageUrl = "";

                /**
                 * BusinessProfileProto servicesOffered.
                 * @member {Array.<string>} servicesOffered
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @instance
                 */
                BusinessProfileProto.prototype.servicesOffered = $util.emptyArray;

                /**
                 * Creates a new BusinessProfileProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @static
                 * @param {space.kenko.proto.IBusinessProfileProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.BusinessProfileProto} BusinessProfileProto instance
                 */
                BusinessProfileProto.create = function create(properties) {
                    return new BusinessProfileProto(properties);
                };

                /**
                 * Encodes the specified BusinessProfileProto message. Does not implicitly {@link space.kenko.proto.BusinessProfileProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @static
                 * @param {space.kenko.proto.IBusinessProfileProto} message BusinessProfileProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BusinessProfileProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.businessName != null && Object.hasOwnProperty.call(message, "businessName"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessName);
                    if (message.businessDescription != null && Object.hasOwnProperty.call(message, "businessDescription"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.businessDescription);
                    if (message.websiteUrl != null && Object.hasOwnProperty.call(message, "websiteUrl"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.websiteUrl);
                    if (message.phoneNumber != null && Object.hasOwnProperty.call(message, "phoneNumber"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.phoneNumber);
                    if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.email);
                    if (message.imageUrl != null && Object.hasOwnProperty.call(message, "imageUrl"))
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.imageUrl);
                    if (message.servicesOffered != null && message.servicesOffered.length)
                        for (var i = 0; i < message.servicesOffered.length; ++i)
                            writer.uint32(/* id 9, wireType 2 =*/74).string(message.servicesOffered[i]);
                    return writer;
                };

                /**
                 * Encodes the specified BusinessProfileProto message, length delimited. Does not implicitly {@link space.kenko.proto.BusinessProfileProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @static
                 * @param {space.kenko.proto.IBusinessProfileProto} message BusinessProfileProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BusinessProfileProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a BusinessProfileProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.BusinessProfileProto} BusinessProfileProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BusinessProfileProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.BusinessProfileProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.businessName = reader.string();
                                break;
                            }
                        case 2: {
                                message.businessDescription = reader.string();
                                break;
                            }
                        case 3: {
                                message.websiteUrl = reader.string();
                                break;
                            }
                        case 4: {
                                message.phoneNumber = reader.string();
                                break;
                            }
                        case 5: {
                                message.email = reader.string();
                                break;
                            }
                        case 6: {
                                message.imageUrl = reader.string();
                                break;
                            }
                        case 9: {
                                if (!(message.servicesOffered && message.servicesOffered.length))
                                    message.servicesOffered = [];
                                message.servicesOffered.push(reader.string());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a BusinessProfileProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.BusinessProfileProto} BusinessProfileProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BusinessProfileProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a BusinessProfileProto message.
                 * @function verify
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BusinessProfileProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.businessName != null && message.hasOwnProperty("businessName"))
                        if (!$util.isString(message.businessName))
                            return "businessName: string expected";
                    if (message.businessDescription != null && message.hasOwnProperty("businessDescription"))
                        if (!$util.isString(message.businessDescription))
                            return "businessDescription: string expected";
                    if (message.websiteUrl != null && message.hasOwnProperty("websiteUrl"))
                        if (!$util.isString(message.websiteUrl))
                            return "websiteUrl: string expected";
                    if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                        if (!$util.isString(message.phoneNumber))
                            return "phoneNumber: string expected";
                    if (message.email != null && message.hasOwnProperty("email"))
                        if (!$util.isString(message.email))
                            return "email: string expected";
                    if (message.imageUrl != null && message.hasOwnProperty("imageUrl"))
                        if (!$util.isString(message.imageUrl))
                            return "imageUrl: string expected";
                    if (message.servicesOffered != null && message.hasOwnProperty("servicesOffered")) {
                        if (!Array.isArray(message.servicesOffered))
                            return "servicesOffered: array expected";
                        for (var i = 0; i < message.servicesOffered.length; ++i)
                            if (!$util.isString(message.servicesOffered[i]))
                                return "servicesOffered: string[] expected";
                    }
                    return null;
                };

                /**
                 * Creates a BusinessProfileProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.BusinessProfileProto} BusinessProfileProto
                 */
                BusinessProfileProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.BusinessProfileProto)
                        return object;
                    var message = new $root.space.kenko.proto.BusinessProfileProto();
                    if (object.businessName != null)
                        message.businessName = String(object.businessName);
                    if (object.businessDescription != null)
                        message.businessDescription = String(object.businessDescription);
                    if (object.websiteUrl != null)
                        message.websiteUrl = String(object.websiteUrl);
                    if (object.phoneNumber != null)
                        message.phoneNumber = String(object.phoneNumber);
                    if (object.email != null)
                        message.email = String(object.email);
                    if (object.imageUrl != null)
                        message.imageUrl = String(object.imageUrl);
                    if (object.servicesOffered) {
                        if (!Array.isArray(object.servicesOffered))
                            throw TypeError(".space.kenko.proto.BusinessProfileProto.servicesOffered: array expected");
                        message.servicesOffered = [];
                        for (var i = 0; i < object.servicesOffered.length; ++i)
                            message.servicesOffered[i] = String(object.servicesOffered[i]);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a BusinessProfileProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @static
                 * @param {space.kenko.proto.BusinessProfileProto} message BusinessProfileProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BusinessProfileProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.servicesOffered = [];
                    if (options.defaults) {
                        object.businessName = "";
                        object.businessDescription = "";
                        object.websiteUrl = "";
                        object.phoneNumber = "";
                        object.email = "";
                        object.imageUrl = "";
                    }
                    if (message.businessName != null && message.hasOwnProperty("businessName"))
                        object.businessName = message.businessName;
                    if (message.businessDescription != null && message.hasOwnProperty("businessDescription"))
                        object.businessDescription = message.businessDescription;
                    if (message.websiteUrl != null && message.hasOwnProperty("websiteUrl"))
                        object.websiteUrl = message.websiteUrl;
                    if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                        object.phoneNumber = message.phoneNumber;
                    if (message.email != null && message.hasOwnProperty("email"))
                        object.email = message.email;
                    if (message.imageUrl != null && message.hasOwnProperty("imageUrl"))
                        object.imageUrl = message.imageUrl;
                    if (message.servicesOffered && message.servicesOffered.length) {
                        object.servicesOffered = [];
                        for (var j = 0; j < message.servicesOffered.length; ++j)
                            object.servicesOffered[j] = message.servicesOffered[j];
                    }
                    return object;
                };

                /**
                 * Converts this BusinessProfileProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BusinessProfileProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for BusinessProfileProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                BusinessProfileProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.BusinessProfileProto";
                };

                return BusinessProfileProto;
            })();

            proto.VirtualAppointmentInfo = (function() {

                /**
                 * Properties of a VirtualAppointmentInfo.
                 * @memberof space.kenko.proto
                 * @interface IVirtualAppointmentInfo
                 * @property {boolean|null} [acceptsVirtualAppointments] VirtualAppointmentInfo acceptsVirtualAppointments
                 */

                /**
                 * Constructs a new VirtualAppointmentInfo.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a VirtualAppointmentInfo.
                 * @implements IVirtualAppointmentInfo
                 * @constructor
                 * @param {space.kenko.proto.IVirtualAppointmentInfo=} [properties] Properties to set
                 */
                function VirtualAppointmentInfo(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * VirtualAppointmentInfo acceptsVirtualAppointments.
                 * @member {boolean} acceptsVirtualAppointments
                 * @memberof space.kenko.proto.VirtualAppointmentInfo
                 * @instance
                 */
                VirtualAppointmentInfo.prototype.acceptsVirtualAppointments = false;

                /**
                 * Creates a new VirtualAppointmentInfo instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.VirtualAppointmentInfo
                 * @static
                 * @param {space.kenko.proto.IVirtualAppointmentInfo=} [properties] Properties to set
                 * @returns {space.kenko.proto.VirtualAppointmentInfo} VirtualAppointmentInfo instance
                 */
                VirtualAppointmentInfo.create = function create(properties) {
                    return new VirtualAppointmentInfo(properties);
                };

                /**
                 * Encodes the specified VirtualAppointmentInfo message. Does not implicitly {@link space.kenko.proto.VirtualAppointmentInfo.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.VirtualAppointmentInfo
                 * @static
                 * @param {space.kenko.proto.IVirtualAppointmentInfo} message VirtualAppointmentInfo message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                VirtualAppointmentInfo.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.acceptsVirtualAppointments != null && Object.hasOwnProperty.call(message, "acceptsVirtualAppointments"))
                        writer.uint32(/* id 1, wireType 0 =*/8).bool(message.acceptsVirtualAppointments);
                    return writer;
                };

                /**
                 * Encodes the specified VirtualAppointmentInfo message, length delimited. Does not implicitly {@link space.kenko.proto.VirtualAppointmentInfo.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.VirtualAppointmentInfo
                 * @static
                 * @param {space.kenko.proto.IVirtualAppointmentInfo} message VirtualAppointmentInfo message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                VirtualAppointmentInfo.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a VirtualAppointmentInfo message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.VirtualAppointmentInfo
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.VirtualAppointmentInfo} VirtualAppointmentInfo
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                VirtualAppointmentInfo.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.VirtualAppointmentInfo();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.acceptsVirtualAppointments = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a VirtualAppointmentInfo message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.VirtualAppointmentInfo
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.VirtualAppointmentInfo} VirtualAppointmentInfo
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                VirtualAppointmentInfo.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a VirtualAppointmentInfo message.
                 * @function verify
                 * @memberof space.kenko.proto.VirtualAppointmentInfo
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                VirtualAppointmentInfo.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.acceptsVirtualAppointments != null && message.hasOwnProperty("acceptsVirtualAppointments"))
                        if (typeof message.acceptsVirtualAppointments !== "boolean")
                            return "acceptsVirtualAppointments: boolean expected";
                    return null;
                };

                /**
                 * Creates a VirtualAppointmentInfo message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.VirtualAppointmentInfo
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.VirtualAppointmentInfo} VirtualAppointmentInfo
                 */
                VirtualAppointmentInfo.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.VirtualAppointmentInfo)
                        return object;
                    var message = new $root.space.kenko.proto.VirtualAppointmentInfo();
                    if (object.acceptsVirtualAppointments != null)
                        message.acceptsVirtualAppointments = Boolean(object.acceptsVirtualAppointments);
                    return message;
                };

                /**
                 * Creates a plain object from a VirtualAppointmentInfo message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.VirtualAppointmentInfo
                 * @static
                 * @param {space.kenko.proto.VirtualAppointmentInfo} message VirtualAppointmentInfo
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                VirtualAppointmentInfo.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.acceptsVirtualAppointments = false;
                    if (message.acceptsVirtualAppointments != null && message.hasOwnProperty("acceptsVirtualAppointments"))
                        object.acceptsVirtualAppointments = message.acceptsVirtualAppointments;
                    return object;
                };

                /**
                 * Converts this VirtualAppointmentInfo to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.VirtualAppointmentInfo
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                VirtualAppointmentInfo.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for VirtualAppointmentInfo
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.VirtualAppointmentInfo
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                VirtualAppointmentInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.VirtualAppointmentInfo";
                };

                return VirtualAppointmentInfo;
            })();

            /**
             * ProviderApprovalState enum.
             * @name space.kenko.proto.ProviderApprovalState
             * @enum {number}
             * @property {number} APPROVAL_STATE_UNKNOWN=0 APPROVAL_STATE_UNKNOWN value
             * @property {number} NEW_PROVIDER_MANUAL_APPROVE=10 NEW_PROVIDER_MANUAL_APPROVE value
             * @property {number} NEW_PROVIDER_AUTO_APPROVE=11 NEW_PROVIDER_AUTO_APPROVE value
             * @property {number} AWAITING_REVIEW=20 AWAITING_REVIEW value
             * @property {number} PROVIDER_APPROVED=30 PROVIDER_APPROVED value
             * @property {number} PROVIDER_REJECTED=40 PROVIDER_REJECTED value
             */
            proto.ProviderApprovalState = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "APPROVAL_STATE_UNKNOWN"] = 0;
                values[valuesById[10] = "NEW_PROVIDER_MANUAL_APPROVE"] = 10;
                values[valuesById[11] = "NEW_PROVIDER_AUTO_APPROVE"] = 11;
                values[valuesById[20] = "AWAITING_REVIEW"] = 20;
                values[valuesById[30] = "PROVIDER_APPROVED"] = 30;
                values[valuesById[40] = "PROVIDER_REJECTED"] = 40;
                return values;
            })();

            proto.BusinessLocationProto = (function() {

                /**
                 * Properties of a BusinessLocationProto.
                 * @memberof space.kenko.proto
                 * @interface IBusinessLocationProto
                 * @property {string|null} [locationId] BusinessLocationProto locationId
                 * @property {string|null} [locationName] BusinessLocationProto locationName
                 * @property {space.kenko.proto.IPhysicalBusinessLocation|null} [physicalLocation] BusinessLocationProto physicalLocation
                 * @property {boolean|null} [archived] BusinessLocationProto archived
                 */

                /**
                 * Constructs a new BusinessLocationProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a BusinessLocationProto.
                 * @implements IBusinessLocationProto
                 * @constructor
                 * @param {space.kenko.proto.IBusinessLocationProto=} [properties] Properties to set
                 */
                function BusinessLocationProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * BusinessLocationProto locationId.
                 * @member {string} locationId
                 * @memberof space.kenko.proto.BusinessLocationProto
                 * @instance
                 */
                BusinessLocationProto.prototype.locationId = "";

                /**
                 * BusinessLocationProto locationName.
                 * @member {string} locationName
                 * @memberof space.kenko.proto.BusinessLocationProto
                 * @instance
                 */
                BusinessLocationProto.prototype.locationName = "";

                /**
                 * BusinessLocationProto physicalLocation.
                 * @member {space.kenko.proto.IPhysicalBusinessLocation|null|undefined} physicalLocation
                 * @memberof space.kenko.proto.BusinessLocationProto
                 * @instance
                 */
                BusinessLocationProto.prototype.physicalLocation = null;

                /**
                 * BusinessLocationProto archived.
                 * @member {boolean} archived
                 * @memberof space.kenko.proto.BusinessLocationProto
                 * @instance
                 */
                BusinessLocationProto.prototype.archived = false;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * BusinessLocationProto LocationType.
                 * @member {"physicalLocation"|undefined} LocationType
                 * @memberof space.kenko.proto.BusinessLocationProto
                 * @instance
                 */
                Object.defineProperty(BusinessLocationProto.prototype, "LocationType", {
                    get: $util.oneOfGetter($oneOfFields = ["physicalLocation"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new BusinessLocationProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.BusinessLocationProto
                 * @static
                 * @param {space.kenko.proto.IBusinessLocationProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.BusinessLocationProto} BusinessLocationProto instance
                 */
                BusinessLocationProto.create = function create(properties) {
                    return new BusinessLocationProto(properties);
                };

                /**
                 * Encodes the specified BusinessLocationProto message. Does not implicitly {@link space.kenko.proto.BusinessLocationProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.BusinessLocationProto
                 * @static
                 * @param {space.kenko.proto.IBusinessLocationProto} message BusinessLocationProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BusinessLocationProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    if (message.locationName != null && Object.hasOwnProperty.call(message, "locationName"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.locationName);
                    if (message.physicalLocation != null && Object.hasOwnProperty.call(message, "physicalLocation"))
                        $root.space.kenko.proto.PhysicalBusinessLocation.encode(message.physicalLocation, writer.uint32(/* id 21, wireType 2 =*/170).fork()).ldelim();
                    if (message.archived != null && Object.hasOwnProperty.call(message, "archived"))
                        writer.uint32(/* id 100, wireType 0 =*/800).bool(message.archived);
                    return writer;
                };

                /**
                 * Encodes the specified BusinessLocationProto message, length delimited. Does not implicitly {@link space.kenko.proto.BusinessLocationProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.BusinessLocationProto
                 * @static
                 * @param {space.kenko.proto.IBusinessLocationProto} message BusinessLocationProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BusinessLocationProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a BusinessLocationProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.BusinessLocationProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.BusinessLocationProto} BusinessLocationProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BusinessLocationProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.BusinessLocationProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 2: {
                                message.locationName = reader.string();
                                break;
                            }
                        case 21: {
                                message.physicalLocation = $root.space.kenko.proto.PhysicalBusinessLocation.decode(reader, reader.uint32());
                                break;
                            }
                        case 100: {
                                message.archived = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a BusinessLocationProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.BusinessLocationProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.BusinessLocationProto} BusinessLocationProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BusinessLocationProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a BusinessLocationProto message.
                 * @function verify
                 * @memberof space.kenko.proto.BusinessLocationProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BusinessLocationProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    if (message.locationName != null && message.hasOwnProperty("locationName"))
                        if (!$util.isString(message.locationName))
                            return "locationName: string expected";
                    if (message.physicalLocation != null && message.hasOwnProperty("physicalLocation")) {
                        properties.LocationType = 1;
                        {
                            var error = $root.space.kenko.proto.PhysicalBusinessLocation.verify(message.physicalLocation);
                            if (error)
                                return "physicalLocation." + error;
                        }
                    }
                    if (message.archived != null && message.hasOwnProperty("archived"))
                        if (typeof message.archived !== "boolean")
                            return "archived: boolean expected";
                    return null;
                };

                /**
                 * Creates a BusinessLocationProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.BusinessLocationProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.BusinessLocationProto} BusinessLocationProto
                 */
                BusinessLocationProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.BusinessLocationProto)
                        return object;
                    var message = new $root.space.kenko.proto.BusinessLocationProto();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.locationName != null)
                        message.locationName = String(object.locationName);
                    if (object.physicalLocation != null) {
                        if (typeof object.physicalLocation !== "object")
                            throw TypeError(".space.kenko.proto.BusinessLocationProto.physicalLocation: object expected");
                        message.physicalLocation = $root.space.kenko.proto.PhysicalBusinessLocation.fromObject(object.physicalLocation);
                    }
                    if (object.archived != null)
                        message.archived = Boolean(object.archived);
                    return message;
                };

                /**
                 * Creates a plain object from a BusinessLocationProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.BusinessLocationProto
                 * @static
                 * @param {space.kenko.proto.BusinessLocationProto} message BusinessLocationProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BusinessLocationProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.locationId = "";
                        object.locationName = "";
                        object.archived = false;
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    if (message.locationName != null && message.hasOwnProperty("locationName"))
                        object.locationName = message.locationName;
                    if (message.physicalLocation != null && message.hasOwnProperty("physicalLocation")) {
                        object.physicalLocation = $root.space.kenko.proto.PhysicalBusinessLocation.toObject(message.physicalLocation, options);
                        if (options.oneofs)
                            object.LocationType = "physicalLocation";
                    }
                    if (message.archived != null && message.hasOwnProperty("archived"))
                        object.archived = message.archived;
                    return object;
                };

                /**
                 * Converts this BusinessLocationProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.BusinessLocationProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BusinessLocationProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for BusinessLocationProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.BusinessLocationProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                BusinessLocationProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.BusinessLocationProto";
                };

                return BusinessLocationProto;
            })();

            proto.PhysicalBusinessLocation = (function() {

                /**
                 * Properties of a PhysicalBusinessLocation.
                 * @memberof space.kenko.proto
                 * @interface IPhysicalBusinessLocation
                 * @property {string|null} [address] PhysicalBusinessLocation address
                 * @property {number|null} [lat] PhysicalBusinessLocation lat
                 * @property {number|null} [lng] PhysicalBusinessLocation lng
                 * @property {string|null} [timeZone] PhysicalBusinessLocation timeZone
                 * @property {boolean|null} ["private"] PhysicalBusinessLocation private
                 * @property {string|null} [imageUrl] PhysicalBusinessLocation imageUrl
                 * @property {string|null} [phone] PhysicalBusinessLocation phone
                 * @property {string|null} [email] PhysicalBusinessLocation email
                 */

                /**
                 * Constructs a new PhysicalBusinessLocation.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a PhysicalBusinessLocation.
                 * @implements IPhysicalBusinessLocation
                 * @constructor
                 * @param {space.kenko.proto.IPhysicalBusinessLocation=} [properties] Properties to set
                 */
                function PhysicalBusinessLocation(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PhysicalBusinessLocation address.
                 * @member {string} address
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @instance
                 */
                PhysicalBusinessLocation.prototype.address = "";

                /**
                 * PhysicalBusinessLocation lat.
                 * @member {number} lat
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @instance
                 */
                PhysicalBusinessLocation.prototype.lat = 0;

                /**
                 * PhysicalBusinessLocation lng.
                 * @member {number} lng
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @instance
                 */
                PhysicalBusinessLocation.prototype.lng = 0;

                /**
                 * PhysicalBusinessLocation timeZone.
                 * @member {string} timeZone
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @instance
                 */
                PhysicalBusinessLocation.prototype.timeZone = "";

                /**
                 * PhysicalBusinessLocation private.
                 * @member {boolean} private
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @instance
                 */
                PhysicalBusinessLocation.prototype["private"] = false;

                /**
                 * PhysicalBusinessLocation imageUrl.
                 * @member {string} imageUrl
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @instance
                 */
                PhysicalBusinessLocation.prototype.imageUrl = "";

                /**
                 * PhysicalBusinessLocation phone.
                 * @member {string} phone
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @instance
                 */
                PhysicalBusinessLocation.prototype.phone = "";

                /**
                 * PhysicalBusinessLocation email.
                 * @member {string} email
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @instance
                 */
                PhysicalBusinessLocation.prototype.email = "";

                /**
                 * Creates a new PhysicalBusinessLocation instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @static
                 * @param {space.kenko.proto.IPhysicalBusinessLocation=} [properties] Properties to set
                 * @returns {space.kenko.proto.PhysicalBusinessLocation} PhysicalBusinessLocation instance
                 */
                PhysicalBusinessLocation.create = function create(properties) {
                    return new PhysicalBusinessLocation(properties);
                };

                /**
                 * Encodes the specified PhysicalBusinessLocation message. Does not implicitly {@link space.kenko.proto.PhysicalBusinessLocation.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @static
                 * @param {space.kenko.proto.IPhysicalBusinessLocation} message PhysicalBusinessLocation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PhysicalBusinessLocation.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.address != null && Object.hasOwnProperty.call(message, "address"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.address);
                    if (message.lat != null && Object.hasOwnProperty.call(message, "lat"))
                        writer.uint32(/* id 4, wireType 1 =*/33).double(message.lat);
                    if (message.lng != null && Object.hasOwnProperty.call(message, "lng"))
                        writer.uint32(/* id 5, wireType 1 =*/41).double(message.lng);
                    if (message.timeZone != null && Object.hasOwnProperty.call(message, "timeZone"))
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.timeZone);
                    if (message["private"] != null && Object.hasOwnProperty.call(message, "private"))
                        writer.uint32(/* id 7, wireType 0 =*/56).bool(message["private"]);
                    if (message.imageUrl != null && Object.hasOwnProperty.call(message, "imageUrl"))
                        writer.uint32(/* id 8, wireType 2 =*/66).string(message.imageUrl);
                    if (message.phone != null && Object.hasOwnProperty.call(message, "phone"))
                        writer.uint32(/* id 9, wireType 2 =*/74).string(message.phone);
                    if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                        writer.uint32(/* id 10, wireType 2 =*/82).string(message.email);
                    return writer;
                };

                /**
                 * Encodes the specified PhysicalBusinessLocation message, length delimited. Does not implicitly {@link space.kenko.proto.PhysicalBusinessLocation.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @static
                 * @param {space.kenko.proto.IPhysicalBusinessLocation} message PhysicalBusinessLocation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PhysicalBusinessLocation.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PhysicalBusinessLocation message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.PhysicalBusinessLocation} PhysicalBusinessLocation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PhysicalBusinessLocation.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.PhysicalBusinessLocation();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.address = reader.string();
                                break;
                            }
                        case 4: {
                                message.lat = reader.double();
                                break;
                            }
                        case 5: {
                                message.lng = reader.double();
                                break;
                            }
                        case 6: {
                                message.timeZone = reader.string();
                                break;
                            }
                        case 7: {
                                message["private"] = reader.bool();
                                break;
                            }
                        case 8: {
                                message.imageUrl = reader.string();
                                break;
                            }
                        case 9: {
                                message.phone = reader.string();
                                break;
                            }
                        case 10: {
                                message.email = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PhysicalBusinessLocation message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.PhysicalBusinessLocation} PhysicalBusinessLocation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PhysicalBusinessLocation.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PhysicalBusinessLocation message.
                 * @function verify
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PhysicalBusinessLocation.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.address != null && message.hasOwnProperty("address"))
                        if (!$util.isString(message.address))
                            return "address: string expected";
                    if (message.lat != null && message.hasOwnProperty("lat"))
                        if (typeof message.lat !== "number")
                            return "lat: number expected";
                    if (message.lng != null && message.hasOwnProperty("lng"))
                        if (typeof message.lng !== "number")
                            return "lng: number expected";
                    if (message.timeZone != null && message.hasOwnProperty("timeZone"))
                        if (!$util.isString(message.timeZone))
                            return "timeZone: string expected";
                    if (message["private"] != null && message.hasOwnProperty("private"))
                        if (typeof message["private"] !== "boolean")
                            return "private: boolean expected";
                    if (message.imageUrl != null && message.hasOwnProperty("imageUrl"))
                        if (!$util.isString(message.imageUrl))
                            return "imageUrl: string expected";
                    if (message.phone != null && message.hasOwnProperty("phone"))
                        if (!$util.isString(message.phone))
                            return "phone: string expected";
                    if (message.email != null && message.hasOwnProperty("email"))
                        if (!$util.isString(message.email))
                            return "email: string expected";
                    return null;
                };

                /**
                 * Creates a PhysicalBusinessLocation message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.PhysicalBusinessLocation} PhysicalBusinessLocation
                 */
                PhysicalBusinessLocation.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.PhysicalBusinessLocation)
                        return object;
                    var message = new $root.space.kenko.proto.PhysicalBusinessLocation();
                    if (object.address != null)
                        message.address = String(object.address);
                    if (object.lat != null)
                        message.lat = Number(object.lat);
                    if (object.lng != null)
                        message.lng = Number(object.lng);
                    if (object.timeZone != null)
                        message.timeZone = String(object.timeZone);
                    if (object["private"] != null)
                        message["private"] = Boolean(object["private"]);
                    if (object.imageUrl != null)
                        message.imageUrl = String(object.imageUrl);
                    if (object.phone != null)
                        message.phone = String(object.phone);
                    if (object.email != null)
                        message.email = String(object.email);
                    return message;
                };

                /**
                 * Creates a plain object from a PhysicalBusinessLocation message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @static
                 * @param {space.kenko.proto.PhysicalBusinessLocation} message PhysicalBusinessLocation
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PhysicalBusinessLocation.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.address = "";
                        object.lat = 0;
                        object.lng = 0;
                        object.timeZone = "";
                        object["private"] = false;
                        object.imageUrl = "";
                        object.phone = "";
                        object.email = "";
                    }
                    if (message.address != null && message.hasOwnProperty("address"))
                        object.address = message.address;
                    if (message.lat != null && message.hasOwnProperty("lat"))
                        object.lat = options.json && !isFinite(message.lat) ? String(message.lat) : message.lat;
                    if (message.lng != null && message.hasOwnProperty("lng"))
                        object.lng = options.json && !isFinite(message.lng) ? String(message.lng) : message.lng;
                    if (message.timeZone != null && message.hasOwnProperty("timeZone"))
                        object.timeZone = message.timeZone;
                    if (message["private"] != null && message.hasOwnProperty("private"))
                        object["private"] = message["private"];
                    if (message.imageUrl != null && message.hasOwnProperty("imageUrl"))
                        object.imageUrl = message.imageUrl;
                    if (message.phone != null && message.hasOwnProperty("phone"))
                        object.phone = message.phone;
                    if (message.email != null && message.hasOwnProperty("email"))
                        object.email = message.email;
                    return object;
                };

                /**
                 * Converts this PhysicalBusinessLocation to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PhysicalBusinessLocation.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for PhysicalBusinessLocation
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                PhysicalBusinessLocation.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.PhysicalBusinessLocation";
                };

                return PhysicalBusinessLocation;
            })();

            proto.ProviderProfileProto = (function() {

                /**
                 * Properties of a ProviderProfileProto.
                 * @memberof space.kenko.proto
                 * @interface IProviderProfileProto
                 * @property {string|null} [firstName] ProviderProfileProto firstName
                 * @property {string|null} [lastName] ProviderProfileProto lastName
                 * @property {string|null} [countryCode] ProviderProfileProto countryCode
                 * @property {boolean|null} [agreedToTerms] ProviderProfileProto agreedToTerms
                 * @property {string|null} [phone] ProviderProfileProto phone
                 * @property {string|null} [email] ProviderProfileProto email
                 */

                /**
                 * Constructs a new ProviderProfileProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a ProviderProfileProto.
                 * @implements IProviderProfileProto
                 * @constructor
                 * @param {space.kenko.proto.IProviderProfileProto=} [properties] Properties to set
                 */
                function ProviderProfileProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ProviderProfileProto firstName.
                 * @member {string} firstName
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @instance
                 */
                ProviderProfileProto.prototype.firstName = "";

                /**
                 * ProviderProfileProto lastName.
                 * @member {string} lastName
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @instance
                 */
                ProviderProfileProto.prototype.lastName = "";

                /**
                 * ProviderProfileProto countryCode.
                 * @member {string} countryCode
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @instance
                 */
                ProviderProfileProto.prototype.countryCode = "";

                /**
                 * ProviderProfileProto agreedToTerms.
                 * @member {boolean} agreedToTerms
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @instance
                 */
                ProviderProfileProto.prototype.agreedToTerms = false;

                /**
                 * ProviderProfileProto phone.
                 * @member {string} phone
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @instance
                 */
                ProviderProfileProto.prototype.phone = "";

                /**
                 * ProviderProfileProto email.
                 * @member {string} email
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @instance
                 */
                ProviderProfileProto.prototype.email = "";

                /**
                 * Creates a new ProviderProfileProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @static
                 * @param {space.kenko.proto.IProviderProfileProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.ProviderProfileProto} ProviderProfileProto instance
                 */
                ProviderProfileProto.create = function create(properties) {
                    return new ProviderProfileProto(properties);
                };

                /**
                 * Encodes the specified ProviderProfileProto message. Does not implicitly {@link space.kenko.proto.ProviderProfileProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @static
                 * @param {space.kenko.proto.IProviderProfileProto} message ProviderProfileProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ProviderProfileProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.firstName != null && Object.hasOwnProperty.call(message, "firstName"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.firstName);
                    if (message.lastName != null && Object.hasOwnProperty.call(message, "lastName"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.lastName);
                    if (message.countryCode != null && Object.hasOwnProperty.call(message, "countryCode"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.countryCode);
                    if (message.agreedToTerms != null && Object.hasOwnProperty.call(message, "agreedToTerms"))
                        writer.uint32(/* id 6, wireType 0 =*/48).bool(message.agreedToTerms);
                    if (message.phone != null && Object.hasOwnProperty.call(message, "phone"))
                        writer.uint32(/* id 7, wireType 2 =*/58).string(message.phone);
                    if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                        writer.uint32(/* id 8, wireType 2 =*/66).string(message.email);
                    return writer;
                };

                /**
                 * Encodes the specified ProviderProfileProto message, length delimited. Does not implicitly {@link space.kenko.proto.ProviderProfileProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @static
                 * @param {space.kenko.proto.IProviderProfileProto} message ProviderProfileProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ProviderProfileProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ProviderProfileProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.ProviderProfileProto} ProviderProfileProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ProviderProfileProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.ProviderProfileProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.firstName = reader.string();
                                break;
                            }
                        case 2: {
                                message.lastName = reader.string();
                                break;
                            }
                        case 5: {
                                message.countryCode = reader.string();
                                break;
                            }
                        case 6: {
                                message.agreedToTerms = reader.bool();
                                break;
                            }
                        case 7: {
                                message.phone = reader.string();
                                break;
                            }
                        case 8: {
                                message.email = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ProviderProfileProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.ProviderProfileProto} ProviderProfileProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ProviderProfileProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ProviderProfileProto message.
                 * @function verify
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ProviderProfileProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.firstName != null && message.hasOwnProperty("firstName"))
                        if (!$util.isString(message.firstName))
                            return "firstName: string expected";
                    if (message.lastName != null && message.hasOwnProperty("lastName"))
                        if (!$util.isString(message.lastName))
                            return "lastName: string expected";
                    if (message.countryCode != null && message.hasOwnProperty("countryCode"))
                        if (!$util.isString(message.countryCode))
                            return "countryCode: string expected";
                    if (message.agreedToTerms != null && message.hasOwnProperty("agreedToTerms"))
                        if (typeof message.agreedToTerms !== "boolean")
                            return "agreedToTerms: boolean expected";
                    if (message.phone != null && message.hasOwnProperty("phone"))
                        if (!$util.isString(message.phone))
                            return "phone: string expected";
                    if (message.email != null && message.hasOwnProperty("email"))
                        if (!$util.isString(message.email))
                            return "email: string expected";
                    return null;
                };

                /**
                 * Creates a ProviderProfileProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.ProviderProfileProto} ProviderProfileProto
                 */
                ProviderProfileProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.ProviderProfileProto)
                        return object;
                    var message = new $root.space.kenko.proto.ProviderProfileProto();
                    if (object.firstName != null)
                        message.firstName = String(object.firstName);
                    if (object.lastName != null)
                        message.lastName = String(object.lastName);
                    if (object.countryCode != null)
                        message.countryCode = String(object.countryCode);
                    if (object.agreedToTerms != null)
                        message.agreedToTerms = Boolean(object.agreedToTerms);
                    if (object.phone != null)
                        message.phone = String(object.phone);
                    if (object.email != null)
                        message.email = String(object.email);
                    return message;
                };

                /**
                 * Creates a plain object from a ProviderProfileProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @static
                 * @param {space.kenko.proto.ProviderProfileProto} message ProviderProfileProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ProviderProfileProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.firstName = "";
                        object.lastName = "";
                        object.countryCode = "";
                        object.agreedToTerms = false;
                        object.phone = "";
                        object.email = "";
                    }
                    if (message.firstName != null && message.hasOwnProperty("firstName"))
                        object.firstName = message.firstName;
                    if (message.lastName != null && message.hasOwnProperty("lastName"))
                        object.lastName = message.lastName;
                    if (message.countryCode != null && message.hasOwnProperty("countryCode"))
                        object.countryCode = message.countryCode;
                    if (message.agreedToTerms != null && message.hasOwnProperty("agreedToTerms"))
                        object.agreedToTerms = message.agreedToTerms;
                    if (message.phone != null && message.hasOwnProperty("phone"))
                        object.phone = message.phone;
                    if (message.email != null && message.hasOwnProperty("email"))
                        object.email = message.email;
                    return object;
                };

                /**
                 * Converts this ProviderProfileProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ProviderProfileProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ProviderProfileProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ProviderProfileProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.ProviderProfileProto";
                };

                return ProviderProfileProto;
            })();

            proto.AddressProto = (function() {

                /**
                 * Properties of an AddressProto.
                 * @memberof space.kenko.proto
                 * @interface IAddressProto
                 * @property {string|null} [formattedAddress] AddressProto formattedAddress
                 * @property {number|null} [lat] AddressProto lat
                 * @property {number|null} [lng] AddressProto lng
                 */

                /**
                 * Constructs a new AddressProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents an AddressProto.
                 * @implements IAddressProto
                 * @constructor
                 * @param {space.kenko.proto.IAddressProto=} [properties] Properties to set
                 */
                function AddressProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * AddressProto formattedAddress.
                 * @member {string} formattedAddress
                 * @memberof space.kenko.proto.AddressProto
                 * @instance
                 */
                AddressProto.prototype.formattedAddress = "";

                /**
                 * AddressProto lat.
                 * @member {number} lat
                 * @memberof space.kenko.proto.AddressProto
                 * @instance
                 */
                AddressProto.prototype.lat = 0;

                /**
                 * AddressProto lng.
                 * @member {number} lng
                 * @memberof space.kenko.proto.AddressProto
                 * @instance
                 */
                AddressProto.prototype.lng = 0;

                /**
                 * Creates a new AddressProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.AddressProto
                 * @static
                 * @param {space.kenko.proto.IAddressProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.AddressProto} AddressProto instance
                 */
                AddressProto.create = function create(properties) {
                    return new AddressProto(properties);
                };

                /**
                 * Encodes the specified AddressProto message. Does not implicitly {@link space.kenko.proto.AddressProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.AddressProto
                 * @static
                 * @param {space.kenko.proto.IAddressProto} message AddressProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AddressProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.formattedAddress != null && Object.hasOwnProperty.call(message, "formattedAddress"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.formattedAddress);
                    if (message.lat != null && Object.hasOwnProperty.call(message, "lat"))
                        writer.uint32(/* id 2, wireType 1 =*/17).double(message.lat);
                    if (message.lng != null && Object.hasOwnProperty.call(message, "lng"))
                        writer.uint32(/* id 3, wireType 1 =*/25).double(message.lng);
                    return writer;
                };

                /**
                 * Encodes the specified AddressProto message, length delimited. Does not implicitly {@link space.kenko.proto.AddressProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.AddressProto
                 * @static
                 * @param {space.kenko.proto.IAddressProto} message AddressProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AddressProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an AddressProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.AddressProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.AddressProto} AddressProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AddressProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.AddressProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.formattedAddress = reader.string();
                                break;
                            }
                        case 2: {
                                message.lat = reader.double();
                                break;
                            }
                        case 3: {
                                message.lng = reader.double();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an AddressProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.AddressProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.AddressProto} AddressProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AddressProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an AddressProto message.
                 * @function verify
                 * @memberof space.kenko.proto.AddressProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                AddressProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.formattedAddress != null && message.hasOwnProperty("formattedAddress"))
                        if (!$util.isString(message.formattedAddress))
                            return "formattedAddress: string expected";
                    if (message.lat != null && message.hasOwnProperty("lat"))
                        if (typeof message.lat !== "number")
                            return "lat: number expected";
                    if (message.lng != null && message.hasOwnProperty("lng"))
                        if (typeof message.lng !== "number")
                            return "lng: number expected";
                    return null;
                };

                /**
                 * Creates an AddressProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.AddressProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.AddressProto} AddressProto
                 */
                AddressProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.AddressProto)
                        return object;
                    var message = new $root.space.kenko.proto.AddressProto();
                    if (object.formattedAddress != null)
                        message.formattedAddress = String(object.formattedAddress);
                    if (object.lat != null)
                        message.lat = Number(object.lat);
                    if (object.lng != null)
                        message.lng = Number(object.lng);
                    return message;
                };

                /**
                 * Creates a plain object from an AddressProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.AddressProto
                 * @static
                 * @param {space.kenko.proto.AddressProto} message AddressProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                AddressProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.formattedAddress = "";
                        object.lat = 0;
                        object.lng = 0;
                    }
                    if (message.formattedAddress != null && message.hasOwnProperty("formattedAddress"))
                        object.formattedAddress = message.formattedAddress;
                    if (message.lat != null && message.hasOwnProperty("lat"))
                        object.lat = options.json && !isFinite(message.lat) ? String(message.lat) : message.lat;
                    if (message.lng != null && message.hasOwnProperty("lng"))
                        object.lng = options.json && !isFinite(message.lng) ? String(message.lng) : message.lng;
                    return object;
                };

                /**
                 * Converts this AddressProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.AddressProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                AddressProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for AddressProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.AddressProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                AddressProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.AddressProto";
                };

                return AddressProto;
            })();

            proto.PractitionerProto = (function() {

                /**
                 * Properties of a PractitionerProto.
                 * @memberof space.kenko.proto
                 * @interface IPractitionerProto
                 * @property {string|null} [practitionerId] PractitionerProto practitionerId
                 * @property {string|null} [firstName] PractitionerProto firstName
                 * @property {string|null} [lastName] PractitionerProto lastName
                 * @property {string|null} [bio] PractitionerProto bio
                 * @property {string|null} [imageUrl] PractitionerProto imageUrl
                 * @property {string|null} [jobTitle] PractitionerProto jobTitle
                 * @property {Array.<space.kenko.proto.IEducationProto>|null} [education] PractitionerProto education
                 * @property {Array.<space.kenko.proto.ILicenseOrCredentialsProto>|null} [credentials] PractitionerProto credentials
                 * @property {Array.<string>|null} [languages] PractitionerProto languages
                 * @property {string|null} [calendarExportKey] PractitionerProto calendarExportKey
                 * @property {string|null} [virtualMeetingLink] PractitionerProto virtualMeetingLink
                 * @property {boolean|null} [archived] PractitionerProto archived
                 */

                /**
                 * Constructs a new PractitionerProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a PractitionerProto.
                 * @implements IPractitionerProto
                 * @constructor
                 * @param {space.kenko.proto.IPractitionerProto=} [properties] Properties to set
                 */
                function PractitionerProto(properties) {
                    this.education = [];
                    this.credentials = [];
                    this.languages = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PractitionerProto practitionerId.
                 * @member {string} practitionerId
                 * @memberof space.kenko.proto.PractitionerProto
                 * @instance
                 */
                PractitionerProto.prototype.practitionerId = "";

                /**
                 * PractitionerProto firstName.
                 * @member {string} firstName
                 * @memberof space.kenko.proto.PractitionerProto
                 * @instance
                 */
                PractitionerProto.prototype.firstName = "";

                /**
                 * PractitionerProto lastName.
                 * @member {string} lastName
                 * @memberof space.kenko.proto.PractitionerProto
                 * @instance
                 */
                PractitionerProto.prototype.lastName = "";

                /**
                 * PractitionerProto bio.
                 * @member {string} bio
                 * @memberof space.kenko.proto.PractitionerProto
                 * @instance
                 */
                PractitionerProto.prototype.bio = "";

                /**
                 * PractitionerProto imageUrl.
                 * @member {string} imageUrl
                 * @memberof space.kenko.proto.PractitionerProto
                 * @instance
                 */
                PractitionerProto.prototype.imageUrl = "";

                /**
                 * PractitionerProto jobTitle.
                 * @member {string} jobTitle
                 * @memberof space.kenko.proto.PractitionerProto
                 * @instance
                 */
                PractitionerProto.prototype.jobTitle = "";

                /**
                 * PractitionerProto education.
                 * @member {Array.<space.kenko.proto.IEducationProto>} education
                 * @memberof space.kenko.proto.PractitionerProto
                 * @instance
                 */
                PractitionerProto.prototype.education = $util.emptyArray;

                /**
                 * PractitionerProto credentials.
                 * @member {Array.<space.kenko.proto.ILicenseOrCredentialsProto>} credentials
                 * @memberof space.kenko.proto.PractitionerProto
                 * @instance
                 */
                PractitionerProto.prototype.credentials = $util.emptyArray;

                /**
                 * PractitionerProto languages.
                 * @member {Array.<string>} languages
                 * @memberof space.kenko.proto.PractitionerProto
                 * @instance
                 */
                PractitionerProto.prototype.languages = $util.emptyArray;

                /**
                 * PractitionerProto calendarExportKey.
                 * @member {string} calendarExportKey
                 * @memberof space.kenko.proto.PractitionerProto
                 * @instance
                 */
                PractitionerProto.prototype.calendarExportKey = "";

                /**
                 * PractitionerProto virtualMeetingLink.
                 * @member {string} virtualMeetingLink
                 * @memberof space.kenko.proto.PractitionerProto
                 * @instance
                 */
                PractitionerProto.prototype.virtualMeetingLink = "";

                /**
                 * PractitionerProto archived.
                 * @member {boolean} archived
                 * @memberof space.kenko.proto.PractitionerProto
                 * @instance
                 */
                PractitionerProto.prototype.archived = false;

                /**
                 * Creates a new PractitionerProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.PractitionerProto
                 * @static
                 * @param {space.kenko.proto.IPractitionerProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.PractitionerProto} PractitionerProto instance
                 */
                PractitionerProto.create = function create(properties) {
                    return new PractitionerProto(properties);
                };

                /**
                 * Encodes the specified PractitionerProto message. Does not implicitly {@link space.kenko.proto.PractitionerProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.PractitionerProto
                 * @static
                 * @param {space.kenko.proto.IPractitionerProto} message PractitionerProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PractitionerProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.practitionerId != null && Object.hasOwnProperty.call(message, "practitionerId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.practitionerId);
                    if (message.firstName != null && Object.hasOwnProperty.call(message, "firstName"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.firstName);
                    if (message.lastName != null && Object.hasOwnProperty.call(message, "lastName"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.lastName);
                    if (message.bio != null && Object.hasOwnProperty.call(message, "bio"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.bio);
                    if (message.imageUrl != null && Object.hasOwnProperty.call(message, "imageUrl"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.imageUrl);
                    if (message.jobTitle != null && Object.hasOwnProperty.call(message, "jobTitle"))
                        writer.uint32(/* id 10, wireType 2 =*/82).string(message.jobTitle);
                    if (message.education != null && message.education.length)
                        for (var i = 0; i < message.education.length; ++i)
                            $root.space.kenko.proto.EducationProto.encode(message.education[i], writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                    if (message.credentials != null && message.credentials.length)
                        for (var i = 0; i < message.credentials.length; ++i)
                            $root.space.kenko.proto.LicenseOrCredentialsProto.encode(message.credentials[i], writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                    if (message.languages != null && message.languages.length)
                        for (var i = 0; i < message.languages.length; ++i)
                            writer.uint32(/* id 13, wireType 2 =*/106).string(message.languages[i]);
                    if (message.calendarExportKey != null && Object.hasOwnProperty.call(message, "calendarExportKey"))
                        writer.uint32(/* id 14, wireType 2 =*/114).string(message.calendarExportKey);
                    if (message.virtualMeetingLink != null && Object.hasOwnProperty.call(message, "virtualMeetingLink"))
                        writer.uint32(/* id 15, wireType 2 =*/122).string(message.virtualMeetingLink);
                    if (message.archived != null && Object.hasOwnProperty.call(message, "archived"))
                        writer.uint32(/* id 100, wireType 0 =*/800).bool(message.archived);
                    return writer;
                };

                /**
                 * Encodes the specified PractitionerProto message, length delimited. Does not implicitly {@link space.kenko.proto.PractitionerProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.PractitionerProto
                 * @static
                 * @param {space.kenko.proto.IPractitionerProto} message PractitionerProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PractitionerProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PractitionerProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.PractitionerProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.PractitionerProto} PractitionerProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PractitionerProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.PractitionerProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.practitionerId = reader.string();
                                break;
                            }
                        case 2: {
                                message.firstName = reader.string();
                                break;
                            }
                        case 3: {
                                message.lastName = reader.string();
                                break;
                            }
                        case 4: {
                                message.bio = reader.string();
                                break;
                            }
                        case 5: {
                                message.imageUrl = reader.string();
                                break;
                            }
                        case 10: {
                                message.jobTitle = reader.string();
                                break;
                            }
                        case 11: {
                                if (!(message.education && message.education.length))
                                    message.education = [];
                                message.education.push($root.space.kenko.proto.EducationProto.decode(reader, reader.uint32()));
                                break;
                            }
                        case 12: {
                                if (!(message.credentials && message.credentials.length))
                                    message.credentials = [];
                                message.credentials.push($root.space.kenko.proto.LicenseOrCredentialsProto.decode(reader, reader.uint32()));
                                break;
                            }
                        case 13: {
                                if (!(message.languages && message.languages.length))
                                    message.languages = [];
                                message.languages.push(reader.string());
                                break;
                            }
                        case 14: {
                                message.calendarExportKey = reader.string();
                                break;
                            }
                        case 15: {
                                message.virtualMeetingLink = reader.string();
                                break;
                            }
                        case 100: {
                                message.archived = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PractitionerProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.PractitionerProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.PractitionerProto} PractitionerProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PractitionerProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PractitionerProto message.
                 * @function verify
                 * @memberof space.kenko.proto.PractitionerProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PractitionerProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.practitionerId != null && message.hasOwnProperty("practitionerId"))
                        if (!$util.isString(message.practitionerId))
                            return "practitionerId: string expected";
                    if (message.firstName != null && message.hasOwnProperty("firstName"))
                        if (!$util.isString(message.firstName))
                            return "firstName: string expected";
                    if (message.lastName != null && message.hasOwnProperty("lastName"))
                        if (!$util.isString(message.lastName))
                            return "lastName: string expected";
                    if (message.bio != null && message.hasOwnProperty("bio"))
                        if (!$util.isString(message.bio))
                            return "bio: string expected";
                    if (message.imageUrl != null && message.hasOwnProperty("imageUrl"))
                        if (!$util.isString(message.imageUrl))
                            return "imageUrl: string expected";
                    if (message.jobTitle != null && message.hasOwnProperty("jobTitle"))
                        if (!$util.isString(message.jobTitle))
                            return "jobTitle: string expected";
                    if (message.education != null && message.hasOwnProperty("education")) {
                        if (!Array.isArray(message.education))
                            return "education: array expected";
                        for (var i = 0; i < message.education.length; ++i) {
                            var error = $root.space.kenko.proto.EducationProto.verify(message.education[i]);
                            if (error)
                                return "education." + error;
                        }
                    }
                    if (message.credentials != null && message.hasOwnProperty("credentials")) {
                        if (!Array.isArray(message.credentials))
                            return "credentials: array expected";
                        for (var i = 0; i < message.credentials.length; ++i) {
                            var error = $root.space.kenko.proto.LicenseOrCredentialsProto.verify(message.credentials[i]);
                            if (error)
                                return "credentials." + error;
                        }
                    }
                    if (message.languages != null && message.hasOwnProperty("languages")) {
                        if (!Array.isArray(message.languages))
                            return "languages: array expected";
                        for (var i = 0; i < message.languages.length; ++i)
                            if (!$util.isString(message.languages[i]))
                                return "languages: string[] expected";
                    }
                    if (message.calendarExportKey != null && message.hasOwnProperty("calendarExportKey"))
                        if (!$util.isString(message.calendarExportKey))
                            return "calendarExportKey: string expected";
                    if (message.virtualMeetingLink != null && message.hasOwnProperty("virtualMeetingLink"))
                        if (!$util.isString(message.virtualMeetingLink))
                            return "virtualMeetingLink: string expected";
                    if (message.archived != null && message.hasOwnProperty("archived"))
                        if (typeof message.archived !== "boolean")
                            return "archived: boolean expected";
                    return null;
                };

                /**
                 * Creates a PractitionerProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.PractitionerProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.PractitionerProto} PractitionerProto
                 */
                PractitionerProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.PractitionerProto)
                        return object;
                    var message = new $root.space.kenko.proto.PractitionerProto();
                    if (object.practitionerId != null)
                        message.practitionerId = String(object.practitionerId);
                    if (object.firstName != null)
                        message.firstName = String(object.firstName);
                    if (object.lastName != null)
                        message.lastName = String(object.lastName);
                    if (object.bio != null)
                        message.bio = String(object.bio);
                    if (object.imageUrl != null)
                        message.imageUrl = String(object.imageUrl);
                    if (object.jobTitle != null)
                        message.jobTitle = String(object.jobTitle);
                    if (object.education) {
                        if (!Array.isArray(object.education))
                            throw TypeError(".space.kenko.proto.PractitionerProto.education: array expected");
                        message.education = [];
                        for (var i = 0; i < object.education.length; ++i) {
                            if (typeof object.education[i] !== "object")
                                throw TypeError(".space.kenko.proto.PractitionerProto.education: object expected");
                            message.education[i] = $root.space.kenko.proto.EducationProto.fromObject(object.education[i]);
                        }
                    }
                    if (object.credentials) {
                        if (!Array.isArray(object.credentials))
                            throw TypeError(".space.kenko.proto.PractitionerProto.credentials: array expected");
                        message.credentials = [];
                        for (var i = 0; i < object.credentials.length; ++i) {
                            if (typeof object.credentials[i] !== "object")
                                throw TypeError(".space.kenko.proto.PractitionerProto.credentials: object expected");
                            message.credentials[i] = $root.space.kenko.proto.LicenseOrCredentialsProto.fromObject(object.credentials[i]);
                        }
                    }
                    if (object.languages) {
                        if (!Array.isArray(object.languages))
                            throw TypeError(".space.kenko.proto.PractitionerProto.languages: array expected");
                        message.languages = [];
                        for (var i = 0; i < object.languages.length; ++i)
                            message.languages[i] = String(object.languages[i]);
                    }
                    if (object.calendarExportKey != null)
                        message.calendarExportKey = String(object.calendarExportKey);
                    if (object.virtualMeetingLink != null)
                        message.virtualMeetingLink = String(object.virtualMeetingLink);
                    if (object.archived != null)
                        message.archived = Boolean(object.archived);
                    return message;
                };

                /**
                 * Creates a plain object from a PractitionerProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.PractitionerProto
                 * @static
                 * @param {space.kenko.proto.PractitionerProto} message PractitionerProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PractitionerProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.education = [];
                        object.credentials = [];
                        object.languages = [];
                    }
                    if (options.defaults) {
                        object.practitionerId = "";
                        object.firstName = "";
                        object.lastName = "";
                        object.bio = "";
                        object.imageUrl = "";
                        object.jobTitle = "";
                        object.calendarExportKey = "";
                        object.virtualMeetingLink = "";
                        object.archived = false;
                    }
                    if (message.practitionerId != null && message.hasOwnProperty("practitionerId"))
                        object.practitionerId = message.practitionerId;
                    if (message.firstName != null && message.hasOwnProperty("firstName"))
                        object.firstName = message.firstName;
                    if (message.lastName != null && message.hasOwnProperty("lastName"))
                        object.lastName = message.lastName;
                    if (message.bio != null && message.hasOwnProperty("bio"))
                        object.bio = message.bio;
                    if (message.imageUrl != null && message.hasOwnProperty("imageUrl"))
                        object.imageUrl = message.imageUrl;
                    if (message.jobTitle != null && message.hasOwnProperty("jobTitle"))
                        object.jobTitle = message.jobTitle;
                    if (message.education && message.education.length) {
                        object.education = [];
                        for (var j = 0; j < message.education.length; ++j)
                            object.education[j] = $root.space.kenko.proto.EducationProto.toObject(message.education[j], options);
                    }
                    if (message.credentials && message.credentials.length) {
                        object.credentials = [];
                        for (var j = 0; j < message.credentials.length; ++j)
                            object.credentials[j] = $root.space.kenko.proto.LicenseOrCredentialsProto.toObject(message.credentials[j], options);
                    }
                    if (message.languages && message.languages.length) {
                        object.languages = [];
                        for (var j = 0; j < message.languages.length; ++j)
                            object.languages[j] = message.languages[j];
                    }
                    if (message.calendarExportKey != null && message.hasOwnProperty("calendarExportKey"))
                        object.calendarExportKey = message.calendarExportKey;
                    if (message.virtualMeetingLink != null && message.hasOwnProperty("virtualMeetingLink"))
                        object.virtualMeetingLink = message.virtualMeetingLink;
                    if (message.archived != null && message.hasOwnProperty("archived"))
                        object.archived = message.archived;
                    return object;
                };

                /**
                 * Converts this PractitionerProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.PractitionerProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PractitionerProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for PractitionerProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.PractitionerProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                PractitionerProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.PractitionerProto";
                };

                return PractitionerProto;
            })();

            proto.SpecialtyProto = (function() {

                /**
                 * Properties of a SpecialtyProto.
                 * @memberof space.kenko.proto
                 * @interface ISpecialtyProto
                 * @property {string|null} [specialty] SpecialtyProto specialty
                 * @property {number|null} [yearsExperience] SpecialtyProto yearsExperience
                 */

                /**
                 * Constructs a new SpecialtyProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a SpecialtyProto.
                 * @implements ISpecialtyProto
                 * @constructor
                 * @param {space.kenko.proto.ISpecialtyProto=} [properties] Properties to set
                 */
                function SpecialtyProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SpecialtyProto specialty.
                 * @member {string} specialty
                 * @memberof space.kenko.proto.SpecialtyProto
                 * @instance
                 */
                SpecialtyProto.prototype.specialty = "";

                /**
                 * SpecialtyProto yearsExperience.
                 * @member {number} yearsExperience
                 * @memberof space.kenko.proto.SpecialtyProto
                 * @instance
                 */
                SpecialtyProto.prototype.yearsExperience = 0;

                /**
                 * Creates a new SpecialtyProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.SpecialtyProto
                 * @static
                 * @param {space.kenko.proto.ISpecialtyProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.SpecialtyProto} SpecialtyProto instance
                 */
                SpecialtyProto.create = function create(properties) {
                    return new SpecialtyProto(properties);
                };

                /**
                 * Encodes the specified SpecialtyProto message. Does not implicitly {@link space.kenko.proto.SpecialtyProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.SpecialtyProto
                 * @static
                 * @param {space.kenko.proto.ISpecialtyProto} message SpecialtyProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SpecialtyProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.specialty != null && Object.hasOwnProperty.call(message, "specialty"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.specialty);
                    if (message.yearsExperience != null && Object.hasOwnProperty.call(message, "yearsExperience"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.yearsExperience);
                    return writer;
                };

                /**
                 * Encodes the specified SpecialtyProto message, length delimited. Does not implicitly {@link space.kenko.proto.SpecialtyProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.SpecialtyProto
                 * @static
                 * @param {space.kenko.proto.ISpecialtyProto} message SpecialtyProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SpecialtyProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SpecialtyProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.SpecialtyProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.SpecialtyProto} SpecialtyProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SpecialtyProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.SpecialtyProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.specialty = reader.string();
                                break;
                            }
                        case 2: {
                                message.yearsExperience = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SpecialtyProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.SpecialtyProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.SpecialtyProto} SpecialtyProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SpecialtyProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SpecialtyProto message.
                 * @function verify
                 * @memberof space.kenko.proto.SpecialtyProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SpecialtyProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.specialty != null && message.hasOwnProperty("specialty"))
                        if (!$util.isString(message.specialty))
                            return "specialty: string expected";
                    if (message.yearsExperience != null && message.hasOwnProperty("yearsExperience"))
                        if (!$util.isInteger(message.yearsExperience))
                            return "yearsExperience: integer expected";
                    return null;
                };

                /**
                 * Creates a SpecialtyProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.SpecialtyProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.SpecialtyProto} SpecialtyProto
                 */
                SpecialtyProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.SpecialtyProto)
                        return object;
                    var message = new $root.space.kenko.proto.SpecialtyProto();
                    if (object.specialty != null)
                        message.specialty = String(object.specialty);
                    if (object.yearsExperience != null)
                        message.yearsExperience = object.yearsExperience | 0;
                    return message;
                };

                /**
                 * Creates a plain object from a SpecialtyProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.SpecialtyProto
                 * @static
                 * @param {space.kenko.proto.SpecialtyProto} message SpecialtyProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SpecialtyProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.specialty = "";
                        object.yearsExperience = 0;
                    }
                    if (message.specialty != null && message.hasOwnProperty("specialty"))
                        object.specialty = message.specialty;
                    if (message.yearsExperience != null && message.hasOwnProperty("yearsExperience"))
                        object.yearsExperience = message.yearsExperience;
                    return object;
                };

                /**
                 * Converts this SpecialtyProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.SpecialtyProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SpecialtyProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for SpecialtyProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.SpecialtyProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                SpecialtyProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.SpecialtyProto";
                };

                return SpecialtyProto;
            })();

            proto.EducationProto = (function() {

                /**
                 * Properties of an EducationProto.
                 * @memberof space.kenko.proto
                 * @interface IEducationProto
                 * @property {string|null} [school] EducationProto school
                 * @property {string|null} [degree] EducationProto degree
                 * @property {number|null} [yearCompleted] EducationProto yearCompleted
                 */

                /**
                 * Constructs a new EducationProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents an EducationProto.
                 * @implements IEducationProto
                 * @constructor
                 * @param {space.kenko.proto.IEducationProto=} [properties] Properties to set
                 */
                function EducationProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * EducationProto school.
                 * @member {string} school
                 * @memberof space.kenko.proto.EducationProto
                 * @instance
                 */
                EducationProto.prototype.school = "";

                /**
                 * EducationProto degree.
                 * @member {string} degree
                 * @memberof space.kenko.proto.EducationProto
                 * @instance
                 */
                EducationProto.prototype.degree = "";

                /**
                 * EducationProto yearCompleted.
                 * @member {number} yearCompleted
                 * @memberof space.kenko.proto.EducationProto
                 * @instance
                 */
                EducationProto.prototype.yearCompleted = 0;

                /**
                 * Creates a new EducationProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.EducationProto
                 * @static
                 * @param {space.kenko.proto.IEducationProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.EducationProto} EducationProto instance
                 */
                EducationProto.create = function create(properties) {
                    return new EducationProto(properties);
                };

                /**
                 * Encodes the specified EducationProto message. Does not implicitly {@link space.kenko.proto.EducationProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.EducationProto
                 * @static
                 * @param {space.kenko.proto.IEducationProto} message EducationProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EducationProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.school != null && Object.hasOwnProperty.call(message, "school"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.school);
                    if (message.degree != null && Object.hasOwnProperty.call(message, "degree"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.degree);
                    if (message.yearCompleted != null && Object.hasOwnProperty.call(message, "yearCompleted"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.yearCompleted);
                    return writer;
                };

                /**
                 * Encodes the specified EducationProto message, length delimited. Does not implicitly {@link space.kenko.proto.EducationProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.EducationProto
                 * @static
                 * @param {space.kenko.proto.IEducationProto} message EducationProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EducationProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an EducationProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.EducationProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.EducationProto} EducationProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EducationProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.EducationProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.school = reader.string();
                                break;
                            }
                        case 2: {
                                message.degree = reader.string();
                                break;
                            }
                        case 3: {
                                message.yearCompleted = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an EducationProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.EducationProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.EducationProto} EducationProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EducationProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an EducationProto message.
                 * @function verify
                 * @memberof space.kenko.proto.EducationProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                EducationProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.school != null && message.hasOwnProperty("school"))
                        if (!$util.isString(message.school))
                            return "school: string expected";
                    if (message.degree != null && message.hasOwnProperty("degree"))
                        if (!$util.isString(message.degree))
                            return "degree: string expected";
                    if (message.yearCompleted != null && message.hasOwnProperty("yearCompleted"))
                        if (!$util.isInteger(message.yearCompleted))
                            return "yearCompleted: integer expected";
                    return null;
                };

                /**
                 * Creates an EducationProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.EducationProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.EducationProto} EducationProto
                 */
                EducationProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.EducationProto)
                        return object;
                    var message = new $root.space.kenko.proto.EducationProto();
                    if (object.school != null)
                        message.school = String(object.school);
                    if (object.degree != null)
                        message.degree = String(object.degree);
                    if (object.yearCompleted != null)
                        message.yearCompleted = object.yearCompleted | 0;
                    return message;
                };

                /**
                 * Creates a plain object from an EducationProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.EducationProto
                 * @static
                 * @param {space.kenko.proto.EducationProto} message EducationProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                EducationProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.school = "";
                        object.degree = "";
                        object.yearCompleted = 0;
                    }
                    if (message.school != null && message.hasOwnProperty("school"))
                        object.school = message.school;
                    if (message.degree != null && message.hasOwnProperty("degree"))
                        object.degree = message.degree;
                    if (message.yearCompleted != null && message.hasOwnProperty("yearCompleted"))
                        object.yearCompleted = message.yearCompleted;
                    return object;
                };

                /**
                 * Converts this EducationProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.EducationProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                EducationProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for EducationProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.EducationProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                EducationProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.EducationProto";
                };

                return EducationProto;
            })();

            proto.LicenseOrCredentialsProto = (function() {

                /**
                 * Properties of a LicenseOrCredentialsProto.
                 * @memberof space.kenko.proto
                 * @interface ILicenseOrCredentialsProto
                 * @property {string|null} [licenseOrCredential] LicenseOrCredentialsProto licenseOrCredential
                 * @property {string|null} [supportDocumentationUrl] LicenseOrCredentialsProto supportDocumentationUrl
                 */

                /**
                 * Constructs a new LicenseOrCredentialsProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a LicenseOrCredentialsProto.
                 * @implements ILicenseOrCredentialsProto
                 * @constructor
                 * @param {space.kenko.proto.ILicenseOrCredentialsProto=} [properties] Properties to set
                 */
                function LicenseOrCredentialsProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * LicenseOrCredentialsProto licenseOrCredential.
                 * @member {string} licenseOrCredential
                 * @memberof space.kenko.proto.LicenseOrCredentialsProto
                 * @instance
                 */
                LicenseOrCredentialsProto.prototype.licenseOrCredential = "";

                /**
                 * LicenseOrCredentialsProto supportDocumentationUrl.
                 * @member {string} supportDocumentationUrl
                 * @memberof space.kenko.proto.LicenseOrCredentialsProto
                 * @instance
                 */
                LicenseOrCredentialsProto.prototype.supportDocumentationUrl = "";

                /**
                 * Creates a new LicenseOrCredentialsProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.LicenseOrCredentialsProto
                 * @static
                 * @param {space.kenko.proto.ILicenseOrCredentialsProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.LicenseOrCredentialsProto} LicenseOrCredentialsProto instance
                 */
                LicenseOrCredentialsProto.create = function create(properties) {
                    return new LicenseOrCredentialsProto(properties);
                };

                /**
                 * Encodes the specified LicenseOrCredentialsProto message. Does not implicitly {@link space.kenko.proto.LicenseOrCredentialsProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.LicenseOrCredentialsProto
                 * @static
                 * @param {space.kenko.proto.ILicenseOrCredentialsProto} message LicenseOrCredentialsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LicenseOrCredentialsProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.licenseOrCredential != null && Object.hasOwnProperty.call(message, "licenseOrCredential"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.licenseOrCredential);
                    if (message.supportDocumentationUrl != null && Object.hasOwnProperty.call(message, "supportDocumentationUrl"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.supportDocumentationUrl);
                    return writer;
                };

                /**
                 * Encodes the specified LicenseOrCredentialsProto message, length delimited. Does not implicitly {@link space.kenko.proto.LicenseOrCredentialsProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.LicenseOrCredentialsProto
                 * @static
                 * @param {space.kenko.proto.ILicenseOrCredentialsProto} message LicenseOrCredentialsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LicenseOrCredentialsProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a LicenseOrCredentialsProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.LicenseOrCredentialsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.LicenseOrCredentialsProto} LicenseOrCredentialsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LicenseOrCredentialsProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.LicenseOrCredentialsProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.licenseOrCredential = reader.string();
                                break;
                            }
                        case 2: {
                                message.supportDocumentationUrl = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a LicenseOrCredentialsProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.LicenseOrCredentialsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.LicenseOrCredentialsProto} LicenseOrCredentialsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LicenseOrCredentialsProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a LicenseOrCredentialsProto message.
                 * @function verify
                 * @memberof space.kenko.proto.LicenseOrCredentialsProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                LicenseOrCredentialsProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.licenseOrCredential != null && message.hasOwnProperty("licenseOrCredential"))
                        if (!$util.isString(message.licenseOrCredential))
                            return "licenseOrCredential: string expected";
                    if (message.supportDocumentationUrl != null && message.hasOwnProperty("supportDocumentationUrl"))
                        if (!$util.isString(message.supportDocumentationUrl))
                            return "supportDocumentationUrl: string expected";
                    return null;
                };

                /**
                 * Creates a LicenseOrCredentialsProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.LicenseOrCredentialsProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.LicenseOrCredentialsProto} LicenseOrCredentialsProto
                 */
                LicenseOrCredentialsProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.LicenseOrCredentialsProto)
                        return object;
                    var message = new $root.space.kenko.proto.LicenseOrCredentialsProto();
                    if (object.licenseOrCredential != null)
                        message.licenseOrCredential = String(object.licenseOrCredential);
                    if (object.supportDocumentationUrl != null)
                        message.supportDocumentationUrl = String(object.supportDocumentationUrl);
                    return message;
                };

                /**
                 * Creates a plain object from a LicenseOrCredentialsProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.LicenseOrCredentialsProto
                 * @static
                 * @param {space.kenko.proto.LicenseOrCredentialsProto} message LicenseOrCredentialsProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                LicenseOrCredentialsProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.licenseOrCredential = "";
                        object.supportDocumentationUrl = "";
                    }
                    if (message.licenseOrCredential != null && message.hasOwnProperty("licenseOrCredential"))
                        object.licenseOrCredential = message.licenseOrCredential;
                    if (message.supportDocumentationUrl != null && message.hasOwnProperty("supportDocumentationUrl"))
                        object.supportDocumentationUrl = message.supportDocumentationUrl;
                    return object;
                };

                /**
                 * Converts this LicenseOrCredentialsProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.LicenseOrCredentialsProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                LicenseOrCredentialsProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for LicenseOrCredentialsProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.LicenseOrCredentialsProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                LicenseOrCredentialsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.LicenseOrCredentialsProto";
                };

                return LicenseOrCredentialsProto;
            })();

            proto.PracticeDetailsProto = (function() {

                /**
                 * Properties of a PracticeDetailsProto.
                 * @memberof space.kenko.proto
                 * @interface IPracticeDetailsProto
                 * @property {Array.<space.kenko.proto.IServiceProto>|null} [services] PracticeDetailsProto services
                 */

                /**
                 * Constructs a new PracticeDetailsProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a PracticeDetailsProto.
                 * @implements IPracticeDetailsProto
                 * @constructor
                 * @param {space.kenko.proto.IPracticeDetailsProto=} [properties] Properties to set
                 */
                function PracticeDetailsProto(properties) {
                    this.services = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PracticeDetailsProto services.
                 * @member {Array.<space.kenko.proto.IServiceProto>} services
                 * @memberof space.kenko.proto.PracticeDetailsProto
                 * @instance
                 */
                PracticeDetailsProto.prototype.services = $util.emptyArray;

                /**
                 * Creates a new PracticeDetailsProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.PracticeDetailsProto
                 * @static
                 * @param {space.kenko.proto.IPracticeDetailsProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.PracticeDetailsProto} PracticeDetailsProto instance
                 */
                PracticeDetailsProto.create = function create(properties) {
                    return new PracticeDetailsProto(properties);
                };

                /**
                 * Encodes the specified PracticeDetailsProto message. Does not implicitly {@link space.kenko.proto.PracticeDetailsProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.PracticeDetailsProto
                 * @static
                 * @param {space.kenko.proto.IPracticeDetailsProto} message PracticeDetailsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PracticeDetailsProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.services != null && message.services.length)
                        for (var i = 0; i < message.services.length; ++i)
                            $root.space.kenko.proto.ServiceProto.encode(message.services[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified PracticeDetailsProto message, length delimited. Does not implicitly {@link space.kenko.proto.PracticeDetailsProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.PracticeDetailsProto
                 * @static
                 * @param {space.kenko.proto.IPracticeDetailsProto} message PracticeDetailsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PracticeDetailsProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PracticeDetailsProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.PracticeDetailsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.PracticeDetailsProto} PracticeDetailsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PracticeDetailsProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.PracticeDetailsProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                if (!(message.services && message.services.length))
                                    message.services = [];
                                message.services.push($root.space.kenko.proto.ServiceProto.decode(reader, reader.uint32()));
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PracticeDetailsProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.PracticeDetailsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.PracticeDetailsProto} PracticeDetailsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PracticeDetailsProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PracticeDetailsProto message.
                 * @function verify
                 * @memberof space.kenko.proto.PracticeDetailsProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PracticeDetailsProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.services != null && message.hasOwnProperty("services")) {
                        if (!Array.isArray(message.services))
                            return "services: array expected";
                        for (var i = 0; i < message.services.length; ++i) {
                            var error = $root.space.kenko.proto.ServiceProto.verify(message.services[i]);
                            if (error)
                                return "services." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a PracticeDetailsProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.PracticeDetailsProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.PracticeDetailsProto} PracticeDetailsProto
                 */
                PracticeDetailsProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.PracticeDetailsProto)
                        return object;
                    var message = new $root.space.kenko.proto.PracticeDetailsProto();
                    if (object.services) {
                        if (!Array.isArray(object.services))
                            throw TypeError(".space.kenko.proto.PracticeDetailsProto.services: array expected");
                        message.services = [];
                        for (var i = 0; i < object.services.length; ++i) {
                            if (typeof object.services[i] !== "object")
                                throw TypeError(".space.kenko.proto.PracticeDetailsProto.services: object expected");
                            message.services[i] = $root.space.kenko.proto.ServiceProto.fromObject(object.services[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a PracticeDetailsProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.PracticeDetailsProto
                 * @static
                 * @param {space.kenko.proto.PracticeDetailsProto} message PracticeDetailsProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PracticeDetailsProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.services = [];
                    if (message.services && message.services.length) {
                        object.services = [];
                        for (var j = 0; j < message.services.length; ++j)
                            object.services[j] = $root.space.kenko.proto.ServiceProto.toObject(message.services[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this PracticeDetailsProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.PracticeDetailsProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PracticeDetailsProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for PracticeDetailsProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.PracticeDetailsProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                PracticeDetailsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.PracticeDetailsProto";
                };

                return PracticeDetailsProto;
            })();

            proto.StudioDetailsProto = (function() {

                /**
                 * Properties of a StudioDetailsProto.
                 * @memberof space.kenko.proto
                 * @interface IStudioDetailsProto
                 * @property {Array.<space.kenko.proto.IClassTemplateProto>|null} [classTemplates] StudioDetailsProto classTemplates
                 */

                /**
                 * Constructs a new StudioDetailsProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a StudioDetailsProto.
                 * @implements IStudioDetailsProto
                 * @constructor
                 * @param {space.kenko.proto.IStudioDetailsProto=} [properties] Properties to set
                 */
                function StudioDetailsProto(properties) {
                    this.classTemplates = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StudioDetailsProto classTemplates.
                 * @member {Array.<space.kenko.proto.IClassTemplateProto>} classTemplates
                 * @memberof space.kenko.proto.StudioDetailsProto
                 * @instance
                 */
                StudioDetailsProto.prototype.classTemplates = $util.emptyArray;

                /**
                 * Creates a new StudioDetailsProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.StudioDetailsProto
                 * @static
                 * @param {space.kenko.proto.IStudioDetailsProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.StudioDetailsProto} StudioDetailsProto instance
                 */
                StudioDetailsProto.create = function create(properties) {
                    return new StudioDetailsProto(properties);
                };

                /**
                 * Encodes the specified StudioDetailsProto message. Does not implicitly {@link space.kenko.proto.StudioDetailsProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.StudioDetailsProto
                 * @static
                 * @param {space.kenko.proto.IStudioDetailsProto} message StudioDetailsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StudioDetailsProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.classTemplates != null && message.classTemplates.length)
                        for (var i = 0; i < message.classTemplates.length; ++i)
                            $root.space.kenko.proto.ClassTemplateProto.encode(message.classTemplates[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified StudioDetailsProto message, length delimited. Does not implicitly {@link space.kenko.proto.StudioDetailsProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.StudioDetailsProto
                 * @static
                 * @param {space.kenko.proto.IStudioDetailsProto} message StudioDetailsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StudioDetailsProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a StudioDetailsProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.StudioDetailsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.StudioDetailsProto} StudioDetailsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StudioDetailsProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.StudioDetailsProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                if (!(message.classTemplates && message.classTemplates.length))
                                    message.classTemplates = [];
                                message.classTemplates.push($root.space.kenko.proto.ClassTemplateProto.decode(reader, reader.uint32()));
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a StudioDetailsProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.StudioDetailsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.StudioDetailsProto} StudioDetailsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StudioDetailsProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StudioDetailsProto message.
                 * @function verify
                 * @memberof space.kenko.proto.StudioDetailsProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StudioDetailsProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.classTemplates != null && message.hasOwnProperty("classTemplates")) {
                        if (!Array.isArray(message.classTemplates))
                            return "classTemplates: array expected";
                        for (var i = 0; i < message.classTemplates.length; ++i) {
                            var error = $root.space.kenko.proto.ClassTemplateProto.verify(message.classTemplates[i]);
                            if (error)
                                return "classTemplates." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a StudioDetailsProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.StudioDetailsProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.StudioDetailsProto} StudioDetailsProto
                 */
                StudioDetailsProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.StudioDetailsProto)
                        return object;
                    var message = new $root.space.kenko.proto.StudioDetailsProto();
                    if (object.classTemplates) {
                        if (!Array.isArray(object.classTemplates))
                            throw TypeError(".space.kenko.proto.StudioDetailsProto.classTemplates: array expected");
                        message.classTemplates = [];
                        for (var i = 0; i < object.classTemplates.length; ++i) {
                            if (typeof object.classTemplates[i] !== "object")
                                throw TypeError(".space.kenko.proto.StudioDetailsProto.classTemplates: object expected");
                            message.classTemplates[i] = $root.space.kenko.proto.ClassTemplateProto.fromObject(object.classTemplates[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a StudioDetailsProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.StudioDetailsProto
                 * @static
                 * @param {space.kenko.proto.StudioDetailsProto} message StudioDetailsProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StudioDetailsProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.classTemplates = [];
                    if (message.classTemplates && message.classTemplates.length) {
                        object.classTemplates = [];
                        for (var j = 0; j < message.classTemplates.length; ++j)
                            object.classTemplates[j] = $root.space.kenko.proto.ClassTemplateProto.toObject(message.classTemplates[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this StudioDetailsProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.StudioDetailsProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StudioDetailsProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for StudioDetailsProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.StudioDetailsProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                StudioDetailsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.StudioDetailsProto";
                };

                return StudioDetailsProto;
            })();

            proto.PricingDetailsProto = (function() {

                /**
                 * Properties of a PricingDetailsProto.
                 * @memberof space.kenko.proto
                 * @interface IPricingDetailsProto
                 * @property {Array.<IPriceCategoryProto>|null} [priceCategories] PricingDetailsProto priceCategories
                 * @property {Array.<IPackageProto>|null} [packages] PricingDetailsProto packages
                 * @property {Array.<space.kenko.proto.ISubscriptionProto>|null} [subscriptions] PricingDetailsProto subscriptions
                 */

                /**
                 * Constructs a new PricingDetailsProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a PricingDetailsProto.
                 * @implements IPricingDetailsProto
                 * @constructor
                 * @param {space.kenko.proto.IPricingDetailsProto=} [properties] Properties to set
                 */
                function PricingDetailsProto(properties) {
                    this.priceCategories = [];
                    this.packages = [];
                    this.subscriptions = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PricingDetailsProto priceCategories.
                 * @member {Array.<IPriceCategoryProto>} priceCategories
                 * @memberof space.kenko.proto.PricingDetailsProto
                 * @instance
                 */
                PricingDetailsProto.prototype.priceCategories = $util.emptyArray;

                /**
                 * PricingDetailsProto packages.
                 * @member {Array.<IPackageProto>} packages
                 * @memberof space.kenko.proto.PricingDetailsProto
                 * @instance
                 */
                PricingDetailsProto.prototype.packages = $util.emptyArray;

                /**
                 * PricingDetailsProto subscriptions.
                 * @member {Array.<space.kenko.proto.ISubscriptionProto>} subscriptions
                 * @memberof space.kenko.proto.PricingDetailsProto
                 * @instance
                 */
                PricingDetailsProto.prototype.subscriptions = $util.emptyArray;

                /**
                 * Creates a new PricingDetailsProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.PricingDetailsProto
                 * @static
                 * @param {space.kenko.proto.IPricingDetailsProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.PricingDetailsProto} PricingDetailsProto instance
                 */
                PricingDetailsProto.create = function create(properties) {
                    return new PricingDetailsProto(properties);
                };

                /**
                 * Encodes the specified PricingDetailsProto message. Does not implicitly {@link space.kenko.proto.PricingDetailsProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.PricingDetailsProto
                 * @static
                 * @param {space.kenko.proto.IPricingDetailsProto} message PricingDetailsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PricingDetailsProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.priceCategories != null && message.priceCategories.length)
                        for (var i = 0; i < message.priceCategories.length; ++i)
                            $root.PriceCategoryProto.encode(message.priceCategories[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.packages != null && message.packages.length)
                        for (var i = 0; i < message.packages.length; ++i)
                            $root.PackageProto.encode(message.packages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.subscriptions != null && message.subscriptions.length)
                        for (var i = 0; i < message.subscriptions.length; ++i)
                            $root.space.kenko.proto.SubscriptionProto.encode(message.subscriptions[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified PricingDetailsProto message, length delimited. Does not implicitly {@link space.kenko.proto.PricingDetailsProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.PricingDetailsProto
                 * @static
                 * @param {space.kenko.proto.IPricingDetailsProto} message PricingDetailsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PricingDetailsProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PricingDetailsProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.PricingDetailsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.PricingDetailsProto} PricingDetailsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PricingDetailsProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.PricingDetailsProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                if (!(message.priceCategories && message.priceCategories.length))
                                    message.priceCategories = [];
                                message.priceCategories.push($root.PriceCategoryProto.decode(reader, reader.uint32()));
                                break;
                            }
                        case 2: {
                                if (!(message.packages && message.packages.length))
                                    message.packages = [];
                                message.packages.push($root.PackageProto.decode(reader, reader.uint32()));
                                break;
                            }
                        case 3: {
                                if (!(message.subscriptions && message.subscriptions.length))
                                    message.subscriptions = [];
                                message.subscriptions.push($root.space.kenko.proto.SubscriptionProto.decode(reader, reader.uint32()));
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PricingDetailsProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.PricingDetailsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.PricingDetailsProto} PricingDetailsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PricingDetailsProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PricingDetailsProto message.
                 * @function verify
                 * @memberof space.kenko.proto.PricingDetailsProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PricingDetailsProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.priceCategories != null && message.hasOwnProperty("priceCategories")) {
                        if (!Array.isArray(message.priceCategories))
                            return "priceCategories: array expected";
                        for (var i = 0; i < message.priceCategories.length; ++i) {
                            var error = $root.PriceCategoryProto.verify(message.priceCategories[i]);
                            if (error)
                                return "priceCategories." + error;
                        }
                    }
                    if (message.packages != null && message.hasOwnProperty("packages")) {
                        if (!Array.isArray(message.packages))
                            return "packages: array expected";
                        for (var i = 0; i < message.packages.length; ++i) {
                            var error = $root.PackageProto.verify(message.packages[i]);
                            if (error)
                                return "packages." + error;
                        }
                    }
                    if (message.subscriptions != null && message.hasOwnProperty("subscriptions")) {
                        if (!Array.isArray(message.subscriptions))
                            return "subscriptions: array expected";
                        for (var i = 0; i < message.subscriptions.length; ++i) {
                            var error = $root.space.kenko.proto.SubscriptionProto.verify(message.subscriptions[i]);
                            if (error)
                                return "subscriptions." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a PricingDetailsProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.PricingDetailsProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.PricingDetailsProto} PricingDetailsProto
                 */
                PricingDetailsProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.PricingDetailsProto)
                        return object;
                    var message = new $root.space.kenko.proto.PricingDetailsProto();
                    if (object.priceCategories) {
                        if (!Array.isArray(object.priceCategories))
                            throw TypeError(".space.kenko.proto.PricingDetailsProto.priceCategories: array expected");
                        message.priceCategories = [];
                        for (var i = 0; i < object.priceCategories.length; ++i) {
                            if (typeof object.priceCategories[i] !== "object")
                                throw TypeError(".space.kenko.proto.PricingDetailsProto.priceCategories: object expected");
                            message.priceCategories[i] = $root.PriceCategoryProto.fromObject(object.priceCategories[i]);
                        }
                    }
                    if (object.packages) {
                        if (!Array.isArray(object.packages))
                            throw TypeError(".space.kenko.proto.PricingDetailsProto.packages: array expected");
                        message.packages = [];
                        for (var i = 0; i < object.packages.length; ++i) {
                            if (typeof object.packages[i] !== "object")
                                throw TypeError(".space.kenko.proto.PricingDetailsProto.packages: object expected");
                            message.packages[i] = $root.PackageProto.fromObject(object.packages[i]);
                        }
                    }
                    if (object.subscriptions) {
                        if (!Array.isArray(object.subscriptions))
                            throw TypeError(".space.kenko.proto.PricingDetailsProto.subscriptions: array expected");
                        message.subscriptions = [];
                        for (var i = 0; i < object.subscriptions.length; ++i) {
                            if (typeof object.subscriptions[i] !== "object")
                                throw TypeError(".space.kenko.proto.PricingDetailsProto.subscriptions: object expected");
                            message.subscriptions[i] = $root.space.kenko.proto.SubscriptionProto.fromObject(object.subscriptions[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a PricingDetailsProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.PricingDetailsProto
                 * @static
                 * @param {space.kenko.proto.PricingDetailsProto} message PricingDetailsProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PricingDetailsProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.priceCategories = [];
                        object.packages = [];
                        object.subscriptions = [];
                    }
                    if (message.priceCategories && message.priceCategories.length) {
                        object.priceCategories = [];
                        for (var j = 0; j < message.priceCategories.length; ++j)
                            object.priceCategories[j] = $root.PriceCategoryProto.toObject(message.priceCategories[j], options);
                    }
                    if (message.packages && message.packages.length) {
                        object.packages = [];
                        for (var j = 0; j < message.packages.length; ++j)
                            object.packages[j] = $root.PackageProto.toObject(message.packages[j], options);
                    }
                    if (message.subscriptions && message.subscriptions.length) {
                        object.subscriptions = [];
                        for (var j = 0; j < message.subscriptions.length; ++j)
                            object.subscriptions[j] = $root.space.kenko.proto.SubscriptionProto.toObject(message.subscriptions[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this PricingDetailsProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.PricingDetailsProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PricingDetailsProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for PricingDetailsProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.PricingDetailsProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                PricingDetailsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.PricingDetailsProto";
                };

                return PricingDetailsProto;
            })();

            proto.ServiceProto = (function() {

                /**
                 * Properties of a ServiceProto.
                 * @memberof space.kenko.proto
                 * @interface IServiceProto
                 * @property {string|null} [sku] ServiceProto sku
                 * @property {string|null} [name] ServiceProto name
                 * @property {string|null} [description] ServiceProto description
                 * @property {number|null} [lengthMinutes] ServiceProto lengthMinutes
                 * @property {string|null} [category] ServiceProto category
                 * @property {Array.<string>|null} [availableLocationIds] ServiceProto availableLocationIds
                 * @property {boolean|null} [isVirtual] ServiceProto isVirtual
                 * @property {Array.<string>|null} [practitionerId] ServiceProto practitionerId
                 * @property {space.kenko.proto.IPaymentPolicyProto|null} [paymentPolicy] ServiceProto paymentPolicy
                 * @property {boolean|null} [archived] ServiceProto archived
                 */

                /**
                 * Constructs a new ServiceProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a ServiceProto.
                 * @implements IServiceProto
                 * @constructor
                 * @param {space.kenko.proto.IServiceProto=} [properties] Properties to set
                 */
                function ServiceProto(properties) {
                    this.availableLocationIds = [];
                    this.practitionerId = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ServiceProto sku.
                 * @member {string} sku
                 * @memberof space.kenko.proto.ServiceProto
                 * @instance
                 */
                ServiceProto.prototype.sku = "";

                /**
                 * ServiceProto name.
                 * @member {string} name
                 * @memberof space.kenko.proto.ServiceProto
                 * @instance
                 */
                ServiceProto.prototype.name = "";

                /**
                 * ServiceProto description.
                 * @member {string} description
                 * @memberof space.kenko.proto.ServiceProto
                 * @instance
                 */
                ServiceProto.prototype.description = "";

                /**
                 * ServiceProto lengthMinutes.
                 * @member {number} lengthMinutes
                 * @memberof space.kenko.proto.ServiceProto
                 * @instance
                 */
                ServiceProto.prototype.lengthMinutes = 0;

                /**
                 * ServiceProto category.
                 * @member {string} category
                 * @memberof space.kenko.proto.ServiceProto
                 * @instance
                 */
                ServiceProto.prototype.category = "";

                /**
                 * ServiceProto availableLocationIds.
                 * @member {Array.<string>} availableLocationIds
                 * @memberof space.kenko.proto.ServiceProto
                 * @instance
                 */
                ServiceProto.prototype.availableLocationIds = $util.emptyArray;

                /**
                 * ServiceProto isVirtual.
                 * @member {boolean} isVirtual
                 * @memberof space.kenko.proto.ServiceProto
                 * @instance
                 */
                ServiceProto.prototype.isVirtual = false;

                /**
                 * ServiceProto practitionerId.
                 * @member {Array.<string>} practitionerId
                 * @memberof space.kenko.proto.ServiceProto
                 * @instance
                 */
                ServiceProto.prototype.practitionerId = $util.emptyArray;

                /**
                 * ServiceProto paymentPolicy.
                 * @member {space.kenko.proto.IPaymentPolicyProto|null|undefined} paymentPolicy
                 * @memberof space.kenko.proto.ServiceProto
                 * @instance
                 */
                ServiceProto.prototype.paymentPolicy = null;

                /**
                 * ServiceProto archived.
                 * @member {boolean} archived
                 * @memberof space.kenko.proto.ServiceProto
                 * @instance
                 */
                ServiceProto.prototype.archived = false;

                /**
                 * Creates a new ServiceProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.ServiceProto
                 * @static
                 * @param {space.kenko.proto.IServiceProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.ServiceProto} ServiceProto instance
                 */
                ServiceProto.create = function create(properties) {
                    return new ServiceProto(properties);
                };

                /**
                 * Encodes the specified ServiceProto message. Does not implicitly {@link space.kenko.proto.ServiceProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.ServiceProto
                 * @static
                 * @param {space.kenko.proto.IServiceProto} message ServiceProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ServiceProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.sku != null && Object.hasOwnProperty.call(message, "sku"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.sku);
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                    if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.description);
                    if (message.lengthMinutes != null && Object.hasOwnProperty.call(message, "lengthMinutes"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.lengthMinutes);
                    if (message.category != null && Object.hasOwnProperty.call(message, "category"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.category);
                    if (message.availableLocationIds != null && message.availableLocationIds.length)
                        for (var i = 0; i < message.availableLocationIds.length; ++i)
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.availableLocationIds[i]);
                    if (message.isVirtual != null && Object.hasOwnProperty.call(message, "isVirtual"))
                        writer.uint32(/* id 7, wireType 0 =*/56).bool(message.isVirtual);
                    if (message.practitionerId != null && message.practitionerId.length)
                        for (var i = 0; i < message.practitionerId.length; ++i)
                            writer.uint32(/* id 9, wireType 2 =*/74).string(message.practitionerId[i]);
                    if (message.paymentPolicy != null && Object.hasOwnProperty.call(message, "paymentPolicy"))
                        $root.space.kenko.proto.PaymentPolicyProto.encode(message.paymentPolicy, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                    if (message.archived != null && Object.hasOwnProperty.call(message, "archived"))
                        writer.uint32(/* id 100, wireType 0 =*/800).bool(message.archived);
                    return writer;
                };

                /**
                 * Encodes the specified ServiceProto message, length delimited. Does not implicitly {@link space.kenko.proto.ServiceProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.ServiceProto
                 * @static
                 * @param {space.kenko.proto.IServiceProto} message ServiceProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ServiceProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ServiceProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.ServiceProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.ServiceProto} ServiceProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ServiceProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.ServiceProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.sku = reader.string();
                                break;
                            }
                        case 2: {
                                message.name = reader.string();
                                break;
                            }
                        case 3: {
                                message.description = reader.string();
                                break;
                            }
                        case 4: {
                                message.lengthMinutes = reader.int32();
                                break;
                            }
                        case 5: {
                                message.category = reader.string();
                                break;
                            }
                        case 6: {
                                if (!(message.availableLocationIds && message.availableLocationIds.length))
                                    message.availableLocationIds = [];
                                message.availableLocationIds.push(reader.string());
                                break;
                            }
                        case 7: {
                                message.isVirtual = reader.bool();
                                break;
                            }
                        case 9: {
                                if (!(message.practitionerId && message.practitionerId.length))
                                    message.practitionerId = [];
                                message.practitionerId.push(reader.string());
                                break;
                            }
                        case 11: {
                                message.paymentPolicy = $root.space.kenko.proto.PaymentPolicyProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 100: {
                                message.archived = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ServiceProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.ServiceProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.ServiceProto} ServiceProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ServiceProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ServiceProto message.
                 * @function verify
                 * @memberof space.kenko.proto.ServiceProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ServiceProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.sku != null && message.hasOwnProperty("sku"))
                        if (!$util.isString(message.sku))
                            return "sku: string expected";
                    if (message.name != null && message.hasOwnProperty("name"))
                        if (!$util.isString(message.name))
                            return "name: string expected";
                    if (message.description != null && message.hasOwnProperty("description"))
                        if (!$util.isString(message.description))
                            return "description: string expected";
                    if (message.lengthMinutes != null && message.hasOwnProperty("lengthMinutes"))
                        if (!$util.isInteger(message.lengthMinutes))
                            return "lengthMinutes: integer expected";
                    if (message.category != null && message.hasOwnProperty("category"))
                        if (!$util.isString(message.category))
                            return "category: string expected";
                    if (message.availableLocationIds != null && message.hasOwnProperty("availableLocationIds")) {
                        if (!Array.isArray(message.availableLocationIds))
                            return "availableLocationIds: array expected";
                        for (var i = 0; i < message.availableLocationIds.length; ++i)
                            if (!$util.isString(message.availableLocationIds[i]))
                                return "availableLocationIds: string[] expected";
                    }
                    if (message.isVirtual != null && message.hasOwnProperty("isVirtual"))
                        if (typeof message.isVirtual !== "boolean")
                            return "isVirtual: boolean expected";
                    if (message.practitionerId != null && message.hasOwnProperty("practitionerId")) {
                        if (!Array.isArray(message.practitionerId))
                            return "practitionerId: array expected";
                        for (var i = 0; i < message.practitionerId.length; ++i)
                            if (!$util.isString(message.practitionerId[i]))
                                return "practitionerId: string[] expected";
                    }
                    if (message.paymentPolicy != null && message.hasOwnProperty("paymentPolicy")) {
                        var error = $root.space.kenko.proto.PaymentPolicyProto.verify(message.paymentPolicy);
                        if (error)
                            return "paymentPolicy." + error;
                    }
                    if (message.archived != null && message.hasOwnProperty("archived"))
                        if (typeof message.archived !== "boolean")
                            return "archived: boolean expected";
                    return null;
                };

                /**
                 * Creates a ServiceProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.ServiceProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.ServiceProto} ServiceProto
                 */
                ServiceProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.ServiceProto)
                        return object;
                    var message = new $root.space.kenko.proto.ServiceProto();
                    if (object.sku != null)
                        message.sku = String(object.sku);
                    if (object.name != null)
                        message.name = String(object.name);
                    if (object.description != null)
                        message.description = String(object.description);
                    if (object.lengthMinutes != null)
                        message.lengthMinutes = object.lengthMinutes | 0;
                    if (object.category != null)
                        message.category = String(object.category);
                    if (object.availableLocationIds) {
                        if (!Array.isArray(object.availableLocationIds))
                            throw TypeError(".space.kenko.proto.ServiceProto.availableLocationIds: array expected");
                        message.availableLocationIds = [];
                        for (var i = 0; i < object.availableLocationIds.length; ++i)
                            message.availableLocationIds[i] = String(object.availableLocationIds[i]);
                    }
                    if (object.isVirtual != null)
                        message.isVirtual = Boolean(object.isVirtual);
                    if (object.practitionerId) {
                        if (!Array.isArray(object.practitionerId))
                            throw TypeError(".space.kenko.proto.ServiceProto.practitionerId: array expected");
                        message.practitionerId = [];
                        for (var i = 0; i < object.practitionerId.length; ++i)
                            message.practitionerId[i] = String(object.practitionerId[i]);
                    }
                    if (object.paymentPolicy != null) {
                        if (typeof object.paymentPolicy !== "object")
                            throw TypeError(".space.kenko.proto.ServiceProto.paymentPolicy: object expected");
                        message.paymentPolicy = $root.space.kenko.proto.PaymentPolicyProto.fromObject(object.paymentPolicy);
                    }
                    if (object.archived != null)
                        message.archived = Boolean(object.archived);
                    return message;
                };

                /**
                 * Creates a plain object from a ServiceProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.ServiceProto
                 * @static
                 * @param {space.kenko.proto.ServiceProto} message ServiceProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ServiceProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.availableLocationIds = [];
                        object.practitionerId = [];
                    }
                    if (options.defaults) {
                        object.sku = "";
                        object.name = "";
                        object.description = "";
                        object.lengthMinutes = 0;
                        object.category = "";
                        object.isVirtual = false;
                        object.paymentPolicy = null;
                        object.archived = false;
                    }
                    if (message.sku != null && message.hasOwnProperty("sku"))
                        object.sku = message.sku;
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = message.name;
                    if (message.description != null && message.hasOwnProperty("description"))
                        object.description = message.description;
                    if (message.lengthMinutes != null && message.hasOwnProperty("lengthMinutes"))
                        object.lengthMinutes = message.lengthMinutes;
                    if (message.category != null && message.hasOwnProperty("category"))
                        object.category = message.category;
                    if (message.availableLocationIds && message.availableLocationIds.length) {
                        object.availableLocationIds = [];
                        for (var j = 0; j < message.availableLocationIds.length; ++j)
                            object.availableLocationIds[j] = message.availableLocationIds[j];
                    }
                    if (message.isVirtual != null && message.hasOwnProperty("isVirtual"))
                        object.isVirtual = message.isVirtual;
                    if (message.practitionerId && message.practitionerId.length) {
                        object.practitionerId = [];
                        for (var j = 0; j < message.practitionerId.length; ++j)
                            object.practitionerId[j] = message.practitionerId[j];
                    }
                    if (message.paymentPolicy != null && message.hasOwnProperty("paymentPolicy"))
                        object.paymentPolicy = $root.space.kenko.proto.PaymentPolicyProto.toObject(message.paymentPolicy, options);
                    if (message.archived != null && message.hasOwnProperty("archived"))
                        object.archived = message.archived;
                    return object;
                };

                /**
                 * Converts this ServiceProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.ServiceProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ServiceProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ServiceProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.ServiceProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ServiceProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.ServiceProto";
                };

                return ServiceProto;
            })();

            proto.ClassTemplateProto = (function() {

                /**
                 * Properties of a ClassTemplateProto.
                 * @memberof space.kenko.proto
                 * @interface IClassTemplateProto
                 * @property {string|null} [classTemplateId] ClassTemplateProto classTemplateId
                 * @property {string|null} [name] ClassTemplateProto name
                 * @property {string|null} [description] ClassTemplateProto description
                 * @property {number|null} [lengthMinutes] ClassTemplateProto lengthMinutes
                 * @property {string|null} [category] ClassTemplateProto category
                 * @property {space.kenko.proto.IPaymentPolicyProto|null} [paymentPolicy] ClassTemplateProto paymentPolicy
                 * @property {number|null} [maxAttendees] ClassTemplateProto maxAttendees
                 * @property {boolean|null} [archived] ClassTemplateProto archived
                 */

                /**
                 * Constructs a new ClassTemplateProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a ClassTemplateProto.
                 * @implements IClassTemplateProto
                 * @constructor
                 * @param {space.kenko.proto.IClassTemplateProto=} [properties] Properties to set
                 */
                function ClassTemplateProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ClassTemplateProto classTemplateId.
                 * @member {string} classTemplateId
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @instance
                 */
                ClassTemplateProto.prototype.classTemplateId = "";

                /**
                 * ClassTemplateProto name.
                 * @member {string} name
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @instance
                 */
                ClassTemplateProto.prototype.name = "";

                /**
                 * ClassTemplateProto description.
                 * @member {string} description
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @instance
                 */
                ClassTemplateProto.prototype.description = "";

                /**
                 * ClassTemplateProto lengthMinutes.
                 * @member {number} lengthMinutes
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @instance
                 */
                ClassTemplateProto.prototype.lengthMinutes = 0;

                /**
                 * ClassTemplateProto category.
                 * @member {string} category
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @instance
                 */
                ClassTemplateProto.prototype.category = "";

                /**
                 * ClassTemplateProto paymentPolicy.
                 * @member {space.kenko.proto.IPaymentPolicyProto|null|undefined} paymentPolicy
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @instance
                 */
                ClassTemplateProto.prototype.paymentPolicy = null;

                /**
                 * ClassTemplateProto maxAttendees.
                 * @member {number} maxAttendees
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @instance
                 */
                ClassTemplateProto.prototype.maxAttendees = 0;

                /**
                 * ClassTemplateProto archived.
                 * @member {boolean} archived
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @instance
                 */
                ClassTemplateProto.prototype.archived = false;

                /**
                 * Creates a new ClassTemplateProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @static
                 * @param {space.kenko.proto.IClassTemplateProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.ClassTemplateProto} ClassTemplateProto instance
                 */
                ClassTemplateProto.create = function create(properties) {
                    return new ClassTemplateProto(properties);
                };

                /**
                 * Encodes the specified ClassTemplateProto message. Does not implicitly {@link space.kenko.proto.ClassTemplateProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @static
                 * @param {space.kenko.proto.IClassTemplateProto} message ClassTemplateProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ClassTemplateProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.classTemplateId != null && Object.hasOwnProperty.call(message, "classTemplateId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.classTemplateId);
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                    if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.description);
                    if (message.lengthMinutes != null && Object.hasOwnProperty.call(message, "lengthMinutes"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.lengthMinutes);
                    if (message.category != null && Object.hasOwnProperty.call(message, "category"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.category);
                    if (message.paymentPolicy != null && Object.hasOwnProperty.call(message, "paymentPolicy"))
                        $root.space.kenko.proto.PaymentPolicyProto.encode(message.paymentPolicy, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                    if (message.maxAttendees != null && Object.hasOwnProperty.call(message, "maxAttendees"))
                        writer.uint32(/* id 12, wireType 0 =*/96).int32(message.maxAttendees);
                    if (message.archived != null && Object.hasOwnProperty.call(message, "archived"))
                        writer.uint32(/* id 100, wireType 0 =*/800).bool(message.archived);
                    return writer;
                };

                /**
                 * Encodes the specified ClassTemplateProto message, length delimited. Does not implicitly {@link space.kenko.proto.ClassTemplateProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @static
                 * @param {space.kenko.proto.IClassTemplateProto} message ClassTemplateProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ClassTemplateProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ClassTemplateProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.ClassTemplateProto} ClassTemplateProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ClassTemplateProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.ClassTemplateProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.classTemplateId = reader.string();
                                break;
                            }
                        case 2: {
                                message.name = reader.string();
                                break;
                            }
                        case 3: {
                                message.description = reader.string();
                                break;
                            }
                        case 4: {
                                message.lengthMinutes = reader.int32();
                                break;
                            }
                        case 5: {
                                message.category = reader.string();
                                break;
                            }
                        case 11: {
                                message.paymentPolicy = $root.space.kenko.proto.PaymentPolicyProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 12: {
                                message.maxAttendees = reader.int32();
                                break;
                            }
                        case 100: {
                                message.archived = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ClassTemplateProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.ClassTemplateProto} ClassTemplateProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ClassTemplateProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ClassTemplateProto message.
                 * @function verify
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ClassTemplateProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.classTemplateId != null && message.hasOwnProperty("classTemplateId"))
                        if (!$util.isString(message.classTemplateId))
                            return "classTemplateId: string expected";
                    if (message.name != null && message.hasOwnProperty("name"))
                        if (!$util.isString(message.name))
                            return "name: string expected";
                    if (message.description != null && message.hasOwnProperty("description"))
                        if (!$util.isString(message.description))
                            return "description: string expected";
                    if (message.lengthMinutes != null && message.hasOwnProperty("lengthMinutes"))
                        if (!$util.isInteger(message.lengthMinutes))
                            return "lengthMinutes: integer expected";
                    if (message.category != null && message.hasOwnProperty("category"))
                        if (!$util.isString(message.category))
                            return "category: string expected";
                    if (message.paymentPolicy != null && message.hasOwnProperty("paymentPolicy")) {
                        var error = $root.space.kenko.proto.PaymentPolicyProto.verify(message.paymentPolicy);
                        if (error)
                            return "paymentPolicy." + error;
                    }
                    if (message.maxAttendees != null && message.hasOwnProperty("maxAttendees"))
                        if (!$util.isInteger(message.maxAttendees))
                            return "maxAttendees: integer expected";
                    if (message.archived != null && message.hasOwnProperty("archived"))
                        if (typeof message.archived !== "boolean")
                            return "archived: boolean expected";
                    return null;
                };

                /**
                 * Creates a ClassTemplateProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.ClassTemplateProto} ClassTemplateProto
                 */
                ClassTemplateProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.ClassTemplateProto)
                        return object;
                    var message = new $root.space.kenko.proto.ClassTemplateProto();
                    if (object.classTemplateId != null)
                        message.classTemplateId = String(object.classTemplateId);
                    if (object.name != null)
                        message.name = String(object.name);
                    if (object.description != null)
                        message.description = String(object.description);
                    if (object.lengthMinutes != null)
                        message.lengthMinutes = object.lengthMinutes | 0;
                    if (object.category != null)
                        message.category = String(object.category);
                    if (object.paymentPolicy != null) {
                        if (typeof object.paymentPolicy !== "object")
                            throw TypeError(".space.kenko.proto.ClassTemplateProto.paymentPolicy: object expected");
                        message.paymentPolicy = $root.space.kenko.proto.PaymentPolicyProto.fromObject(object.paymentPolicy);
                    }
                    if (object.maxAttendees != null)
                        message.maxAttendees = object.maxAttendees | 0;
                    if (object.archived != null)
                        message.archived = Boolean(object.archived);
                    return message;
                };

                /**
                 * Creates a plain object from a ClassTemplateProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @static
                 * @param {space.kenko.proto.ClassTemplateProto} message ClassTemplateProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ClassTemplateProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.classTemplateId = "";
                        object.name = "";
                        object.description = "";
                        object.lengthMinutes = 0;
                        object.category = "";
                        object.paymentPolicy = null;
                        object.maxAttendees = 0;
                        object.archived = false;
                    }
                    if (message.classTemplateId != null && message.hasOwnProperty("classTemplateId"))
                        object.classTemplateId = message.classTemplateId;
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = message.name;
                    if (message.description != null && message.hasOwnProperty("description"))
                        object.description = message.description;
                    if (message.lengthMinutes != null && message.hasOwnProperty("lengthMinutes"))
                        object.lengthMinutes = message.lengthMinutes;
                    if (message.category != null && message.hasOwnProperty("category"))
                        object.category = message.category;
                    if (message.paymentPolicy != null && message.hasOwnProperty("paymentPolicy"))
                        object.paymentPolicy = $root.space.kenko.proto.PaymentPolicyProto.toObject(message.paymentPolicy, options);
                    if (message.maxAttendees != null && message.hasOwnProperty("maxAttendees"))
                        object.maxAttendees = message.maxAttendees;
                    if (message.archived != null && message.hasOwnProperty("archived"))
                        object.archived = message.archived;
                    return object;
                };

                /**
                 * Converts this ClassTemplateProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ClassTemplateProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ClassTemplateProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ClassTemplateProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.ClassTemplateProto";
                };

                return ClassTemplateProto;
            })();

            proto.SubscriptionProto = (function() {

                /**
                 * Properties of a SubscriptionProto.
                 * @memberof space.kenko.proto
                 * @interface ISubscriptionProto
                 * @property {string|null} [stripeSubscriptionId] SubscriptionProto stripeSubscriptionId
                 * @property {string|null} [name] SubscriptionProto name
                 * @property {string|null} [description] SubscriptionProto description
                 * @property {space.kenko.proto.IBillingPeriodProto|null} [billingPeriod] SubscriptionProto billingPeriod
                 * @property {space.kenko.proto.IPriceProto|null} [price] SubscriptionProto price
                 * @property {space.kenko.proto.ISubscriptionEntitlementProto|null} [entitlement] SubscriptionProto entitlement
                 * @property {boolean|null} [archived] SubscriptionProto archived
                 */

                /**
                 * Constructs a new SubscriptionProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a SubscriptionProto.
                 * @implements ISubscriptionProto
                 * @constructor
                 * @param {space.kenko.proto.ISubscriptionProto=} [properties] Properties to set
                 */
                function SubscriptionProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SubscriptionProto stripeSubscriptionId.
                 * @member {string} stripeSubscriptionId
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @instance
                 */
                SubscriptionProto.prototype.stripeSubscriptionId = "";

                /**
                 * SubscriptionProto name.
                 * @member {string} name
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @instance
                 */
                SubscriptionProto.prototype.name = "";

                /**
                 * SubscriptionProto description.
                 * @member {string} description
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @instance
                 */
                SubscriptionProto.prototype.description = "";

                /**
                 * SubscriptionProto billingPeriod.
                 * @member {space.kenko.proto.IBillingPeriodProto|null|undefined} billingPeriod
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @instance
                 */
                SubscriptionProto.prototype.billingPeriod = null;

                /**
                 * SubscriptionProto price.
                 * @member {space.kenko.proto.IPriceProto|null|undefined} price
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @instance
                 */
                SubscriptionProto.prototype.price = null;

                /**
                 * SubscriptionProto entitlement.
                 * @member {space.kenko.proto.ISubscriptionEntitlementProto|null|undefined} entitlement
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @instance
                 */
                SubscriptionProto.prototype.entitlement = null;

                /**
                 * SubscriptionProto archived.
                 * @member {boolean} archived
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @instance
                 */
                SubscriptionProto.prototype.archived = false;

                /**
                 * Creates a new SubscriptionProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @static
                 * @param {space.kenko.proto.ISubscriptionProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.SubscriptionProto} SubscriptionProto instance
                 */
                SubscriptionProto.create = function create(properties) {
                    return new SubscriptionProto(properties);
                };

                /**
                 * Encodes the specified SubscriptionProto message. Does not implicitly {@link space.kenko.proto.SubscriptionProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @static
                 * @param {space.kenko.proto.ISubscriptionProto} message SubscriptionProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SubscriptionProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.stripeSubscriptionId != null && Object.hasOwnProperty.call(message, "stripeSubscriptionId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.stripeSubscriptionId);
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                    if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.description);
                    if (message.billingPeriod != null && Object.hasOwnProperty.call(message, "billingPeriod"))
                        $root.space.kenko.proto.BillingPeriodProto.encode(message.billingPeriod, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.price != null && Object.hasOwnProperty.call(message, "price"))
                        $root.space.kenko.proto.PriceProto.encode(message.price, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.entitlement != null && Object.hasOwnProperty.call(message, "entitlement"))
                        $root.space.kenko.proto.SubscriptionEntitlementProto.encode(message.entitlement, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.archived != null && Object.hasOwnProperty.call(message, "archived"))
                        writer.uint32(/* id 100, wireType 0 =*/800).bool(message.archived);
                    return writer;
                };

                /**
                 * Encodes the specified SubscriptionProto message, length delimited. Does not implicitly {@link space.kenko.proto.SubscriptionProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @static
                 * @param {space.kenko.proto.ISubscriptionProto} message SubscriptionProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SubscriptionProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SubscriptionProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.SubscriptionProto} SubscriptionProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SubscriptionProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.SubscriptionProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.stripeSubscriptionId = reader.string();
                                break;
                            }
                        case 2: {
                                message.name = reader.string();
                                break;
                            }
                        case 3: {
                                message.description = reader.string();
                                break;
                            }
                        case 4: {
                                message.billingPeriod = $root.space.kenko.proto.BillingPeriodProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 5: {
                                message.price = $root.space.kenko.proto.PriceProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 6: {
                                message.entitlement = $root.space.kenko.proto.SubscriptionEntitlementProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 100: {
                                message.archived = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SubscriptionProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.SubscriptionProto} SubscriptionProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SubscriptionProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SubscriptionProto message.
                 * @function verify
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SubscriptionProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.stripeSubscriptionId != null && message.hasOwnProperty("stripeSubscriptionId"))
                        if (!$util.isString(message.stripeSubscriptionId))
                            return "stripeSubscriptionId: string expected";
                    if (message.name != null && message.hasOwnProperty("name"))
                        if (!$util.isString(message.name))
                            return "name: string expected";
                    if (message.description != null && message.hasOwnProperty("description"))
                        if (!$util.isString(message.description))
                            return "description: string expected";
                    if (message.billingPeriod != null && message.hasOwnProperty("billingPeriod")) {
                        var error = $root.space.kenko.proto.BillingPeriodProto.verify(message.billingPeriod);
                        if (error)
                            return "billingPeriod." + error;
                    }
                    if (message.price != null && message.hasOwnProperty("price")) {
                        var error = $root.space.kenko.proto.PriceProto.verify(message.price);
                        if (error)
                            return "price." + error;
                    }
                    if (message.entitlement != null && message.hasOwnProperty("entitlement")) {
                        var error = $root.space.kenko.proto.SubscriptionEntitlementProto.verify(message.entitlement);
                        if (error)
                            return "entitlement." + error;
                    }
                    if (message.archived != null && message.hasOwnProperty("archived"))
                        if (typeof message.archived !== "boolean")
                            return "archived: boolean expected";
                    return null;
                };

                /**
                 * Creates a SubscriptionProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.SubscriptionProto} SubscriptionProto
                 */
                SubscriptionProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.SubscriptionProto)
                        return object;
                    var message = new $root.space.kenko.proto.SubscriptionProto();
                    if (object.stripeSubscriptionId != null)
                        message.stripeSubscriptionId = String(object.stripeSubscriptionId);
                    if (object.name != null)
                        message.name = String(object.name);
                    if (object.description != null)
                        message.description = String(object.description);
                    if (object.billingPeriod != null) {
                        if (typeof object.billingPeriod !== "object")
                            throw TypeError(".space.kenko.proto.SubscriptionProto.billingPeriod: object expected");
                        message.billingPeriod = $root.space.kenko.proto.BillingPeriodProto.fromObject(object.billingPeriod);
                    }
                    if (object.price != null) {
                        if (typeof object.price !== "object")
                            throw TypeError(".space.kenko.proto.SubscriptionProto.price: object expected");
                        message.price = $root.space.kenko.proto.PriceProto.fromObject(object.price);
                    }
                    if (object.entitlement != null) {
                        if (typeof object.entitlement !== "object")
                            throw TypeError(".space.kenko.proto.SubscriptionProto.entitlement: object expected");
                        message.entitlement = $root.space.kenko.proto.SubscriptionEntitlementProto.fromObject(object.entitlement);
                    }
                    if (object.archived != null)
                        message.archived = Boolean(object.archived);
                    return message;
                };

                /**
                 * Creates a plain object from a SubscriptionProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @static
                 * @param {space.kenko.proto.SubscriptionProto} message SubscriptionProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SubscriptionProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.stripeSubscriptionId = "";
                        object.name = "";
                        object.description = "";
                        object.billingPeriod = null;
                        object.price = null;
                        object.entitlement = null;
                        object.archived = false;
                    }
                    if (message.stripeSubscriptionId != null && message.hasOwnProperty("stripeSubscriptionId"))
                        object.stripeSubscriptionId = message.stripeSubscriptionId;
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = message.name;
                    if (message.description != null && message.hasOwnProperty("description"))
                        object.description = message.description;
                    if (message.billingPeriod != null && message.hasOwnProperty("billingPeriod"))
                        object.billingPeriod = $root.space.kenko.proto.BillingPeriodProto.toObject(message.billingPeriod, options);
                    if (message.price != null && message.hasOwnProperty("price"))
                        object.price = $root.space.kenko.proto.PriceProto.toObject(message.price, options);
                    if (message.entitlement != null && message.hasOwnProperty("entitlement"))
                        object.entitlement = $root.space.kenko.proto.SubscriptionEntitlementProto.toObject(message.entitlement, options);
                    if (message.archived != null && message.hasOwnProperty("archived"))
                        object.archived = message.archived;
                    return object;
                };

                /**
                 * Converts this SubscriptionProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SubscriptionProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for SubscriptionProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                SubscriptionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.SubscriptionProto";
                };

                return SubscriptionProto;
            })();

            /**
             * BillingPeriodUnitProto enum.
             * @name space.kenko.proto.BillingPeriodUnitProto
             * @enum {number}
             * @property {number} BILLING_PERIOD_UNKNOWN=0 BILLING_PERIOD_UNKNOWN value
             * @property {number} MONTH=1 MONTH value
             * @property {number} YEAR=2 YEAR value
             */
            proto.BillingPeriodUnitProto = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "BILLING_PERIOD_UNKNOWN"] = 0;
                values[valuesById[1] = "MONTH"] = 1;
                values[valuesById[2] = "YEAR"] = 2;
                return values;
            })();

            proto.BillingPeriodProto = (function() {

                /**
                 * Properties of a BillingPeriodProto.
                 * @memberof space.kenko.proto
                 * @interface IBillingPeriodProto
                 * @property {number|null} [amount] BillingPeriodProto amount
                 * @property {space.kenko.proto.BillingPeriodUnitProto|null} [unit] BillingPeriodProto unit
                 */

                /**
                 * Constructs a new BillingPeriodProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a BillingPeriodProto.
                 * @implements IBillingPeriodProto
                 * @constructor
                 * @param {space.kenko.proto.IBillingPeriodProto=} [properties] Properties to set
                 */
                function BillingPeriodProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * BillingPeriodProto amount.
                 * @member {number} amount
                 * @memberof space.kenko.proto.BillingPeriodProto
                 * @instance
                 */
                BillingPeriodProto.prototype.amount = 0;

                /**
                 * BillingPeriodProto unit.
                 * @member {space.kenko.proto.BillingPeriodUnitProto} unit
                 * @memberof space.kenko.proto.BillingPeriodProto
                 * @instance
                 */
                BillingPeriodProto.prototype.unit = 0;

                /**
                 * Creates a new BillingPeriodProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.BillingPeriodProto
                 * @static
                 * @param {space.kenko.proto.IBillingPeriodProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.BillingPeriodProto} BillingPeriodProto instance
                 */
                BillingPeriodProto.create = function create(properties) {
                    return new BillingPeriodProto(properties);
                };

                /**
                 * Encodes the specified BillingPeriodProto message. Does not implicitly {@link space.kenko.proto.BillingPeriodProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.BillingPeriodProto
                 * @static
                 * @param {space.kenko.proto.IBillingPeriodProto} message BillingPeriodProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BillingPeriodProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.amount);
                    if (message.unit != null && Object.hasOwnProperty.call(message, "unit"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.unit);
                    return writer;
                };

                /**
                 * Encodes the specified BillingPeriodProto message, length delimited. Does not implicitly {@link space.kenko.proto.BillingPeriodProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.BillingPeriodProto
                 * @static
                 * @param {space.kenko.proto.IBillingPeriodProto} message BillingPeriodProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BillingPeriodProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a BillingPeriodProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.BillingPeriodProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.BillingPeriodProto} BillingPeriodProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BillingPeriodProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.BillingPeriodProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.amount = reader.int32();
                                break;
                            }
                        case 2: {
                                message.unit = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a BillingPeriodProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.BillingPeriodProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.BillingPeriodProto} BillingPeriodProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BillingPeriodProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a BillingPeriodProto message.
                 * @function verify
                 * @memberof space.kenko.proto.BillingPeriodProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BillingPeriodProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.amount != null && message.hasOwnProperty("amount"))
                        if (!$util.isInteger(message.amount))
                            return "amount: integer expected";
                    if (message.unit != null && message.hasOwnProperty("unit"))
                        switch (message.unit) {
                        default:
                            return "unit: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    return null;
                };

                /**
                 * Creates a BillingPeriodProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.BillingPeriodProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.BillingPeriodProto} BillingPeriodProto
                 */
                BillingPeriodProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.BillingPeriodProto)
                        return object;
                    var message = new $root.space.kenko.proto.BillingPeriodProto();
                    if (object.amount != null)
                        message.amount = object.amount | 0;
                    switch (object.unit) {
                    default:
                        if (typeof object.unit === "number") {
                            message.unit = object.unit;
                            break;
                        }
                        break;
                    case "BILLING_PERIOD_UNKNOWN":
                    case 0:
                        message.unit = 0;
                        break;
                    case "MONTH":
                    case 1:
                        message.unit = 1;
                        break;
                    case "YEAR":
                    case 2:
                        message.unit = 2;
                        break;
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a BillingPeriodProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.BillingPeriodProto
                 * @static
                 * @param {space.kenko.proto.BillingPeriodProto} message BillingPeriodProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BillingPeriodProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.amount = 0;
                        object.unit = options.enums === String ? "BILLING_PERIOD_UNKNOWN" : 0;
                    }
                    if (message.amount != null && message.hasOwnProperty("amount"))
                        object.amount = message.amount;
                    if (message.unit != null && message.hasOwnProperty("unit"))
                        object.unit = options.enums === String ? $root.space.kenko.proto.BillingPeriodUnitProto[message.unit] === undefined ? message.unit : $root.space.kenko.proto.BillingPeriodUnitProto[message.unit] : message.unit;
                    return object;
                };

                /**
                 * Converts this BillingPeriodProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.BillingPeriodProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BillingPeriodProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for BillingPeriodProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.BillingPeriodProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                BillingPeriodProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.BillingPeriodProto";
                };

                return BillingPeriodProto;
            })();

            proto.SubscriptionEntitlementProto = (function() {

                /**
                 * Properties of a SubscriptionEntitlementProto.
                 * @memberof space.kenko.proto
                 * @interface ISubscriptionEntitlementProto
                 * @property {string|null} [id] SubscriptionEntitlementProto id
                 * @property {string|null} [displayName] SubscriptionEntitlementProto displayName
                 * @property {space.kenko.proto.IClassSubscriptionEntitlement|null} [classes] SubscriptionEntitlementProto classes
                 */

                /**
                 * Constructs a new SubscriptionEntitlementProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a SubscriptionEntitlementProto.
                 * @implements ISubscriptionEntitlementProto
                 * @constructor
                 * @param {space.kenko.proto.ISubscriptionEntitlementProto=} [properties] Properties to set
                 */
                function SubscriptionEntitlementProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SubscriptionEntitlementProto id.
                 * @member {string} id
                 * @memberof space.kenko.proto.SubscriptionEntitlementProto
                 * @instance
                 */
                SubscriptionEntitlementProto.prototype.id = "";

                /**
                 * SubscriptionEntitlementProto displayName.
                 * @member {string} displayName
                 * @memberof space.kenko.proto.SubscriptionEntitlementProto
                 * @instance
                 */
                SubscriptionEntitlementProto.prototype.displayName = "";

                /**
                 * SubscriptionEntitlementProto classes.
                 * @member {space.kenko.proto.IClassSubscriptionEntitlement|null|undefined} classes
                 * @memberof space.kenko.proto.SubscriptionEntitlementProto
                 * @instance
                 */
                SubscriptionEntitlementProto.prototype.classes = null;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * SubscriptionEntitlementProto EntitlementType.
                 * @member {"classes"|undefined} EntitlementType
                 * @memberof space.kenko.proto.SubscriptionEntitlementProto
                 * @instance
                 */
                Object.defineProperty(SubscriptionEntitlementProto.prototype, "EntitlementType", {
                    get: $util.oneOfGetter($oneOfFields = ["classes"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new SubscriptionEntitlementProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.SubscriptionEntitlementProto
                 * @static
                 * @param {space.kenko.proto.ISubscriptionEntitlementProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.SubscriptionEntitlementProto} SubscriptionEntitlementProto instance
                 */
                SubscriptionEntitlementProto.create = function create(properties) {
                    return new SubscriptionEntitlementProto(properties);
                };

                /**
                 * Encodes the specified SubscriptionEntitlementProto message. Does not implicitly {@link space.kenko.proto.SubscriptionEntitlementProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.SubscriptionEntitlementProto
                 * @static
                 * @param {space.kenko.proto.ISubscriptionEntitlementProto} message SubscriptionEntitlementProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SubscriptionEntitlementProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                    if (message.displayName != null && Object.hasOwnProperty.call(message, "displayName"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.displayName);
                    if (message.classes != null && Object.hasOwnProperty.call(message, "classes"))
                        $root.space.kenko.proto.ClassSubscriptionEntitlement.encode(message.classes, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SubscriptionEntitlementProto message, length delimited. Does not implicitly {@link space.kenko.proto.SubscriptionEntitlementProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.SubscriptionEntitlementProto
                 * @static
                 * @param {space.kenko.proto.ISubscriptionEntitlementProto} message SubscriptionEntitlementProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SubscriptionEntitlementProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SubscriptionEntitlementProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.SubscriptionEntitlementProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.SubscriptionEntitlementProto} SubscriptionEntitlementProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SubscriptionEntitlementProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.SubscriptionEntitlementProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.id = reader.string();
                                break;
                            }
                        case 2: {
                                message.displayName = reader.string();
                                break;
                            }
                        case 10: {
                                message.classes = $root.space.kenko.proto.ClassSubscriptionEntitlement.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SubscriptionEntitlementProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.SubscriptionEntitlementProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.SubscriptionEntitlementProto} SubscriptionEntitlementProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SubscriptionEntitlementProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SubscriptionEntitlementProto message.
                 * @function verify
                 * @memberof space.kenko.proto.SubscriptionEntitlementProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SubscriptionEntitlementProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (!$util.isString(message.id))
                            return "id: string expected";
                    if (message.displayName != null && message.hasOwnProperty("displayName"))
                        if (!$util.isString(message.displayName))
                            return "displayName: string expected";
                    if (message.classes != null && message.hasOwnProperty("classes")) {
                        properties.EntitlementType = 1;
                        {
                            var error = $root.space.kenko.proto.ClassSubscriptionEntitlement.verify(message.classes);
                            if (error)
                                return "classes." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a SubscriptionEntitlementProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.SubscriptionEntitlementProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.SubscriptionEntitlementProto} SubscriptionEntitlementProto
                 */
                SubscriptionEntitlementProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.SubscriptionEntitlementProto)
                        return object;
                    var message = new $root.space.kenko.proto.SubscriptionEntitlementProto();
                    if (object.id != null)
                        message.id = String(object.id);
                    if (object.displayName != null)
                        message.displayName = String(object.displayName);
                    if (object.classes != null) {
                        if (typeof object.classes !== "object")
                            throw TypeError(".space.kenko.proto.SubscriptionEntitlementProto.classes: object expected");
                        message.classes = $root.space.kenko.proto.ClassSubscriptionEntitlement.fromObject(object.classes);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SubscriptionEntitlementProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.SubscriptionEntitlementProto
                 * @static
                 * @param {space.kenko.proto.SubscriptionEntitlementProto} message SubscriptionEntitlementProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SubscriptionEntitlementProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.id = "";
                        object.displayName = "";
                    }
                    if (message.id != null && message.hasOwnProperty("id"))
                        object.id = message.id;
                    if (message.displayName != null && message.hasOwnProperty("displayName"))
                        object.displayName = message.displayName;
                    if (message.classes != null && message.hasOwnProperty("classes")) {
                        object.classes = $root.space.kenko.proto.ClassSubscriptionEntitlement.toObject(message.classes, options);
                        if (options.oneofs)
                            object.EntitlementType = "classes";
                    }
                    return object;
                };

                /**
                 * Converts this SubscriptionEntitlementProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.SubscriptionEntitlementProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SubscriptionEntitlementProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for SubscriptionEntitlementProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.SubscriptionEntitlementProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                SubscriptionEntitlementProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.SubscriptionEntitlementProto";
                };

                return SubscriptionEntitlementProto;
            })();

            proto.ClassSubscriptionEntitlement = (function() {

                /**
                 * Properties of a ClassSubscriptionEntitlement.
                 * @memberof space.kenko.proto
                 * @interface IClassSubscriptionEntitlement
                 * @property {string|null} [includedPriceCategory] ClassSubscriptionEntitlement includedPriceCategory
                 * @property {number|null} [maxClassesPerDay] ClassSubscriptionEntitlement maxClassesPerDay
                 */

                /**
                 * Constructs a new ClassSubscriptionEntitlement.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a ClassSubscriptionEntitlement.
                 * @implements IClassSubscriptionEntitlement
                 * @constructor
                 * @param {space.kenko.proto.IClassSubscriptionEntitlement=} [properties] Properties to set
                 */
                function ClassSubscriptionEntitlement(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ClassSubscriptionEntitlement includedPriceCategory.
                 * @member {string} includedPriceCategory
                 * @memberof space.kenko.proto.ClassSubscriptionEntitlement
                 * @instance
                 */
                ClassSubscriptionEntitlement.prototype.includedPriceCategory = "";

                /**
                 * ClassSubscriptionEntitlement maxClassesPerDay.
                 * @member {number} maxClassesPerDay
                 * @memberof space.kenko.proto.ClassSubscriptionEntitlement
                 * @instance
                 */
                ClassSubscriptionEntitlement.prototype.maxClassesPerDay = 0;

                /**
                 * Creates a new ClassSubscriptionEntitlement instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.ClassSubscriptionEntitlement
                 * @static
                 * @param {space.kenko.proto.IClassSubscriptionEntitlement=} [properties] Properties to set
                 * @returns {space.kenko.proto.ClassSubscriptionEntitlement} ClassSubscriptionEntitlement instance
                 */
                ClassSubscriptionEntitlement.create = function create(properties) {
                    return new ClassSubscriptionEntitlement(properties);
                };

                /**
                 * Encodes the specified ClassSubscriptionEntitlement message. Does not implicitly {@link space.kenko.proto.ClassSubscriptionEntitlement.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.ClassSubscriptionEntitlement
                 * @static
                 * @param {space.kenko.proto.IClassSubscriptionEntitlement} message ClassSubscriptionEntitlement message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ClassSubscriptionEntitlement.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.includedPriceCategory != null && Object.hasOwnProperty.call(message, "includedPriceCategory"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.includedPriceCategory);
                    if (message.maxClassesPerDay != null && Object.hasOwnProperty.call(message, "maxClassesPerDay"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.maxClassesPerDay);
                    return writer;
                };

                /**
                 * Encodes the specified ClassSubscriptionEntitlement message, length delimited. Does not implicitly {@link space.kenko.proto.ClassSubscriptionEntitlement.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.ClassSubscriptionEntitlement
                 * @static
                 * @param {space.kenko.proto.IClassSubscriptionEntitlement} message ClassSubscriptionEntitlement message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ClassSubscriptionEntitlement.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ClassSubscriptionEntitlement message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.ClassSubscriptionEntitlement
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.ClassSubscriptionEntitlement} ClassSubscriptionEntitlement
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ClassSubscriptionEntitlement.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.ClassSubscriptionEntitlement();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.includedPriceCategory = reader.string();
                                break;
                            }
                        case 2: {
                                message.maxClassesPerDay = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ClassSubscriptionEntitlement message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.ClassSubscriptionEntitlement
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.ClassSubscriptionEntitlement} ClassSubscriptionEntitlement
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ClassSubscriptionEntitlement.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ClassSubscriptionEntitlement message.
                 * @function verify
                 * @memberof space.kenko.proto.ClassSubscriptionEntitlement
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ClassSubscriptionEntitlement.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.includedPriceCategory != null && message.hasOwnProperty("includedPriceCategory"))
                        if (!$util.isString(message.includedPriceCategory))
                            return "includedPriceCategory: string expected";
                    if (message.maxClassesPerDay != null && message.hasOwnProperty("maxClassesPerDay"))
                        if (!$util.isInteger(message.maxClassesPerDay))
                            return "maxClassesPerDay: integer expected";
                    return null;
                };

                /**
                 * Creates a ClassSubscriptionEntitlement message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.ClassSubscriptionEntitlement
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.ClassSubscriptionEntitlement} ClassSubscriptionEntitlement
                 */
                ClassSubscriptionEntitlement.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.ClassSubscriptionEntitlement)
                        return object;
                    var message = new $root.space.kenko.proto.ClassSubscriptionEntitlement();
                    if (object.includedPriceCategory != null)
                        message.includedPriceCategory = String(object.includedPriceCategory);
                    if (object.maxClassesPerDay != null)
                        message.maxClassesPerDay = object.maxClassesPerDay | 0;
                    return message;
                };

                /**
                 * Creates a plain object from a ClassSubscriptionEntitlement message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.ClassSubscriptionEntitlement
                 * @static
                 * @param {space.kenko.proto.ClassSubscriptionEntitlement} message ClassSubscriptionEntitlement
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ClassSubscriptionEntitlement.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.includedPriceCategory = "";
                        object.maxClassesPerDay = 0;
                    }
                    if (message.includedPriceCategory != null && message.hasOwnProperty("includedPriceCategory"))
                        object.includedPriceCategory = message.includedPriceCategory;
                    if (message.maxClassesPerDay != null && message.hasOwnProperty("maxClassesPerDay"))
                        object.maxClassesPerDay = message.maxClassesPerDay;
                    return object;
                };

                /**
                 * Converts this ClassSubscriptionEntitlement to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.ClassSubscriptionEntitlement
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ClassSubscriptionEntitlement.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ClassSubscriptionEntitlement
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.ClassSubscriptionEntitlement
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ClassSubscriptionEntitlement.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.ClassSubscriptionEntitlement";
                };

                return ClassSubscriptionEntitlement;
            })();

            proto.PurchasedSubscriptionProto = (function() {

                /**
                 * Properties of a PurchasedSubscriptionProto.
                 * @memberof space.kenko.proto
                 * @interface IPurchasedSubscriptionProto
                 * @property {string|null} [purchasedSubscriptionId] PurchasedSubscriptionProto purchasedSubscriptionId
                 * @property {space.kenko.proto.ISubscriptionProto|null} [subscriptionDetails] PurchasedSubscriptionProto subscriptionDetails
                 * @property {number|Long|null} [purchaseTimestamp] PurchasedSubscriptionProto purchaseTimestamp
                 * @property {string|null} [subscriptionState] PurchasedSubscriptionProto subscriptionState
                 * @property {number|Long|null} [lastPaidInvoice] PurchasedSubscriptionProto lastPaidInvoice
                 */

                /**
                 * Constructs a new PurchasedSubscriptionProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a PurchasedSubscriptionProto.
                 * @implements IPurchasedSubscriptionProto
                 * @constructor
                 * @param {space.kenko.proto.IPurchasedSubscriptionProto=} [properties] Properties to set
                 */
                function PurchasedSubscriptionProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PurchasedSubscriptionProto purchasedSubscriptionId.
                 * @member {string} purchasedSubscriptionId
                 * @memberof space.kenko.proto.PurchasedSubscriptionProto
                 * @instance
                 */
                PurchasedSubscriptionProto.prototype.purchasedSubscriptionId = "";

                /**
                 * PurchasedSubscriptionProto subscriptionDetails.
                 * @member {space.kenko.proto.ISubscriptionProto|null|undefined} subscriptionDetails
                 * @memberof space.kenko.proto.PurchasedSubscriptionProto
                 * @instance
                 */
                PurchasedSubscriptionProto.prototype.subscriptionDetails = null;

                /**
                 * PurchasedSubscriptionProto purchaseTimestamp.
                 * @member {number|Long} purchaseTimestamp
                 * @memberof space.kenko.proto.PurchasedSubscriptionProto
                 * @instance
                 */
                PurchasedSubscriptionProto.prototype.purchaseTimestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * PurchasedSubscriptionProto subscriptionState.
                 * @member {string} subscriptionState
                 * @memberof space.kenko.proto.PurchasedSubscriptionProto
                 * @instance
                 */
                PurchasedSubscriptionProto.prototype.subscriptionState = "";

                /**
                 * PurchasedSubscriptionProto lastPaidInvoice.
                 * @member {number|Long} lastPaidInvoice
                 * @memberof space.kenko.proto.PurchasedSubscriptionProto
                 * @instance
                 */
                PurchasedSubscriptionProto.prototype.lastPaidInvoice = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Creates a new PurchasedSubscriptionProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.PurchasedSubscriptionProto
                 * @static
                 * @param {space.kenko.proto.IPurchasedSubscriptionProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.PurchasedSubscriptionProto} PurchasedSubscriptionProto instance
                 */
                PurchasedSubscriptionProto.create = function create(properties) {
                    return new PurchasedSubscriptionProto(properties);
                };

                /**
                 * Encodes the specified PurchasedSubscriptionProto message. Does not implicitly {@link space.kenko.proto.PurchasedSubscriptionProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.PurchasedSubscriptionProto
                 * @static
                 * @param {space.kenko.proto.IPurchasedSubscriptionProto} message PurchasedSubscriptionProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PurchasedSubscriptionProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.purchasedSubscriptionId != null && Object.hasOwnProperty.call(message, "purchasedSubscriptionId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.purchasedSubscriptionId);
                    if (message.subscriptionDetails != null && Object.hasOwnProperty.call(message, "subscriptionDetails"))
                        $root.space.kenko.proto.SubscriptionProto.encode(message.subscriptionDetails, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.purchaseTimestamp != null && Object.hasOwnProperty.call(message, "purchaseTimestamp"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int64(message.purchaseTimestamp);
                    if (message.subscriptionState != null && Object.hasOwnProperty.call(message, "subscriptionState"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.subscriptionState);
                    if (message.lastPaidInvoice != null && Object.hasOwnProperty.call(message, "lastPaidInvoice"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int64(message.lastPaidInvoice);
                    return writer;
                };

                /**
                 * Encodes the specified PurchasedSubscriptionProto message, length delimited. Does not implicitly {@link space.kenko.proto.PurchasedSubscriptionProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.PurchasedSubscriptionProto
                 * @static
                 * @param {space.kenko.proto.IPurchasedSubscriptionProto} message PurchasedSubscriptionProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PurchasedSubscriptionProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PurchasedSubscriptionProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.PurchasedSubscriptionProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.PurchasedSubscriptionProto} PurchasedSubscriptionProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PurchasedSubscriptionProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.PurchasedSubscriptionProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.purchasedSubscriptionId = reader.string();
                                break;
                            }
                        case 2: {
                                message.subscriptionDetails = $root.space.kenko.proto.SubscriptionProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.purchaseTimestamp = reader.int64();
                                break;
                            }
                        case 4: {
                                message.subscriptionState = reader.string();
                                break;
                            }
                        case 5: {
                                message.lastPaidInvoice = reader.int64();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PurchasedSubscriptionProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.PurchasedSubscriptionProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.PurchasedSubscriptionProto} PurchasedSubscriptionProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PurchasedSubscriptionProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PurchasedSubscriptionProto message.
                 * @function verify
                 * @memberof space.kenko.proto.PurchasedSubscriptionProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PurchasedSubscriptionProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.purchasedSubscriptionId != null && message.hasOwnProperty("purchasedSubscriptionId"))
                        if (!$util.isString(message.purchasedSubscriptionId))
                            return "purchasedSubscriptionId: string expected";
                    if (message.subscriptionDetails != null && message.hasOwnProperty("subscriptionDetails")) {
                        var error = $root.space.kenko.proto.SubscriptionProto.verify(message.subscriptionDetails);
                        if (error)
                            return "subscriptionDetails." + error;
                    }
                    if (message.purchaseTimestamp != null && message.hasOwnProperty("purchaseTimestamp"))
                        if (!$util.isInteger(message.purchaseTimestamp) && !(message.purchaseTimestamp && $util.isInteger(message.purchaseTimestamp.low) && $util.isInteger(message.purchaseTimestamp.high)))
                            return "purchaseTimestamp: integer|Long expected";
                    if (message.subscriptionState != null && message.hasOwnProperty("subscriptionState"))
                        if (!$util.isString(message.subscriptionState))
                            return "subscriptionState: string expected";
                    if (message.lastPaidInvoice != null && message.hasOwnProperty("lastPaidInvoice"))
                        if (!$util.isInteger(message.lastPaidInvoice) && !(message.lastPaidInvoice && $util.isInteger(message.lastPaidInvoice.low) && $util.isInteger(message.lastPaidInvoice.high)))
                            return "lastPaidInvoice: integer|Long expected";
                    return null;
                };

                /**
                 * Creates a PurchasedSubscriptionProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.PurchasedSubscriptionProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.PurchasedSubscriptionProto} PurchasedSubscriptionProto
                 */
                PurchasedSubscriptionProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.PurchasedSubscriptionProto)
                        return object;
                    var message = new $root.space.kenko.proto.PurchasedSubscriptionProto();
                    if (object.purchasedSubscriptionId != null)
                        message.purchasedSubscriptionId = String(object.purchasedSubscriptionId);
                    if (object.subscriptionDetails != null) {
                        if (typeof object.subscriptionDetails !== "object")
                            throw TypeError(".space.kenko.proto.PurchasedSubscriptionProto.subscriptionDetails: object expected");
                        message.subscriptionDetails = $root.space.kenko.proto.SubscriptionProto.fromObject(object.subscriptionDetails);
                    }
                    if (object.purchaseTimestamp != null)
                        if ($util.Long)
                            (message.purchaseTimestamp = $util.Long.fromValue(object.purchaseTimestamp)).unsigned = false;
                        else if (typeof object.purchaseTimestamp === "string")
                            message.purchaseTimestamp = parseInt(object.purchaseTimestamp, 10);
                        else if (typeof object.purchaseTimestamp === "number")
                            message.purchaseTimestamp = object.purchaseTimestamp;
                        else if (typeof object.purchaseTimestamp === "object")
                            message.purchaseTimestamp = new $util.LongBits(object.purchaseTimestamp.low >>> 0, object.purchaseTimestamp.high >>> 0).toNumber();
                    if (object.subscriptionState != null)
                        message.subscriptionState = String(object.subscriptionState);
                    if (object.lastPaidInvoice != null)
                        if ($util.Long)
                            (message.lastPaidInvoice = $util.Long.fromValue(object.lastPaidInvoice)).unsigned = false;
                        else if (typeof object.lastPaidInvoice === "string")
                            message.lastPaidInvoice = parseInt(object.lastPaidInvoice, 10);
                        else if (typeof object.lastPaidInvoice === "number")
                            message.lastPaidInvoice = object.lastPaidInvoice;
                        else if (typeof object.lastPaidInvoice === "object")
                            message.lastPaidInvoice = new $util.LongBits(object.lastPaidInvoice.low >>> 0, object.lastPaidInvoice.high >>> 0).toNumber();
                    return message;
                };

                /**
                 * Creates a plain object from a PurchasedSubscriptionProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.PurchasedSubscriptionProto
                 * @static
                 * @param {space.kenko.proto.PurchasedSubscriptionProto} message PurchasedSubscriptionProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PurchasedSubscriptionProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.purchasedSubscriptionId = "";
                        object.subscriptionDetails = null;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.purchaseTimestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.purchaseTimestamp = options.longs === String ? "0" : 0;
                        object.subscriptionState = "";
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.lastPaidInvoice = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.lastPaidInvoice = options.longs === String ? "0" : 0;
                    }
                    if (message.purchasedSubscriptionId != null && message.hasOwnProperty("purchasedSubscriptionId"))
                        object.purchasedSubscriptionId = message.purchasedSubscriptionId;
                    if (message.subscriptionDetails != null && message.hasOwnProperty("subscriptionDetails"))
                        object.subscriptionDetails = $root.space.kenko.proto.SubscriptionProto.toObject(message.subscriptionDetails, options);
                    if (message.purchaseTimestamp != null && message.hasOwnProperty("purchaseTimestamp"))
                        if (typeof message.purchaseTimestamp === "number")
                            object.purchaseTimestamp = options.longs === String ? String(message.purchaseTimestamp) : message.purchaseTimestamp;
                        else
                            object.purchaseTimestamp = options.longs === String ? $util.Long.prototype.toString.call(message.purchaseTimestamp) : options.longs === Number ? new $util.LongBits(message.purchaseTimestamp.low >>> 0, message.purchaseTimestamp.high >>> 0).toNumber() : message.purchaseTimestamp;
                    if (message.subscriptionState != null && message.hasOwnProperty("subscriptionState"))
                        object.subscriptionState = message.subscriptionState;
                    if (message.lastPaidInvoice != null && message.hasOwnProperty("lastPaidInvoice"))
                        if (typeof message.lastPaidInvoice === "number")
                            object.lastPaidInvoice = options.longs === String ? String(message.lastPaidInvoice) : message.lastPaidInvoice;
                        else
                            object.lastPaidInvoice = options.longs === String ? $util.Long.prototype.toString.call(message.lastPaidInvoice) : options.longs === Number ? new $util.LongBits(message.lastPaidInvoice.low >>> 0, message.lastPaidInvoice.high >>> 0).toNumber() : message.lastPaidInvoice;
                    return object;
                };

                /**
                 * Converts this PurchasedSubscriptionProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.PurchasedSubscriptionProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PurchasedSubscriptionProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for PurchasedSubscriptionProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.PurchasedSubscriptionProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                PurchasedSubscriptionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.PurchasedSubscriptionProto";
                };

                return PurchasedSubscriptionProto;
            })();

            /**
             * BusinessSubscriptionType enum.
             * @name space.kenko.proto.BusinessSubscriptionType
             * @enum {number}
             * @property {number} SUBSCRIPTION_TYPE_UNKNOWN=0 SUBSCRIPTION_TYPE_UNKNOWN value
             * @property {number} LISTING=1 LISTING value
             * @property {number} LISTING_PLUS_BOOKING=2 LISTING_PLUS_BOOKING value
             */
            proto.BusinessSubscriptionType = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "SUBSCRIPTION_TYPE_UNKNOWN"] = 0;
                values[valuesById[1] = "LISTING"] = 1;
                values[valuesById[2] = "LISTING_PLUS_BOOKING"] = 2;
                return values;
            })();

            proto.BusinessSubscriptionProto = (function() {

                /**
                 * Properties of a BusinessSubscriptionProto.
                 * @memberof space.kenko.proto
                 * @interface IBusinessSubscriptionProto
                 * @property {space.kenko.proto.BusinessSubscriptionType|null} [type] BusinessSubscriptionProto type
                 * @property {number|null} [quantity] BusinessSubscriptionProto quantity
                 * @property {string|null} [paymentProvider] BusinessSubscriptionProto paymentProvider
                 * @property {boolean|null} [isActive] BusinessSubscriptionProto isActive
                 * @property {string|null} [subscriptionId] BusinessSubscriptionProto subscriptionId
                 */

                /**
                 * Constructs a new BusinessSubscriptionProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a BusinessSubscriptionProto.
                 * @implements IBusinessSubscriptionProto
                 * @constructor
                 * @param {space.kenko.proto.IBusinessSubscriptionProto=} [properties] Properties to set
                 */
                function BusinessSubscriptionProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * BusinessSubscriptionProto type.
                 * @member {space.kenko.proto.BusinessSubscriptionType} type
                 * @memberof space.kenko.proto.BusinessSubscriptionProto
                 * @instance
                 */
                BusinessSubscriptionProto.prototype.type = 0;

                /**
                 * BusinessSubscriptionProto quantity.
                 * @member {number} quantity
                 * @memberof space.kenko.proto.BusinessSubscriptionProto
                 * @instance
                 */
                BusinessSubscriptionProto.prototype.quantity = 0;

                /**
                 * BusinessSubscriptionProto paymentProvider.
                 * @member {string} paymentProvider
                 * @memberof space.kenko.proto.BusinessSubscriptionProto
                 * @instance
                 */
                BusinessSubscriptionProto.prototype.paymentProvider = "";

                /**
                 * BusinessSubscriptionProto isActive.
                 * @member {boolean} isActive
                 * @memberof space.kenko.proto.BusinessSubscriptionProto
                 * @instance
                 */
                BusinessSubscriptionProto.prototype.isActive = false;

                /**
                 * BusinessSubscriptionProto subscriptionId.
                 * @member {string} subscriptionId
                 * @memberof space.kenko.proto.BusinessSubscriptionProto
                 * @instance
                 */
                BusinessSubscriptionProto.prototype.subscriptionId = "";

                /**
                 * Creates a new BusinessSubscriptionProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.BusinessSubscriptionProto
                 * @static
                 * @param {space.kenko.proto.IBusinessSubscriptionProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.BusinessSubscriptionProto} BusinessSubscriptionProto instance
                 */
                BusinessSubscriptionProto.create = function create(properties) {
                    return new BusinessSubscriptionProto(properties);
                };

                /**
                 * Encodes the specified BusinessSubscriptionProto message. Does not implicitly {@link space.kenko.proto.BusinessSubscriptionProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.BusinessSubscriptionProto
                 * @static
                 * @param {space.kenko.proto.IBusinessSubscriptionProto} message BusinessSubscriptionProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BusinessSubscriptionProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
                    if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.quantity);
                    if (message.paymentProvider != null && Object.hasOwnProperty.call(message, "paymentProvider"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.paymentProvider);
                    if (message.isActive != null && Object.hasOwnProperty.call(message, "isActive"))
                        writer.uint32(/* id 4, wireType 0 =*/32).bool(message.isActive);
                    if (message.subscriptionId != null && Object.hasOwnProperty.call(message, "subscriptionId"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.subscriptionId);
                    return writer;
                };

                /**
                 * Encodes the specified BusinessSubscriptionProto message, length delimited. Does not implicitly {@link space.kenko.proto.BusinessSubscriptionProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.BusinessSubscriptionProto
                 * @static
                 * @param {space.kenko.proto.IBusinessSubscriptionProto} message BusinessSubscriptionProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BusinessSubscriptionProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a BusinessSubscriptionProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.BusinessSubscriptionProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.BusinessSubscriptionProto} BusinessSubscriptionProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BusinessSubscriptionProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.BusinessSubscriptionProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.type = reader.int32();
                                break;
                            }
                        case 2: {
                                message.quantity = reader.int32();
                                break;
                            }
                        case 3: {
                                message.paymentProvider = reader.string();
                                break;
                            }
                        case 4: {
                                message.isActive = reader.bool();
                                break;
                            }
                        case 5: {
                                message.subscriptionId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a BusinessSubscriptionProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.BusinessSubscriptionProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.BusinessSubscriptionProto} BusinessSubscriptionProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BusinessSubscriptionProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a BusinessSubscriptionProto message.
                 * @function verify
                 * @memberof space.kenko.proto.BusinessSubscriptionProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BusinessSubscriptionProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.type != null && message.hasOwnProperty("type"))
                        switch (message.type) {
                        default:
                            return "type: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.quantity != null && message.hasOwnProperty("quantity"))
                        if (!$util.isInteger(message.quantity))
                            return "quantity: integer expected";
                    if (message.paymentProvider != null && message.hasOwnProperty("paymentProvider"))
                        if (!$util.isString(message.paymentProvider))
                            return "paymentProvider: string expected";
                    if (message.isActive != null && message.hasOwnProperty("isActive"))
                        if (typeof message.isActive !== "boolean")
                            return "isActive: boolean expected";
                    if (message.subscriptionId != null && message.hasOwnProperty("subscriptionId"))
                        if (!$util.isString(message.subscriptionId))
                            return "subscriptionId: string expected";
                    return null;
                };

                /**
                 * Creates a BusinessSubscriptionProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.BusinessSubscriptionProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.BusinessSubscriptionProto} BusinessSubscriptionProto
                 */
                BusinessSubscriptionProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.BusinessSubscriptionProto)
                        return object;
                    var message = new $root.space.kenko.proto.BusinessSubscriptionProto();
                    switch (object.type) {
                    default:
                        if (typeof object.type === "number") {
                            message.type = object.type;
                            break;
                        }
                        break;
                    case "SUBSCRIPTION_TYPE_UNKNOWN":
                    case 0:
                        message.type = 0;
                        break;
                    case "LISTING":
                    case 1:
                        message.type = 1;
                        break;
                    case "LISTING_PLUS_BOOKING":
                    case 2:
                        message.type = 2;
                        break;
                    }
                    if (object.quantity != null)
                        message.quantity = object.quantity | 0;
                    if (object.paymentProvider != null)
                        message.paymentProvider = String(object.paymentProvider);
                    if (object.isActive != null)
                        message.isActive = Boolean(object.isActive);
                    if (object.subscriptionId != null)
                        message.subscriptionId = String(object.subscriptionId);
                    return message;
                };

                /**
                 * Creates a plain object from a BusinessSubscriptionProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.BusinessSubscriptionProto
                 * @static
                 * @param {space.kenko.proto.BusinessSubscriptionProto} message BusinessSubscriptionProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BusinessSubscriptionProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.type = options.enums === String ? "SUBSCRIPTION_TYPE_UNKNOWN" : 0;
                        object.quantity = 0;
                        object.paymentProvider = "";
                        object.isActive = false;
                        object.subscriptionId = "";
                    }
                    if (message.type != null && message.hasOwnProperty("type"))
                        object.type = options.enums === String ? $root.space.kenko.proto.BusinessSubscriptionType[message.type] === undefined ? message.type : $root.space.kenko.proto.BusinessSubscriptionType[message.type] : message.type;
                    if (message.quantity != null && message.hasOwnProperty("quantity"))
                        object.quantity = message.quantity;
                    if (message.paymentProvider != null && message.hasOwnProperty("paymentProvider"))
                        object.paymentProvider = message.paymentProvider;
                    if (message.isActive != null && message.hasOwnProperty("isActive"))
                        object.isActive = message.isActive;
                    if (message.subscriptionId != null && message.hasOwnProperty("subscriptionId"))
                        object.subscriptionId = message.subscriptionId;
                    return object;
                };

                /**
                 * Converts this BusinessSubscriptionProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.BusinessSubscriptionProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BusinessSubscriptionProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for BusinessSubscriptionProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.BusinessSubscriptionProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                BusinessSubscriptionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.BusinessSubscriptionProto";
                };

                return BusinessSubscriptionProto;
            })();

            proto.ConnectedAccountStatusProto = (function() {

                /**
                 * Properties of a ConnectedAccountStatusProto.
                 * @memberof space.kenko.proto
                 * @interface IConnectedAccountStatusProto
                 * @property {boolean|null} [accountIsReady] ConnectedAccountStatusProto accountIsReady
                 * @property {boolean|null} [stripeChargesEnabled] ConnectedAccountStatusProto stripeChargesEnabled
                 * @property {boolean|null} [stripeDetailsSubmitted] ConnectedAccountStatusProto stripeDetailsSubmitted
                 */

                /**
                 * Constructs a new ConnectedAccountStatusProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a ConnectedAccountStatusProto.
                 * @implements IConnectedAccountStatusProto
                 * @constructor
                 * @param {space.kenko.proto.IConnectedAccountStatusProto=} [properties] Properties to set
                 */
                function ConnectedAccountStatusProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ConnectedAccountStatusProto accountIsReady.
                 * @member {boolean} accountIsReady
                 * @memberof space.kenko.proto.ConnectedAccountStatusProto
                 * @instance
                 */
                ConnectedAccountStatusProto.prototype.accountIsReady = false;

                /**
                 * ConnectedAccountStatusProto stripeChargesEnabled.
                 * @member {boolean} stripeChargesEnabled
                 * @memberof space.kenko.proto.ConnectedAccountStatusProto
                 * @instance
                 */
                ConnectedAccountStatusProto.prototype.stripeChargesEnabled = false;

                /**
                 * ConnectedAccountStatusProto stripeDetailsSubmitted.
                 * @member {boolean} stripeDetailsSubmitted
                 * @memberof space.kenko.proto.ConnectedAccountStatusProto
                 * @instance
                 */
                ConnectedAccountStatusProto.prototype.stripeDetailsSubmitted = false;

                /**
                 * Creates a new ConnectedAccountStatusProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.ConnectedAccountStatusProto
                 * @static
                 * @param {space.kenko.proto.IConnectedAccountStatusProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.ConnectedAccountStatusProto} ConnectedAccountStatusProto instance
                 */
                ConnectedAccountStatusProto.create = function create(properties) {
                    return new ConnectedAccountStatusProto(properties);
                };

                /**
                 * Encodes the specified ConnectedAccountStatusProto message. Does not implicitly {@link space.kenko.proto.ConnectedAccountStatusProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.ConnectedAccountStatusProto
                 * @static
                 * @param {space.kenko.proto.IConnectedAccountStatusProto} message ConnectedAccountStatusProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ConnectedAccountStatusProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.accountIsReady != null && Object.hasOwnProperty.call(message, "accountIsReady"))
                        writer.uint32(/* id 1, wireType 0 =*/8).bool(message.accountIsReady);
                    if (message.stripeChargesEnabled != null && Object.hasOwnProperty.call(message, "stripeChargesEnabled"))
                        writer.uint32(/* id 100, wireType 0 =*/800).bool(message.stripeChargesEnabled);
                    if (message.stripeDetailsSubmitted != null && Object.hasOwnProperty.call(message, "stripeDetailsSubmitted"))
                        writer.uint32(/* id 101, wireType 0 =*/808).bool(message.stripeDetailsSubmitted);
                    return writer;
                };

                /**
                 * Encodes the specified ConnectedAccountStatusProto message, length delimited. Does not implicitly {@link space.kenko.proto.ConnectedAccountStatusProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.ConnectedAccountStatusProto
                 * @static
                 * @param {space.kenko.proto.IConnectedAccountStatusProto} message ConnectedAccountStatusProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ConnectedAccountStatusProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ConnectedAccountStatusProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.ConnectedAccountStatusProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.ConnectedAccountStatusProto} ConnectedAccountStatusProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ConnectedAccountStatusProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.ConnectedAccountStatusProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.accountIsReady = reader.bool();
                                break;
                            }
                        case 100: {
                                message.stripeChargesEnabled = reader.bool();
                                break;
                            }
                        case 101: {
                                message.stripeDetailsSubmitted = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ConnectedAccountStatusProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.ConnectedAccountStatusProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.ConnectedAccountStatusProto} ConnectedAccountStatusProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ConnectedAccountStatusProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ConnectedAccountStatusProto message.
                 * @function verify
                 * @memberof space.kenko.proto.ConnectedAccountStatusProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ConnectedAccountStatusProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.accountIsReady != null && message.hasOwnProperty("accountIsReady"))
                        if (typeof message.accountIsReady !== "boolean")
                            return "accountIsReady: boolean expected";
                    if (message.stripeChargesEnabled != null && message.hasOwnProperty("stripeChargesEnabled"))
                        if (typeof message.stripeChargesEnabled !== "boolean")
                            return "stripeChargesEnabled: boolean expected";
                    if (message.stripeDetailsSubmitted != null && message.hasOwnProperty("stripeDetailsSubmitted"))
                        if (typeof message.stripeDetailsSubmitted !== "boolean")
                            return "stripeDetailsSubmitted: boolean expected";
                    return null;
                };

                /**
                 * Creates a ConnectedAccountStatusProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.ConnectedAccountStatusProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.ConnectedAccountStatusProto} ConnectedAccountStatusProto
                 */
                ConnectedAccountStatusProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.ConnectedAccountStatusProto)
                        return object;
                    var message = new $root.space.kenko.proto.ConnectedAccountStatusProto();
                    if (object.accountIsReady != null)
                        message.accountIsReady = Boolean(object.accountIsReady);
                    if (object.stripeChargesEnabled != null)
                        message.stripeChargesEnabled = Boolean(object.stripeChargesEnabled);
                    if (object.stripeDetailsSubmitted != null)
                        message.stripeDetailsSubmitted = Boolean(object.stripeDetailsSubmitted);
                    return message;
                };

                /**
                 * Creates a plain object from a ConnectedAccountStatusProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.ConnectedAccountStatusProto
                 * @static
                 * @param {space.kenko.proto.ConnectedAccountStatusProto} message ConnectedAccountStatusProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ConnectedAccountStatusProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.accountIsReady = false;
                        object.stripeChargesEnabled = false;
                        object.stripeDetailsSubmitted = false;
                    }
                    if (message.accountIsReady != null && message.hasOwnProperty("accountIsReady"))
                        object.accountIsReady = message.accountIsReady;
                    if (message.stripeChargesEnabled != null && message.hasOwnProperty("stripeChargesEnabled"))
                        object.stripeChargesEnabled = message.stripeChargesEnabled;
                    if (message.stripeDetailsSubmitted != null && message.hasOwnProperty("stripeDetailsSubmitted"))
                        object.stripeDetailsSubmitted = message.stripeDetailsSubmitted;
                    return object;
                };

                /**
                 * Converts this ConnectedAccountStatusProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.ConnectedAccountStatusProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ConnectedAccountStatusProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ConnectedAccountStatusProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.ConnectedAccountStatusProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ConnectedAccountStatusProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.ConnectedAccountStatusProto";
                };

                return ConnectedAccountStatusProto;
            })();

            proto.BusinessSettingsProto = (function() {

                /**
                 * Properties of a BusinessSettingsProto.
                 * @memberof space.kenko.proto
                 * @interface IBusinessSettingsProto
                 * @property {boolean|null} [offersClasses] BusinessSettingsProto offersClasses
                 * @property {boolean|null} [offersAppointments] BusinessSettingsProto offersAppointments
                 * @property {boolean|null} [offersVirtualServices] BusinessSettingsProto offersVirtualServices
                 * @property {boolean|null} [offersInPersonServices] BusinessSettingsProto offersInPersonServices
                 * @property {boolean|null} [newClientsMustInquire] BusinessSettingsProto newClientsMustInquire
                 */

                /**
                 * Constructs a new BusinessSettingsProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a BusinessSettingsProto.
                 * @implements IBusinessSettingsProto
                 * @constructor
                 * @param {space.kenko.proto.IBusinessSettingsProto=} [properties] Properties to set
                 */
                function BusinessSettingsProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * BusinessSettingsProto offersClasses.
                 * @member {boolean} offersClasses
                 * @memberof space.kenko.proto.BusinessSettingsProto
                 * @instance
                 */
                BusinessSettingsProto.prototype.offersClasses = false;

                /**
                 * BusinessSettingsProto offersAppointments.
                 * @member {boolean} offersAppointments
                 * @memberof space.kenko.proto.BusinessSettingsProto
                 * @instance
                 */
                BusinessSettingsProto.prototype.offersAppointments = false;

                /**
                 * BusinessSettingsProto offersVirtualServices.
                 * @member {boolean} offersVirtualServices
                 * @memberof space.kenko.proto.BusinessSettingsProto
                 * @instance
                 */
                BusinessSettingsProto.prototype.offersVirtualServices = false;

                /**
                 * BusinessSettingsProto offersInPersonServices.
                 * @member {boolean} offersInPersonServices
                 * @memberof space.kenko.proto.BusinessSettingsProto
                 * @instance
                 */
                BusinessSettingsProto.prototype.offersInPersonServices = false;

                /**
                 * BusinessSettingsProto newClientsMustInquire.
                 * @member {boolean} newClientsMustInquire
                 * @memberof space.kenko.proto.BusinessSettingsProto
                 * @instance
                 */
                BusinessSettingsProto.prototype.newClientsMustInquire = false;

                /**
                 * Creates a new BusinessSettingsProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.BusinessSettingsProto
                 * @static
                 * @param {space.kenko.proto.IBusinessSettingsProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.BusinessSettingsProto} BusinessSettingsProto instance
                 */
                BusinessSettingsProto.create = function create(properties) {
                    return new BusinessSettingsProto(properties);
                };

                /**
                 * Encodes the specified BusinessSettingsProto message. Does not implicitly {@link space.kenko.proto.BusinessSettingsProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.BusinessSettingsProto
                 * @static
                 * @param {space.kenko.proto.IBusinessSettingsProto} message BusinessSettingsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BusinessSettingsProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.offersClasses != null && Object.hasOwnProperty.call(message, "offersClasses"))
                        writer.uint32(/* id 1, wireType 0 =*/8).bool(message.offersClasses);
                    if (message.offersAppointments != null && Object.hasOwnProperty.call(message, "offersAppointments"))
                        writer.uint32(/* id 2, wireType 0 =*/16).bool(message.offersAppointments);
                    if (message.offersVirtualServices != null && Object.hasOwnProperty.call(message, "offersVirtualServices"))
                        writer.uint32(/* id 3, wireType 0 =*/24).bool(message.offersVirtualServices);
                    if (message.offersInPersonServices != null && Object.hasOwnProperty.call(message, "offersInPersonServices"))
                        writer.uint32(/* id 4, wireType 0 =*/32).bool(message.offersInPersonServices);
                    if (message.newClientsMustInquire != null && Object.hasOwnProperty.call(message, "newClientsMustInquire"))
                        writer.uint32(/* id 10, wireType 0 =*/80).bool(message.newClientsMustInquire);
                    return writer;
                };

                /**
                 * Encodes the specified BusinessSettingsProto message, length delimited. Does not implicitly {@link space.kenko.proto.BusinessSettingsProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.BusinessSettingsProto
                 * @static
                 * @param {space.kenko.proto.IBusinessSettingsProto} message BusinessSettingsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BusinessSettingsProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a BusinessSettingsProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.BusinessSettingsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.BusinessSettingsProto} BusinessSettingsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BusinessSettingsProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.BusinessSettingsProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.offersClasses = reader.bool();
                                break;
                            }
                        case 2: {
                                message.offersAppointments = reader.bool();
                                break;
                            }
                        case 3: {
                                message.offersVirtualServices = reader.bool();
                                break;
                            }
                        case 4: {
                                message.offersInPersonServices = reader.bool();
                                break;
                            }
                        case 10: {
                                message.newClientsMustInquire = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a BusinessSettingsProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.BusinessSettingsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.BusinessSettingsProto} BusinessSettingsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BusinessSettingsProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a BusinessSettingsProto message.
                 * @function verify
                 * @memberof space.kenko.proto.BusinessSettingsProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BusinessSettingsProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.offersClasses != null && message.hasOwnProperty("offersClasses"))
                        if (typeof message.offersClasses !== "boolean")
                            return "offersClasses: boolean expected";
                    if (message.offersAppointments != null && message.hasOwnProperty("offersAppointments"))
                        if (typeof message.offersAppointments !== "boolean")
                            return "offersAppointments: boolean expected";
                    if (message.offersVirtualServices != null && message.hasOwnProperty("offersVirtualServices"))
                        if (typeof message.offersVirtualServices !== "boolean")
                            return "offersVirtualServices: boolean expected";
                    if (message.offersInPersonServices != null && message.hasOwnProperty("offersInPersonServices"))
                        if (typeof message.offersInPersonServices !== "boolean")
                            return "offersInPersonServices: boolean expected";
                    if (message.newClientsMustInquire != null && message.hasOwnProperty("newClientsMustInquire"))
                        if (typeof message.newClientsMustInquire !== "boolean")
                            return "newClientsMustInquire: boolean expected";
                    return null;
                };

                /**
                 * Creates a BusinessSettingsProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.BusinessSettingsProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.BusinessSettingsProto} BusinessSettingsProto
                 */
                BusinessSettingsProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.BusinessSettingsProto)
                        return object;
                    var message = new $root.space.kenko.proto.BusinessSettingsProto();
                    if (object.offersClasses != null)
                        message.offersClasses = Boolean(object.offersClasses);
                    if (object.offersAppointments != null)
                        message.offersAppointments = Boolean(object.offersAppointments);
                    if (object.offersVirtualServices != null)
                        message.offersVirtualServices = Boolean(object.offersVirtualServices);
                    if (object.offersInPersonServices != null)
                        message.offersInPersonServices = Boolean(object.offersInPersonServices);
                    if (object.newClientsMustInquire != null)
                        message.newClientsMustInquire = Boolean(object.newClientsMustInquire);
                    return message;
                };

                /**
                 * Creates a plain object from a BusinessSettingsProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.BusinessSettingsProto
                 * @static
                 * @param {space.kenko.proto.BusinessSettingsProto} message BusinessSettingsProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BusinessSettingsProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.offersClasses = false;
                        object.offersAppointments = false;
                        object.offersVirtualServices = false;
                        object.offersInPersonServices = false;
                        object.newClientsMustInquire = false;
                    }
                    if (message.offersClasses != null && message.hasOwnProperty("offersClasses"))
                        object.offersClasses = message.offersClasses;
                    if (message.offersAppointments != null && message.hasOwnProperty("offersAppointments"))
                        object.offersAppointments = message.offersAppointments;
                    if (message.offersVirtualServices != null && message.hasOwnProperty("offersVirtualServices"))
                        object.offersVirtualServices = message.offersVirtualServices;
                    if (message.offersInPersonServices != null && message.hasOwnProperty("offersInPersonServices"))
                        object.offersInPersonServices = message.offersInPersonServices;
                    if (message.newClientsMustInquire != null && message.hasOwnProperty("newClientsMustInquire"))
                        object.newClientsMustInquire = message.newClientsMustInquire;
                    return object;
                };

                /**
                 * Converts this BusinessSettingsProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.BusinessSettingsProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BusinessSettingsProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for BusinessSettingsProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.BusinessSettingsProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                BusinessSettingsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.BusinessSettingsProto";
                };

                return BusinessSettingsProto;
            })();

            proto.BusinessOnboardingStateProto = (function() {

                /**
                 * Properties of a BusinessOnboardingStateProto.
                 * @memberof space.kenko.proto
                 * @interface IBusinessOnboardingStateProto
                 * @property {boolean|null} [createdFirstCalendarAppt] BusinessOnboardingStateProto createdFirstCalendarAppt
                 */

                /**
                 * Constructs a new BusinessOnboardingStateProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a BusinessOnboardingStateProto.
                 * @implements IBusinessOnboardingStateProto
                 * @constructor
                 * @param {space.kenko.proto.IBusinessOnboardingStateProto=} [properties] Properties to set
                 */
                function BusinessOnboardingStateProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * BusinessOnboardingStateProto createdFirstCalendarAppt.
                 * @member {boolean} createdFirstCalendarAppt
                 * @memberof space.kenko.proto.BusinessOnboardingStateProto
                 * @instance
                 */
                BusinessOnboardingStateProto.prototype.createdFirstCalendarAppt = false;

                /**
                 * Creates a new BusinessOnboardingStateProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.BusinessOnboardingStateProto
                 * @static
                 * @param {space.kenko.proto.IBusinessOnboardingStateProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.BusinessOnboardingStateProto} BusinessOnboardingStateProto instance
                 */
                BusinessOnboardingStateProto.create = function create(properties) {
                    return new BusinessOnboardingStateProto(properties);
                };

                /**
                 * Encodes the specified BusinessOnboardingStateProto message. Does not implicitly {@link space.kenko.proto.BusinessOnboardingStateProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.BusinessOnboardingStateProto
                 * @static
                 * @param {space.kenko.proto.IBusinessOnboardingStateProto} message BusinessOnboardingStateProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BusinessOnboardingStateProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.createdFirstCalendarAppt != null && Object.hasOwnProperty.call(message, "createdFirstCalendarAppt"))
                        writer.uint32(/* id 1, wireType 0 =*/8).bool(message.createdFirstCalendarAppt);
                    return writer;
                };

                /**
                 * Encodes the specified BusinessOnboardingStateProto message, length delimited. Does not implicitly {@link space.kenko.proto.BusinessOnboardingStateProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.BusinessOnboardingStateProto
                 * @static
                 * @param {space.kenko.proto.IBusinessOnboardingStateProto} message BusinessOnboardingStateProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BusinessOnboardingStateProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a BusinessOnboardingStateProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.BusinessOnboardingStateProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.BusinessOnboardingStateProto} BusinessOnboardingStateProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BusinessOnboardingStateProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.BusinessOnboardingStateProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.createdFirstCalendarAppt = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a BusinessOnboardingStateProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.BusinessOnboardingStateProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.BusinessOnboardingStateProto} BusinessOnboardingStateProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BusinessOnboardingStateProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a BusinessOnboardingStateProto message.
                 * @function verify
                 * @memberof space.kenko.proto.BusinessOnboardingStateProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BusinessOnboardingStateProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.createdFirstCalendarAppt != null && message.hasOwnProperty("createdFirstCalendarAppt"))
                        if (typeof message.createdFirstCalendarAppt !== "boolean")
                            return "createdFirstCalendarAppt: boolean expected";
                    return null;
                };

                /**
                 * Creates a BusinessOnboardingStateProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.BusinessOnboardingStateProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.BusinessOnboardingStateProto} BusinessOnboardingStateProto
                 */
                BusinessOnboardingStateProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.BusinessOnboardingStateProto)
                        return object;
                    var message = new $root.space.kenko.proto.BusinessOnboardingStateProto();
                    if (object.createdFirstCalendarAppt != null)
                        message.createdFirstCalendarAppt = Boolean(object.createdFirstCalendarAppt);
                    return message;
                };

                /**
                 * Creates a plain object from a BusinessOnboardingStateProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.BusinessOnboardingStateProto
                 * @static
                 * @param {space.kenko.proto.BusinessOnboardingStateProto} message BusinessOnboardingStateProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BusinessOnboardingStateProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.createdFirstCalendarAppt = false;
                    if (message.createdFirstCalendarAppt != null && message.hasOwnProperty("createdFirstCalendarAppt"))
                        object.createdFirstCalendarAppt = message.createdFirstCalendarAppt;
                    return object;
                };

                /**
                 * Converts this BusinessOnboardingStateProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.BusinessOnboardingStateProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BusinessOnboardingStateProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for BusinessOnboardingStateProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.BusinessOnboardingStateProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                BusinessOnboardingStateProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.BusinessOnboardingStateProto";
                };

                return BusinessOnboardingStateProto;
            })();

            proto.PaymentPolicyProto = (function() {

                /**
                 * Properties of a PaymentPolicyProto.
                 * @memberof space.kenko.proto
                 * @interface IPaymentPolicyProto
                 * @property {space.kenko.proto.IPrepaidPaymentPolicyProto|null} [prepaid] PaymentPolicyProto prepaid
                 * @property {space.kenko.proto.IPostpaidPaymentPolicyProto|null} [postpaid] PaymentPolicyProto postpaid
                 */

                /**
                 * Constructs a new PaymentPolicyProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a PaymentPolicyProto.
                 * @implements IPaymentPolicyProto
                 * @constructor
                 * @param {space.kenko.proto.IPaymentPolicyProto=} [properties] Properties to set
                 */
                function PaymentPolicyProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PaymentPolicyProto prepaid.
                 * @member {space.kenko.proto.IPrepaidPaymentPolicyProto|null|undefined} prepaid
                 * @memberof space.kenko.proto.PaymentPolicyProto
                 * @instance
                 */
                PaymentPolicyProto.prototype.prepaid = null;

                /**
                 * PaymentPolicyProto postpaid.
                 * @member {space.kenko.proto.IPostpaidPaymentPolicyProto|null|undefined} postpaid
                 * @memberof space.kenko.proto.PaymentPolicyProto
                 * @instance
                 */
                PaymentPolicyProto.prototype.postpaid = null;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * PaymentPolicyProto PaymentPolicy.
                 * @member {"prepaid"|"postpaid"|undefined} PaymentPolicy
                 * @memberof space.kenko.proto.PaymentPolicyProto
                 * @instance
                 */
                Object.defineProperty(PaymentPolicyProto.prototype, "PaymentPolicy", {
                    get: $util.oneOfGetter($oneOfFields = ["prepaid", "postpaid"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new PaymentPolicyProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.PaymentPolicyProto
                 * @static
                 * @param {space.kenko.proto.IPaymentPolicyProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.PaymentPolicyProto} PaymentPolicyProto instance
                 */
                PaymentPolicyProto.create = function create(properties) {
                    return new PaymentPolicyProto(properties);
                };

                /**
                 * Encodes the specified PaymentPolicyProto message. Does not implicitly {@link space.kenko.proto.PaymentPolicyProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.PaymentPolicyProto
                 * @static
                 * @param {space.kenko.proto.IPaymentPolicyProto} message PaymentPolicyProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PaymentPolicyProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.prepaid != null && Object.hasOwnProperty.call(message, "prepaid"))
                        $root.space.kenko.proto.PrepaidPaymentPolicyProto.encode(message.prepaid, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.postpaid != null && Object.hasOwnProperty.call(message, "postpaid"))
                        $root.space.kenko.proto.PostpaidPaymentPolicyProto.encode(message.postpaid, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified PaymentPolicyProto message, length delimited. Does not implicitly {@link space.kenko.proto.PaymentPolicyProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.PaymentPolicyProto
                 * @static
                 * @param {space.kenko.proto.IPaymentPolicyProto} message PaymentPolicyProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PaymentPolicyProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PaymentPolicyProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.PaymentPolicyProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.PaymentPolicyProto} PaymentPolicyProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PaymentPolicyProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.PaymentPolicyProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.prepaid = $root.space.kenko.proto.PrepaidPaymentPolicyProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.postpaid = $root.space.kenko.proto.PostpaidPaymentPolicyProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PaymentPolicyProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.PaymentPolicyProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.PaymentPolicyProto} PaymentPolicyProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PaymentPolicyProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PaymentPolicyProto message.
                 * @function verify
                 * @memberof space.kenko.proto.PaymentPolicyProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PaymentPolicyProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.prepaid != null && message.hasOwnProperty("prepaid")) {
                        properties.PaymentPolicy = 1;
                        {
                            var error = $root.space.kenko.proto.PrepaidPaymentPolicyProto.verify(message.prepaid);
                            if (error)
                                return "prepaid." + error;
                        }
                    }
                    if (message.postpaid != null && message.hasOwnProperty("postpaid")) {
                        if (properties.PaymentPolicy === 1)
                            return "PaymentPolicy: multiple values";
                        properties.PaymentPolicy = 1;
                        {
                            var error = $root.space.kenko.proto.PostpaidPaymentPolicyProto.verify(message.postpaid);
                            if (error)
                                return "postpaid." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a PaymentPolicyProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.PaymentPolicyProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.PaymentPolicyProto} PaymentPolicyProto
                 */
                PaymentPolicyProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.PaymentPolicyProto)
                        return object;
                    var message = new $root.space.kenko.proto.PaymentPolicyProto();
                    if (object.prepaid != null) {
                        if (typeof object.prepaid !== "object")
                            throw TypeError(".space.kenko.proto.PaymentPolicyProto.prepaid: object expected");
                        message.prepaid = $root.space.kenko.proto.PrepaidPaymentPolicyProto.fromObject(object.prepaid);
                    }
                    if (object.postpaid != null) {
                        if (typeof object.postpaid !== "object")
                            throw TypeError(".space.kenko.proto.PaymentPolicyProto.postpaid: object expected");
                        message.postpaid = $root.space.kenko.proto.PostpaidPaymentPolicyProto.fromObject(object.postpaid);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a PaymentPolicyProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.PaymentPolicyProto
                 * @static
                 * @param {space.kenko.proto.PaymentPolicyProto} message PaymentPolicyProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PaymentPolicyProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (message.prepaid != null && message.hasOwnProperty("prepaid")) {
                        object.prepaid = $root.space.kenko.proto.PrepaidPaymentPolicyProto.toObject(message.prepaid, options);
                        if (options.oneofs)
                            object.PaymentPolicy = "prepaid";
                    }
                    if (message.postpaid != null && message.hasOwnProperty("postpaid")) {
                        object.postpaid = $root.space.kenko.proto.PostpaidPaymentPolicyProto.toObject(message.postpaid, options);
                        if (options.oneofs)
                            object.PaymentPolicy = "postpaid";
                    }
                    return object;
                };

                /**
                 * Converts this PaymentPolicyProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.PaymentPolicyProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PaymentPolicyProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for PaymentPolicyProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.PaymentPolicyProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                PaymentPolicyProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.PaymentPolicyProto";
                };

                return PaymentPolicyProto;
            })();

            proto.PrepaidPaymentPolicyProto = (function() {

                /**
                 * Properties of a PrepaidPaymentPolicyProto.
                 * @memberof space.kenko.proto
                 * @interface IPrepaidPaymentPolicyProto
                 * @property {string|null} [priceCategoryId] PrepaidPaymentPolicyProto priceCategoryId
                 * @property {space.kenko.proto.IPriceProto|null} [price] PrepaidPaymentPolicyProto price
                 */

                /**
                 * Constructs a new PrepaidPaymentPolicyProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a PrepaidPaymentPolicyProto.
                 * @implements IPrepaidPaymentPolicyProto
                 * @constructor
                 * @param {space.kenko.proto.IPrepaidPaymentPolicyProto=} [properties] Properties to set
                 */
                function PrepaidPaymentPolicyProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PrepaidPaymentPolicyProto priceCategoryId.
                 * @member {string} priceCategoryId
                 * @memberof space.kenko.proto.PrepaidPaymentPolicyProto
                 * @instance
                 */
                PrepaidPaymentPolicyProto.prototype.priceCategoryId = "";

                /**
                 * PrepaidPaymentPolicyProto price.
                 * @member {space.kenko.proto.IPriceProto|null|undefined} price
                 * @memberof space.kenko.proto.PrepaidPaymentPolicyProto
                 * @instance
                 */
                PrepaidPaymentPolicyProto.prototype.price = null;

                /**
                 * Creates a new PrepaidPaymentPolicyProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.PrepaidPaymentPolicyProto
                 * @static
                 * @param {space.kenko.proto.IPrepaidPaymentPolicyProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.PrepaidPaymentPolicyProto} PrepaidPaymentPolicyProto instance
                 */
                PrepaidPaymentPolicyProto.create = function create(properties) {
                    return new PrepaidPaymentPolicyProto(properties);
                };

                /**
                 * Encodes the specified PrepaidPaymentPolicyProto message. Does not implicitly {@link space.kenko.proto.PrepaidPaymentPolicyProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.PrepaidPaymentPolicyProto
                 * @static
                 * @param {space.kenko.proto.IPrepaidPaymentPolicyProto} message PrepaidPaymentPolicyProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PrepaidPaymentPolicyProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.priceCategoryId != null && Object.hasOwnProperty.call(message, "priceCategoryId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.priceCategoryId);
                    if (message.price != null && Object.hasOwnProperty.call(message, "price"))
                        $root.space.kenko.proto.PriceProto.encode(message.price, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified PrepaidPaymentPolicyProto message, length delimited. Does not implicitly {@link space.kenko.proto.PrepaidPaymentPolicyProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.PrepaidPaymentPolicyProto
                 * @static
                 * @param {space.kenko.proto.IPrepaidPaymentPolicyProto} message PrepaidPaymentPolicyProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PrepaidPaymentPolicyProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PrepaidPaymentPolicyProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.PrepaidPaymentPolicyProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.PrepaidPaymentPolicyProto} PrepaidPaymentPolicyProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PrepaidPaymentPolicyProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.PrepaidPaymentPolicyProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.priceCategoryId = reader.string();
                                break;
                            }
                        case 2: {
                                message.price = $root.space.kenko.proto.PriceProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PrepaidPaymentPolicyProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.PrepaidPaymentPolicyProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.PrepaidPaymentPolicyProto} PrepaidPaymentPolicyProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PrepaidPaymentPolicyProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PrepaidPaymentPolicyProto message.
                 * @function verify
                 * @memberof space.kenko.proto.PrepaidPaymentPolicyProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PrepaidPaymentPolicyProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.priceCategoryId != null && message.hasOwnProperty("priceCategoryId"))
                        if (!$util.isString(message.priceCategoryId))
                            return "priceCategoryId: string expected";
                    if (message.price != null && message.hasOwnProperty("price")) {
                        var error = $root.space.kenko.proto.PriceProto.verify(message.price);
                        if (error)
                            return "price." + error;
                    }
                    return null;
                };

                /**
                 * Creates a PrepaidPaymentPolicyProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.PrepaidPaymentPolicyProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.PrepaidPaymentPolicyProto} PrepaidPaymentPolicyProto
                 */
                PrepaidPaymentPolicyProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.PrepaidPaymentPolicyProto)
                        return object;
                    var message = new $root.space.kenko.proto.PrepaidPaymentPolicyProto();
                    if (object.priceCategoryId != null)
                        message.priceCategoryId = String(object.priceCategoryId);
                    if (object.price != null) {
                        if (typeof object.price !== "object")
                            throw TypeError(".space.kenko.proto.PrepaidPaymentPolicyProto.price: object expected");
                        message.price = $root.space.kenko.proto.PriceProto.fromObject(object.price);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a PrepaidPaymentPolicyProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.PrepaidPaymentPolicyProto
                 * @static
                 * @param {space.kenko.proto.PrepaidPaymentPolicyProto} message PrepaidPaymentPolicyProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PrepaidPaymentPolicyProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.priceCategoryId = "";
                        object.price = null;
                    }
                    if (message.priceCategoryId != null && message.hasOwnProperty("priceCategoryId"))
                        object.priceCategoryId = message.priceCategoryId;
                    if (message.price != null && message.hasOwnProperty("price"))
                        object.price = $root.space.kenko.proto.PriceProto.toObject(message.price, options);
                    return object;
                };

                /**
                 * Converts this PrepaidPaymentPolicyProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.PrepaidPaymentPolicyProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PrepaidPaymentPolicyProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for PrepaidPaymentPolicyProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.PrepaidPaymentPolicyProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                PrepaidPaymentPolicyProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.PrepaidPaymentPolicyProto";
                };

                return PrepaidPaymentPolicyProto;
            })();

            proto.PostpaidPaymentPolicyProto = (function() {

                /**
                 * Properties of a PostpaidPaymentPolicyProto.
                 * @memberof space.kenko.proto
                 * @interface IPostpaidPaymentPolicyProto
                 * @property {space.kenko.proto.IPriceProto|null} [price] PostpaidPaymentPolicyProto price
                 */

                /**
                 * Constructs a new PostpaidPaymentPolicyProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a PostpaidPaymentPolicyProto.
                 * @implements IPostpaidPaymentPolicyProto
                 * @constructor
                 * @param {space.kenko.proto.IPostpaidPaymentPolicyProto=} [properties] Properties to set
                 */
                function PostpaidPaymentPolicyProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PostpaidPaymentPolicyProto price.
                 * @member {space.kenko.proto.IPriceProto|null|undefined} price
                 * @memberof space.kenko.proto.PostpaidPaymentPolicyProto
                 * @instance
                 */
                PostpaidPaymentPolicyProto.prototype.price = null;

                /**
                 * Creates a new PostpaidPaymentPolicyProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.PostpaidPaymentPolicyProto
                 * @static
                 * @param {space.kenko.proto.IPostpaidPaymentPolicyProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.PostpaidPaymentPolicyProto} PostpaidPaymentPolicyProto instance
                 */
                PostpaidPaymentPolicyProto.create = function create(properties) {
                    return new PostpaidPaymentPolicyProto(properties);
                };

                /**
                 * Encodes the specified PostpaidPaymentPolicyProto message. Does not implicitly {@link space.kenko.proto.PostpaidPaymentPolicyProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.PostpaidPaymentPolicyProto
                 * @static
                 * @param {space.kenko.proto.IPostpaidPaymentPolicyProto} message PostpaidPaymentPolicyProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PostpaidPaymentPolicyProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.price != null && Object.hasOwnProperty.call(message, "price"))
                        $root.space.kenko.proto.PriceProto.encode(message.price, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified PostpaidPaymentPolicyProto message, length delimited. Does not implicitly {@link space.kenko.proto.PostpaidPaymentPolicyProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.PostpaidPaymentPolicyProto
                 * @static
                 * @param {space.kenko.proto.IPostpaidPaymentPolicyProto} message PostpaidPaymentPolicyProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PostpaidPaymentPolicyProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PostpaidPaymentPolicyProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.PostpaidPaymentPolicyProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.PostpaidPaymentPolicyProto} PostpaidPaymentPolicyProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PostpaidPaymentPolicyProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.PostpaidPaymentPolicyProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.price = $root.space.kenko.proto.PriceProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PostpaidPaymentPolicyProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.PostpaidPaymentPolicyProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.PostpaidPaymentPolicyProto} PostpaidPaymentPolicyProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PostpaidPaymentPolicyProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PostpaidPaymentPolicyProto message.
                 * @function verify
                 * @memberof space.kenko.proto.PostpaidPaymentPolicyProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PostpaidPaymentPolicyProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.price != null && message.hasOwnProperty("price")) {
                        var error = $root.space.kenko.proto.PriceProto.verify(message.price);
                        if (error)
                            return "price." + error;
                    }
                    return null;
                };

                /**
                 * Creates a PostpaidPaymentPolicyProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.PostpaidPaymentPolicyProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.PostpaidPaymentPolicyProto} PostpaidPaymentPolicyProto
                 */
                PostpaidPaymentPolicyProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.PostpaidPaymentPolicyProto)
                        return object;
                    var message = new $root.space.kenko.proto.PostpaidPaymentPolicyProto();
                    if (object.price != null) {
                        if (typeof object.price !== "object")
                            throw TypeError(".space.kenko.proto.PostpaidPaymentPolicyProto.price: object expected");
                        message.price = $root.space.kenko.proto.PriceProto.fromObject(object.price);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a PostpaidPaymentPolicyProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.PostpaidPaymentPolicyProto
                 * @static
                 * @param {space.kenko.proto.PostpaidPaymentPolicyProto} message PostpaidPaymentPolicyProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PostpaidPaymentPolicyProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.price = null;
                    if (message.price != null && message.hasOwnProperty("price"))
                        object.price = $root.space.kenko.proto.PriceProto.toObject(message.price, options);
                    return object;
                };

                /**
                 * Converts this PostpaidPaymentPolicyProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.PostpaidPaymentPolicyProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PostpaidPaymentPolicyProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for PostpaidPaymentPolicyProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.PostpaidPaymentPolicyProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                PostpaidPaymentPolicyProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.PostpaidPaymentPolicyProto";
                };

                return PostpaidPaymentPolicyProto;
            })();

            proto.ApiPaymentProto = (function() {

                /**
                 * Properties of an ApiPaymentProto.
                 * @memberof space.kenko.proto
                 * @interface IApiPaymentProto
                 * @property {string|null} [paymentId] ApiPaymentProto paymentId
                 * @property {string|null} [userId] ApiPaymentProto userId
                 * @property {string|null} [userName] ApiPaymentProto userName
                 * @property {string|null} [businessId] ApiPaymentProto businessId
                 * @property {space.kenko.proto.IPriceProto|null} [price] ApiPaymentProto price
                 * @property {number|Long|null} [createdTimestampMs] ApiPaymentProto createdTimestampMs
                 * @property {string|null} [status] ApiPaymentProto status
                 * @property {string|null} [purchasedThingName] ApiPaymentProto purchasedThingName
                 */

                /**
                 * Constructs a new ApiPaymentProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents an ApiPaymentProto.
                 * @implements IApiPaymentProto
                 * @constructor
                 * @param {space.kenko.proto.IApiPaymentProto=} [properties] Properties to set
                 */
                function ApiPaymentProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ApiPaymentProto paymentId.
                 * @member {string} paymentId
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @instance
                 */
                ApiPaymentProto.prototype.paymentId = "";

                /**
                 * ApiPaymentProto userId.
                 * @member {string} userId
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @instance
                 */
                ApiPaymentProto.prototype.userId = "";

                /**
                 * ApiPaymentProto userName.
                 * @member {string} userName
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @instance
                 */
                ApiPaymentProto.prototype.userName = "";

                /**
                 * ApiPaymentProto businessId.
                 * @member {string} businessId
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @instance
                 */
                ApiPaymentProto.prototype.businessId = "";

                /**
                 * ApiPaymentProto price.
                 * @member {space.kenko.proto.IPriceProto|null|undefined} price
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @instance
                 */
                ApiPaymentProto.prototype.price = null;

                /**
                 * ApiPaymentProto createdTimestampMs.
                 * @member {number|Long} createdTimestampMs
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @instance
                 */
                ApiPaymentProto.prototype.createdTimestampMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * ApiPaymentProto status.
                 * @member {string} status
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @instance
                 */
                ApiPaymentProto.prototype.status = "";

                /**
                 * ApiPaymentProto purchasedThingName.
                 * @member {string} purchasedThingName
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @instance
                 */
                ApiPaymentProto.prototype.purchasedThingName = "";

                /**
                 * Creates a new ApiPaymentProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @static
                 * @param {space.kenko.proto.IApiPaymentProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.ApiPaymentProto} ApiPaymentProto instance
                 */
                ApiPaymentProto.create = function create(properties) {
                    return new ApiPaymentProto(properties);
                };

                /**
                 * Encodes the specified ApiPaymentProto message. Does not implicitly {@link space.kenko.proto.ApiPaymentProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @static
                 * @param {space.kenko.proto.IApiPaymentProto} message ApiPaymentProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ApiPaymentProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.paymentId != null && Object.hasOwnProperty.call(message, "paymentId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.paymentId);
                    if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.userId);
                    if (message.userName != null && Object.hasOwnProperty.call(message, "userName"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.userName);
                    if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.businessId);
                    if (message.price != null && Object.hasOwnProperty.call(message, "price"))
                        $root.space.kenko.proto.PriceProto.encode(message.price, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.createdTimestampMs != null && Object.hasOwnProperty.call(message, "createdTimestampMs"))
                        writer.uint32(/* id 6, wireType 0 =*/48).int64(message.createdTimestampMs);
                    if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                        writer.uint32(/* id 7, wireType 2 =*/58).string(message.status);
                    if (message.purchasedThingName != null && Object.hasOwnProperty.call(message, "purchasedThingName"))
                        writer.uint32(/* id 8, wireType 2 =*/66).string(message.purchasedThingName);
                    return writer;
                };

                /**
                 * Encodes the specified ApiPaymentProto message, length delimited. Does not implicitly {@link space.kenko.proto.ApiPaymentProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @static
                 * @param {space.kenko.proto.IApiPaymentProto} message ApiPaymentProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ApiPaymentProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an ApiPaymentProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.ApiPaymentProto} ApiPaymentProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ApiPaymentProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.ApiPaymentProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.paymentId = reader.string();
                                break;
                            }
                        case 2: {
                                message.userId = reader.string();
                                break;
                            }
                        case 3: {
                                message.userName = reader.string();
                                break;
                            }
                        case 4: {
                                message.businessId = reader.string();
                                break;
                            }
                        case 5: {
                                message.price = $root.space.kenko.proto.PriceProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 6: {
                                message.createdTimestampMs = reader.int64();
                                break;
                            }
                        case 7: {
                                message.status = reader.string();
                                break;
                            }
                        case 8: {
                                message.purchasedThingName = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an ApiPaymentProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.ApiPaymentProto} ApiPaymentProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ApiPaymentProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an ApiPaymentProto message.
                 * @function verify
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ApiPaymentProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.paymentId != null && message.hasOwnProperty("paymentId"))
                        if (!$util.isString(message.paymentId))
                            return "paymentId: string expected";
                    if (message.userId != null && message.hasOwnProperty("userId"))
                        if (!$util.isString(message.userId))
                            return "userId: string expected";
                    if (message.userName != null && message.hasOwnProperty("userName"))
                        if (!$util.isString(message.userName))
                            return "userName: string expected";
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        if (!$util.isString(message.businessId))
                            return "businessId: string expected";
                    if (message.price != null && message.hasOwnProperty("price")) {
                        var error = $root.space.kenko.proto.PriceProto.verify(message.price);
                        if (error)
                            return "price." + error;
                    }
                    if (message.createdTimestampMs != null && message.hasOwnProperty("createdTimestampMs"))
                        if (!$util.isInteger(message.createdTimestampMs) && !(message.createdTimestampMs && $util.isInteger(message.createdTimestampMs.low) && $util.isInteger(message.createdTimestampMs.high)))
                            return "createdTimestampMs: integer|Long expected";
                    if (message.status != null && message.hasOwnProperty("status"))
                        if (!$util.isString(message.status))
                            return "status: string expected";
                    if (message.purchasedThingName != null && message.hasOwnProperty("purchasedThingName"))
                        if (!$util.isString(message.purchasedThingName))
                            return "purchasedThingName: string expected";
                    return null;
                };

                /**
                 * Creates an ApiPaymentProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.ApiPaymentProto} ApiPaymentProto
                 */
                ApiPaymentProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.ApiPaymentProto)
                        return object;
                    var message = new $root.space.kenko.proto.ApiPaymentProto();
                    if (object.paymentId != null)
                        message.paymentId = String(object.paymentId);
                    if (object.userId != null)
                        message.userId = String(object.userId);
                    if (object.userName != null)
                        message.userName = String(object.userName);
                    if (object.businessId != null)
                        message.businessId = String(object.businessId);
                    if (object.price != null) {
                        if (typeof object.price !== "object")
                            throw TypeError(".space.kenko.proto.ApiPaymentProto.price: object expected");
                        message.price = $root.space.kenko.proto.PriceProto.fromObject(object.price);
                    }
                    if (object.createdTimestampMs != null)
                        if ($util.Long)
                            (message.createdTimestampMs = $util.Long.fromValue(object.createdTimestampMs)).unsigned = false;
                        else if (typeof object.createdTimestampMs === "string")
                            message.createdTimestampMs = parseInt(object.createdTimestampMs, 10);
                        else if (typeof object.createdTimestampMs === "number")
                            message.createdTimestampMs = object.createdTimestampMs;
                        else if (typeof object.createdTimestampMs === "object")
                            message.createdTimestampMs = new $util.LongBits(object.createdTimestampMs.low >>> 0, object.createdTimestampMs.high >>> 0).toNumber();
                    if (object.status != null)
                        message.status = String(object.status);
                    if (object.purchasedThingName != null)
                        message.purchasedThingName = String(object.purchasedThingName);
                    return message;
                };

                /**
                 * Creates a plain object from an ApiPaymentProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @static
                 * @param {space.kenko.proto.ApiPaymentProto} message ApiPaymentProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ApiPaymentProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.paymentId = "";
                        object.userId = "";
                        object.userName = "";
                        object.businessId = "";
                        object.price = null;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.createdTimestampMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.createdTimestampMs = options.longs === String ? "0" : 0;
                        object.status = "";
                        object.purchasedThingName = "";
                    }
                    if (message.paymentId != null && message.hasOwnProperty("paymentId"))
                        object.paymentId = message.paymentId;
                    if (message.userId != null && message.hasOwnProperty("userId"))
                        object.userId = message.userId;
                    if (message.userName != null && message.hasOwnProperty("userName"))
                        object.userName = message.userName;
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        object.businessId = message.businessId;
                    if (message.price != null && message.hasOwnProperty("price"))
                        object.price = $root.space.kenko.proto.PriceProto.toObject(message.price, options);
                    if (message.createdTimestampMs != null && message.hasOwnProperty("createdTimestampMs"))
                        if (typeof message.createdTimestampMs === "number")
                            object.createdTimestampMs = options.longs === String ? String(message.createdTimestampMs) : message.createdTimestampMs;
                        else
                            object.createdTimestampMs = options.longs === String ? $util.Long.prototype.toString.call(message.createdTimestampMs) : options.longs === Number ? new $util.LongBits(message.createdTimestampMs.low >>> 0, message.createdTimestampMs.high >>> 0).toNumber() : message.createdTimestampMs;
                    if (message.status != null && message.hasOwnProperty("status"))
                        object.status = message.status;
                    if (message.purchasedThingName != null && message.hasOwnProperty("purchasedThingName"))
                        object.purchasedThingName = message.purchasedThingName;
                    return object;
                };

                /**
                 * Converts this ApiPaymentProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ApiPaymentProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ApiPaymentProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ApiPaymentProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.ApiPaymentProto";
                };

                return ApiPaymentProto;
            })();

            proto.SettingsProto = (function() {

                /**
                 * Properties of a SettingsProto.
                 * @memberof space.kenko.proto
                 * @interface ISettingsProto
                 * @property {string|null} [llmModel] SettingsProto llmModel
                 * @property {string|null} [llmSystemPrompt] SettingsProto llmSystemPrompt
                 * @property {string|null} [llmBackend] SettingsProto llmBackend
                 * @property {string|null} [providerImagesBucket] SettingsProto providerImagesBucket
                 * @property {string|null} [sendgridApiKey] SettingsProto sendgridApiKey
                 * @property {string|null} [adminSiteUri] SettingsProto adminSiteUri
                 * @property {string|null} [bookingSiteUri] SettingsProto bookingSiteUri
                 * @property {string|null} [providerSiteUri] SettingsProto providerSiteUri
                 * @property {space.kenko.proto.IMembershipSettingsProto|null} [membership] SettingsProto membership
                 * @property {space.kenko.proto.ITwilioSettingsProto|null} [twilio] SettingsProto twilio
                 * @property {boolean|null} [enableDebugActions] SettingsProto enableDebugActions
                 * @property {boolean|null} [allowOpenAccountCreation] SettingsProto allowOpenAccountCreation
                 * @property {space.kenko.proto.IStripeSettings|null} [stripeSettings] SettingsProto stripeSettings
                 * @property {space.kenko.proto.IBigquerySettings|null} [bigquery] SettingsProto bigquery
                 */

                /**
                 * Constructs a new SettingsProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a SettingsProto.
                 * @implements ISettingsProto
                 * @constructor
                 * @param {space.kenko.proto.ISettingsProto=} [properties] Properties to set
                 */
                function SettingsProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SettingsProto llmModel.
                 * @member {string} llmModel
                 * @memberof space.kenko.proto.SettingsProto
                 * @instance
                 */
                SettingsProto.prototype.llmModel = "";

                /**
                 * SettingsProto llmSystemPrompt.
                 * @member {string} llmSystemPrompt
                 * @memberof space.kenko.proto.SettingsProto
                 * @instance
                 */
                SettingsProto.prototype.llmSystemPrompt = "";

                /**
                 * SettingsProto llmBackend.
                 * @member {string} llmBackend
                 * @memberof space.kenko.proto.SettingsProto
                 * @instance
                 */
                SettingsProto.prototype.llmBackend = "";

                /**
                 * SettingsProto providerImagesBucket.
                 * @member {string} providerImagesBucket
                 * @memberof space.kenko.proto.SettingsProto
                 * @instance
                 */
                SettingsProto.prototype.providerImagesBucket = "";

                /**
                 * SettingsProto sendgridApiKey.
                 * @member {string} sendgridApiKey
                 * @memberof space.kenko.proto.SettingsProto
                 * @instance
                 */
                SettingsProto.prototype.sendgridApiKey = "";

                /**
                 * SettingsProto adminSiteUri.
                 * @member {string} adminSiteUri
                 * @memberof space.kenko.proto.SettingsProto
                 * @instance
                 */
                SettingsProto.prototype.adminSiteUri = "";

                /**
                 * SettingsProto bookingSiteUri.
                 * @member {string} bookingSiteUri
                 * @memberof space.kenko.proto.SettingsProto
                 * @instance
                 */
                SettingsProto.prototype.bookingSiteUri = "";

                /**
                 * SettingsProto providerSiteUri.
                 * @member {string} providerSiteUri
                 * @memberof space.kenko.proto.SettingsProto
                 * @instance
                 */
                SettingsProto.prototype.providerSiteUri = "";

                /**
                 * SettingsProto membership.
                 * @member {space.kenko.proto.IMembershipSettingsProto|null|undefined} membership
                 * @memberof space.kenko.proto.SettingsProto
                 * @instance
                 */
                SettingsProto.prototype.membership = null;

                /**
                 * SettingsProto twilio.
                 * @member {space.kenko.proto.ITwilioSettingsProto|null|undefined} twilio
                 * @memberof space.kenko.proto.SettingsProto
                 * @instance
                 */
                SettingsProto.prototype.twilio = null;

                /**
                 * SettingsProto enableDebugActions.
                 * @member {boolean} enableDebugActions
                 * @memberof space.kenko.proto.SettingsProto
                 * @instance
                 */
                SettingsProto.prototype.enableDebugActions = false;

                /**
                 * SettingsProto allowOpenAccountCreation.
                 * @member {boolean} allowOpenAccountCreation
                 * @memberof space.kenko.proto.SettingsProto
                 * @instance
                 */
                SettingsProto.prototype.allowOpenAccountCreation = false;

                /**
                 * SettingsProto stripeSettings.
                 * @member {space.kenko.proto.IStripeSettings|null|undefined} stripeSettings
                 * @memberof space.kenko.proto.SettingsProto
                 * @instance
                 */
                SettingsProto.prototype.stripeSettings = null;

                /**
                 * SettingsProto bigquery.
                 * @member {space.kenko.proto.IBigquerySettings|null|undefined} bigquery
                 * @memberof space.kenko.proto.SettingsProto
                 * @instance
                 */
                SettingsProto.prototype.bigquery = null;

                /**
                 * Creates a new SettingsProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.SettingsProto
                 * @static
                 * @param {space.kenko.proto.ISettingsProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.SettingsProto} SettingsProto instance
                 */
                SettingsProto.create = function create(properties) {
                    return new SettingsProto(properties);
                };

                /**
                 * Encodes the specified SettingsProto message. Does not implicitly {@link space.kenko.proto.SettingsProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.SettingsProto
                 * @static
                 * @param {space.kenko.proto.ISettingsProto} message SettingsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SettingsProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.llmModel != null && Object.hasOwnProperty.call(message, "llmModel"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.llmModel);
                    if (message.llmSystemPrompt != null && Object.hasOwnProperty.call(message, "llmSystemPrompt"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.llmSystemPrompt);
                    if (message.llmBackend != null && Object.hasOwnProperty.call(message, "llmBackend"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.llmBackend);
                    if (message.providerImagesBucket != null && Object.hasOwnProperty.call(message, "providerImagesBucket"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.providerImagesBucket);
                    if (message.sendgridApiKey != null && Object.hasOwnProperty.call(message, "sendgridApiKey"))
                        writer.uint32(/* id 7, wireType 2 =*/58).string(message.sendgridApiKey);
                    if (message.adminSiteUri != null && Object.hasOwnProperty.call(message, "adminSiteUri"))
                        writer.uint32(/* id 10, wireType 2 =*/82).string(message.adminSiteUri);
                    if (message.bookingSiteUri != null && Object.hasOwnProperty.call(message, "bookingSiteUri"))
                        writer.uint32(/* id 11, wireType 2 =*/90).string(message.bookingSiteUri);
                    if (message.providerSiteUri != null && Object.hasOwnProperty.call(message, "providerSiteUri"))
                        writer.uint32(/* id 12, wireType 2 =*/98).string(message.providerSiteUri);
                    if (message.membership != null && Object.hasOwnProperty.call(message, "membership"))
                        $root.space.kenko.proto.MembershipSettingsProto.encode(message.membership, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
                    if (message.twilio != null && Object.hasOwnProperty.call(message, "twilio"))
                        $root.space.kenko.proto.TwilioSettingsProto.encode(message.twilio, writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
                    if (message.enableDebugActions != null && Object.hasOwnProperty.call(message, "enableDebugActions"))
                        writer.uint32(/* id 16, wireType 0 =*/128).bool(message.enableDebugActions);
                    if (message.allowOpenAccountCreation != null && Object.hasOwnProperty.call(message, "allowOpenAccountCreation"))
                        writer.uint32(/* id 17, wireType 0 =*/136).bool(message.allowOpenAccountCreation);
                    if (message.stripeSettings != null && Object.hasOwnProperty.call(message, "stripeSettings"))
                        $root.space.kenko.proto.StripeSettings.encode(message.stripeSettings, writer.uint32(/* id 18, wireType 2 =*/146).fork()).ldelim();
                    if (message.bigquery != null && Object.hasOwnProperty.call(message, "bigquery"))
                        $root.space.kenko.proto.BigquerySettings.encode(message.bigquery, writer.uint32(/* id 19, wireType 2 =*/154).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SettingsProto message, length delimited. Does not implicitly {@link space.kenko.proto.SettingsProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.SettingsProto
                 * @static
                 * @param {space.kenko.proto.ISettingsProto} message SettingsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SettingsProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SettingsProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.SettingsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.SettingsProto} SettingsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SettingsProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.SettingsProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.llmModel = reader.string();
                                break;
                            }
                        case 2: {
                                message.llmSystemPrompt = reader.string();
                                break;
                            }
                        case 3: {
                                message.llmBackend = reader.string();
                                break;
                            }
                        case 4: {
                                message.providerImagesBucket = reader.string();
                                break;
                            }
                        case 7: {
                                message.sendgridApiKey = reader.string();
                                break;
                            }
                        case 10: {
                                message.adminSiteUri = reader.string();
                                break;
                            }
                        case 11: {
                                message.bookingSiteUri = reader.string();
                                break;
                            }
                        case 12: {
                                message.providerSiteUri = reader.string();
                                break;
                            }
                        case 14: {
                                message.membership = $root.space.kenko.proto.MembershipSettingsProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 15: {
                                message.twilio = $root.space.kenko.proto.TwilioSettingsProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 16: {
                                message.enableDebugActions = reader.bool();
                                break;
                            }
                        case 17: {
                                message.allowOpenAccountCreation = reader.bool();
                                break;
                            }
                        case 18: {
                                message.stripeSettings = $root.space.kenko.proto.StripeSettings.decode(reader, reader.uint32());
                                break;
                            }
                        case 19: {
                                message.bigquery = $root.space.kenko.proto.BigquerySettings.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SettingsProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.SettingsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.SettingsProto} SettingsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SettingsProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SettingsProto message.
                 * @function verify
                 * @memberof space.kenko.proto.SettingsProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SettingsProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.llmModel != null && message.hasOwnProperty("llmModel"))
                        if (!$util.isString(message.llmModel))
                            return "llmModel: string expected";
                    if (message.llmSystemPrompt != null && message.hasOwnProperty("llmSystemPrompt"))
                        if (!$util.isString(message.llmSystemPrompt))
                            return "llmSystemPrompt: string expected";
                    if (message.llmBackend != null && message.hasOwnProperty("llmBackend"))
                        if (!$util.isString(message.llmBackend))
                            return "llmBackend: string expected";
                    if (message.providerImagesBucket != null && message.hasOwnProperty("providerImagesBucket"))
                        if (!$util.isString(message.providerImagesBucket))
                            return "providerImagesBucket: string expected";
                    if (message.sendgridApiKey != null && message.hasOwnProperty("sendgridApiKey"))
                        if (!$util.isString(message.sendgridApiKey))
                            return "sendgridApiKey: string expected";
                    if (message.adminSiteUri != null && message.hasOwnProperty("adminSiteUri"))
                        if (!$util.isString(message.adminSiteUri))
                            return "adminSiteUri: string expected";
                    if (message.bookingSiteUri != null && message.hasOwnProperty("bookingSiteUri"))
                        if (!$util.isString(message.bookingSiteUri))
                            return "bookingSiteUri: string expected";
                    if (message.providerSiteUri != null && message.hasOwnProperty("providerSiteUri"))
                        if (!$util.isString(message.providerSiteUri))
                            return "providerSiteUri: string expected";
                    if (message.membership != null && message.hasOwnProperty("membership")) {
                        var error = $root.space.kenko.proto.MembershipSettingsProto.verify(message.membership);
                        if (error)
                            return "membership." + error;
                    }
                    if (message.twilio != null && message.hasOwnProperty("twilio")) {
                        var error = $root.space.kenko.proto.TwilioSettingsProto.verify(message.twilio);
                        if (error)
                            return "twilio." + error;
                    }
                    if (message.enableDebugActions != null && message.hasOwnProperty("enableDebugActions"))
                        if (typeof message.enableDebugActions !== "boolean")
                            return "enableDebugActions: boolean expected";
                    if (message.allowOpenAccountCreation != null && message.hasOwnProperty("allowOpenAccountCreation"))
                        if (typeof message.allowOpenAccountCreation !== "boolean")
                            return "allowOpenAccountCreation: boolean expected";
                    if (message.stripeSettings != null && message.hasOwnProperty("stripeSettings")) {
                        var error = $root.space.kenko.proto.StripeSettings.verify(message.stripeSettings);
                        if (error)
                            return "stripeSettings." + error;
                    }
                    if (message.bigquery != null && message.hasOwnProperty("bigquery")) {
                        var error = $root.space.kenko.proto.BigquerySettings.verify(message.bigquery);
                        if (error)
                            return "bigquery." + error;
                    }
                    return null;
                };

                /**
                 * Creates a SettingsProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.SettingsProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.SettingsProto} SettingsProto
                 */
                SettingsProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.SettingsProto)
                        return object;
                    var message = new $root.space.kenko.proto.SettingsProto();
                    if (object.llmModel != null)
                        message.llmModel = String(object.llmModel);
                    if (object.llmSystemPrompt != null)
                        message.llmSystemPrompt = String(object.llmSystemPrompt);
                    if (object.llmBackend != null)
                        message.llmBackend = String(object.llmBackend);
                    if (object.providerImagesBucket != null)
                        message.providerImagesBucket = String(object.providerImagesBucket);
                    if (object.sendgridApiKey != null)
                        message.sendgridApiKey = String(object.sendgridApiKey);
                    if (object.adminSiteUri != null)
                        message.adminSiteUri = String(object.adminSiteUri);
                    if (object.bookingSiteUri != null)
                        message.bookingSiteUri = String(object.bookingSiteUri);
                    if (object.providerSiteUri != null)
                        message.providerSiteUri = String(object.providerSiteUri);
                    if (object.membership != null) {
                        if (typeof object.membership !== "object")
                            throw TypeError(".space.kenko.proto.SettingsProto.membership: object expected");
                        message.membership = $root.space.kenko.proto.MembershipSettingsProto.fromObject(object.membership);
                    }
                    if (object.twilio != null) {
                        if (typeof object.twilio !== "object")
                            throw TypeError(".space.kenko.proto.SettingsProto.twilio: object expected");
                        message.twilio = $root.space.kenko.proto.TwilioSettingsProto.fromObject(object.twilio);
                    }
                    if (object.enableDebugActions != null)
                        message.enableDebugActions = Boolean(object.enableDebugActions);
                    if (object.allowOpenAccountCreation != null)
                        message.allowOpenAccountCreation = Boolean(object.allowOpenAccountCreation);
                    if (object.stripeSettings != null) {
                        if (typeof object.stripeSettings !== "object")
                            throw TypeError(".space.kenko.proto.SettingsProto.stripeSettings: object expected");
                        message.stripeSettings = $root.space.kenko.proto.StripeSettings.fromObject(object.stripeSettings);
                    }
                    if (object.bigquery != null) {
                        if (typeof object.bigquery !== "object")
                            throw TypeError(".space.kenko.proto.SettingsProto.bigquery: object expected");
                        message.bigquery = $root.space.kenko.proto.BigquerySettings.fromObject(object.bigquery);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SettingsProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.SettingsProto
                 * @static
                 * @param {space.kenko.proto.SettingsProto} message SettingsProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SettingsProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.llmModel = "";
                        object.llmSystemPrompt = "";
                        object.llmBackend = "";
                        object.providerImagesBucket = "";
                        object.sendgridApiKey = "";
                        object.adminSiteUri = "";
                        object.bookingSiteUri = "";
                        object.providerSiteUri = "";
                        object.membership = null;
                        object.twilio = null;
                        object.enableDebugActions = false;
                        object.allowOpenAccountCreation = false;
                        object.stripeSettings = null;
                        object.bigquery = null;
                    }
                    if (message.llmModel != null && message.hasOwnProperty("llmModel"))
                        object.llmModel = message.llmModel;
                    if (message.llmSystemPrompt != null && message.hasOwnProperty("llmSystemPrompt"))
                        object.llmSystemPrompt = message.llmSystemPrompt;
                    if (message.llmBackend != null && message.hasOwnProperty("llmBackend"))
                        object.llmBackend = message.llmBackend;
                    if (message.providerImagesBucket != null && message.hasOwnProperty("providerImagesBucket"))
                        object.providerImagesBucket = message.providerImagesBucket;
                    if (message.sendgridApiKey != null && message.hasOwnProperty("sendgridApiKey"))
                        object.sendgridApiKey = message.sendgridApiKey;
                    if (message.adminSiteUri != null && message.hasOwnProperty("adminSiteUri"))
                        object.adminSiteUri = message.adminSiteUri;
                    if (message.bookingSiteUri != null && message.hasOwnProperty("bookingSiteUri"))
                        object.bookingSiteUri = message.bookingSiteUri;
                    if (message.providerSiteUri != null && message.hasOwnProperty("providerSiteUri"))
                        object.providerSiteUri = message.providerSiteUri;
                    if (message.membership != null && message.hasOwnProperty("membership"))
                        object.membership = $root.space.kenko.proto.MembershipSettingsProto.toObject(message.membership, options);
                    if (message.twilio != null && message.hasOwnProperty("twilio"))
                        object.twilio = $root.space.kenko.proto.TwilioSettingsProto.toObject(message.twilio, options);
                    if (message.enableDebugActions != null && message.hasOwnProperty("enableDebugActions"))
                        object.enableDebugActions = message.enableDebugActions;
                    if (message.allowOpenAccountCreation != null && message.hasOwnProperty("allowOpenAccountCreation"))
                        object.allowOpenAccountCreation = message.allowOpenAccountCreation;
                    if (message.stripeSettings != null && message.hasOwnProperty("stripeSettings"))
                        object.stripeSettings = $root.space.kenko.proto.StripeSettings.toObject(message.stripeSettings, options);
                    if (message.bigquery != null && message.hasOwnProperty("bigquery"))
                        object.bigquery = $root.space.kenko.proto.BigquerySettings.toObject(message.bigquery, options);
                    return object;
                };

                /**
                 * Converts this SettingsProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.SettingsProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SettingsProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for SettingsProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.SettingsProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                SettingsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.SettingsProto";
                };

                return SettingsProto;
            })();

            proto.TwilioSettingsProto = (function() {

                /**
                 * Properties of a TwilioSettingsProto.
                 * @memberof space.kenko.proto
                 * @interface ITwilioSettingsProto
                 * @property {string|null} [accountSid] TwilioSettingsProto accountSid
                 * @property {string|null} [authToken] TwilioSettingsProto authToken
                 */

                /**
                 * Constructs a new TwilioSettingsProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a TwilioSettingsProto.
                 * @implements ITwilioSettingsProto
                 * @constructor
                 * @param {space.kenko.proto.ITwilioSettingsProto=} [properties] Properties to set
                 */
                function TwilioSettingsProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * TwilioSettingsProto accountSid.
                 * @member {string} accountSid
                 * @memberof space.kenko.proto.TwilioSettingsProto
                 * @instance
                 */
                TwilioSettingsProto.prototype.accountSid = "";

                /**
                 * TwilioSettingsProto authToken.
                 * @member {string} authToken
                 * @memberof space.kenko.proto.TwilioSettingsProto
                 * @instance
                 */
                TwilioSettingsProto.prototype.authToken = "";

                /**
                 * Creates a new TwilioSettingsProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.TwilioSettingsProto
                 * @static
                 * @param {space.kenko.proto.ITwilioSettingsProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.TwilioSettingsProto} TwilioSettingsProto instance
                 */
                TwilioSettingsProto.create = function create(properties) {
                    return new TwilioSettingsProto(properties);
                };

                /**
                 * Encodes the specified TwilioSettingsProto message. Does not implicitly {@link space.kenko.proto.TwilioSettingsProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.TwilioSettingsProto
                 * @static
                 * @param {space.kenko.proto.ITwilioSettingsProto} message TwilioSettingsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                TwilioSettingsProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.accountSid != null && Object.hasOwnProperty.call(message, "accountSid"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.accountSid);
                    if (message.authToken != null && Object.hasOwnProperty.call(message, "authToken"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.authToken);
                    return writer;
                };

                /**
                 * Encodes the specified TwilioSettingsProto message, length delimited. Does not implicitly {@link space.kenko.proto.TwilioSettingsProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.TwilioSettingsProto
                 * @static
                 * @param {space.kenko.proto.ITwilioSettingsProto} message TwilioSettingsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                TwilioSettingsProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a TwilioSettingsProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.TwilioSettingsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.TwilioSettingsProto} TwilioSettingsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                TwilioSettingsProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.TwilioSettingsProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.accountSid = reader.string();
                                break;
                            }
                        case 2: {
                                message.authToken = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a TwilioSettingsProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.TwilioSettingsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.TwilioSettingsProto} TwilioSettingsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                TwilioSettingsProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a TwilioSettingsProto message.
                 * @function verify
                 * @memberof space.kenko.proto.TwilioSettingsProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                TwilioSettingsProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.accountSid != null && message.hasOwnProperty("accountSid"))
                        if (!$util.isString(message.accountSid))
                            return "accountSid: string expected";
                    if (message.authToken != null && message.hasOwnProperty("authToken"))
                        if (!$util.isString(message.authToken))
                            return "authToken: string expected";
                    return null;
                };

                /**
                 * Creates a TwilioSettingsProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.TwilioSettingsProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.TwilioSettingsProto} TwilioSettingsProto
                 */
                TwilioSettingsProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.TwilioSettingsProto)
                        return object;
                    var message = new $root.space.kenko.proto.TwilioSettingsProto();
                    if (object.accountSid != null)
                        message.accountSid = String(object.accountSid);
                    if (object.authToken != null)
                        message.authToken = String(object.authToken);
                    return message;
                };

                /**
                 * Creates a plain object from a TwilioSettingsProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.TwilioSettingsProto
                 * @static
                 * @param {space.kenko.proto.TwilioSettingsProto} message TwilioSettingsProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                TwilioSettingsProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.accountSid = "";
                        object.authToken = "";
                    }
                    if (message.accountSid != null && message.hasOwnProperty("accountSid"))
                        object.accountSid = message.accountSid;
                    if (message.authToken != null && message.hasOwnProperty("authToken"))
                        object.authToken = message.authToken;
                    return object;
                };

                /**
                 * Converts this TwilioSettingsProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.TwilioSettingsProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                TwilioSettingsProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for TwilioSettingsProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.TwilioSettingsProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                TwilioSettingsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.TwilioSettingsProto";
                };

                return TwilioSettingsProto;
            })();

            proto.MembershipSettingsProto = (function() {

                /**
                 * Properties of a MembershipSettingsProto.
                 * @memberof space.kenko.proto
                 * @interface IMembershipSettingsProto
                 * @property {space.kenko.proto.IMembershipOption|null} [listing] MembershipSettingsProto listing
                 * @property {space.kenko.proto.IMembershipOption|null} [listingPlusBooking] MembershipSettingsProto listingPlusBooking
                 */

                /**
                 * Constructs a new MembershipSettingsProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a MembershipSettingsProto.
                 * @implements IMembershipSettingsProto
                 * @constructor
                 * @param {space.kenko.proto.IMembershipSettingsProto=} [properties] Properties to set
                 */
                function MembershipSettingsProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * MembershipSettingsProto listing.
                 * @member {space.kenko.proto.IMembershipOption|null|undefined} listing
                 * @memberof space.kenko.proto.MembershipSettingsProto
                 * @instance
                 */
                MembershipSettingsProto.prototype.listing = null;

                /**
                 * MembershipSettingsProto listingPlusBooking.
                 * @member {space.kenko.proto.IMembershipOption|null|undefined} listingPlusBooking
                 * @memberof space.kenko.proto.MembershipSettingsProto
                 * @instance
                 */
                MembershipSettingsProto.prototype.listingPlusBooking = null;

                /**
                 * Creates a new MembershipSettingsProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.MembershipSettingsProto
                 * @static
                 * @param {space.kenko.proto.IMembershipSettingsProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.MembershipSettingsProto} MembershipSettingsProto instance
                 */
                MembershipSettingsProto.create = function create(properties) {
                    return new MembershipSettingsProto(properties);
                };

                /**
                 * Encodes the specified MembershipSettingsProto message. Does not implicitly {@link space.kenko.proto.MembershipSettingsProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.MembershipSettingsProto
                 * @static
                 * @param {space.kenko.proto.IMembershipSettingsProto} message MembershipSettingsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MembershipSettingsProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.listing != null && Object.hasOwnProperty.call(message, "listing"))
                        $root.space.kenko.proto.MembershipOption.encode(message.listing, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.listingPlusBooking != null && Object.hasOwnProperty.call(message, "listingPlusBooking"))
                        $root.space.kenko.proto.MembershipOption.encode(message.listingPlusBooking, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified MembershipSettingsProto message, length delimited. Does not implicitly {@link space.kenko.proto.MembershipSettingsProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.MembershipSettingsProto
                 * @static
                 * @param {space.kenko.proto.IMembershipSettingsProto} message MembershipSettingsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MembershipSettingsProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a MembershipSettingsProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.MembershipSettingsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.MembershipSettingsProto} MembershipSettingsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MembershipSettingsProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.MembershipSettingsProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.listing = $root.space.kenko.proto.MembershipOption.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.listingPlusBooking = $root.space.kenko.proto.MembershipOption.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a MembershipSettingsProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.MembershipSettingsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.MembershipSettingsProto} MembershipSettingsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MembershipSettingsProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a MembershipSettingsProto message.
                 * @function verify
                 * @memberof space.kenko.proto.MembershipSettingsProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                MembershipSettingsProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.listing != null && message.hasOwnProperty("listing")) {
                        var error = $root.space.kenko.proto.MembershipOption.verify(message.listing);
                        if (error)
                            return "listing." + error;
                    }
                    if (message.listingPlusBooking != null && message.hasOwnProperty("listingPlusBooking")) {
                        var error = $root.space.kenko.proto.MembershipOption.verify(message.listingPlusBooking);
                        if (error)
                            return "listingPlusBooking." + error;
                    }
                    return null;
                };

                /**
                 * Creates a MembershipSettingsProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.MembershipSettingsProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.MembershipSettingsProto} MembershipSettingsProto
                 */
                MembershipSettingsProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.MembershipSettingsProto)
                        return object;
                    var message = new $root.space.kenko.proto.MembershipSettingsProto();
                    if (object.listing != null) {
                        if (typeof object.listing !== "object")
                            throw TypeError(".space.kenko.proto.MembershipSettingsProto.listing: object expected");
                        message.listing = $root.space.kenko.proto.MembershipOption.fromObject(object.listing);
                    }
                    if (object.listingPlusBooking != null) {
                        if (typeof object.listingPlusBooking !== "object")
                            throw TypeError(".space.kenko.proto.MembershipSettingsProto.listingPlusBooking: object expected");
                        message.listingPlusBooking = $root.space.kenko.proto.MembershipOption.fromObject(object.listingPlusBooking);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a MembershipSettingsProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.MembershipSettingsProto
                 * @static
                 * @param {space.kenko.proto.MembershipSettingsProto} message MembershipSettingsProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                MembershipSettingsProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.listing = null;
                        object.listingPlusBooking = null;
                    }
                    if (message.listing != null && message.hasOwnProperty("listing"))
                        object.listing = $root.space.kenko.proto.MembershipOption.toObject(message.listing, options);
                    if (message.listingPlusBooking != null && message.hasOwnProperty("listingPlusBooking"))
                        object.listingPlusBooking = $root.space.kenko.proto.MembershipOption.toObject(message.listingPlusBooking, options);
                    return object;
                };

                /**
                 * Converts this MembershipSettingsProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.MembershipSettingsProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                MembershipSettingsProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for MembershipSettingsProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.MembershipSettingsProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                MembershipSettingsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.MembershipSettingsProto";
                };

                return MembershipSettingsProto;
            })();

            proto.MembershipOption = (function() {

                /**
                 * Properties of a MembershipOption.
                 * @memberof space.kenko.proto
                 * @interface IMembershipOption
                 * @property {string|null} [stripeProductId] MembershipOption stripeProductId
                 * @property {string|null} [monthlyPriceId] MembershipOption monthlyPriceId
                 * @property {number|null} [monthlyPriceCents] MembershipOption monthlyPriceCents
                 * @property {string|null} [annualPriceId] MembershipOption annualPriceId
                 * @property {number|null} [annualPriceCents] MembershipOption annualPriceCents
                 */

                /**
                 * Constructs a new MembershipOption.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a MembershipOption.
                 * @implements IMembershipOption
                 * @constructor
                 * @param {space.kenko.proto.IMembershipOption=} [properties] Properties to set
                 */
                function MembershipOption(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * MembershipOption stripeProductId.
                 * @member {string} stripeProductId
                 * @memberof space.kenko.proto.MembershipOption
                 * @instance
                 */
                MembershipOption.prototype.stripeProductId = "";

                /**
                 * MembershipOption monthlyPriceId.
                 * @member {string} monthlyPriceId
                 * @memberof space.kenko.proto.MembershipOption
                 * @instance
                 */
                MembershipOption.prototype.monthlyPriceId = "";

                /**
                 * MembershipOption monthlyPriceCents.
                 * @member {number} monthlyPriceCents
                 * @memberof space.kenko.proto.MembershipOption
                 * @instance
                 */
                MembershipOption.prototype.monthlyPriceCents = 0;

                /**
                 * MembershipOption annualPriceId.
                 * @member {string} annualPriceId
                 * @memberof space.kenko.proto.MembershipOption
                 * @instance
                 */
                MembershipOption.prototype.annualPriceId = "";

                /**
                 * MembershipOption annualPriceCents.
                 * @member {number} annualPriceCents
                 * @memberof space.kenko.proto.MembershipOption
                 * @instance
                 */
                MembershipOption.prototype.annualPriceCents = 0;

                /**
                 * Creates a new MembershipOption instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.MembershipOption
                 * @static
                 * @param {space.kenko.proto.IMembershipOption=} [properties] Properties to set
                 * @returns {space.kenko.proto.MembershipOption} MembershipOption instance
                 */
                MembershipOption.create = function create(properties) {
                    return new MembershipOption(properties);
                };

                /**
                 * Encodes the specified MembershipOption message. Does not implicitly {@link space.kenko.proto.MembershipOption.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.MembershipOption
                 * @static
                 * @param {space.kenko.proto.IMembershipOption} message MembershipOption message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MembershipOption.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.stripeProductId != null && Object.hasOwnProperty.call(message, "stripeProductId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.stripeProductId);
                    if (message.monthlyPriceId != null && Object.hasOwnProperty.call(message, "monthlyPriceId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.monthlyPriceId);
                    if (message.monthlyPriceCents != null && Object.hasOwnProperty.call(message, "monthlyPriceCents"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.monthlyPriceCents);
                    if (message.annualPriceId != null && Object.hasOwnProperty.call(message, "annualPriceId"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.annualPriceId);
                    if (message.annualPriceCents != null && Object.hasOwnProperty.call(message, "annualPriceCents"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int32(message.annualPriceCents);
                    return writer;
                };

                /**
                 * Encodes the specified MembershipOption message, length delimited. Does not implicitly {@link space.kenko.proto.MembershipOption.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.MembershipOption
                 * @static
                 * @param {space.kenko.proto.IMembershipOption} message MembershipOption message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MembershipOption.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a MembershipOption message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.MembershipOption
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.MembershipOption} MembershipOption
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MembershipOption.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.MembershipOption();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.stripeProductId = reader.string();
                                break;
                            }
                        case 2: {
                                message.monthlyPriceId = reader.string();
                                break;
                            }
                        case 3: {
                                message.monthlyPriceCents = reader.int32();
                                break;
                            }
                        case 4: {
                                message.annualPriceId = reader.string();
                                break;
                            }
                        case 5: {
                                message.annualPriceCents = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a MembershipOption message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.MembershipOption
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.MembershipOption} MembershipOption
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MembershipOption.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a MembershipOption message.
                 * @function verify
                 * @memberof space.kenko.proto.MembershipOption
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                MembershipOption.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.stripeProductId != null && message.hasOwnProperty("stripeProductId"))
                        if (!$util.isString(message.stripeProductId))
                            return "stripeProductId: string expected";
                    if (message.monthlyPriceId != null && message.hasOwnProperty("monthlyPriceId"))
                        if (!$util.isString(message.monthlyPriceId))
                            return "monthlyPriceId: string expected";
                    if (message.monthlyPriceCents != null && message.hasOwnProperty("monthlyPriceCents"))
                        if (!$util.isInteger(message.monthlyPriceCents))
                            return "monthlyPriceCents: integer expected";
                    if (message.annualPriceId != null && message.hasOwnProperty("annualPriceId"))
                        if (!$util.isString(message.annualPriceId))
                            return "annualPriceId: string expected";
                    if (message.annualPriceCents != null && message.hasOwnProperty("annualPriceCents"))
                        if (!$util.isInteger(message.annualPriceCents))
                            return "annualPriceCents: integer expected";
                    return null;
                };

                /**
                 * Creates a MembershipOption message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.MembershipOption
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.MembershipOption} MembershipOption
                 */
                MembershipOption.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.MembershipOption)
                        return object;
                    var message = new $root.space.kenko.proto.MembershipOption();
                    if (object.stripeProductId != null)
                        message.stripeProductId = String(object.stripeProductId);
                    if (object.monthlyPriceId != null)
                        message.monthlyPriceId = String(object.monthlyPriceId);
                    if (object.monthlyPriceCents != null)
                        message.monthlyPriceCents = object.monthlyPriceCents | 0;
                    if (object.annualPriceId != null)
                        message.annualPriceId = String(object.annualPriceId);
                    if (object.annualPriceCents != null)
                        message.annualPriceCents = object.annualPriceCents | 0;
                    return message;
                };

                /**
                 * Creates a plain object from a MembershipOption message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.MembershipOption
                 * @static
                 * @param {space.kenko.proto.MembershipOption} message MembershipOption
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                MembershipOption.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.stripeProductId = "";
                        object.monthlyPriceId = "";
                        object.monthlyPriceCents = 0;
                        object.annualPriceId = "";
                        object.annualPriceCents = 0;
                    }
                    if (message.stripeProductId != null && message.hasOwnProperty("stripeProductId"))
                        object.stripeProductId = message.stripeProductId;
                    if (message.monthlyPriceId != null && message.hasOwnProperty("monthlyPriceId"))
                        object.monthlyPriceId = message.monthlyPriceId;
                    if (message.monthlyPriceCents != null && message.hasOwnProperty("monthlyPriceCents"))
                        object.monthlyPriceCents = message.monthlyPriceCents;
                    if (message.annualPriceId != null && message.hasOwnProperty("annualPriceId"))
                        object.annualPriceId = message.annualPriceId;
                    if (message.annualPriceCents != null && message.hasOwnProperty("annualPriceCents"))
                        object.annualPriceCents = message.annualPriceCents;
                    return object;
                };

                /**
                 * Converts this MembershipOption to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.MembershipOption
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                MembershipOption.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for MembershipOption
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.MembershipOption
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                MembershipOption.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.MembershipOption";
                };

                return MembershipOption;
            })();

            proto.StripeSettings = (function() {

                /**
                 * Properties of a StripeSettings.
                 * @memberof space.kenko.proto
                 * @interface IStripeSettings
                 * @property {string|null} [stripeApiKey] StripeSettings stripeApiKey
                 * @property {string|null} [stripePlatformWebhookSecret] StripeSettings stripePlatformWebhookSecret
                 * @property {string|null} [stripeConnectWebhookSecret] StripeSettings stripeConnectWebhookSecret
                 */

                /**
                 * Constructs a new StripeSettings.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a StripeSettings.
                 * @implements IStripeSettings
                 * @constructor
                 * @param {space.kenko.proto.IStripeSettings=} [properties] Properties to set
                 */
                function StripeSettings(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StripeSettings stripeApiKey.
                 * @member {string} stripeApiKey
                 * @memberof space.kenko.proto.StripeSettings
                 * @instance
                 */
                StripeSettings.prototype.stripeApiKey = "";

                /**
                 * StripeSettings stripePlatformWebhookSecret.
                 * @member {string} stripePlatformWebhookSecret
                 * @memberof space.kenko.proto.StripeSettings
                 * @instance
                 */
                StripeSettings.prototype.stripePlatformWebhookSecret = "";

                /**
                 * StripeSettings stripeConnectWebhookSecret.
                 * @member {string} stripeConnectWebhookSecret
                 * @memberof space.kenko.proto.StripeSettings
                 * @instance
                 */
                StripeSettings.prototype.stripeConnectWebhookSecret = "";

                /**
                 * Creates a new StripeSettings instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.StripeSettings
                 * @static
                 * @param {space.kenko.proto.IStripeSettings=} [properties] Properties to set
                 * @returns {space.kenko.proto.StripeSettings} StripeSettings instance
                 */
                StripeSettings.create = function create(properties) {
                    return new StripeSettings(properties);
                };

                /**
                 * Encodes the specified StripeSettings message. Does not implicitly {@link space.kenko.proto.StripeSettings.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.StripeSettings
                 * @static
                 * @param {space.kenko.proto.IStripeSettings} message StripeSettings message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StripeSettings.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.stripeApiKey != null && Object.hasOwnProperty.call(message, "stripeApiKey"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.stripeApiKey);
                    if (message.stripePlatformWebhookSecret != null && Object.hasOwnProperty.call(message, "stripePlatformWebhookSecret"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.stripePlatformWebhookSecret);
                    if (message.stripeConnectWebhookSecret != null && Object.hasOwnProperty.call(message, "stripeConnectWebhookSecret"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.stripeConnectWebhookSecret);
                    return writer;
                };

                /**
                 * Encodes the specified StripeSettings message, length delimited. Does not implicitly {@link space.kenko.proto.StripeSettings.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.StripeSettings
                 * @static
                 * @param {space.kenko.proto.IStripeSettings} message StripeSettings message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StripeSettings.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a StripeSettings message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.StripeSettings
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.StripeSettings} StripeSettings
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StripeSettings.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.StripeSettings();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.stripeApiKey = reader.string();
                                break;
                            }
                        case 2: {
                                message.stripePlatformWebhookSecret = reader.string();
                                break;
                            }
                        case 3: {
                                message.stripeConnectWebhookSecret = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a StripeSettings message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.StripeSettings
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.StripeSettings} StripeSettings
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StripeSettings.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StripeSettings message.
                 * @function verify
                 * @memberof space.kenko.proto.StripeSettings
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StripeSettings.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.stripeApiKey != null && message.hasOwnProperty("stripeApiKey"))
                        if (!$util.isString(message.stripeApiKey))
                            return "stripeApiKey: string expected";
                    if (message.stripePlatformWebhookSecret != null && message.hasOwnProperty("stripePlatformWebhookSecret"))
                        if (!$util.isString(message.stripePlatformWebhookSecret))
                            return "stripePlatformWebhookSecret: string expected";
                    if (message.stripeConnectWebhookSecret != null && message.hasOwnProperty("stripeConnectWebhookSecret"))
                        if (!$util.isString(message.stripeConnectWebhookSecret))
                            return "stripeConnectWebhookSecret: string expected";
                    return null;
                };

                /**
                 * Creates a StripeSettings message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.StripeSettings
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.StripeSettings} StripeSettings
                 */
                StripeSettings.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.StripeSettings)
                        return object;
                    var message = new $root.space.kenko.proto.StripeSettings();
                    if (object.stripeApiKey != null)
                        message.stripeApiKey = String(object.stripeApiKey);
                    if (object.stripePlatformWebhookSecret != null)
                        message.stripePlatformWebhookSecret = String(object.stripePlatformWebhookSecret);
                    if (object.stripeConnectWebhookSecret != null)
                        message.stripeConnectWebhookSecret = String(object.stripeConnectWebhookSecret);
                    return message;
                };

                /**
                 * Creates a plain object from a StripeSettings message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.StripeSettings
                 * @static
                 * @param {space.kenko.proto.StripeSettings} message StripeSettings
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StripeSettings.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.stripeApiKey = "";
                        object.stripePlatformWebhookSecret = "";
                        object.stripeConnectWebhookSecret = "";
                    }
                    if (message.stripeApiKey != null && message.hasOwnProperty("stripeApiKey"))
                        object.stripeApiKey = message.stripeApiKey;
                    if (message.stripePlatformWebhookSecret != null && message.hasOwnProperty("stripePlatformWebhookSecret"))
                        object.stripePlatformWebhookSecret = message.stripePlatformWebhookSecret;
                    if (message.stripeConnectWebhookSecret != null && message.hasOwnProperty("stripeConnectWebhookSecret"))
                        object.stripeConnectWebhookSecret = message.stripeConnectWebhookSecret;
                    return object;
                };

                /**
                 * Converts this StripeSettings to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.StripeSettings
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StripeSettings.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for StripeSettings
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.StripeSettings
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                StripeSettings.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.StripeSettings";
                };

                return StripeSettings;
            })();

            proto.BigquerySettings = (function() {

                /**
                 * Properties of a BigquerySettings.
                 * @memberof space.kenko.proto
                 * @interface IBigquerySettings
                 * @property {string|null} [projectId] BigquerySettings projectId
                 * @property {string|null} [dataset] BigquerySettings dataset
                 * @property {string|null} [table] BigquerySettings table
                 */

                /**
                 * Constructs a new BigquerySettings.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a BigquerySettings.
                 * @implements IBigquerySettings
                 * @constructor
                 * @param {space.kenko.proto.IBigquerySettings=} [properties] Properties to set
                 */
                function BigquerySettings(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * BigquerySettings projectId.
                 * @member {string} projectId
                 * @memberof space.kenko.proto.BigquerySettings
                 * @instance
                 */
                BigquerySettings.prototype.projectId = "";

                /**
                 * BigquerySettings dataset.
                 * @member {string} dataset
                 * @memberof space.kenko.proto.BigquerySettings
                 * @instance
                 */
                BigquerySettings.prototype.dataset = "";

                /**
                 * BigquerySettings table.
                 * @member {string} table
                 * @memberof space.kenko.proto.BigquerySettings
                 * @instance
                 */
                BigquerySettings.prototype.table = "";

                /**
                 * Creates a new BigquerySettings instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.BigquerySettings
                 * @static
                 * @param {space.kenko.proto.IBigquerySettings=} [properties] Properties to set
                 * @returns {space.kenko.proto.BigquerySettings} BigquerySettings instance
                 */
                BigquerySettings.create = function create(properties) {
                    return new BigquerySettings(properties);
                };

                /**
                 * Encodes the specified BigquerySettings message. Does not implicitly {@link space.kenko.proto.BigquerySettings.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.BigquerySettings
                 * @static
                 * @param {space.kenko.proto.IBigquerySettings} message BigquerySettings message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BigquerySettings.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.projectId != null && Object.hasOwnProperty.call(message, "projectId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.projectId);
                    if (message.dataset != null && Object.hasOwnProperty.call(message, "dataset"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.dataset);
                    if (message.table != null && Object.hasOwnProperty.call(message, "table"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.table);
                    return writer;
                };

                /**
                 * Encodes the specified BigquerySettings message, length delimited. Does not implicitly {@link space.kenko.proto.BigquerySettings.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.BigquerySettings
                 * @static
                 * @param {space.kenko.proto.IBigquerySettings} message BigquerySettings message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BigquerySettings.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a BigquerySettings message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.BigquerySettings
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.BigquerySettings} BigquerySettings
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BigquerySettings.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.BigquerySettings();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.projectId = reader.string();
                                break;
                            }
                        case 2: {
                                message.dataset = reader.string();
                                break;
                            }
                        case 3: {
                                message.table = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a BigquerySettings message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.BigquerySettings
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.BigquerySettings} BigquerySettings
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BigquerySettings.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a BigquerySettings message.
                 * @function verify
                 * @memberof space.kenko.proto.BigquerySettings
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BigquerySettings.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.projectId != null && message.hasOwnProperty("projectId"))
                        if (!$util.isString(message.projectId))
                            return "projectId: string expected";
                    if (message.dataset != null && message.hasOwnProperty("dataset"))
                        if (!$util.isString(message.dataset))
                            return "dataset: string expected";
                    if (message.table != null && message.hasOwnProperty("table"))
                        if (!$util.isString(message.table))
                            return "table: string expected";
                    return null;
                };

                /**
                 * Creates a BigquerySettings message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.BigquerySettings
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.BigquerySettings} BigquerySettings
                 */
                BigquerySettings.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.BigquerySettings)
                        return object;
                    var message = new $root.space.kenko.proto.BigquerySettings();
                    if (object.projectId != null)
                        message.projectId = String(object.projectId);
                    if (object.dataset != null)
                        message.dataset = String(object.dataset);
                    if (object.table != null)
                        message.table = String(object.table);
                    return message;
                };

                /**
                 * Creates a plain object from a BigquerySettings message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.BigquerySettings
                 * @static
                 * @param {space.kenko.proto.BigquerySettings} message BigquerySettings
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BigquerySettings.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.projectId = "";
                        object.dataset = "";
                        object.table = "";
                    }
                    if (message.projectId != null && message.hasOwnProperty("projectId"))
                        object.projectId = message.projectId;
                    if (message.dataset != null && message.hasOwnProperty("dataset"))
                        object.dataset = message.dataset;
                    if (message.table != null && message.hasOwnProperty("table"))
                        object.table = message.table;
                    return object;
                };

                /**
                 * Converts this BigquerySettings to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.BigquerySettings
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BigquerySettings.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for BigquerySettings
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.BigquerySettings
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                BigquerySettings.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.BigquerySettings";
                };

                return BigquerySettings;
            })();

            proto.ProviderSurveyProto = (function() {

                /**
                 * Properties of a ProviderSurveyProto.
                 * @memberof space.kenko.proto
                 * @interface IProviderSurveyProto
                 * @property {string|null} [businessName] ProviderSurveyProto businessName
                 * @property {Array.<space.kenko.proto.SurveySessionType>|null} [sessionTypes] ProviderSurveyProto sessionTypes
                 * @property {string|null} [surveyCompletedByProviderId] ProviderSurveyProto surveyCompletedByProviderId
                 * @property {space.kenko.proto.SurveyCurrentBookingPlatform|null} [currentBookingPlatform] ProviderSurveyProto currentBookingPlatform
                 * @property {space.kenko.proto.BusinessSubscriptionType|null} [chosenSubscription] ProviderSurveyProto chosenSubscription
                 * @property {number|null} [numLocations] ProviderSurveyProto numLocations
                 * @property {number|null} [numPractitioners] ProviderSurveyProto numPractitioners
                 * @property {space.kenko.proto.SurveyVirtualServices|null} [virtualServices] ProviderSurveyProto virtualServices
                 */

                /**
                 * Constructs a new ProviderSurveyProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a ProviderSurveyProto.
                 * @implements IProviderSurveyProto
                 * @constructor
                 * @param {space.kenko.proto.IProviderSurveyProto=} [properties] Properties to set
                 */
                function ProviderSurveyProto(properties) {
                    this.sessionTypes = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ProviderSurveyProto businessName.
                 * @member {string} businessName
                 * @memberof space.kenko.proto.ProviderSurveyProto
                 * @instance
                 */
                ProviderSurveyProto.prototype.businessName = "";

                /**
                 * ProviderSurveyProto sessionTypes.
                 * @member {Array.<space.kenko.proto.SurveySessionType>} sessionTypes
                 * @memberof space.kenko.proto.ProviderSurveyProto
                 * @instance
                 */
                ProviderSurveyProto.prototype.sessionTypes = $util.emptyArray;

                /**
                 * ProviderSurveyProto surveyCompletedByProviderId.
                 * @member {string} surveyCompletedByProviderId
                 * @memberof space.kenko.proto.ProviderSurveyProto
                 * @instance
                 */
                ProviderSurveyProto.prototype.surveyCompletedByProviderId = "";

                /**
                 * ProviderSurveyProto currentBookingPlatform.
                 * @member {space.kenko.proto.SurveyCurrentBookingPlatform} currentBookingPlatform
                 * @memberof space.kenko.proto.ProviderSurveyProto
                 * @instance
                 */
                ProviderSurveyProto.prototype.currentBookingPlatform = 0;

                /**
                 * ProviderSurveyProto chosenSubscription.
                 * @member {space.kenko.proto.BusinessSubscriptionType} chosenSubscription
                 * @memberof space.kenko.proto.ProviderSurveyProto
                 * @instance
                 */
                ProviderSurveyProto.prototype.chosenSubscription = 0;

                /**
                 * ProviderSurveyProto numLocations.
                 * @member {number} numLocations
                 * @memberof space.kenko.proto.ProviderSurveyProto
                 * @instance
                 */
                ProviderSurveyProto.prototype.numLocations = 0;

                /**
                 * ProviderSurveyProto numPractitioners.
                 * @member {number} numPractitioners
                 * @memberof space.kenko.proto.ProviderSurveyProto
                 * @instance
                 */
                ProviderSurveyProto.prototype.numPractitioners = 0;

                /**
                 * ProviderSurveyProto virtualServices.
                 * @member {space.kenko.proto.SurveyVirtualServices} virtualServices
                 * @memberof space.kenko.proto.ProviderSurveyProto
                 * @instance
                 */
                ProviderSurveyProto.prototype.virtualServices = 0;

                /**
                 * Creates a new ProviderSurveyProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.ProviderSurveyProto
                 * @static
                 * @param {space.kenko.proto.IProviderSurveyProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.ProviderSurveyProto} ProviderSurveyProto instance
                 */
                ProviderSurveyProto.create = function create(properties) {
                    return new ProviderSurveyProto(properties);
                };

                /**
                 * Encodes the specified ProviderSurveyProto message. Does not implicitly {@link space.kenko.proto.ProviderSurveyProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.ProviderSurveyProto
                 * @static
                 * @param {space.kenko.proto.IProviderSurveyProto} message ProviderSurveyProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ProviderSurveyProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.businessName != null && Object.hasOwnProperty.call(message, "businessName"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessName);
                    if (message.sessionTypes != null && message.sessionTypes.length) {
                        writer.uint32(/* id 11, wireType 2 =*/90).fork();
                        for (var i = 0; i < message.sessionTypes.length; ++i)
                            writer.int32(message.sessionTypes[i]);
                        writer.ldelim();
                    }
                    if (message.surveyCompletedByProviderId != null && Object.hasOwnProperty.call(message, "surveyCompletedByProviderId"))
                        writer.uint32(/* id 14, wireType 2 =*/114).string(message.surveyCompletedByProviderId);
                    if (message.currentBookingPlatform != null && Object.hasOwnProperty.call(message, "currentBookingPlatform"))
                        writer.uint32(/* id 21, wireType 0 =*/168).int32(message.currentBookingPlatform);
                    if (message.chosenSubscription != null && Object.hasOwnProperty.call(message, "chosenSubscription"))
                        writer.uint32(/* id 24, wireType 0 =*/192).int32(message.chosenSubscription);
                    if (message.numLocations != null && Object.hasOwnProperty.call(message, "numLocations"))
                        writer.uint32(/* id 25, wireType 0 =*/200).int32(message.numLocations);
                    if (message.numPractitioners != null && Object.hasOwnProperty.call(message, "numPractitioners"))
                        writer.uint32(/* id 26, wireType 0 =*/208).int32(message.numPractitioners);
                    if (message.virtualServices != null && Object.hasOwnProperty.call(message, "virtualServices"))
                        writer.uint32(/* id 27, wireType 0 =*/216).int32(message.virtualServices);
                    return writer;
                };

                /**
                 * Encodes the specified ProviderSurveyProto message, length delimited. Does not implicitly {@link space.kenko.proto.ProviderSurveyProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.ProviderSurveyProto
                 * @static
                 * @param {space.kenko.proto.IProviderSurveyProto} message ProviderSurveyProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ProviderSurveyProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ProviderSurveyProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.ProviderSurveyProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.ProviderSurveyProto} ProviderSurveyProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ProviderSurveyProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.ProviderSurveyProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.businessName = reader.string();
                                break;
                            }
                        case 11: {
                                if (!(message.sessionTypes && message.sessionTypes.length))
                                    message.sessionTypes = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.sessionTypes.push(reader.int32());
                                } else
                                    message.sessionTypes.push(reader.int32());
                                break;
                            }
                        case 14: {
                                message.surveyCompletedByProviderId = reader.string();
                                break;
                            }
                        case 21: {
                                message.currentBookingPlatform = reader.int32();
                                break;
                            }
                        case 24: {
                                message.chosenSubscription = reader.int32();
                                break;
                            }
                        case 25: {
                                message.numLocations = reader.int32();
                                break;
                            }
                        case 26: {
                                message.numPractitioners = reader.int32();
                                break;
                            }
                        case 27: {
                                message.virtualServices = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ProviderSurveyProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.ProviderSurveyProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.ProviderSurveyProto} ProviderSurveyProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ProviderSurveyProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ProviderSurveyProto message.
                 * @function verify
                 * @memberof space.kenko.proto.ProviderSurveyProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ProviderSurveyProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.businessName != null && message.hasOwnProperty("businessName"))
                        if (!$util.isString(message.businessName))
                            return "businessName: string expected";
                    if (message.sessionTypes != null && message.hasOwnProperty("sessionTypes")) {
                        if (!Array.isArray(message.sessionTypes))
                            return "sessionTypes: array expected";
                        for (var i = 0; i < message.sessionTypes.length; ++i)
                            switch (message.sessionTypes[i]) {
                            default:
                                return "sessionTypes: enum value[] expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                                break;
                            }
                    }
                    if (message.surveyCompletedByProviderId != null && message.hasOwnProperty("surveyCompletedByProviderId"))
                        if (!$util.isString(message.surveyCompletedByProviderId))
                            return "surveyCompletedByProviderId: string expected";
                    if (message.currentBookingPlatform != null && message.hasOwnProperty("currentBookingPlatform"))
                        switch (message.currentBookingPlatform) {
                        default:
                            return "currentBookingPlatform: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                            break;
                        }
                    if (message.chosenSubscription != null && message.hasOwnProperty("chosenSubscription"))
                        switch (message.chosenSubscription) {
                        default:
                            return "chosenSubscription: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.numLocations != null && message.hasOwnProperty("numLocations"))
                        if (!$util.isInteger(message.numLocations))
                            return "numLocations: integer expected";
                    if (message.numPractitioners != null && message.hasOwnProperty("numPractitioners"))
                        if (!$util.isInteger(message.numPractitioners))
                            return "numPractitioners: integer expected";
                    if (message.virtualServices != null && message.hasOwnProperty("virtualServices"))
                        switch (message.virtualServices) {
                        default:
                            return "virtualServices: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                            break;
                        }
                    return null;
                };

                /**
                 * Creates a ProviderSurveyProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.ProviderSurveyProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.ProviderSurveyProto} ProviderSurveyProto
                 */
                ProviderSurveyProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.ProviderSurveyProto)
                        return object;
                    var message = new $root.space.kenko.proto.ProviderSurveyProto();
                    if (object.businessName != null)
                        message.businessName = String(object.businessName);
                    if (object.sessionTypes) {
                        if (!Array.isArray(object.sessionTypes))
                            throw TypeError(".space.kenko.proto.ProviderSurveyProto.sessionTypes: array expected");
                        message.sessionTypes = [];
                        for (var i = 0; i < object.sessionTypes.length; ++i)
                            switch (object.sessionTypes[i]) {
                            default:
                                if (typeof object.sessionTypes[i] === "number") {
                                    message.sessionTypes[i] = object.sessionTypes[i];
                                    break;
                                }
                            case "SESSION_TYPE_UNKNOWN":
                            case 0:
                                message.sessionTypes[i] = 0;
                                break;
                            case "PRIVATE_SESSIONS":
                            case 1:
                                message.sessionTypes[i] = 1;
                                break;
                            case "SEMI_PRIVATE_SESSIONS":
                            case 2:
                                message.sessionTypes[i] = 2;
                                break;
                            case "GROUP_CLASSES":
                            case 3:
                                message.sessionTypes[i] = 3;
                                break;
                            case "EVENTS":
                            case 4:
                                message.sessionTypes[i] = 4;
                                break;
                            }
                    }
                    if (object.surveyCompletedByProviderId != null)
                        message.surveyCompletedByProviderId = String(object.surveyCompletedByProviderId);
                    switch (object.currentBookingPlatform) {
                    default:
                        if (typeof object.currentBookingPlatform === "number") {
                            message.currentBookingPlatform = object.currentBookingPlatform;
                            break;
                        }
                        break;
                    case "PLATFORM_UNKNOWN":
                    case 0:
                        message.currentBookingPlatform = 0;
                        break;
                    case "YES_AND_HAPPY":
                    case 1:
                        message.currentBookingPlatform = 1;
                        break;
                    case "YES_AND_OPEN":
                    case 2:
                        message.currentBookingPlatform = 2;
                        break;
                    case "NO_BUT_LOOKING":
                    case 3:
                        message.currentBookingPlatform = 3;
                        break;
                    case "NO_DONT_NEED":
                    case 4:
                        message.currentBookingPlatform = 4;
                        break;
                    }
                    switch (object.chosenSubscription) {
                    default:
                        if (typeof object.chosenSubscription === "number") {
                            message.chosenSubscription = object.chosenSubscription;
                            break;
                        }
                        break;
                    case "SUBSCRIPTION_TYPE_UNKNOWN":
                    case 0:
                        message.chosenSubscription = 0;
                        break;
                    case "LISTING":
                    case 1:
                        message.chosenSubscription = 1;
                        break;
                    case "LISTING_PLUS_BOOKING":
                    case 2:
                        message.chosenSubscription = 2;
                        break;
                    }
                    if (object.numLocations != null)
                        message.numLocations = object.numLocations | 0;
                    if (object.numPractitioners != null)
                        message.numPractitioners = object.numPractitioners | 0;
                    switch (object.virtualServices) {
                    default:
                        if (typeof object.virtualServices === "number") {
                            message.virtualServices = object.virtualServices;
                            break;
                        }
                        break;
                    case "VIRTUAL_UNKNOWN":
                    case 0:
                        message.virtualServices = 0;
                        break;
                    case "IN_PERSON_ONLY":
                    case 1:
                        message.virtualServices = 1;
                        break;
                    case "IN_PERSON_AND_VIRTUAL":
                    case 2:
                        message.virtualServices = 2;
                        break;
                    case "VIRTUAL_ONLY":
                    case 3:
                        message.virtualServices = 3;
                        break;
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a ProviderSurveyProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.ProviderSurveyProto
                 * @static
                 * @param {space.kenko.proto.ProviderSurveyProto} message ProviderSurveyProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ProviderSurveyProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.sessionTypes = [];
                    if (options.defaults) {
                        object.businessName = "";
                        object.surveyCompletedByProviderId = "";
                        object.currentBookingPlatform = options.enums === String ? "PLATFORM_UNKNOWN" : 0;
                        object.chosenSubscription = options.enums === String ? "SUBSCRIPTION_TYPE_UNKNOWN" : 0;
                        object.numLocations = 0;
                        object.numPractitioners = 0;
                        object.virtualServices = options.enums === String ? "VIRTUAL_UNKNOWN" : 0;
                    }
                    if (message.businessName != null && message.hasOwnProperty("businessName"))
                        object.businessName = message.businessName;
                    if (message.sessionTypes && message.sessionTypes.length) {
                        object.sessionTypes = [];
                        for (var j = 0; j < message.sessionTypes.length; ++j)
                            object.sessionTypes[j] = options.enums === String ? $root.space.kenko.proto.SurveySessionType[message.sessionTypes[j]] === undefined ? message.sessionTypes[j] : $root.space.kenko.proto.SurveySessionType[message.sessionTypes[j]] : message.sessionTypes[j];
                    }
                    if (message.surveyCompletedByProviderId != null && message.hasOwnProperty("surveyCompletedByProviderId"))
                        object.surveyCompletedByProviderId = message.surveyCompletedByProviderId;
                    if (message.currentBookingPlatform != null && message.hasOwnProperty("currentBookingPlatform"))
                        object.currentBookingPlatform = options.enums === String ? $root.space.kenko.proto.SurveyCurrentBookingPlatform[message.currentBookingPlatform] === undefined ? message.currentBookingPlatform : $root.space.kenko.proto.SurveyCurrentBookingPlatform[message.currentBookingPlatform] : message.currentBookingPlatform;
                    if (message.chosenSubscription != null && message.hasOwnProperty("chosenSubscription"))
                        object.chosenSubscription = options.enums === String ? $root.space.kenko.proto.BusinessSubscriptionType[message.chosenSubscription] === undefined ? message.chosenSubscription : $root.space.kenko.proto.BusinessSubscriptionType[message.chosenSubscription] : message.chosenSubscription;
                    if (message.numLocations != null && message.hasOwnProperty("numLocations"))
                        object.numLocations = message.numLocations;
                    if (message.numPractitioners != null && message.hasOwnProperty("numPractitioners"))
                        object.numPractitioners = message.numPractitioners;
                    if (message.virtualServices != null && message.hasOwnProperty("virtualServices"))
                        object.virtualServices = options.enums === String ? $root.space.kenko.proto.SurveyVirtualServices[message.virtualServices] === undefined ? message.virtualServices : $root.space.kenko.proto.SurveyVirtualServices[message.virtualServices] : message.virtualServices;
                    return object;
                };

                /**
                 * Converts this ProviderSurveyProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.ProviderSurveyProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ProviderSurveyProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ProviderSurveyProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.ProviderSurveyProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ProviderSurveyProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.ProviderSurveyProto";
                };

                return ProviderSurveyProto;
            })();

            /**
             * SurveyRole enum.
             * @name space.kenko.proto.SurveyRole
             * @enum {number}
             * @property {number} ROLE_UNKNOWN=0 ROLE_UNKNOWN value
             * @property {number} OFFICE_MANAGER_OR_STAFF=1 OFFICE_MANAGER_OR_STAFF value
             * @property {number} PRACTITIONER=2 PRACTITIONER value
             * @property {number} BUSINESS_OWNER_AND_PRACTITIONER=3 BUSINESS_OWNER_AND_PRACTITIONER value
             * @property {number} BUSINESS_OWNER_NON_PRACTITIONER=4 BUSINESS_OWNER_NON_PRACTITIONER value
             * @property {number} OTHER=5 OTHER value
             */
            proto.SurveyRole = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "ROLE_UNKNOWN"] = 0;
                values[valuesById[1] = "OFFICE_MANAGER_OR_STAFF"] = 1;
                values[valuesById[2] = "PRACTITIONER"] = 2;
                values[valuesById[3] = "BUSINESS_OWNER_AND_PRACTITIONER"] = 3;
                values[valuesById[4] = "BUSINESS_OWNER_NON_PRACTITIONER"] = 4;
                values[valuesById[5] = "OTHER"] = 5;
                return values;
            })();

            /**
             * SurveySessionType enum.
             * @name space.kenko.proto.SurveySessionType
             * @enum {number}
             * @property {number} SESSION_TYPE_UNKNOWN=0 SESSION_TYPE_UNKNOWN value
             * @property {number} PRIVATE_SESSIONS=1 PRIVATE_SESSIONS value
             * @property {number} SEMI_PRIVATE_SESSIONS=2 SEMI_PRIVATE_SESSIONS value
             * @property {number} GROUP_CLASSES=3 GROUP_CLASSES value
             * @property {number} EVENTS=4 EVENTS value
             */
            proto.SurveySessionType = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "SESSION_TYPE_UNKNOWN"] = 0;
                values[valuesById[1] = "PRIVATE_SESSIONS"] = 1;
                values[valuesById[2] = "SEMI_PRIVATE_SESSIONS"] = 2;
                values[valuesById[3] = "GROUP_CLASSES"] = 3;
                values[valuesById[4] = "EVENTS"] = 4;
                return values;
            })();

            /**
             * SurveyApptLocations enum.
             * @name space.kenko.proto.SurveyApptLocations
             * @enum {number}
             * @property {number} APPT_LOCATION_UNKNOWN=0 APPT_LOCATION_UNKNOWN value
             * @property {number} IN_PERSON_AT_BUSINESS=1 IN_PERSON_AT_BUSINESS value
             * @property {number} VIRTUAL_APPOINTMENTS=2 VIRTUAL_APPOINTMENTS value
             * @property {number} IN_HOME_APPOINTMENTS=3 IN_HOME_APPOINTMENTS value
             */
            proto.SurveyApptLocations = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "APPT_LOCATION_UNKNOWN"] = 0;
                values[valuesById[1] = "IN_PERSON_AT_BUSINESS"] = 1;
                values[valuesById[2] = "VIRTUAL_APPOINTMENTS"] = 2;
                values[valuesById[3] = "IN_HOME_APPOINTMENTS"] = 3;
                return values;
            })();

            /**
             * SurveyPracticeYearsInOperation enum.
             * @name space.kenko.proto.SurveyPracticeYearsInOperation
             * @enum {number}
             * @property {number} YEARS_UNKNOWN=0 YEARS_UNKNOWN value
             * @property {number} LESS_THAN_1=1 LESS_THAN_1 value
             * @property {number} ONE_TO_THREE=2 ONE_TO_THREE value
             * @property {number} FOUR_TO_SEVEN=3 FOUR_TO_SEVEN value
             * @property {number} EIGHT_TO_TEN=4 EIGHT_TO_TEN value
             * @property {number} MORE_THAN_TEN=5 MORE_THAN_TEN value
             */
            proto.SurveyPracticeYearsInOperation = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "YEARS_UNKNOWN"] = 0;
                values[valuesById[1] = "LESS_THAN_1"] = 1;
                values[valuesById[2] = "ONE_TO_THREE"] = 2;
                values[valuesById[3] = "FOUR_TO_SEVEN"] = 3;
                values[valuesById[4] = "EIGHT_TO_TEN"] = 4;
                values[valuesById[5] = "MORE_THAN_TEN"] = 5;
                return values;
            })();

            /**
             * SurveyCurrentBookingPlatform enum.
             * @name space.kenko.proto.SurveyCurrentBookingPlatform
             * @enum {number}
             * @property {number} PLATFORM_UNKNOWN=0 PLATFORM_UNKNOWN value
             * @property {number} YES_AND_HAPPY=1 YES_AND_HAPPY value
             * @property {number} YES_AND_OPEN=2 YES_AND_OPEN value
             * @property {number} NO_BUT_LOOKING=3 NO_BUT_LOOKING value
             * @property {number} NO_DONT_NEED=4 NO_DONT_NEED value
             */
            proto.SurveyCurrentBookingPlatform = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "PLATFORM_UNKNOWN"] = 0;
                values[valuesById[1] = "YES_AND_HAPPY"] = 1;
                values[valuesById[2] = "YES_AND_OPEN"] = 2;
                values[valuesById[3] = "NO_BUT_LOOKING"] = 3;
                values[valuesById[4] = "NO_DONT_NEED"] = 4;
                return values;
            })();

            /**
             * SurveyTeamMembers enum.
             * @name space.kenko.proto.SurveyTeamMembers
             * @enum {number}
             * @property {number} TEAM_MEMBERS_UNKNOWN=0 TEAM_MEMBERS_UNKNOWN value
             * @property {number} SOLO_PRACTITIONER=1 SOLO_PRACTITIONER value
             * @property {number} TWO_TO_FIVE=2 TWO_TO_FIVE value
             * @property {number} SIX_TO_TEN=3 SIX_TO_TEN value
             * @property {number} ELEVEN_PLUS=4 ELEVEN_PLUS value
             */
            proto.SurveyTeamMembers = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "TEAM_MEMBERS_UNKNOWN"] = 0;
                values[valuesById[1] = "SOLO_PRACTITIONER"] = 1;
                values[valuesById[2] = "TWO_TO_FIVE"] = 2;
                values[valuesById[3] = "SIX_TO_TEN"] = 3;
                values[valuesById[4] = "ELEVEN_PLUS"] = 4;
                return values;
            })();

            /**
             * SurveyVirtualServices enum.
             * @name space.kenko.proto.SurveyVirtualServices
             * @enum {number}
             * @property {number} VIRTUAL_UNKNOWN=0 VIRTUAL_UNKNOWN value
             * @property {number} IN_PERSON_ONLY=1 IN_PERSON_ONLY value
             * @property {number} IN_PERSON_AND_VIRTUAL=2 IN_PERSON_AND_VIRTUAL value
             * @property {number} VIRTUAL_ONLY=3 VIRTUAL_ONLY value
             */
            proto.SurveyVirtualServices = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "VIRTUAL_UNKNOWN"] = 0;
                values[valuesById[1] = "IN_PERSON_ONLY"] = 1;
                values[valuesById[2] = "IN_PERSON_AND_VIRTUAL"] = 2;
                values[valuesById[3] = "VIRTUAL_ONLY"] = 3;
                return values;
            })();

            proto.InvitationProtos = (function() {

                /**
                 * Properties of an InvitationProtos.
                 * @memberof space.kenko.proto
                 * @interface IInvitationProtos
                 * @property {Array.<space.kenko.proto.IInvitationProto>|null} [invitations] InvitationProtos invitations
                 */

                /**
                 * Constructs a new InvitationProtos.
                 * @memberof space.kenko.proto
                 * @classdesc Represents an InvitationProtos.
                 * @implements IInvitationProtos
                 * @constructor
                 * @param {space.kenko.proto.IInvitationProtos=} [properties] Properties to set
                 */
                function InvitationProtos(properties) {
                    this.invitations = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * InvitationProtos invitations.
                 * @member {Array.<space.kenko.proto.IInvitationProto>} invitations
                 * @memberof space.kenko.proto.InvitationProtos
                 * @instance
                 */
                InvitationProtos.prototype.invitations = $util.emptyArray;

                /**
                 * Creates a new InvitationProtos instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.InvitationProtos
                 * @static
                 * @param {space.kenko.proto.IInvitationProtos=} [properties] Properties to set
                 * @returns {space.kenko.proto.InvitationProtos} InvitationProtos instance
                 */
                InvitationProtos.create = function create(properties) {
                    return new InvitationProtos(properties);
                };

                /**
                 * Encodes the specified InvitationProtos message. Does not implicitly {@link space.kenko.proto.InvitationProtos.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.InvitationProtos
                 * @static
                 * @param {space.kenko.proto.IInvitationProtos} message InvitationProtos message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                InvitationProtos.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.invitations != null && message.invitations.length)
                        for (var i = 0; i < message.invitations.length; ++i)
                            $root.space.kenko.proto.InvitationProto.encode(message.invitations[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified InvitationProtos message, length delimited. Does not implicitly {@link space.kenko.proto.InvitationProtos.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.InvitationProtos
                 * @static
                 * @param {space.kenko.proto.IInvitationProtos} message InvitationProtos message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                InvitationProtos.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an InvitationProtos message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.InvitationProtos
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.InvitationProtos} InvitationProtos
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                InvitationProtos.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.InvitationProtos();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                if (!(message.invitations && message.invitations.length))
                                    message.invitations = [];
                                message.invitations.push($root.space.kenko.proto.InvitationProto.decode(reader, reader.uint32()));
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an InvitationProtos message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.InvitationProtos
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.InvitationProtos} InvitationProtos
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                InvitationProtos.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an InvitationProtos message.
                 * @function verify
                 * @memberof space.kenko.proto.InvitationProtos
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                InvitationProtos.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.invitations != null && message.hasOwnProperty("invitations")) {
                        if (!Array.isArray(message.invitations))
                            return "invitations: array expected";
                        for (var i = 0; i < message.invitations.length; ++i) {
                            var error = $root.space.kenko.proto.InvitationProto.verify(message.invitations[i]);
                            if (error)
                                return "invitations." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates an InvitationProtos message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.InvitationProtos
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.InvitationProtos} InvitationProtos
                 */
                InvitationProtos.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.InvitationProtos)
                        return object;
                    var message = new $root.space.kenko.proto.InvitationProtos();
                    if (object.invitations) {
                        if (!Array.isArray(object.invitations))
                            throw TypeError(".space.kenko.proto.InvitationProtos.invitations: array expected");
                        message.invitations = [];
                        for (var i = 0; i < object.invitations.length; ++i) {
                            if (typeof object.invitations[i] !== "object")
                                throw TypeError(".space.kenko.proto.InvitationProtos.invitations: object expected");
                            message.invitations[i] = $root.space.kenko.proto.InvitationProto.fromObject(object.invitations[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an InvitationProtos message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.InvitationProtos
                 * @static
                 * @param {space.kenko.proto.InvitationProtos} message InvitationProtos
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                InvitationProtos.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.invitations = [];
                    if (message.invitations && message.invitations.length) {
                        object.invitations = [];
                        for (var j = 0; j < message.invitations.length; ++j)
                            object.invitations[j] = $root.space.kenko.proto.InvitationProto.toObject(message.invitations[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this InvitationProtos to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.InvitationProtos
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                InvitationProtos.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for InvitationProtos
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.InvitationProtos
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                InvitationProtos.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.InvitationProtos";
                };

                return InvitationProtos;
            })();

            proto.InvitationProto = (function() {

                /**
                 * Properties of an InvitationProto.
                 * @memberof space.kenko.proto
                 * @interface IInvitationProto
                 * @property {string|null} [inviteCode] InvitationProto inviteCode
                 * @property {number|Long|null} [generatedTimestamp] InvitationProto generatedTimestamp
                 * @property {boolean|null} [alphaProviderAutoApprove] InvitationProto alphaProviderAutoApprove
                 */

                /**
                 * Constructs a new InvitationProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents an InvitationProto.
                 * @implements IInvitationProto
                 * @constructor
                 * @param {space.kenko.proto.IInvitationProto=} [properties] Properties to set
                 */
                function InvitationProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * InvitationProto inviteCode.
                 * @member {string} inviteCode
                 * @memberof space.kenko.proto.InvitationProto
                 * @instance
                 */
                InvitationProto.prototype.inviteCode = "";

                /**
                 * InvitationProto generatedTimestamp.
                 * @member {number|Long} generatedTimestamp
                 * @memberof space.kenko.proto.InvitationProto
                 * @instance
                 */
                InvitationProto.prototype.generatedTimestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * InvitationProto alphaProviderAutoApprove.
                 * @member {boolean} alphaProviderAutoApprove
                 * @memberof space.kenko.proto.InvitationProto
                 * @instance
                 */
                InvitationProto.prototype.alphaProviderAutoApprove = false;

                /**
                 * Creates a new InvitationProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.InvitationProto
                 * @static
                 * @param {space.kenko.proto.IInvitationProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.InvitationProto} InvitationProto instance
                 */
                InvitationProto.create = function create(properties) {
                    return new InvitationProto(properties);
                };

                /**
                 * Encodes the specified InvitationProto message. Does not implicitly {@link space.kenko.proto.InvitationProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.InvitationProto
                 * @static
                 * @param {space.kenko.proto.IInvitationProto} message InvitationProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                InvitationProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.inviteCode != null && Object.hasOwnProperty.call(message, "inviteCode"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.inviteCode);
                    if (message.generatedTimestamp != null && Object.hasOwnProperty.call(message, "generatedTimestamp"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int64(message.generatedTimestamp);
                    if (message.alphaProviderAutoApprove != null && Object.hasOwnProperty.call(message, "alphaProviderAutoApprove"))
                        writer.uint32(/* id 1000, wireType 0 =*/8000).bool(message.alphaProviderAutoApprove);
                    return writer;
                };

                /**
                 * Encodes the specified InvitationProto message, length delimited. Does not implicitly {@link space.kenko.proto.InvitationProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.InvitationProto
                 * @static
                 * @param {space.kenko.proto.IInvitationProto} message InvitationProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                InvitationProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an InvitationProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.InvitationProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.InvitationProto} InvitationProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                InvitationProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.InvitationProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.inviteCode = reader.string();
                                break;
                            }
                        case 2: {
                                message.generatedTimestamp = reader.int64();
                                break;
                            }
                        case 1000: {
                                message.alphaProviderAutoApprove = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an InvitationProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.InvitationProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.InvitationProto} InvitationProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                InvitationProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an InvitationProto message.
                 * @function verify
                 * @memberof space.kenko.proto.InvitationProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                InvitationProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.inviteCode != null && message.hasOwnProperty("inviteCode"))
                        if (!$util.isString(message.inviteCode))
                            return "inviteCode: string expected";
                    if (message.generatedTimestamp != null && message.hasOwnProperty("generatedTimestamp"))
                        if (!$util.isInteger(message.generatedTimestamp) && !(message.generatedTimestamp && $util.isInteger(message.generatedTimestamp.low) && $util.isInteger(message.generatedTimestamp.high)))
                            return "generatedTimestamp: integer|Long expected";
                    if (message.alphaProviderAutoApprove != null && message.hasOwnProperty("alphaProviderAutoApprove"))
                        if (typeof message.alphaProviderAutoApprove !== "boolean")
                            return "alphaProviderAutoApprove: boolean expected";
                    return null;
                };

                /**
                 * Creates an InvitationProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.InvitationProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.InvitationProto} InvitationProto
                 */
                InvitationProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.InvitationProto)
                        return object;
                    var message = new $root.space.kenko.proto.InvitationProto();
                    if (object.inviteCode != null)
                        message.inviteCode = String(object.inviteCode);
                    if (object.generatedTimestamp != null)
                        if ($util.Long)
                            (message.generatedTimestamp = $util.Long.fromValue(object.generatedTimestamp)).unsigned = false;
                        else if (typeof object.generatedTimestamp === "string")
                            message.generatedTimestamp = parseInt(object.generatedTimestamp, 10);
                        else if (typeof object.generatedTimestamp === "number")
                            message.generatedTimestamp = object.generatedTimestamp;
                        else if (typeof object.generatedTimestamp === "object")
                            message.generatedTimestamp = new $util.LongBits(object.generatedTimestamp.low >>> 0, object.generatedTimestamp.high >>> 0).toNumber();
                    if (object.alphaProviderAutoApprove != null)
                        message.alphaProviderAutoApprove = Boolean(object.alphaProviderAutoApprove);
                    return message;
                };

                /**
                 * Creates a plain object from an InvitationProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.InvitationProto
                 * @static
                 * @param {space.kenko.proto.InvitationProto} message InvitationProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                InvitationProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.inviteCode = "";
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.generatedTimestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.generatedTimestamp = options.longs === String ? "0" : 0;
                        object.alphaProviderAutoApprove = false;
                    }
                    if (message.inviteCode != null && message.hasOwnProperty("inviteCode"))
                        object.inviteCode = message.inviteCode;
                    if (message.generatedTimestamp != null && message.hasOwnProperty("generatedTimestamp"))
                        if (typeof message.generatedTimestamp === "number")
                            object.generatedTimestamp = options.longs === String ? String(message.generatedTimestamp) : message.generatedTimestamp;
                        else
                            object.generatedTimestamp = options.longs === String ? $util.Long.prototype.toString.call(message.generatedTimestamp) : options.longs === Number ? new $util.LongBits(message.generatedTimestamp.low >>> 0, message.generatedTimestamp.high >>> 0).toNumber() : message.generatedTimestamp;
                    if (message.alphaProviderAutoApprove != null && message.hasOwnProperty("alphaProviderAutoApprove"))
                        object.alphaProviderAutoApprove = message.alphaProviderAutoApprove;
                    return object;
                };

                /**
                 * Converts this InvitationProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.InvitationProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                InvitationProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for InvitationProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.InvitationProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                InvitationProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.InvitationProto";
                };

                return InvitationProto;
            })();

            proto.SchemaChallengeVerificationProto = (function() {

                /**
                 * Properties of a SchemaChallengeVerificationProto.
                 * @memberof space.kenko.proto
                 * @interface ISchemaChallengeVerificationProto
                 * @property {Array.<number|Long>|null} [challengeTimestamps] SchemaChallengeVerificationProto challengeTimestamps
                 * @property {Array.<number|Long>|null} [verificationAttemptTimestamps] SchemaChallengeVerificationProto verificationAttemptTimestamps
                 * @property {string|null} [latestOtp] SchemaChallengeVerificationProto latestOtp
                 * @property {number|Long|null} [latestChallengeTimestamp] SchemaChallengeVerificationProto latestChallengeTimestamp
                 * @property {space.kenko.proto.IContactMethodProto|null} [latestChallengeRecipient] SchemaChallengeVerificationProto latestChallengeRecipient
                 */

                /**
                 * Constructs a new SchemaChallengeVerificationProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a SchemaChallengeVerificationProto.
                 * @implements ISchemaChallengeVerificationProto
                 * @constructor
                 * @param {space.kenko.proto.ISchemaChallengeVerificationProto=} [properties] Properties to set
                 */
                function SchemaChallengeVerificationProto(properties) {
                    this.challengeTimestamps = [];
                    this.verificationAttemptTimestamps = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SchemaChallengeVerificationProto challengeTimestamps.
                 * @member {Array.<number|Long>} challengeTimestamps
                 * @memberof space.kenko.proto.SchemaChallengeVerificationProto
                 * @instance
                 */
                SchemaChallengeVerificationProto.prototype.challengeTimestamps = $util.emptyArray;

                /**
                 * SchemaChallengeVerificationProto verificationAttemptTimestamps.
                 * @member {Array.<number|Long>} verificationAttemptTimestamps
                 * @memberof space.kenko.proto.SchemaChallengeVerificationProto
                 * @instance
                 */
                SchemaChallengeVerificationProto.prototype.verificationAttemptTimestamps = $util.emptyArray;

                /**
                 * SchemaChallengeVerificationProto latestOtp.
                 * @member {string} latestOtp
                 * @memberof space.kenko.proto.SchemaChallengeVerificationProto
                 * @instance
                 */
                SchemaChallengeVerificationProto.prototype.latestOtp = "";

                /**
                 * SchemaChallengeVerificationProto latestChallengeTimestamp.
                 * @member {number|Long} latestChallengeTimestamp
                 * @memberof space.kenko.proto.SchemaChallengeVerificationProto
                 * @instance
                 */
                SchemaChallengeVerificationProto.prototype.latestChallengeTimestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * SchemaChallengeVerificationProto latestChallengeRecipient.
                 * @member {space.kenko.proto.IContactMethodProto|null|undefined} latestChallengeRecipient
                 * @memberof space.kenko.proto.SchemaChallengeVerificationProto
                 * @instance
                 */
                SchemaChallengeVerificationProto.prototype.latestChallengeRecipient = null;

                /**
                 * Creates a new SchemaChallengeVerificationProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.SchemaChallengeVerificationProto
                 * @static
                 * @param {space.kenko.proto.ISchemaChallengeVerificationProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.SchemaChallengeVerificationProto} SchemaChallengeVerificationProto instance
                 */
                SchemaChallengeVerificationProto.create = function create(properties) {
                    return new SchemaChallengeVerificationProto(properties);
                };

                /**
                 * Encodes the specified SchemaChallengeVerificationProto message. Does not implicitly {@link space.kenko.proto.SchemaChallengeVerificationProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.SchemaChallengeVerificationProto
                 * @static
                 * @param {space.kenko.proto.ISchemaChallengeVerificationProto} message SchemaChallengeVerificationProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SchemaChallengeVerificationProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.challengeTimestamps != null && message.challengeTimestamps.length) {
                        writer.uint32(/* id 2, wireType 2 =*/18).fork();
                        for (var i = 0; i < message.challengeTimestamps.length; ++i)
                            writer.int64(message.challengeTimestamps[i]);
                        writer.ldelim();
                    }
                    if (message.verificationAttemptTimestamps != null && message.verificationAttemptTimestamps.length) {
                        writer.uint32(/* id 3, wireType 2 =*/26).fork();
                        for (var i = 0; i < message.verificationAttemptTimestamps.length; ++i)
                            writer.int64(message.verificationAttemptTimestamps[i]);
                        writer.ldelim();
                    }
                    if (message.latestOtp != null && Object.hasOwnProperty.call(message, "latestOtp"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.latestOtp);
                    if (message.latestChallengeTimestamp != null && Object.hasOwnProperty.call(message, "latestChallengeTimestamp"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int64(message.latestChallengeTimestamp);
                    if (message.latestChallengeRecipient != null && Object.hasOwnProperty.call(message, "latestChallengeRecipient"))
                        $root.space.kenko.proto.ContactMethodProto.encode(message.latestChallengeRecipient, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SchemaChallengeVerificationProto message, length delimited. Does not implicitly {@link space.kenko.proto.SchemaChallengeVerificationProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.SchemaChallengeVerificationProto
                 * @static
                 * @param {space.kenko.proto.ISchemaChallengeVerificationProto} message SchemaChallengeVerificationProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SchemaChallengeVerificationProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SchemaChallengeVerificationProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.SchemaChallengeVerificationProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.SchemaChallengeVerificationProto} SchemaChallengeVerificationProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SchemaChallengeVerificationProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.SchemaChallengeVerificationProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 2: {
                                if (!(message.challengeTimestamps && message.challengeTimestamps.length))
                                    message.challengeTimestamps = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.challengeTimestamps.push(reader.int64());
                                } else
                                    message.challengeTimestamps.push(reader.int64());
                                break;
                            }
                        case 3: {
                                if (!(message.verificationAttemptTimestamps && message.verificationAttemptTimestamps.length))
                                    message.verificationAttemptTimestamps = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.verificationAttemptTimestamps.push(reader.int64());
                                } else
                                    message.verificationAttemptTimestamps.push(reader.int64());
                                break;
                            }
                        case 4: {
                                message.latestOtp = reader.string();
                                break;
                            }
                        case 5: {
                                message.latestChallengeTimestamp = reader.int64();
                                break;
                            }
                        case 7: {
                                message.latestChallengeRecipient = $root.space.kenko.proto.ContactMethodProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SchemaChallengeVerificationProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.SchemaChallengeVerificationProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.SchemaChallengeVerificationProto} SchemaChallengeVerificationProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SchemaChallengeVerificationProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SchemaChallengeVerificationProto message.
                 * @function verify
                 * @memberof space.kenko.proto.SchemaChallengeVerificationProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SchemaChallengeVerificationProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.challengeTimestamps != null && message.hasOwnProperty("challengeTimestamps")) {
                        if (!Array.isArray(message.challengeTimestamps))
                            return "challengeTimestamps: array expected";
                        for (var i = 0; i < message.challengeTimestamps.length; ++i)
                            if (!$util.isInteger(message.challengeTimestamps[i]) && !(message.challengeTimestamps[i] && $util.isInteger(message.challengeTimestamps[i].low) && $util.isInteger(message.challengeTimestamps[i].high)))
                                return "challengeTimestamps: integer|Long[] expected";
                    }
                    if (message.verificationAttemptTimestamps != null && message.hasOwnProperty("verificationAttemptTimestamps")) {
                        if (!Array.isArray(message.verificationAttemptTimestamps))
                            return "verificationAttemptTimestamps: array expected";
                        for (var i = 0; i < message.verificationAttemptTimestamps.length; ++i)
                            if (!$util.isInteger(message.verificationAttemptTimestamps[i]) && !(message.verificationAttemptTimestamps[i] && $util.isInteger(message.verificationAttemptTimestamps[i].low) && $util.isInteger(message.verificationAttemptTimestamps[i].high)))
                                return "verificationAttemptTimestamps: integer|Long[] expected";
                    }
                    if (message.latestOtp != null && message.hasOwnProperty("latestOtp"))
                        if (!$util.isString(message.latestOtp))
                            return "latestOtp: string expected";
                    if (message.latestChallengeTimestamp != null && message.hasOwnProperty("latestChallengeTimestamp"))
                        if (!$util.isInteger(message.latestChallengeTimestamp) && !(message.latestChallengeTimestamp && $util.isInteger(message.latestChallengeTimestamp.low) && $util.isInteger(message.latestChallengeTimestamp.high)))
                            return "latestChallengeTimestamp: integer|Long expected";
                    if (message.latestChallengeRecipient != null && message.hasOwnProperty("latestChallengeRecipient")) {
                        var error = $root.space.kenko.proto.ContactMethodProto.verify(message.latestChallengeRecipient);
                        if (error)
                            return "latestChallengeRecipient." + error;
                    }
                    return null;
                };

                /**
                 * Creates a SchemaChallengeVerificationProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.SchemaChallengeVerificationProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.SchemaChallengeVerificationProto} SchemaChallengeVerificationProto
                 */
                SchemaChallengeVerificationProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.SchemaChallengeVerificationProto)
                        return object;
                    var message = new $root.space.kenko.proto.SchemaChallengeVerificationProto();
                    if (object.challengeTimestamps) {
                        if (!Array.isArray(object.challengeTimestamps))
                            throw TypeError(".space.kenko.proto.SchemaChallengeVerificationProto.challengeTimestamps: array expected");
                        message.challengeTimestamps = [];
                        for (var i = 0; i < object.challengeTimestamps.length; ++i)
                            if ($util.Long)
                                (message.challengeTimestamps[i] = $util.Long.fromValue(object.challengeTimestamps[i])).unsigned = false;
                            else if (typeof object.challengeTimestamps[i] === "string")
                                message.challengeTimestamps[i] = parseInt(object.challengeTimestamps[i], 10);
                            else if (typeof object.challengeTimestamps[i] === "number")
                                message.challengeTimestamps[i] = object.challengeTimestamps[i];
                            else if (typeof object.challengeTimestamps[i] === "object")
                                message.challengeTimestamps[i] = new $util.LongBits(object.challengeTimestamps[i].low >>> 0, object.challengeTimestamps[i].high >>> 0).toNumber();
                    }
                    if (object.verificationAttemptTimestamps) {
                        if (!Array.isArray(object.verificationAttemptTimestamps))
                            throw TypeError(".space.kenko.proto.SchemaChallengeVerificationProto.verificationAttemptTimestamps: array expected");
                        message.verificationAttemptTimestamps = [];
                        for (var i = 0; i < object.verificationAttemptTimestamps.length; ++i)
                            if ($util.Long)
                                (message.verificationAttemptTimestamps[i] = $util.Long.fromValue(object.verificationAttemptTimestamps[i])).unsigned = false;
                            else if (typeof object.verificationAttemptTimestamps[i] === "string")
                                message.verificationAttemptTimestamps[i] = parseInt(object.verificationAttemptTimestamps[i], 10);
                            else if (typeof object.verificationAttemptTimestamps[i] === "number")
                                message.verificationAttemptTimestamps[i] = object.verificationAttemptTimestamps[i];
                            else if (typeof object.verificationAttemptTimestamps[i] === "object")
                                message.verificationAttemptTimestamps[i] = new $util.LongBits(object.verificationAttemptTimestamps[i].low >>> 0, object.verificationAttemptTimestamps[i].high >>> 0).toNumber();
                    }
                    if (object.latestOtp != null)
                        message.latestOtp = String(object.latestOtp);
                    if (object.latestChallengeTimestamp != null)
                        if ($util.Long)
                            (message.latestChallengeTimestamp = $util.Long.fromValue(object.latestChallengeTimestamp)).unsigned = false;
                        else if (typeof object.latestChallengeTimestamp === "string")
                            message.latestChallengeTimestamp = parseInt(object.latestChallengeTimestamp, 10);
                        else if (typeof object.latestChallengeTimestamp === "number")
                            message.latestChallengeTimestamp = object.latestChallengeTimestamp;
                        else if (typeof object.latestChallengeTimestamp === "object")
                            message.latestChallengeTimestamp = new $util.LongBits(object.latestChallengeTimestamp.low >>> 0, object.latestChallengeTimestamp.high >>> 0).toNumber();
                    if (object.latestChallengeRecipient != null) {
                        if (typeof object.latestChallengeRecipient !== "object")
                            throw TypeError(".space.kenko.proto.SchemaChallengeVerificationProto.latestChallengeRecipient: object expected");
                        message.latestChallengeRecipient = $root.space.kenko.proto.ContactMethodProto.fromObject(object.latestChallengeRecipient);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SchemaChallengeVerificationProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.SchemaChallengeVerificationProto
                 * @static
                 * @param {space.kenko.proto.SchemaChallengeVerificationProto} message SchemaChallengeVerificationProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SchemaChallengeVerificationProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.challengeTimestamps = [];
                        object.verificationAttemptTimestamps = [];
                    }
                    if (options.defaults) {
                        object.latestOtp = "";
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.latestChallengeTimestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.latestChallengeTimestamp = options.longs === String ? "0" : 0;
                        object.latestChallengeRecipient = null;
                    }
                    if (message.challengeTimestamps && message.challengeTimestamps.length) {
                        object.challengeTimestamps = [];
                        for (var j = 0; j < message.challengeTimestamps.length; ++j)
                            if (typeof message.challengeTimestamps[j] === "number")
                                object.challengeTimestamps[j] = options.longs === String ? String(message.challengeTimestamps[j]) : message.challengeTimestamps[j];
                            else
                                object.challengeTimestamps[j] = options.longs === String ? $util.Long.prototype.toString.call(message.challengeTimestamps[j]) : options.longs === Number ? new $util.LongBits(message.challengeTimestamps[j].low >>> 0, message.challengeTimestamps[j].high >>> 0).toNumber() : message.challengeTimestamps[j];
                    }
                    if (message.verificationAttemptTimestamps && message.verificationAttemptTimestamps.length) {
                        object.verificationAttemptTimestamps = [];
                        for (var j = 0; j < message.verificationAttemptTimestamps.length; ++j)
                            if (typeof message.verificationAttemptTimestamps[j] === "number")
                                object.verificationAttemptTimestamps[j] = options.longs === String ? String(message.verificationAttemptTimestamps[j]) : message.verificationAttemptTimestamps[j];
                            else
                                object.verificationAttemptTimestamps[j] = options.longs === String ? $util.Long.prototype.toString.call(message.verificationAttemptTimestamps[j]) : options.longs === Number ? new $util.LongBits(message.verificationAttemptTimestamps[j].low >>> 0, message.verificationAttemptTimestamps[j].high >>> 0).toNumber() : message.verificationAttemptTimestamps[j];
                    }
                    if (message.latestOtp != null && message.hasOwnProperty("latestOtp"))
                        object.latestOtp = message.latestOtp;
                    if (message.latestChallengeTimestamp != null && message.hasOwnProperty("latestChallengeTimestamp"))
                        if (typeof message.latestChallengeTimestamp === "number")
                            object.latestChallengeTimestamp = options.longs === String ? String(message.latestChallengeTimestamp) : message.latestChallengeTimestamp;
                        else
                            object.latestChallengeTimestamp = options.longs === String ? $util.Long.prototype.toString.call(message.latestChallengeTimestamp) : options.longs === Number ? new $util.LongBits(message.latestChallengeTimestamp.low >>> 0, message.latestChallengeTimestamp.high >>> 0).toNumber() : message.latestChallengeTimestamp;
                    if (message.latestChallengeRecipient != null && message.hasOwnProperty("latestChallengeRecipient"))
                        object.latestChallengeRecipient = $root.space.kenko.proto.ContactMethodProto.toObject(message.latestChallengeRecipient, options);
                    return object;
                };

                /**
                 * Converts this SchemaChallengeVerificationProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.SchemaChallengeVerificationProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SchemaChallengeVerificationProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for SchemaChallengeVerificationProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.SchemaChallengeVerificationProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                SchemaChallengeVerificationProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.SchemaChallengeVerificationProto";
                };

                return SchemaChallengeVerificationProto;
            })();

            proto.RequestEnvelopeProto = (function() {

                /**
                 * Properties of a RequestEnvelopeProto.
                 * @memberof space.kenko.proto
                 * @interface IRequestEnvelopeProto
                 * @property {string|null} [authToken] RequestEnvelopeProto authToken
                 * @property {Uint8Array|null} [requestMessage] RequestEnvelopeProto requestMessage
                 * @property {space.kenko.proto.IProviderContextProto|null} [impersonation] RequestEnvelopeProto impersonation
                 */

                /**
                 * Constructs a new RequestEnvelopeProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a RequestEnvelopeProto.
                 * @implements IRequestEnvelopeProto
                 * @constructor
                 * @param {space.kenko.proto.IRequestEnvelopeProto=} [properties] Properties to set
                 */
                function RequestEnvelopeProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * RequestEnvelopeProto authToken.
                 * @member {string} authToken
                 * @memberof space.kenko.proto.RequestEnvelopeProto
                 * @instance
                 */
                RequestEnvelopeProto.prototype.authToken = "";

                /**
                 * RequestEnvelopeProto requestMessage.
                 * @member {Uint8Array} requestMessage
                 * @memberof space.kenko.proto.RequestEnvelopeProto
                 * @instance
                 */
                RequestEnvelopeProto.prototype.requestMessage = $util.newBuffer([]);

                /**
                 * RequestEnvelopeProto impersonation.
                 * @member {space.kenko.proto.IProviderContextProto|null|undefined} impersonation
                 * @memberof space.kenko.proto.RequestEnvelopeProto
                 * @instance
                 */
                RequestEnvelopeProto.prototype.impersonation = null;

                /**
                 * Creates a new RequestEnvelopeProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.RequestEnvelopeProto
                 * @static
                 * @param {space.kenko.proto.IRequestEnvelopeProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.RequestEnvelopeProto} RequestEnvelopeProto instance
                 */
                RequestEnvelopeProto.create = function create(properties) {
                    return new RequestEnvelopeProto(properties);
                };

                /**
                 * Encodes the specified RequestEnvelopeProto message. Does not implicitly {@link space.kenko.proto.RequestEnvelopeProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.RequestEnvelopeProto
                 * @static
                 * @param {space.kenko.proto.IRequestEnvelopeProto} message RequestEnvelopeProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RequestEnvelopeProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.authToken != null && Object.hasOwnProperty.call(message, "authToken"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.authToken);
                    if (message.requestMessage != null && Object.hasOwnProperty.call(message, "requestMessage"))
                        writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.requestMessage);
                    if (message.impersonation != null && Object.hasOwnProperty.call(message, "impersonation"))
                        $root.space.kenko.proto.ProviderContextProto.encode(message.impersonation, writer.uint32(/* id 100, wireType 2 =*/802).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified RequestEnvelopeProto message, length delimited. Does not implicitly {@link space.kenko.proto.RequestEnvelopeProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.RequestEnvelopeProto
                 * @static
                 * @param {space.kenko.proto.IRequestEnvelopeProto} message RequestEnvelopeProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RequestEnvelopeProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a RequestEnvelopeProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.RequestEnvelopeProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.RequestEnvelopeProto} RequestEnvelopeProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RequestEnvelopeProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.RequestEnvelopeProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.authToken = reader.string();
                                break;
                            }
                        case 2: {
                                message.requestMessage = reader.bytes();
                                break;
                            }
                        case 100: {
                                message.impersonation = $root.space.kenko.proto.ProviderContextProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a RequestEnvelopeProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.RequestEnvelopeProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.RequestEnvelopeProto} RequestEnvelopeProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RequestEnvelopeProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a RequestEnvelopeProto message.
                 * @function verify
                 * @memberof space.kenko.proto.RequestEnvelopeProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                RequestEnvelopeProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.authToken != null && message.hasOwnProperty("authToken"))
                        if (!$util.isString(message.authToken))
                            return "authToken: string expected";
                    if (message.requestMessage != null && message.hasOwnProperty("requestMessage"))
                        if (!(message.requestMessage && typeof message.requestMessage.length === "number" || $util.isString(message.requestMessage)))
                            return "requestMessage: buffer expected";
                    if (message.impersonation != null && message.hasOwnProperty("impersonation")) {
                        var error = $root.space.kenko.proto.ProviderContextProto.verify(message.impersonation);
                        if (error)
                            return "impersonation." + error;
                    }
                    return null;
                };

                /**
                 * Creates a RequestEnvelopeProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.RequestEnvelopeProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.RequestEnvelopeProto} RequestEnvelopeProto
                 */
                RequestEnvelopeProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.RequestEnvelopeProto)
                        return object;
                    var message = new $root.space.kenko.proto.RequestEnvelopeProto();
                    if (object.authToken != null)
                        message.authToken = String(object.authToken);
                    if (object.requestMessage != null)
                        if (typeof object.requestMessage === "string")
                            $util.base64.decode(object.requestMessage, message.requestMessage = $util.newBuffer($util.base64.length(object.requestMessage)), 0);
                        else if (object.requestMessage.length >= 0)
                            message.requestMessage = object.requestMessage;
                    if (object.impersonation != null) {
                        if (typeof object.impersonation !== "object")
                            throw TypeError(".space.kenko.proto.RequestEnvelopeProto.impersonation: object expected");
                        message.impersonation = $root.space.kenko.proto.ProviderContextProto.fromObject(object.impersonation);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a RequestEnvelopeProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.RequestEnvelopeProto
                 * @static
                 * @param {space.kenko.proto.RequestEnvelopeProto} message RequestEnvelopeProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                RequestEnvelopeProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.authToken = "";
                        if (options.bytes === String)
                            object.requestMessage = "";
                        else {
                            object.requestMessage = [];
                            if (options.bytes !== Array)
                                object.requestMessage = $util.newBuffer(object.requestMessage);
                        }
                        object.impersonation = null;
                    }
                    if (message.authToken != null && message.hasOwnProperty("authToken"))
                        object.authToken = message.authToken;
                    if (message.requestMessage != null && message.hasOwnProperty("requestMessage"))
                        object.requestMessage = options.bytes === String ? $util.base64.encode(message.requestMessage, 0, message.requestMessage.length) : options.bytes === Array ? Array.prototype.slice.call(message.requestMessage) : message.requestMessage;
                    if (message.impersonation != null && message.hasOwnProperty("impersonation"))
                        object.impersonation = $root.space.kenko.proto.ProviderContextProto.toObject(message.impersonation, options);
                    return object;
                };

                /**
                 * Converts this RequestEnvelopeProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.RequestEnvelopeProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                RequestEnvelopeProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for RequestEnvelopeProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.RequestEnvelopeProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                RequestEnvelopeProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.RequestEnvelopeProto";
                };

                return RequestEnvelopeProto;
            })();

            proto.ProviderContextProto = (function() {

                /**
                 * Properties of a ProviderContextProto.
                 * @memberof space.kenko.proto
                 * @interface IProviderContextProto
                 * @property {string|null} [impersonatedBusinessId] ProviderContextProto impersonatedBusinessId
                 * @property {string|null} [impersonatedProviderId] ProviderContextProto impersonatedProviderId
                 */

                /**
                 * Constructs a new ProviderContextProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a ProviderContextProto.
                 * @implements IProviderContextProto
                 * @constructor
                 * @param {space.kenko.proto.IProviderContextProto=} [properties] Properties to set
                 */
                function ProviderContextProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ProviderContextProto impersonatedBusinessId.
                 * @member {string} impersonatedBusinessId
                 * @memberof space.kenko.proto.ProviderContextProto
                 * @instance
                 */
                ProviderContextProto.prototype.impersonatedBusinessId = "";

                /**
                 * ProviderContextProto impersonatedProviderId.
                 * @member {string} impersonatedProviderId
                 * @memberof space.kenko.proto.ProviderContextProto
                 * @instance
                 */
                ProviderContextProto.prototype.impersonatedProviderId = "";

                /**
                 * Creates a new ProviderContextProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.ProviderContextProto
                 * @static
                 * @param {space.kenko.proto.IProviderContextProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.ProviderContextProto} ProviderContextProto instance
                 */
                ProviderContextProto.create = function create(properties) {
                    return new ProviderContextProto(properties);
                };

                /**
                 * Encodes the specified ProviderContextProto message. Does not implicitly {@link space.kenko.proto.ProviderContextProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.ProviderContextProto
                 * @static
                 * @param {space.kenko.proto.IProviderContextProto} message ProviderContextProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ProviderContextProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.impersonatedBusinessId != null && Object.hasOwnProperty.call(message, "impersonatedBusinessId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.impersonatedBusinessId);
                    if (message.impersonatedProviderId != null && Object.hasOwnProperty.call(message, "impersonatedProviderId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.impersonatedProviderId);
                    return writer;
                };

                /**
                 * Encodes the specified ProviderContextProto message, length delimited. Does not implicitly {@link space.kenko.proto.ProviderContextProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.ProviderContextProto
                 * @static
                 * @param {space.kenko.proto.IProviderContextProto} message ProviderContextProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ProviderContextProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ProviderContextProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.ProviderContextProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.ProviderContextProto} ProviderContextProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ProviderContextProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.ProviderContextProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.impersonatedBusinessId = reader.string();
                                break;
                            }
                        case 2: {
                                message.impersonatedProviderId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ProviderContextProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.ProviderContextProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.ProviderContextProto} ProviderContextProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ProviderContextProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ProviderContextProto message.
                 * @function verify
                 * @memberof space.kenko.proto.ProviderContextProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ProviderContextProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.impersonatedBusinessId != null && message.hasOwnProperty("impersonatedBusinessId"))
                        if (!$util.isString(message.impersonatedBusinessId))
                            return "impersonatedBusinessId: string expected";
                    if (message.impersonatedProviderId != null && message.hasOwnProperty("impersonatedProviderId"))
                        if (!$util.isString(message.impersonatedProviderId))
                            return "impersonatedProviderId: string expected";
                    return null;
                };

                /**
                 * Creates a ProviderContextProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.ProviderContextProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.ProviderContextProto} ProviderContextProto
                 */
                ProviderContextProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.ProviderContextProto)
                        return object;
                    var message = new $root.space.kenko.proto.ProviderContextProto();
                    if (object.impersonatedBusinessId != null)
                        message.impersonatedBusinessId = String(object.impersonatedBusinessId);
                    if (object.impersonatedProviderId != null)
                        message.impersonatedProviderId = String(object.impersonatedProviderId);
                    return message;
                };

                /**
                 * Creates a plain object from a ProviderContextProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.ProviderContextProto
                 * @static
                 * @param {space.kenko.proto.ProviderContextProto} message ProviderContextProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ProviderContextProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.impersonatedBusinessId = "";
                        object.impersonatedProviderId = "";
                    }
                    if (message.impersonatedBusinessId != null && message.hasOwnProperty("impersonatedBusinessId"))
                        object.impersonatedBusinessId = message.impersonatedBusinessId;
                    if (message.impersonatedProviderId != null && message.hasOwnProperty("impersonatedProviderId"))
                        object.impersonatedProviderId = message.impersonatedProviderId;
                    return object;
                };

                /**
                 * Converts this ProviderContextProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.ProviderContextProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ProviderContextProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ProviderContextProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.ProviderContextProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ProviderContextProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.ProviderContextProto";
                };

                return ProviderContextProto;
            })();

            return proto;
        })();

        return kenko;
    })();

    return space;
})();

$root.ApiUserProto = (function() {

    /**
     * Properties of an ApiUserProto.
     * @exports IApiUserProto
     * @interface IApiUserProto
     * @property {string|null} [userId] ApiUserProto userId
     * @property {string|null} [familyName] ApiUserProto familyName
     * @property {string|null} [givenName] ApiUserProto givenName
     * @property {IWellnessSurveyProto|null} [wellnessSurveyAnswers] ApiUserProto wellnessSurveyAnswers
     * @property {string|null} [mobileNumber] ApiUserProto mobileNumber
     * @property {string|null} [contactEmail] ApiUserProto contactEmail
     * @property {Array.<space.kenko.proto.IVerifiedContactMethodProto>|null} [verifiedContactMethods] ApiUserProto verifiedContactMethods
     * @property {Array.<string>|null} [acceptedTermsVersions] ApiUserProto acceptedTermsVersions
     * @property {space.kenko.proto.ILocalDateProto|null} [birthDate] ApiUserProto birthDate
     */

    /**
     * Constructs a new ApiUserProto.
     * @exports ApiUserProto
     * @classdesc Represents an ApiUserProto.
     * @implements IApiUserProto
     * @constructor
     * @param {IApiUserProto=} [properties] Properties to set
     */
    function ApiUserProto(properties) {
        this.verifiedContactMethods = [];
        this.acceptedTermsVersions = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ApiUserProto userId.
     * @member {string} userId
     * @memberof ApiUserProto
     * @instance
     */
    ApiUserProto.prototype.userId = "";

    /**
     * ApiUserProto familyName.
     * @member {string} familyName
     * @memberof ApiUserProto
     * @instance
     */
    ApiUserProto.prototype.familyName = "";

    /**
     * ApiUserProto givenName.
     * @member {string} givenName
     * @memberof ApiUserProto
     * @instance
     */
    ApiUserProto.prototype.givenName = "";

    /**
     * ApiUserProto wellnessSurveyAnswers.
     * @member {IWellnessSurveyProto|null|undefined} wellnessSurveyAnswers
     * @memberof ApiUserProto
     * @instance
     */
    ApiUserProto.prototype.wellnessSurveyAnswers = null;

    /**
     * ApiUserProto mobileNumber.
     * @member {string} mobileNumber
     * @memberof ApiUserProto
     * @instance
     */
    ApiUserProto.prototype.mobileNumber = "";

    /**
     * ApiUserProto contactEmail.
     * @member {string} contactEmail
     * @memberof ApiUserProto
     * @instance
     */
    ApiUserProto.prototype.contactEmail = "";

    /**
     * ApiUserProto verifiedContactMethods.
     * @member {Array.<space.kenko.proto.IVerifiedContactMethodProto>} verifiedContactMethods
     * @memberof ApiUserProto
     * @instance
     */
    ApiUserProto.prototype.verifiedContactMethods = $util.emptyArray;

    /**
     * ApiUserProto acceptedTermsVersions.
     * @member {Array.<string>} acceptedTermsVersions
     * @memberof ApiUserProto
     * @instance
     */
    ApiUserProto.prototype.acceptedTermsVersions = $util.emptyArray;

    /**
     * ApiUserProto birthDate.
     * @member {space.kenko.proto.ILocalDateProto|null|undefined} birthDate
     * @memberof ApiUserProto
     * @instance
     */
    ApiUserProto.prototype.birthDate = null;

    /**
     * Creates a new ApiUserProto instance using the specified properties.
     * @function create
     * @memberof ApiUserProto
     * @static
     * @param {IApiUserProto=} [properties] Properties to set
     * @returns {ApiUserProto} ApiUserProto instance
     */
    ApiUserProto.create = function create(properties) {
        return new ApiUserProto(properties);
    };

    /**
     * Encodes the specified ApiUserProto message. Does not implicitly {@link ApiUserProto.verify|verify} messages.
     * @function encode
     * @memberof ApiUserProto
     * @static
     * @param {IApiUserProto} message ApiUserProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ApiUserProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.userId);
        if (message.familyName != null && Object.hasOwnProperty.call(message, "familyName"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.familyName);
        if (message.givenName != null && Object.hasOwnProperty.call(message, "givenName"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.givenName);
        if (message.wellnessSurveyAnswers != null && Object.hasOwnProperty.call(message, "wellnessSurveyAnswers"))
            $root.WellnessSurveyProto.encode(message.wellnessSurveyAnswers, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.mobileNumber != null && Object.hasOwnProperty.call(message, "mobileNumber"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.mobileNumber);
        if (message.contactEmail != null && Object.hasOwnProperty.call(message, "contactEmail"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.contactEmail);
        if (message.verifiedContactMethods != null && message.verifiedContactMethods.length)
            for (var i = 0; i < message.verifiedContactMethods.length; ++i)
                $root.space.kenko.proto.VerifiedContactMethodProto.encode(message.verifiedContactMethods[i], writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
        if (message.acceptedTermsVersions != null && message.acceptedTermsVersions.length)
            for (var i = 0; i < message.acceptedTermsVersions.length; ++i)
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.acceptedTermsVersions[i]);
        if (message.birthDate != null && Object.hasOwnProperty.call(message, "birthDate"))
            $root.space.kenko.proto.LocalDateProto.encode(message.birthDate, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ApiUserProto message, length delimited. Does not implicitly {@link ApiUserProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ApiUserProto
     * @static
     * @param {IApiUserProto} message ApiUserProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ApiUserProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an ApiUserProto message from the specified reader or buffer.
     * @function decode
     * @memberof ApiUserProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ApiUserProto} ApiUserProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ApiUserProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ApiUserProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.userId = reader.string();
                    break;
                }
            case 2: {
                    message.familyName = reader.string();
                    break;
                }
            case 3: {
                    message.givenName = reader.string();
                    break;
                }
            case 4: {
                    message.wellnessSurveyAnswers = $root.WellnessSurveyProto.decode(reader, reader.uint32());
                    break;
                }
            case 5: {
                    message.mobileNumber = reader.string();
                    break;
                }
            case 6: {
                    message.contactEmail = reader.string();
                    break;
                }
            case 7: {
                    if (!(message.verifiedContactMethods && message.verifiedContactMethods.length))
                        message.verifiedContactMethods = [];
                    message.verifiedContactMethods.push($root.space.kenko.proto.VerifiedContactMethodProto.decode(reader, reader.uint32()));
                    break;
                }
            case 8: {
                    if (!(message.acceptedTermsVersions && message.acceptedTermsVersions.length))
                        message.acceptedTermsVersions = [];
                    message.acceptedTermsVersions.push(reader.string());
                    break;
                }
            case 9: {
                    message.birthDate = $root.space.kenko.proto.LocalDateProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an ApiUserProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ApiUserProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ApiUserProto} ApiUserProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ApiUserProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an ApiUserProto message.
     * @function verify
     * @memberof ApiUserProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ApiUserProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.userId != null && message.hasOwnProperty("userId"))
            if (!$util.isString(message.userId))
                return "userId: string expected";
        if (message.familyName != null && message.hasOwnProperty("familyName"))
            if (!$util.isString(message.familyName))
                return "familyName: string expected";
        if (message.givenName != null && message.hasOwnProperty("givenName"))
            if (!$util.isString(message.givenName))
                return "givenName: string expected";
        if (message.wellnessSurveyAnswers != null && message.hasOwnProperty("wellnessSurveyAnswers")) {
            var error = $root.WellnessSurveyProto.verify(message.wellnessSurveyAnswers);
            if (error)
                return "wellnessSurveyAnswers." + error;
        }
        if (message.mobileNumber != null && message.hasOwnProperty("mobileNumber"))
            if (!$util.isString(message.mobileNumber))
                return "mobileNumber: string expected";
        if (message.contactEmail != null && message.hasOwnProperty("contactEmail"))
            if (!$util.isString(message.contactEmail))
                return "contactEmail: string expected";
        if (message.verifiedContactMethods != null && message.hasOwnProperty("verifiedContactMethods")) {
            if (!Array.isArray(message.verifiedContactMethods))
                return "verifiedContactMethods: array expected";
            for (var i = 0; i < message.verifiedContactMethods.length; ++i) {
                var error = $root.space.kenko.proto.VerifiedContactMethodProto.verify(message.verifiedContactMethods[i]);
                if (error)
                    return "verifiedContactMethods." + error;
            }
        }
        if (message.acceptedTermsVersions != null && message.hasOwnProperty("acceptedTermsVersions")) {
            if (!Array.isArray(message.acceptedTermsVersions))
                return "acceptedTermsVersions: array expected";
            for (var i = 0; i < message.acceptedTermsVersions.length; ++i)
                if (!$util.isString(message.acceptedTermsVersions[i]))
                    return "acceptedTermsVersions: string[] expected";
        }
        if (message.birthDate != null && message.hasOwnProperty("birthDate")) {
            var error = $root.space.kenko.proto.LocalDateProto.verify(message.birthDate);
            if (error)
                return "birthDate." + error;
        }
        return null;
    };

    /**
     * Creates an ApiUserProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ApiUserProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ApiUserProto} ApiUserProto
     */
    ApiUserProto.fromObject = function fromObject(object) {
        if (object instanceof $root.ApiUserProto)
            return object;
        var message = new $root.ApiUserProto();
        if (object.userId != null)
            message.userId = String(object.userId);
        if (object.familyName != null)
            message.familyName = String(object.familyName);
        if (object.givenName != null)
            message.givenName = String(object.givenName);
        if (object.wellnessSurveyAnswers != null) {
            if (typeof object.wellnessSurveyAnswers !== "object")
                throw TypeError(".ApiUserProto.wellnessSurveyAnswers: object expected");
            message.wellnessSurveyAnswers = $root.WellnessSurveyProto.fromObject(object.wellnessSurveyAnswers);
        }
        if (object.mobileNumber != null)
            message.mobileNumber = String(object.mobileNumber);
        if (object.contactEmail != null)
            message.contactEmail = String(object.contactEmail);
        if (object.verifiedContactMethods) {
            if (!Array.isArray(object.verifiedContactMethods))
                throw TypeError(".ApiUserProto.verifiedContactMethods: array expected");
            message.verifiedContactMethods = [];
            for (var i = 0; i < object.verifiedContactMethods.length; ++i) {
                if (typeof object.verifiedContactMethods[i] !== "object")
                    throw TypeError(".ApiUserProto.verifiedContactMethods: object expected");
                message.verifiedContactMethods[i] = $root.space.kenko.proto.VerifiedContactMethodProto.fromObject(object.verifiedContactMethods[i]);
            }
        }
        if (object.acceptedTermsVersions) {
            if (!Array.isArray(object.acceptedTermsVersions))
                throw TypeError(".ApiUserProto.acceptedTermsVersions: array expected");
            message.acceptedTermsVersions = [];
            for (var i = 0; i < object.acceptedTermsVersions.length; ++i)
                message.acceptedTermsVersions[i] = String(object.acceptedTermsVersions[i]);
        }
        if (object.birthDate != null) {
            if (typeof object.birthDate !== "object")
                throw TypeError(".ApiUserProto.birthDate: object expected");
            message.birthDate = $root.space.kenko.proto.LocalDateProto.fromObject(object.birthDate);
        }
        return message;
    };

    /**
     * Creates a plain object from an ApiUserProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ApiUserProto
     * @static
     * @param {ApiUserProto} message ApiUserProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ApiUserProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.verifiedContactMethods = [];
            object.acceptedTermsVersions = [];
        }
        if (options.defaults) {
            object.userId = "";
            object.familyName = "";
            object.givenName = "";
            object.wellnessSurveyAnswers = null;
            object.mobileNumber = "";
            object.contactEmail = "";
            object.birthDate = null;
        }
        if (message.userId != null && message.hasOwnProperty("userId"))
            object.userId = message.userId;
        if (message.familyName != null && message.hasOwnProperty("familyName"))
            object.familyName = message.familyName;
        if (message.givenName != null && message.hasOwnProperty("givenName"))
            object.givenName = message.givenName;
        if (message.wellnessSurveyAnswers != null && message.hasOwnProperty("wellnessSurveyAnswers"))
            object.wellnessSurveyAnswers = $root.WellnessSurveyProto.toObject(message.wellnessSurveyAnswers, options);
        if (message.mobileNumber != null && message.hasOwnProperty("mobileNumber"))
            object.mobileNumber = message.mobileNumber;
        if (message.contactEmail != null && message.hasOwnProperty("contactEmail"))
            object.contactEmail = message.contactEmail;
        if (message.verifiedContactMethods && message.verifiedContactMethods.length) {
            object.verifiedContactMethods = [];
            for (var j = 0; j < message.verifiedContactMethods.length; ++j)
                object.verifiedContactMethods[j] = $root.space.kenko.proto.VerifiedContactMethodProto.toObject(message.verifiedContactMethods[j], options);
        }
        if (message.acceptedTermsVersions && message.acceptedTermsVersions.length) {
            object.acceptedTermsVersions = [];
            for (var j = 0; j < message.acceptedTermsVersions.length; ++j)
                object.acceptedTermsVersions[j] = message.acceptedTermsVersions[j];
        }
        if (message.birthDate != null && message.hasOwnProperty("birthDate"))
            object.birthDate = $root.space.kenko.proto.LocalDateProto.toObject(message.birthDate, options);
        return object;
    };

    /**
     * Converts this ApiUserProto to JSON.
     * @function toJSON
     * @memberof ApiUserProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ApiUserProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ApiUserProto
     * @function getTypeUrl
     * @memberof ApiUserProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ApiUserProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ApiUserProto";
    };

    return ApiUserProto;
})();

$root.WellnessSurveyProto = (function() {

    /**
     * Properties of a WellnessSurveyProto.
     * @exports IWellnessSurveyProto
     * @interface IWellnessSurveyProto
     * @property {Array.<string>|null} [wellnessGoals] WellnessSurveyProto wellnessGoals
     * @property {Array.<string>|null} [holisticHealthInterests] WellnessSurveyProto holisticHealthInterests
     * @property {string|null} [opennessToHolisticModalities] WellnessSurveyProto opennessToHolisticModalities
     * @property {string|null} [gender] WellnessSurveyProto gender
     */

    /**
     * Constructs a new WellnessSurveyProto.
     * @exports WellnessSurveyProto
     * @classdesc Represents a WellnessSurveyProto.
     * @implements IWellnessSurveyProto
     * @constructor
     * @param {IWellnessSurveyProto=} [properties] Properties to set
     */
    function WellnessSurveyProto(properties) {
        this.wellnessGoals = [];
        this.holisticHealthInterests = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * WellnessSurveyProto wellnessGoals.
     * @member {Array.<string>} wellnessGoals
     * @memberof WellnessSurveyProto
     * @instance
     */
    WellnessSurveyProto.prototype.wellnessGoals = $util.emptyArray;

    /**
     * WellnessSurveyProto holisticHealthInterests.
     * @member {Array.<string>} holisticHealthInterests
     * @memberof WellnessSurveyProto
     * @instance
     */
    WellnessSurveyProto.prototype.holisticHealthInterests = $util.emptyArray;

    /**
     * WellnessSurveyProto opennessToHolisticModalities.
     * @member {string} opennessToHolisticModalities
     * @memberof WellnessSurveyProto
     * @instance
     */
    WellnessSurveyProto.prototype.opennessToHolisticModalities = "";

    /**
     * WellnessSurveyProto gender.
     * @member {string} gender
     * @memberof WellnessSurveyProto
     * @instance
     */
    WellnessSurveyProto.prototype.gender = "";

    /**
     * Creates a new WellnessSurveyProto instance using the specified properties.
     * @function create
     * @memberof WellnessSurveyProto
     * @static
     * @param {IWellnessSurveyProto=} [properties] Properties to set
     * @returns {WellnessSurveyProto} WellnessSurveyProto instance
     */
    WellnessSurveyProto.create = function create(properties) {
        return new WellnessSurveyProto(properties);
    };

    /**
     * Encodes the specified WellnessSurveyProto message. Does not implicitly {@link WellnessSurveyProto.verify|verify} messages.
     * @function encode
     * @memberof WellnessSurveyProto
     * @static
     * @param {IWellnessSurveyProto} message WellnessSurveyProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WellnessSurveyProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.wellnessGoals != null && message.wellnessGoals.length)
            for (var i = 0; i < message.wellnessGoals.length; ++i)
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.wellnessGoals[i]);
        if (message.holisticHealthInterests != null && message.holisticHealthInterests.length)
            for (var i = 0; i < message.holisticHealthInterests.length; ++i)
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.holisticHealthInterests[i]);
        if (message.opennessToHolisticModalities != null && Object.hasOwnProperty.call(message, "opennessToHolisticModalities"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.opennessToHolisticModalities);
        if (message.gender != null && Object.hasOwnProperty.call(message, "gender"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.gender);
        return writer;
    };

    /**
     * Encodes the specified WellnessSurveyProto message, length delimited. Does not implicitly {@link WellnessSurveyProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof WellnessSurveyProto
     * @static
     * @param {IWellnessSurveyProto} message WellnessSurveyProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WellnessSurveyProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a WellnessSurveyProto message from the specified reader or buffer.
     * @function decode
     * @memberof WellnessSurveyProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {WellnessSurveyProto} WellnessSurveyProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WellnessSurveyProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.WellnessSurveyProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    if (!(message.wellnessGoals && message.wellnessGoals.length))
                        message.wellnessGoals = [];
                    message.wellnessGoals.push(reader.string());
                    break;
                }
            case 2: {
                    if (!(message.holisticHealthInterests && message.holisticHealthInterests.length))
                        message.holisticHealthInterests = [];
                    message.holisticHealthInterests.push(reader.string());
                    break;
                }
            case 3: {
                    message.opennessToHolisticModalities = reader.string();
                    break;
                }
            case 4: {
                    message.gender = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a WellnessSurveyProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof WellnessSurveyProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {WellnessSurveyProto} WellnessSurveyProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WellnessSurveyProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a WellnessSurveyProto message.
     * @function verify
     * @memberof WellnessSurveyProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    WellnessSurveyProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.wellnessGoals != null && message.hasOwnProperty("wellnessGoals")) {
            if (!Array.isArray(message.wellnessGoals))
                return "wellnessGoals: array expected";
            for (var i = 0; i < message.wellnessGoals.length; ++i)
                if (!$util.isString(message.wellnessGoals[i]))
                    return "wellnessGoals: string[] expected";
        }
        if (message.holisticHealthInterests != null && message.hasOwnProperty("holisticHealthInterests")) {
            if (!Array.isArray(message.holisticHealthInterests))
                return "holisticHealthInterests: array expected";
            for (var i = 0; i < message.holisticHealthInterests.length; ++i)
                if (!$util.isString(message.holisticHealthInterests[i]))
                    return "holisticHealthInterests: string[] expected";
        }
        if (message.opennessToHolisticModalities != null && message.hasOwnProperty("opennessToHolisticModalities"))
            if (!$util.isString(message.opennessToHolisticModalities))
                return "opennessToHolisticModalities: string expected";
        if (message.gender != null && message.hasOwnProperty("gender"))
            if (!$util.isString(message.gender))
                return "gender: string expected";
        return null;
    };

    /**
     * Creates a WellnessSurveyProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof WellnessSurveyProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {WellnessSurveyProto} WellnessSurveyProto
     */
    WellnessSurveyProto.fromObject = function fromObject(object) {
        if (object instanceof $root.WellnessSurveyProto)
            return object;
        var message = new $root.WellnessSurveyProto();
        if (object.wellnessGoals) {
            if (!Array.isArray(object.wellnessGoals))
                throw TypeError(".WellnessSurveyProto.wellnessGoals: array expected");
            message.wellnessGoals = [];
            for (var i = 0; i < object.wellnessGoals.length; ++i)
                message.wellnessGoals[i] = String(object.wellnessGoals[i]);
        }
        if (object.holisticHealthInterests) {
            if (!Array.isArray(object.holisticHealthInterests))
                throw TypeError(".WellnessSurveyProto.holisticHealthInterests: array expected");
            message.holisticHealthInterests = [];
            for (var i = 0; i < object.holisticHealthInterests.length; ++i)
                message.holisticHealthInterests[i] = String(object.holisticHealthInterests[i]);
        }
        if (object.opennessToHolisticModalities != null)
            message.opennessToHolisticModalities = String(object.opennessToHolisticModalities);
        if (object.gender != null)
            message.gender = String(object.gender);
        return message;
    };

    /**
     * Creates a plain object from a WellnessSurveyProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof WellnessSurveyProto
     * @static
     * @param {WellnessSurveyProto} message WellnessSurveyProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    WellnessSurveyProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.wellnessGoals = [];
            object.holisticHealthInterests = [];
        }
        if (options.defaults) {
            object.opennessToHolisticModalities = "";
            object.gender = "";
        }
        if (message.wellnessGoals && message.wellnessGoals.length) {
            object.wellnessGoals = [];
            for (var j = 0; j < message.wellnessGoals.length; ++j)
                object.wellnessGoals[j] = message.wellnessGoals[j];
        }
        if (message.holisticHealthInterests && message.holisticHealthInterests.length) {
            object.holisticHealthInterests = [];
            for (var j = 0; j < message.holisticHealthInterests.length; ++j)
                object.holisticHealthInterests[j] = message.holisticHealthInterests[j];
        }
        if (message.opennessToHolisticModalities != null && message.hasOwnProperty("opennessToHolisticModalities"))
            object.opennessToHolisticModalities = message.opennessToHolisticModalities;
        if (message.gender != null && message.hasOwnProperty("gender"))
            object.gender = message.gender;
        return object;
    };

    /**
     * Converts this WellnessSurveyProto to JSON.
     * @function toJSON
     * @memberof WellnessSurveyProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    WellnessSurveyProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for WellnessSurveyProto
     * @function getTypeUrl
     * @memberof WellnessSurveyProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    WellnessSurveyProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/WellnessSurveyProto";
    };

    return WellnessSurveyProto;
})();

$root.ClientRelationshipProto = (function() {

    /**
     * Properties of a ClientRelationshipProto.
     * @exports IClientRelationshipProto
     * @interface IClientRelationshipProto
     * @property {string|null} [businessId] ClientRelationshipProto businessId
     * @property {IClientRelationshipDetailsProto|null} [details] ClientRelationshipProto details
     */

    /**
     * Constructs a new ClientRelationshipProto.
     * @exports ClientRelationshipProto
     * @classdesc Represents a ClientRelationshipProto.
     * @implements IClientRelationshipProto
     * @constructor
     * @param {IClientRelationshipProto=} [properties] Properties to set
     */
    function ClientRelationshipProto(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientRelationshipProto businessId.
     * @member {string} businessId
     * @memberof ClientRelationshipProto
     * @instance
     */
    ClientRelationshipProto.prototype.businessId = "";

    /**
     * ClientRelationshipProto details.
     * @member {IClientRelationshipDetailsProto|null|undefined} details
     * @memberof ClientRelationshipProto
     * @instance
     */
    ClientRelationshipProto.prototype.details = null;

    /**
     * Creates a new ClientRelationshipProto instance using the specified properties.
     * @function create
     * @memberof ClientRelationshipProto
     * @static
     * @param {IClientRelationshipProto=} [properties] Properties to set
     * @returns {ClientRelationshipProto} ClientRelationshipProto instance
     */
    ClientRelationshipProto.create = function create(properties) {
        return new ClientRelationshipProto(properties);
    };

    /**
     * Encodes the specified ClientRelationshipProto message. Does not implicitly {@link ClientRelationshipProto.verify|verify} messages.
     * @function encode
     * @memberof ClientRelationshipProto
     * @static
     * @param {IClientRelationshipProto} message ClientRelationshipProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientRelationshipProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessId);
        if (message.details != null && Object.hasOwnProperty.call(message, "details"))
            $root.ClientRelationshipDetailsProto.encode(message.details, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ClientRelationshipProto message, length delimited. Does not implicitly {@link ClientRelationshipProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientRelationshipProto
     * @static
     * @param {IClientRelationshipProto} message ClientRelationshipProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientRelationshipProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientRelationshipProto message from the specified reader or buffer.
     * @function decode
     * @memberof ClientRelationshipProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientRelationshipProto} ClientRelationshipProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientRelationshipProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientRelationshipProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.businessId = reader.string();
                    break;
                }
            case 2: {
                    message.details = $root.ClientRelationshipDetailsProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientRelationshipProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientRelationshipProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientRelationshipProto} ClientRelationshipProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientRelationshipProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientRelationshipProto message.
     * @function verify
     * @memberof ClientRelationshipProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientRelationshipProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.businessId != null && message.hasOwnProperty("businessId"))
            if (!$util.isString(message.businessId))
                return "businessId: string expected";
        if (message.details != null && message.hasOwnProperty("details")) {
            var error = $root.ClientRelationshipDetailsProto.verify(message.details);
            if (error)
                return "details." + error;
        }
        return null;
    };

    /**
     * Creates a ClientRelationshipProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientRelationshipProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientRelationshipProto} ClientRelationshipProto
     */
    ClientRelationshipProto.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientRelationshipProto)
            return object;
        var message = new $root.ClientRelationshipProto();
        if (object.businessId != null)
            message.businessId = String(object.businessId);
        if (object.details != null) {
            if (typeof object.details !== "object")
                throw TypeError(".ClientRelationshipProto.details: object expected");
            message.details = $root.ClientRelationshipDetailsProto.fromObject(object.details);
        }
        return message;
    };

    /**
     * Creates a plain object from a ClientRelationshipProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientRelationshipProto
     * @static
     * @param {ClientRelationshipProto} message ClientRelationshipProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientRelationshipProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.businessId = "";
            object.details = null;
        }
        if (message.businessId != null && message.hasOwnProperty("businessId"))
            object.businessId = message.businessId;
        if (message.details != null && message.hasOwnProperty("details"))
            object.details = $root.ClientRelationshipDetailsProto.toObject(message.details, options);
        return object;
    };

    /**
     * Converts this ClientRelationshipProto to JSON.
     * @function toJSON
     * @memberof ClientRelationshipProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientRelationshipProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientRelationshipProto
     * @function getTypeUrl
     * @memberof ClientRelationshipProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientRelationshipProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientRelationshipProto";
    };

    return ClientRelationshipProto;
})();

$root.ClientRelationshipDetailsProto = (function() {

    /**
     * Properties of a ClientRelationshipDetailsProto.
     * @exports IClientRelationshipDetailsProto
     * @interface IClientRelationshipDetailsProto
     * @property {number|Long|null} [createdTimestampMs] ClientRelationshipDetailsProto createdTimestampMs
     * @property {Array.<IPurchasedPackageProto>|null} [purchasedClassPacks] ClientRelationshipDetailsProto purchasedClassPacks
     * @property {Array.<IPurchasedSingleClassCreditProto>|null} [singleClassCredits] ClientRelationshipDetailsProto singleClassCredits
     */

    /**
     * Constructs a new ClientRelationshipDetailsProto.
     * @exports ClientRelationshipDetailsProto
     * @classdesc Represents a ClientRelationshipDetailsProto.
     * @implements IClientRelationshipDetailsProto
     * @constructor
     * @param {IClientRelationshipDetailsProto=} [properties] Properties to set
     */
    function ClientRelationshipDetailsProto(properties) {
        this.purchasedClassPacks = [];
        this.singleClassCredits = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientRelationshipDetailsProto createdTimestampMs.
     * @member {number|Long} createdTimestampMs
     * @memberof ClientRelationshipDetailsProto
     * @instance
     */
    ClientRelationshipDetailsProto.prototype.createdTimestampMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * ClientRelationshipDetailsProto purchasedClassPacks.
     * @member {Array.<IPurchasedPackageProto>} purchasedClassPacks
     * @memberof ClientRelationshipDetailsProto
     * @instance
     */
    ClientRelationshipDetailsProto.prototype.purchasedClassPacks = $util.emptyArray;

    /**
     * ClientRelationshipDetailsProto singleClassCredits.
     * @member {Array.<IPurchasedSingleClassCreditProto>} singleClassCredits
     * @memberof ClientRelationshipDetailsProto
     * @instance
     */
    ClientRelationshipDetailsProto.prototype.singleClassCredits = $util.emptyArray;

    /**
     * Creates a new ClientRelationshipDetailsProto instance using the specified properties.
     * @function create
     * @memberof ClientRelationshipDetailsProto
     * @static
     * @param {IClientRelationshipDetailsProto=} [properties] Properties to set
     * @returns {ClientRelationshipDetailsProto} ClientRelationshipDetailsProto instance
     */
    ClientRelationshipDetailsProto.create = function create(properties) {
        return new ClientRelationshipDetailsProto(properties);
    };

    /**
     * Encodes the specified ClientRelationshipDetailsProto message. Does not implicitly {@link ClientRelationshipDetailsProto.verify|verify} messages.
     * @function encode
     * @memberof ClientRelationshipDetailsProto
     * @static
     * @param {IClientRelationshipDetailsProto} message ClientRelationshipDetailsProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientRelationshipDetailsProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.createdTimestampMs != null && Object.hasOwnProperty.call(message, "createdTimestampMs"))
            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.createdTimestampMs);
        if (message.purchasedClassPacks != null && message.purchasedClassPacks.length)
            for (var i = 0; i < message.purchasedClassPacks.length; ++i)
                $root.PurchasedPackageProto.encode(message.purchasedClassPacks[i], writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
        if (message.singleClassCredits != null && message.singleClassCredits.length)
            for (var i = 0; i < message.singleClassCredits.length; ++i)
                $root.PurchasedSingleClassCreditProto.encode(message.singleClassCredits[i], writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ClientRelationshipDetailsProto message, length delimited. Does not implicitly {@link ClientRelationshipDetailsProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientRelationshipDetailsProto
     * @static
     * @param {IClientRelationshipDetailsProto} message ClientRelationshipDetailsProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientRelationshipDetailsProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientRelationshipDetailsProto message from the specified reader or buffer.
     * @function decode
     * @memberof ClientRelationshipDetailsProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientRelationshipDetailsProto} ClientRelationshipDetailsProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientRelationshipDetailsProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientRelationshipDetailsProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.createdTimestampMs = reader.int64();
                    break;
                }
            case 10: {
                    if (!(message.purchasedClassPacks && message.purchasedClassPacks.length))
                        message.purchasedClassPacks = [];
                    message.purchasedClassPacks.push($root.PurchasedPackageProto.decode(reader, reader.uint32()));
                    break;
                }
            case 11: {
                    if (!(message.singleClassCredits && message.singleClassCredits.length))
                        message.singleClassCredits = [];
                    message.singleClassCredits.push($root.PurchasedSingleClassCreditProto.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientRelationshipDetailsProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientRelationshipDetailsProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientRelationshipDetailsProto} ClientRelationshipDetailsProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientRelationshipDetailsProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientRelationshipDetailsProto message.
     * @function verify
     * @memberof ClientRelationshipDetailsProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientRelationshipDetailsProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.createdTimestampMs != null && message.hasOwnProperty("createdTimestampMs"))
            if (!$util.isInteger(message.createdTimestampMs) && !(message.createdTimestampMs && $util.isInteger(message.createdTimestampMs.low) && $util.isInteger(message.createdTimestampMs.high)))
                return "createdTimestampMs: integer|Long expected";
        if (message.purchasedClassPacks != null && message.hasOwnProperty("purchasedClassPacks")) {
            if (!Array.isArray(message.purchasedClassPacks))
                return "purchasedClassPacks: array expected";
            for (var i = 0; i < message.purchasedClassPacks.length; ++i) {
                var error = $root.PurchasedPackageProto.verify(message.purchasedClassPacks[i]);
                if (error)
                    return "purchasedClassPacks." + error;
            }
        }
        if (message.singleClassCredits != null && message.hasOwnProperty("singleClassCredits")) {
            if (!Array.isArray(message.singleClassCredits))
                return "singleClassCredits: array expected";
            for (var i = 0; i < message.singleClassCredits.length; ++i) {
                var error = $root.PurchasedSingleClassCreditProto.verify(message.singleClassCredits[i]);
                if (error)
                    return "singleClassCredits." + error;
            }
        }
        return null;
    };

    /**
     * Creates a ClientRelationshipDetailsProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientRelationshipDetailsProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientRelationshipDetailsProto} ClientRelationshipDetailsProto
     */
    ClientRelationshipDetailsProto.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientRelationshipDetailsProto)
            return object;
        var message = new $root.ClientRelationshipDetailsProto();
        if (object.createdTimestampMs != null)
            if ($util.Long)
                (message.createdTimestampMs = $util.Long.fromValue(object.createdTimestampMs)).unsigned = false;
            else if (typeof object.createdTimestampMs === "string")
                message.createdTimestampMs = parseInt(object.createdTimestampMs, 10);
            else if (typeof object.createdTimestampMs === "number")
                message.createdTimestampMs = object.createdTimestampMs;
            else if (typeof object.createdTimestampMs === "object")
                message.createdTimestampMs = new $util.LongBits(object.createdTimestampMs.low >>> 0, object.createdTimestampMs.high >>> 0).toNumber();
        if (object.purchasedClassPacks) {
            if (!Array.isArray(object.purchasedClassPacks))
                throw TypeError(".ClientRelationshipDetailsProto.purchasedClassPacks: array expected");
            message.purchasedClassPacks = [];
            for (var i = 0; i < object.purchasedClassPacks.length; ++i) {
                if (typeof object.purchasedClassPacks[i] !== "object")
                    throw TypeError(".ClientRelationshipDetailsProto.purchasedClassPacks: object expected");
                message.purchasedClassPacks[i] = $root.PurchasedPackageProto.fromObject(object.purchasedClassPacks[i]);
            }
        }
        if (object.singleClassCredits) {
            if (!Array.isArray(object.singleClassCredits))
                throw TypeError(".ClientRelationshipDetailsProto.singleClassCredits: array expected");
            message.singleClassCredits = [];
            for (var i = 0; i < object.singleClassCredits.length; ++i) {
                if (typeof object.singleClassCredits[i] !== "object")
                    throw TypeError(".ClientRelationshipDetailsProto.singleClassCredits: object expected");
                message.singleClassCredits[i] = $root.PurchasedSingleClassCreditProto.fromObject(object.singleClassCredits[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a ClientRelationshipDetailsProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientRelationshipDetailsProto
     * @static
     * @param {ClientRelationshipDetailsProto} message ClientRelationshipDetailsProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientRelationshipDetailsProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.purchasedClassPacks = [];
            object.singleClassCredits = [];
        }
        if (options.defaults)
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.createdTimestampMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.createdTimestampMs = options.longs === String ? "0" : 0;
        if (message.createdTimestampMs != null && message.hasOwnProperty("createdTimestampMs"))
            if (typeof message.createdTimestampMs === "number")
                object.createdTimestampMs = options.longs === String ? String(message.createdTimestampMs) : message.createdTimestampMs;
            else
                object.createdTimestampMs = options.longs === String ? $util.Long.prototype.toString.call(message.createdTimestampMs) : options.longs === Number ? new $util.LongBits(message.createdTimestampMs.low >>> 0, message.createdTimestampMs.high >>> 0).toNumber() : message.createdTimestampMs;
        if (message.purchasedClassPacks && message.purchasedClassPacks.length) {
            object.purchasedClassPacks = [];
            for (var j = 0; j < message.purchasedClassPacks.length; ++j)
                object.purchasedClassPacks[j] = $root.PurchasedPackageProto.toObject(message.purchasedClassPacks[j], options);
        }
        if (message.singleClassCredits && message.singleClassCredits.length) {
            object.singleClassCredits = [];
            for (var j = 0; j < message.singleClassCredits.length; ++j)
                object.singleClassCredits[j] = $root.PurchasedSingleClassCreditProto.toObject(message.singleClassCredits[j], options);
        }
        return object;
    };

    /**
     * Converts this ClientRelationshipDetailsProto to JSON.
     * @function toJSON
     * @memberof ClientRelationshipDetailsProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientRelationshipDetailsProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientRelationshipDetailsProto
     * @function getTypeUrl
     * @memberof ClientRelationshipDetailsProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientRelationshipDetailsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientRelationshipDetailsProto";
    };

    return ClientRelationshipDetailsProto;
})();

$root.ApiClientInquiryProto = (function() {

    /**
     * Properties of an ApiClientInquiryProto.
     * @exports IApiClientInquiryProto
     * @interface IApiClientInquiryProto
     * @property {string|null} [userId] ApiClientInquiryProto userId
     * @property {IClientInquiryDetailsProto|null} [details] ApiClientInquiryProto details
     */

    /**
     * Constructs a new ApiClientInquiryProto.
     * @exports ApiClientInquiryProto
     * @classdesc Represents an ApiClientInquiryProto.
     * @implements IApiClientInquiryProto
     * @constructor
     * @param {IApiClientInquiryProto=} [properties] Properties to set
     */
    function ApiClientInquiryProto(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ApiClientInquiryProto userId.
     * @member {string} userId
     * @memberof ApiClientInquiryProto
     * @instance
     */
    ApiClientInquiryProto.prototype.userId = "";

    /**
     * ApiClientInquiryProto details.
     * @member {IClientInquiryDetailsProto|null|undefined} details
     * @memberof ApiClientInquiryProto
     * @instance
     */
    ApiClientInquiryProto.prototype.details = null;

    /**
     * Creates a new ApiClientInquiryProto instance using the specified properties.
     * @function create
     * @memberof ApiClientInquiryProto
     * @static
     * @param {IApiClientInquiryProto=} [properties] Properties to set
     * @returns {ApiClientInquiryProto} ApiClientInquiryProto instance
     */
    ApiClientInquiryProto.create = function create(properties) {
        return new ApiClientInquiryProto(properties);
    };

    /**
     * Encodes the specified ApiClientInquiryProto message. Does not implicitly {@link ApiClientInquiryProto.verify|verify} messages.
     * @function encode
     * @memberof ApiClientInquiryProto
     * @static
     * @param {IApiClientInquiryProto} message ApiClientInquiryProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ApiClientInquiryProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.userId);
        if (message.details != null && Object.hasOwnProperty.call(message, "details"))
            $root.ClientInquiryDetailsProto.encode(message.details, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ApiClientInquiryProto message, length delimited. Does not implicitly {@link ApiClientInquiryProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ApiClientInquiryProto
     * @static
     * @param {IApiClientInquiryProto} message ApiClientInquiryProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ApiClientInquiryProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an ApiClientInquiryProto message from the specified reader or buffer.
     * @function decode
     * @memberof ApiClientInquiryProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ApiClientInquiryProto} ApiClientInquiryProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ApiClientInquiryProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ApiClientInquiryProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.userId = reader.string();
                    break;
                }
            case 2: {
                    message.details = $root.ClientInquiryDetailsProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an ApiClientInquiryProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ApiClientInquiryProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ApiClientInquiryProto} ApiClientInquiryProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ApiClientInquiryProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an ApiClientInquiryProto message.
     * @function verify
     * @memberof ApiClientInquiryProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ApiClientInquiryProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.userId != null && message.hasOwnProperty("userId"))
            if (!$util.isString(message.userId))
                return "userId: string expected";
        if (message.details != null && message.hasOwnProperty("details")) {
            var error = $root.ClientInquiryDetailsProto.verify(message.details);
            if (error)
                return "details." + error;
        }
        return null;
    };

    /**
     * Creates an ApiClientInquiryProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ApiClientInquiryProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ApiClientInquiryProto} ApiClientInquiryProto
     */
    ApiClientInquiryProto.fromObject = function fromObject(object) {
        if (object instanceof $root.ApiClientInquiryProto)
            return object;
        var message = new $root.ApiClientInquiryProto();
        if (object.userId != null)
            message.userId = String(object.userId);
        if (object.details != null) {
            if (typeof object.details !== "object")
                throw TypeError(".ApiClientInquiryProto.details: object expected");
            message.details = $root.ClientInquiryDetailsProto.fromObject(object.details);
        }
        return message;
    };

    /**
     * Creates a plain object from an ApiClientInquiryProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ApiClientInquiryProto
     * @static
     * @param {ApiClientInquiryProto} message ApiClientInquiryProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ApiClientInquiryProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.userId = "";
            object.details = null;
        }
        if (message.userId != null && message.hasOwnProperty("userId"))
            object.userId = message.userId;
        if (message.details != null && message.hasOwnProperty("details"))
            object.details = $root.ClientInquiryDetailsProto.toObject(message.details, options);
        return object;
    };

    /**
     * Converts this ApiClientInquiryProto to JSON.
     * @function toJSON
     * @memberof ApiClientInquiryProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ApiClientInquiryProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ApiClientInquiryProto
     * @function getTypeUrl
     * @memberof ApiClientInquiryProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ApiClientInquiryProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ApiClientInquiryProto";
    };

    return ApiClientInquiryProto;
})();

$root.ClientInquiryDetailsProto = (function() {

    /**
     * Properties of a ClientInquiryDetailsProto.
     * @exports IClientInquiryDetailsProto
     * @interface IClientInquiryDetailsProto
     * @property {number|Long|null} [createTimestampMs] ClientInquiryDetailsProto createTimestampMs
     * @property {string|null} [message] ClientInquiryDetailsProto message
     * @property {boolean|null} [rejectedByProvider] ClientInquiryDetailsProto rejectedByProvider
     * @property {string|null} [inquirerEmail] ClientInquiryDetailsProto inquirerEmail
     * @property {string|null} [inquirerName] ClientInquiryDetailsProto inquirerName
     */

    /**
     * Constructs a new ClientInquiryDetailsProto.
     * @exports ClientInquiryDetailsProto
     * @classdesc Represents a ClientInquiryDetailsProto.
     * @implements IClientInquiryDetailsProto
     * @constructor
     * @param {IClientInquiryDetailsProto=} [properties] Properties to set
     */
    function ClientInquiryDetailsProto(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientInquiryDetailsProto createTimestampMs.
     * @member {number|Long} createTimestampMs
     * @memberof ClientInquiryDetailsProto
     * @instance
     */
    ClientInquiryDetailsProto.prototype.createTimestampMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * ClientInquiryDetailsProto message.
     * @member {string} message
     * @memberof ClientInquiryDetailsProto
     * @instance
     */
    ClientInquiryDetailsProto.prototype.message = "";

    /**
     * ClientInquiryDetailsProto rejectedByProvider.
     * @member {boolean} rejectedByProvider
     * @memberof ClientInquiryDetailsProto
     * @instance
     */
    ClientInquiryDetailsProto.prototype.rejectedByProvider = false;

    /**
     * ClientInquiryDetailsProto inquirerEmail.
     * @member {string} inquirerEmail
     * @memberof ClientInquiryDetailsProto
     * @instance
     */
    ClientInquiryDetailsProto.prototype.inquirerEmail = "";

    /**
     * ClientInquiryDetailsProto inquirerName.
     * @member {string} inquirerName
     * @memberof ClientInquiryDetailsProto
     * @instance
     */
    ClientInquiryDetailsProto.prototype.inquirerName = "";

    /**
     * Creates a new ClientInquiryDetailsProto instance using the specified properties.
     * @function create
     * @memberof ClientInquiryDetailsProto
     * @static
     * @param {IClientInquiryDetailsProto=} [properties] Properties to set
     * @returns {ClientInquiryDetailsProto} ClientInquiryDetailsProto instance
     */
    ClientInquiryDetailsProto.create = function create(properties) {
        return new ClientInquiryDetailsProto(properties);
    };

    /**
     * Encodes the specified ClientInquiryDetailsProto message. Does not implicitly {@link ClientInquiryDetailsProto.verify|verify} messages.
     * @function encode
     * @memberof ClientInquiryDetailsProto
     * @static
     * @param {IClientInquiryDetailsProto} message ClientInquiryDetailsProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientInquiryDetailsProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.createTimestampMs != null && Object.hasOwnProperty.call(message, "createTimestampMs"))
            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.createTimestampMs);
        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
        if (message.rejectedByProvider != null && Object.hasOwnProperty.call(message, "rejectedByProvider"))
            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.rejectedByProvider);
        if (message.inquirerEmail != null && Object.hasOwnProperty.call(message, "inquirerEmail"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.inquirerEmail);
        if (message.inquirerName != null && Object.hasOwnProperty.call(message, "inquirerName"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.inquirerName);
        return writer;
    };

    /**
     * Encodes the specified ClientInquiryDetailsProto message, length delimited. Does not implicitly {@link ClientInquiryDetailsProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientInquiryDetailsProto
     * @static
     * @param {IClientInquiryDetailsProto} message ClientInquiryDetailsProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientInquiryDetailsProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientInquiryDetailsProto message from the specified reader or buffer.
     * @function decode
     * @memberof ClientInquiryDetailsProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientInquiryDetailsProto} ClientInquiryDetailsProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientInquiryDetailsProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientInquiryDetailsProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.createTimestampMs = reader.int64();
                    break;
                }
            case 2: {
                    message.message = reader.string();
                    break;
                }
            case 3: {
                    message.rejectedByProvider = reader.bool();
                    break;
                }
            case 4: {
                    message.inquirerEmail = reader.string();
                    break;
                }
            case 5: {
                    message.inquirerName = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientInquiryDetailsProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientInquiryDetailsProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientInquiryDetailsProto} ClientInquiryDetailsProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientInquiryDetailsProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientInquiryDetailsProto message.
     * @function verify
     * @memberof ClientInquiryDetailsProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientInquiryDetailsProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.createTimestampMs != null && message.hasOwnProperty("createTimestampMs"))
            if (!$util.isInteger(message.createTimestampMs) && !(message.createTimestampMs && $util.isInteger(message.createTimestampMs.low) && $util.isInteger(message.createTimestampMs.high)))
                return "createTimestampMs: integer|Long expected";
        if (message.message != null && message.hasOwnProperty("message"))
            if (!$util.isString(message.message))
                return "message: string expected";
        if (message.rejectedByProvider != null && message.hasOwnProperty("rejectedByProvider"))
            if (typeof message.rejectedByProvider !== "boolean")
                return "rejectedByProvider: boolean expected";
        if (message.inquirerEmail != null && message.hasOwnProperty("inquirerEmail"))
            if (!$util.isString(message.inquirerEmail))
                return "inquirerEmail: string expected";
        if (message.inquirerName != null && message.hasOwnProperty("inquirerName"))
            if (!$util.isString(message.inquirerName))
                return "inquirerName: string expected";
        return null;
    };

    /**
     * Creates a ClientInquiryDetailsProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientInquiryDetailsProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientInquiryDetailsProto} ClientInquiryDetailsProto
     */
    ClientInquiryDetailsProto.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientInquiryDetailsProto)
            return object;
        var message = new $root.ClientInquiryDetailsProto();
        if (object.createTimestampMs != null)
            if ($util.Long)
                (message.createTimestampMs = $util.Long.fromValue(object.createTimestampMs)).unsigned = false;
            else if (typeof object.createTimestampMs === "string")
                message.createTimestampMs = parseInt(object.createTimestampMs, 10);
            else if (typeof object.createTimestampMs === "number")
                message.createTimestampMs = object.createTimestampMs;
            else if (typeof object.createTimestampMs === "object")
                message.createTimestampMs = new $util.LongBits(object.createTimestampMs.low >>> 0, object.createTimestampMs.high >>> 0).toNumber();
        if (object.message != null)
            message.message = String(object.message);
        if (object.rejectedByProvider != null)
            message.rejectedByProvider = Boolean(object.rejectedByProvider);
        if (object.inquirerEmail != null)
            message.inquirerEmail = String(object.inquirerEmail);
        if (object.inquirerName != null)
            message.inquirerName = String(object.inquirerName);
        return message;
    };

    /**
     * Creates a plain object from a ClientInquiryDetailsProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientInquiryDetailsProto
     * @static
     * @param {ClientInquiryDetailsProto} message ClientInquiryDetailsProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientInquiryDetailsProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.createTimestampMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.createTimestampMs = options.longs === String ? "0" : 0;
            object.message = "";
            object.rejectedByProvider = false;
            object.inquirerEmail = "";
            object.inquirerName = "";
        }
        if (message.createTimestampMs != null && message.hasOwnProperty("createTimestampMs"))
            if (typeof message.createTimestampMs === "number")
                object.createTimestampMs = options.longs === String ? String(message.createTimestampMs) : message.createTimestampMs;
            else
                object.createTimestampMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimestampMs) : options.longs === Number ? new $util.LongBits(message.createTimestampMs.low >>> 0, message.createTimestampMs.high >>> 0).toNumber() : message.createTimestampMs;
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = message.message;
        if (message.rejectedByProvider != null && message.hasOwnProperty("rejectedByProvider"))
            object.rejectedByProvider = message.rejectedByProvider;
        if (message.inquirerEmail != null && message.hasOwnProperty("inquirerEmail"))
            object.inquirerEmail = message.inquirerEmail;
        if (message.inquirerName != null && message.hasOwnProperty("inquirerName"))
            object.inquirerName = message.inquirerName;
        return object;
    };

    /**
     * Converts this ClientInquiryDetailsProto to JSON.
     * @function toJSON
     * @memberof ClientInquiryDetailsProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientInquiryDetailsProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientInquiryDetailsProto
     * @function getTypeUrl
     * @memberof ClientInquiryDetailsProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientInquiryDetailsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientInquiryDetailsProto";
    };

    return ClientInquiryDetailsProto;
})();

$root.PurchasedPackageProto = (function() {

    /**
     * Properties of a PurchasedPackageProto.
     * @exports IPurchasedPackageProto
     * @interface IPurchasedPackageProto
     * @property {string|null} [purchasedClassPackId] PurchasedPackageProto purchasedClassPackId
     * @property {IPackageProto|null} [packageDetails] PurchasedPackageProto packageDetails
     * @property {number|Long|null} [purchaseTimestamp] PurchasedPackageProto purchaseTimestamp
     * @property {string|null} [stripeSessionId] PurchasedPackageProto stripeSessionId
     * @property {number|null} [classesRemaining] PurchasedPackageProto classesRemaining
     */

    /**
     * Constructs a new PurchasedPackageProto.
     * @exports PurchasedPackageProto
     * @classdesc Represents a PurchasedPackageProto.
     * @implements IPurchasedPackageProto
     * @constructor
     * @param {IPurchasedPackageProto=} [properties] Properties to set
     */
    function PurchasedPackageProto(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PurchasedPackageProto purchasedClassPackId.
     * @member {string} purchasedClassPackId
     * @memberof PurchasedPackageProto
     * @instance
     */
    PurchasedPackageProto.prototype.purchasedClassPackId = "";

    /**
     * PurchasedPackageProto packageDetails.
     * @member {IPackageProto|null|undefined} packageDetails
     * @memberof PurchasedPackageProto
     * @instance
     */
    PurchasedPackageProto.prototype.packageDetails = null;

    /**
     * PurchasedPackageProto purchaseTimestamp.
     * @member {number|Long} purchaseTimestamp
     * @memberof PurchasedPackageProto
     * @instance
     */
    PurchasedPackageProto.prototype.purchaseTimestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * PurchasedPackageProto stripeSessionId.
     * @member {string} stripeSessionId
     * @memberof PurchasedPackageProto
     * @instance
     */
    PurchasedPackageProto.prototype.stripeSessionId = "";

    /**
     * PurchasedPackageProto classesRemaining.
     * @member {number} classesRemaining
     * @memberof PurchasedPackageProto
     * @instance
     */
    PurchasedPackageProto.prototype.classesRemaining = 0;

    /**
     * Creates a new PurchasedPackageProto instance using the specified properties.
     * @function create
     * @memberof PurchasedPackageProto
     * @static
     * @param {IPurchasedPackageProto=} [properties] Properties to set
     * @returns {PurchasedPackageProto} PurchasedPackageProto instance
     */
    PurchasedPackageProto.create = function create(properties) {
        return new PurchasedPackageProto(properties);
    };

    /**
     * Encodes the specified PurchasedPackageProto message. Does not implicitly {@link PurchasedPackageProto.verify|verify} messages.
     * @function encode
     * @memberof PurchasedPackageProto
     * @static
     * @param {IPurchasedPackageProto} message PurchasedPackageProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PurchasedPackageProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.purchasedClassPackId != null && Object.hasOwnProperty.call(message, "purchasedClassPackId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.purchasedClassPackId);
        if (message.packageDetails != null && Object.hasOwnProperty.call(message, "packageDetails"))
            $root.PackageProto.encode(message.packageDetails, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.purchaseTimestamp != null && Object.hasOwnProperty.call(message, "purchaseTimestamp"))
            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.purchaseTimestamp);
        if (message.stripeSessionId != null && Object.hasOwnProperty.call(message, "stripeSessionId"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.stripeSessionId);
        if (message.classesRemaining != null && Object.hasOwnProperty.call(message, "classesRemaining"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.classesRemaining);
        return writer;
    };

    /**
     * Encodes the specified PurchasedPackageProto message, length delimited. Does not implicitly {@link PurchasedPackageProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PurchasedPackageProto
     * @static
     * @param {IPurchasedPackageProto} message PurchasedPackageProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PurchasedPackageProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PurchasedPackageProto message from the specified reader or buffer.
     * @function decode
     * @memberof PurchasedPackageProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PurchasedPackageProto} PurchasedPackageProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PurchasedPackageProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PurchasedPackageProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.purchasedClassPackId = reader.string();
                    break;
                }
            case 2: {
                    message.packageDetails = $root.PackageProto.decode(reader, reader.uint32());
                    break;
                }
            case 3: {
                    message.purchaseTimestamp = reader.int64();
                    break;
                }
            case 4: {
                    message.stripeSessionId = reader.string();
                    break;
                }
            case 5: {
                    message.classesRemaining = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PurchasedPackageProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PurchasedPackageProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PurchasedPackageProto} PurchasedPackageProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PurchasedPackageProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PurchasedPackageProto message.
     * @function verify
     * @memberof PurchasedPackageProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PurchasedPackageProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.purchasedClassPackId != null && message.hasOwnProperty("purchasedClassPackId"))
            if (!$util.isString(message.purchasedClassPackId))
                return "purchasedClassPackId: string expected";
        if (message.packageDetails != null && message.hasOwnProperty("packageDetails")) {
            var error = $root.PackageProto.verify(message.packageDetails);
            if (error)
                return "packageDetails." + error;
        }
        if (message.purchaseTimestamp != null && message.hasOwnProperty("purchaseTimestamp"))
            if (!$util.isInteger(message.purchaseTimestamp) && !(message.purchaseTimestamp && $util.isInteger(message.purchaseTimestamp.low) && $util.isInteger(message.purchaseTimestamp.high)))
                return "purchaseTimestamp: integer|Long expected";
        if (message.stripeSessionId != null && message.hasOwnProperty("stripeSessionId"))
            if (!$util.isString(message.stripeSessionId))
                return "stripeSessionId: string expected";
        if (message.classesRemaining != null && message.hasOwnProperty("classesRemaining"))
            if (!$util.isInteger(message.classesRemaining))
                return "classesRemaining: integer expected";
        return null;
    };

    /**
     * Creates a PurchasedPackageProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PurchasedPackageProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PurchasedPackageProto} PurchasedPackageProto
     */
    PurchasedPackageProto.fromObject = function fromObject(object) {
        if (object instanceof $root.PurchasedPackageProto)
            return object;
        var message = new $root.PurchasedPackageProto();
        if (object.purchasedClassPackId != null)
            message.purchasedClassPackId = String(object.purchasedClassPackId);
        if (object.packageDetails != null) {
            if (typeof object.packageDetails !== "object")
                throw TypeError(".PurchasedPackageProto.packageDetails: object expected");
            message.packageDetails = $root.PackageProto.fromObject(object.packageDetails);
        }
        if (object.purchaseTimestamp != null)
            if ($util.Long)
                (message.purchaseTimestamp = $util.Long.fromValue(object.purchaseTimestamp)).unsigned = false;
            else if (typeof object.purchaseTimestamp === "string")
                message.purchaseTimestamp = parseInt(object.purchaseTimestamp, 10);
            else if (typeof object.purchaseTimestamp === "number")
                message.purchaseTimestamp = object.purchaseTimestamp;
            else if (typeof object.purchaseTimestamp === "object")
                message.purchaseTimestamp = new $util.LongBits(object.purchaseTimestamp.low >>> 0, object.purchaseTimestamp.high >>> 0).toNumber();
        if (object.stripeSessionId != null)
            message.stripeSessionId = String(object.stripeSessionId);
        if (object.classesRemaining != null)
            message.classesRemaining = object.classesRemaining | 0;
        return message;
    };

    /**
     * Creates a plain object from a PurchasedPackageProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PurchasedPackageProto
     * @static
     * @param {PurchasedPackageProto} message PurchasedPackageProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PurchasedPackageProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.purchasedClassPackId = "";
            object.packageDetails = null;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.purchaseTimestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.purchaseTimestamp = options.longs === String ? "0" : 0;
            object.stripeSessionId = "";
            object.classesRemaining = 0;
        }
        if (message.purchasedClassPackId != null && message.hasOwnProperty("purchasedClassPackId"))
            object.purchasedClassPackId = message.purchasedClassPackId;
        if (message.packageDetails != null && message.hasOwnProperty("packageDetails"))
            object.packageDetails = $root.PackageProto.toObject(message.packageDetails, options);
        if (message.purchaseTimestamp != null && message.hasOwnProperty("purchaseTimestamp"))
            if (typeof message.purchaseTimestamp === "number")
                object.purchaseTimestamp = options.longs === String ? String(message.purchaseTimestamp) : message.purchaseTimestamp;
            else
                object.purchaseTimestamp = options.longs === String ? $util.Long.prototype.toString.call(message.purchaseTimestamp) : options.longs === Number ? new $util.LongBits(message.purchaseTimestamp.low >>> 0, message.purchaseTimestamp.high >>> 0).toNumber() : message.purchaseTimestamp;
        if (message.stripeSessionId != null && message.hasOwnProperty("stripeSessionId"))
            object.stripeSessionId = message.stripeSessionId;
        if (message.classesRemaining != null && message.hasOwnProperty("classesRemaining"))
            object.classesRemaining = message.classesRemaining;
        return object;
    };

    /**
     * Converts this PurchasedPackageProto to JSON.
     * @function toJSON
     * @memberof PurchasedPackageProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PurchasedPackageProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PurchasedPackageProto
     * @function getTypeUrl
     * @memberof PurchasedPackageProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PurchasedPackageProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PurchasedPackageProto";
    };

    return PurchasedPackageProto;
})();

$root.PurchasedSingleClassCreditProto = (function() {

    /**
     * Properties of a PurchasedSingleClassCreditProto.
     * @exports IPurchasedSingleClassCreditProto
     * @interface IPurchasedSingleClassCreditProto
     * @property {string|null} [classCreditId] PurchasedSingleClassCreditProto classCreditId
     * @property {IPriceCategoryProto|null} [priceCategoryDetails] PurchasedSingleClassCreditProto priceCategoryDetails
     * @property {IPurchasedClassCreditProto|null} [classDetails] PurchasedSingleClassCreditProto classDetails
     * @property {IPurchasedServiceCreditProto|null} [serviceDetails] PurchasedSingleClassCreditProto serviceDetails
     * @property {number|Long|null} [purchaseTimestamp] PurchasedSingleClassCreditProto purchaseTimestamp
     * @property {string|null} [stripeSessionId] PurchasedSingleClassCreditProto stripeSessionId
     * @property {boolean|null} [used] PurchasedSingleClassCreditProto used
     */

    /**
     * Constructs a new PurchasedSingleClassCreditProto.
     * @exports PurchasedSingleClassCreditProto
     * @classdesc Represents a PurchasedSingleClassCreditProto.
     * @implements IPurchasedSingleClassCreditProto
     * @constructor
     * @param {IPurchasedSingleClassCreditProto=} [properties] Properties to set
     */
    function PurchasedSingleClassCreditProto(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PurchasedSingleClassCreditProto classCreditId.
     * @member {string} classCreditId
     * @memberof PurchasedSingleClassCreditProto
     * @instance
     */
    PurchasedSingleClassCreditProto.prototype.classCreditId = "";

    /**
     * PurchasedSingleClassCreditProto priceCategoryDetails.
     * @member {IPriceCategoryProto|null|undefined} priceCategoryDetails
     * @memberof PurchasedSingleClassCreditProto
     * @instance
     */
    PurchasedSingleClassCreditProto.prototype.priceCategoryDetails = null;

    /**
     * PurchasedSingleClassCreditProto classDetails.
     * @member {IPurchasedClassCreditProto|null|undefined} classDetails
     * @memberof PurchasedSingleClassCreditProto
     * @instance
     */
    PurchasedSingleClassCreditProto.prototype.classDetails = null;

    /**
     * PurchasedSingleClassCreditProto serviceDetails.
     * @member {IPurchasedServiceCreditProto|null|undefined} serviceDetails
     * @memberof PurchasedSingleClassCreditProto
     * @instance
     */
    PurchasedSingleClassCreditProto.prototype.serviceDetails = null;

    /**
     * PurchasedSingleClassCreditProto purchaseTimestamp.
     * @member {number|Long} purchaseTimestamp
     * @memberof PurchasedSingleClassCreditProto
     * @instance
     */
    PurchasedSingleClassCreditProto.prototype.purchaseTimestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * PurchasedSingleClassCreditProto stripeSessionId.
     * @member {string} stripeSessionId
     * @memberof PurchasedSingleClassCreditProto
     * @instance
     */
    PurchasedSingleClassCreditProto.prototype.stripeSessionId = "";

    /**
     * PurchasedSingleClassCreditProto used.
     * @member {boolean} used
     * @memberof PurchasedSingleClassCreditProto
     * @instance
     */
    PurchasedSingleClassCreditProto.prototype.used = false;

    // OneOf field names bound to virtual getters and setters
    var $oneOfFields;

    /**
     * PurchasedSingleClassCreditProto CreditType.
     * @member {"priceCategoryDetails"|"classDetails"|"serviceDetails"|undefined} CreditType
     * @memberof PurchasedSingleClassCreditProto
     * @instance
     */
    Object.defineProperty(PurchasedSingleClassCreditProto.prototype, "CreditType", {
        get: $util.oneOfGetter($oneOfFields = ["priceCategoryDetails", "classDetails", "serviceDetails"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new PurchasedSingleClassCreditProto instance using the specified properties.
     * @function create
     * @memberof PurchasedSingleClassCreditProto
     * @static
     * @param {IPurchasedSingleClassCreditProto=} [properties] Properties to set
     * @returns {PurchasedSingleClassCreditProto} PurchasedSingleClassCreditProto instance
     */
    PurchasedSingleClassCreditProto.create = function create(properties) {
        return new PurchasedSingleClassCreditProto(properties);
    };

    /**
     * Encodes the specified PurchasedSingleClassCreditProto message. Does not implicitly {@link PurchasedSingleClassCreditProto.verify|verify} messages.
     * @function encode
     * @memberof PurchasedSingleClassCreditProto
     * @static
     * @param {IPurchasedSingleClassCreditProto} message PurchasedSingleClassCreditProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PurchasedSingleClassCreditProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.classCreditId != null && Object.hasOwnProperty.call(message, "classCreditId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.classCreditId);
        if (message.priceCategoryDetails != null && Object.hasOwnProperty.call(message, "priceCategoryDetails"))
            $root.PriceCategoryProto.encode(message.priceCategoryDetails, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.purchaseTimestamp != null && Object.hasOwnProperty.call(message, "purchaseTimestamp"))
            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.purchaseTimestamp);
        if (message.stripeSessionId != null && Object.hasOwnProperty.call(message, "stripeSessionId"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.stripeSessionId);
        if (message.used != null && Object.hasOwnProperty.call(message, "used"))
            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.used);
        if (message.classDetails != null && Object.hasOwnProperty.call(message, "classDetails"))
            $root.PurchasedClassCreditProto.encode(message.classDetails, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
        if (message.serviceDetails != null && Object.hasOwnProperty.call(message, "serviceDetails"))
            $root.PurchasedServiceCreditProto.encode(message.serviceDetails, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified PurchasedSingleClassCreditProto message, length delimited. Does not implicitly {@link PurchasedSingleClassCreditProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PurchasedSingleClassCreditProto
     * @static
     * @param {IPurchasedSingleClassCreditProto} message PurchasedSingleClassCreditProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PurchasedSingleClassCreditProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PurchasedSingleClassCreditProto message from the specified reader or buffer.
     * @function decode
     * @memberof PurchasedSingleClassCreditProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PurchasedSingleClassCreditProto} PurchasedSingleClassCreditProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PurchasedSingleClassCreditProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PurchasedSingleClassCreditProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.classCreditId = reader.string();
                    break;
                }
            case 2: {
                    message.priceCategoryDetails = $root.PriceCategoryProto.decode(reader, reader.uint32());
                    break;
                }
            case 6: {
                    message.classDetails = $root.PurchasedClassCreditProto.decode(reader, reader.uint32());
                    break;
                }
            case 7: {
                    message.serviceDetails = $root.PurchasedServiceCreditProto.decode(reader, reader.uint32());
                    break;
                }
            case 3: {
                    message.purchaseTimestamp = reader.int64();
                    break;
                }
            case 4: {
                    message.stripeSessionId = reader.string();
                    break;
                }
            case 5: {
                    message.used = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PurchasedSingleClassCreditProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PurchasedSingleClassCreditProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PurchasedSingleClassCreditProto} PurchasedSingleClassCreditProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PurchasedSingleClassCreditProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PurchasedSingleClassCreditProto message.
     * @function verify
     * @memberof PurchasedSingleClassCreditProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PurchasedSingleClassCreditProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        var properties = {};
        if (message.classCreditId != null && message.hasOwnProperty("classCreditId"))
            if (!$util.isString(message.classCreditId))
                return "classCreditId: string expected";
        if (message.priceCategoryDetails != null && message.hasOwnProperty("priceCategoryDetails")) {
            properties.CreditType = 1;
            {
                var error = $root.PriceCategoryProto.verify(message.priceCategoryDetails);
                if (error)
                    return "priceCategoryDetails." + error;
            }
        }
        if (message.classDetails != null && message.hasOwnProperty("classDetails")) {
            if (properties.CreditType === 1)
                return "CreditType: multiple values";
            properties.CreditType = 1;
            {
                var error = $root.PurchasedClassCreditProto.verify(message.classDetails);
                if (error)
                    return "classDetails." + error;
            }
        }
        if (message.serviceDetails != null && message.hasOwnProperty("serviceDetails")) {
            if (properties.CreditType === 1)
                return "CreditType: multiple values";
            properties.CreditType = 1;
            {
                var error = $root.PurchasedServiceCreditProto.verify(message.serviceDetails);
                if (error)
                    return "serviceDetails." + error;
            }
        }
        if (message.purchaseTimestamp != null && message.hasOwnProperty("purchaseTimestamp"))
            if (!$util.isInteger(message.purchaseTimestamp) && !(message.purchaseTimestamp && $util.isInteger(message.purchaseTimestamp.low) && $util.isInteger(message.purchaseTimestamp.high)))
                return "purchaseTimestamp: integer|Long expected";
        if (message.stripeSessionId != null && message.hasOwnProperty("stripeSessionId"))
            if (!$util.isString(message.stripeSessionId))
                return "stripeSessionId: string expected";
        if (message.used != null && message.hasOwnProperty("used"))
            if (typeof message.used !== "boolean")
                return "used: boolean expected";
        return null;
    };

    /**
     * Creates a PurchasedSingleClassCreditProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PurchasedSingleClassCreditProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PurchasedSingleClassCreditProto} PurchasedSingleClassCreditProto
     */
    PurchasedSingleClassCreditProto.fromObject = function fromObject(object) {
        if (object instanceof $root.PurchasedSingleClassCreditProto)
            return object;
        var message = new $root.PurchasedSingleClassCreditProto();
        if (object.classCreditId != null)
            message.classCreditId = String(object.classCreditId);
        if (object.priceCategoryDetails != null) {
            if (typeof object.priceCategoryDetails !== "object")
                throw TypeError(".PurchasedSingleClassCreditProto.priceCategoryDetails: object expected");
            message.priceCategoryDetails = $root.PriceCategoryProto.fromObject(object.priceCategoryDetails);
        }
        if (object.classDetails != null) {
            if (typeof object.classDetails !== "object")
                throw TypeError(".PurchasedSingleClassCreditProto.classDetails: object expected");
            message.classDetails = $root.PurchasedClassCreditProto.fromObject(object.classDetails);
        }
        if (object.serviceDetails != null) {
            if (typeof object.serviceDetails !== "object")
                throw TypeError(".PurchasedSingleClassCreditProto.serviceDetails: object expected");
            message.serviceDetails = $root.PurchasedServiceCreditProto.fromObject(object.serviceDetails);
        }
        if (object.purchaseTimestamp != null)
            if ($util.Long)
                (message.purchaseTimestamp = $util.Long.fromValue(object.purchaseTimestamp)).unsigned = false;
            else if (typeof object.purchaseTimestamp === "string")
                message.purchaseTimestamp = parseInt(object.purchaseTimestamp, 10);
            else if (typeof object.purchaseTimestamp === "number")
                message.purchaseTimestamp = object.purchaseTimestamp;
            else if (typeof object.purchaseTimestamp === "object")
                message.purchaseTimestamp = new $util.LongBits(object.purchaseTimestamp.low >>> 0, object.purchaseTimestamp.high >>> 0).toNumber();
        if (object.stripeSessionId != null)
            message.stripeSessionId = String(object.stripeSessionId);
        if (object.used != null)
            message.used = Boolean(object.used);
        return message;
    };

    /**
     * Creates a plain object from a PurchasedSingleClassCreditProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PurchasedSingleClassCreditProto
     * @static
     * @param {PurchasedSingleClassCreditProto} message PurchasedSingleClassCreditProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PurchasedSingleClassCreditProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.classCreditId = "";
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.purchaseTimestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.purchaseTimestamp = options.longs === String ? "0" : 0;
            object.stripeSessionId = "";
            object.used = false;
        }
        if (message.classCreditId != null && message.hasOwnProperty("classCreditId"))
            object.classCreditId = message.classCreditId;
        if (message.priceCategoryDetails != null && message.hasOwnProperty("priceCategoryDetails")) {
            object.priceCategoryDetails = $root.PriceCategoryProto.toObject(message.priceCategoryDetails, options);
            if (options.oneofs)
                object.CreditType = "priceCategoryDetails";
        }
        if (message.purchaseTimestamp != null && message.hasOwnProperty("purchaseTimestamp"))
            if (typeof message.purchaseTimestamp === "number")
                object.purchaseTimestamp = options.longs === String ? String(message.purchaseTimestamp) : message.purchaseTimestamp;
            else
                object.purchaseTimestamp = options.longs === String ? $util.Long.prototype.toString.call(message.purchaseTimestamp) : options.longs === Number ? new $util.LongBits(message.purchaseTimestamp.low >>> 0, message.purchaseTimestamp.high >>> 0).toNumber() : message.purchaseTimestamp;
        if (message.stripeSessionId != null && message.hasOwnProperty("stripeSessionId"))
            object.stripeSessionId = message.stripeSessionId;
        if (message.used != null && message.hasOwnProperty("used"))
            object.used = message.used;
        if (message.classDetails != null && message.hasOwnProperty("classDetails")) {
            object.classDetails = $root.PurchasedClassCreditProto.toObject(message.classDetails, options);
            if (options.oneofs)
                object.CreditType = "classDetails";
        }
        if (message.serviceDetails != null && message.hasOwnProperty("serviceDetails")) {
            object.serviceDetails = $root.PurchasedServiceCreditProto.toObject(message.serviceDetails, options);
            if (options.oneofs)
                object.CreditType = "serviceDetails";
        }
        return object;
    };

    /**
     * Converts this PurchasedSingleClassCreditProto to JSON.
     * @function toJSON
     * @memberof PurchasedSingleClassCreditProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PurchasedSingleClassCreditProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PurchasedSingleClassCreditProto
     * @function getTypeUrl
     * @memberof PurchasedSingleClassCreditProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PurchasedSingleClassCreditProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PurchasedSingleClassCreditProto";
    };

    return PurchasedSingleClassCreditProto;
})();

$root.PurchasedClassCreditProto = (function() {

    /**
     * Properties of a PurchasedClassCreditProto.
     * @exports IPurchasedClassCreditProto
     * @interface IPurchasedClassCreditProto
     * @property {string|null} [classTemplateId] PurchasedClassCreditProto classTemplateId
     * @property {string|null} [className] PurchasedClassCreditProto className
     * @property {space.kenko.proto.IPriceProto|null} [purchasePrice] PurchasedClassCreditProto purchasePrice
     */

    /**
     * Constructs a new PurchasedClassCreditProto.
     * @exports PurchasedClassCreditProto
     * @classdesc Represents a PurchasedClassCreditProto.
     * @implements IPurchasedClassCreditProto
     * @constructor
     * @param {IPurchasedClassCreditProto=} [properties] Properties to set
     */
    function PurchasedClassCreditProto(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PurchasedClassCreditProto classTemplateId.
     * @member {string} classTemplateId
     * @memberof PurchasedClassCreditProto
     * @instance
     */
    PurchasedClassCreditProto.prototype.classTemplateId = "";

    /**
     * PurchasedClassCreditProto className.
     * @member {string} className
     * @memberof PurchasedClassCreditProto
     * @instance
     */
    PurchasedClassCreditProto.prototype.className = "";

    /**
     * PurchasedClassCreditProto purchasePrice.
     * @member {space.kenko.proto.IPriceProto|null|undefined} purchasePrice
     * @memberof PurchasedClassCreditProto
     * @instance
     */
    PurchasedClassCreditProto.prototype.purchasePrice = null;

    /**
     * Creates a new PurchasedClassCreditProto instance using the specified properties.
     * @function create
     * @memberof PurchasedClassCreditProto
     * @static
     * @param {IPurchasedClassCreditProto=} [properties] Properties to set
     * @returns {PurchasedClassCreditProto} PurchasedClassCreditProto instance
     */
    PurchasedClassCreditProto.create = function create(properties) {
        return new PurchasedClassCreditProto(properties);
    };

    /**
     * Encodes the specified PurchasedClassCreditProto message. Does not implicitly {@link PurchasedClassCreditProto.verify|verify} messages.
     * @function encode
     * @memberof PurchasedClassCreditProto
     * @static
     * @param {IPurchasedClassCreditProto} message PurchasedClassCreditProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PurchasedClassCreditProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.classTemplateId != null && Object.hasOwnProperty.call(message, "classTemplateId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.classTemplateId);
        if (message.className != null && Object.hasOwnProperty.call(message, "className"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.className);
        if (message.purchasePrice != null && Object.hasOwnProperty.call(message, "purchasePrice"))
            $root.space.kenko.proto.PriceProto.encode(message.purchasePrice, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified PurchasedClassCreditProto message, length delimited. Does not implicitly {@link PurchasedClassCreditProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PurchasedClassCreditProto
     * @static
     * @param {IPurchasedClassCreditProto} message PurchasedClassCreditProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PurchasedClassCreditProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PurchasedClassCreditProto message from the specified reader or buffer.
     * @function decode
     * @memberof PurchasedClassCreditProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PurchasedClassCreditProto} PurchasedClassCreditProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PurchasedClassCreditProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PurchasedClassCreditProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.classTemplateId = reader.string();
                    break;
                }
            case 2: {
                    message.className = reader.string();
                    break;
                }
            case 3: {
                    message.purchasePrice = $root.space.kenko.proto.PriceProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PurchasedClassCreditProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PurchasedClassCreditProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PurchasedClassCreditProto} PurchasedClassCreditProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PurchasedClassCreditProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PurchasedClassCreditProto message.
     * @function verify
     * @memberof PurchasedClassCreditProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PurchasedClassCreditProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.classTemplateId != null && message.hasOwnProperty("classTemplateId"))
            if (!$util.isString(message.classTemplateId))
                return "classTemplateId: string expected";
        if (message.className != null && message.hasOwnProperty("className"))
            if (!$util.isString(message.className))
                return "className: string expected";
        if (message.purchasePrice != null && message.hasOwnProperty("purchasePrice")) {
            var error = $root.space.kenko.proto.PriceProto.verify(message.purchasePrice);
            if (error)
                return "purchasePrice." + error;
        }
        return null;
    };

    /**
     * Creates a PurchasedClassCreditProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PurchasedClassCreditProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PurchasedClassCreditProto} PurchasedClassCreditProto
     */
    PurchasedClassCreditProto.fromObject = function fromObject(object) {
        if (object instanceof $root.PurchasedClassCreditProto)
            return object;
        var message = new $root.PurchasedClassCreditProto();
        if (object.classTemplateId != null)
            message.classTemplateId = String(object.classTemplateId);
        if (object.className != null)
            message.className = String(object.className);
        if (object.purchasePrice != null) {
            if (typeof object.purchasePrice !== "object")
                throw TypeError(".PurchasedClassCreditProto.purchasePrice: object expected");
            message.purchasePrice = $root.space.kenko.proto.PriceProto.fromObject(object.purchasePrice);
        }
        return message;
    };

    /**
     * Creates a plain object from a PurchasedClassCreditProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PurchasedClassCreditProto
     * @static
     * @param {PurchasedClassCreditProto} message PurchasedClassCreditProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PurchasedClassCreditProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.classTemplateId = "";
            object.className = "";
            object.purchasePrice = null;
        }
        if (message.classTemplateId != null && message.hasOwnProperty("classTemplateId"))
            object.classTemplateId = message.classTemplateId;
        if (message.className != null && message.hasOwnProperty("className"))
            object.className = message.className;
        if (message.purchasePrice != null && message.hasOwnProperty("purchasePrice"))
            object.purchasePrice = $root.space.kenko.proto.PriceProto.toObject(message.purchasePrice, options);
        return object;
    };

    /**
     * Converts this PurchasedClassCreditProto to JSON.
     * @function toJSON
     * @memberof PurchasedClassCreditProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PurchasedClassCreditProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PurchasedClassCreditProto
     * @function getTypeUrl
     * @memberof PurchasedClassCreditProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PurchasedClassCreditProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PurchasedClassCreditProto";
    };

    return PurchasedClassCreditProto;
})();

$root.PurchasedServiceCreditProto = (function() {

    /**
     * Properties of a PurchasedServiceCreditProto.
     * @exports IPurchasedServiceCreditProto
     * @interface IPurchasedServiceCreditProto
     * @property {string|null} [serviceSku] PurchasedServiceCreditProto serviceSku
     * @property {string|null} [serviceName] PurchasedServiceCreditProto serviceName
     * @property {space.kenko.proto.IPriceProto|null} [purchasePrice] PurchasedServiceCreditProto purchasePrice
     */

    /**
     * Constructs a new PurchasedServiceCreditProto.
     * @exports PurchasedServiceCreditProto
     * @classdesc Represents a PurchasedServiceCreditProto.
     * @implements IPurchasedServiceCreditProto
     * @constructor
     * @param {IPurchasedServiceCreditProto=} [properties] Properties to set
     */
    function PurchasedServiceCreditProto(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PurchasedServiceCreditProto serviceSku.
     * @member {string} serviceSku
     * @memberof PurchasedServiceCreditProto
     * @instance
     */
    PurchasedServiceCreditProto.prototype.serviceSku = "";

    /**
     * PurchasedServiceCreditProto serviceName.
     * @member {string} serviceName
     * @memberof PurchasedServiceCreditProto
     * @instance
     */
    PurchasedServiceCreditProto.prototype.serviceName = "";

    /**
     * PurchasedServiceCreditProto purchasePrice.
     * @member {space.kenko.proto.IPriceProto|null|undefined} purchasePrice
     * @memberof PurchasedServiceCreditProto
     * @instance
     */
    PurchasedServiceCreditProto.prototype.purchasePrice = null;

    /**
     * Creates a new PurchasedServiceCreditProto instance using the specified properties.
     * @function create
     * @memberof PurchasedServiceCreditProto
     * @static
     * @param {IPurchasedServiceCreditProto=} [properties] Properties to set
     * @returns {PurchasedServiceCreditProto} PurchasedServiceCreditProto instance
     */
    PurchasedServiceCreditProto.create = function create(properties) {
        return new PurchasedServiceCreditProto(properties);
    };

    /**
     * Encodes the specified PurchasedServiceCreditProto message. Does not implicitly {@link PurchasedServiceCreditProto.verify|verify} messages.
     * @function encode
     * @memberof PurchasedServiceCreditProto
     * @static
     * @param {IPurchasedServiceCreditProto} message PurchasedServiceCreditProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PurchasedServiceCreditProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.serviceSku != null && Object.hasOwnProperty.call(message, "serviceSku"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.serviceSku);
        if (message.serviceName != null && Object.hasOwnProperty.call(message, "serviceName"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.serviceName);
        if (message.purchasePrice != null && Object.hasOwnProperty.call(message, "purchasePrice"))
            $root.space.kenko.proto.PriceProto.encode(message.purchasePrice, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified PurchasedServiceCreditProto message, length delimited. Does not implicitly {@link PurchasedServiceCreditProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PurchasedServiceCreditProto
     * @static
     * @param {IPurchasedServiceCreditProto} message PurchasedServiceCreditProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PurchasedServiceCreditProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PurchasedServiceCreditProto message from the specified reader or buffer.
     * @function decode
     * @memberof PurchasedServiceCreditProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PurchasedServiceCreditProto} PurchasedServiceCreditProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PurchasedServiceCreditProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PurchasedServiceCreditProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.serviceSku = reader.string();
                    break;
                }
            case 2: {
                    message.serviceName = reader.string();
                    break;
                }
            case 3: {
                    message.purchasePrice = $root.space.kenko.proto.PriceProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PurchasedServiceCreditProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PurchasedServiceCreditProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PurchasedServiceCreditProto} PurchasedServiceCreditProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PurchasedServiceCreditProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PurchasedServiceCreditProto message.
     * @function verify
     * @memberof PurchasedServiceCreditProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PurchasedServiceCreditProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.serviceSku != null && message.hasOwnProperty("serviceSku"))
            if (!$util.isString(message.serviceSku))
                return "serviceSku: string expected";
        if (message.serviceName != null && message.hasOwnProperty("serviceName"))
            if (!$util.isString(message.serviceName))
                return "serviceName: string expected";
        if (message.purchasePrice != null && message.hasOwnProperty("purchasePrice")) {
            var error = $root.space.kenko.proto.PriceProto.verify(message.purchasePrice);
            if (error)
                return "purchasePrice." + error;
        }
        return null;
    };

    /**
     * Creates a PurchasedServiceCreditProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PurchasedServiceCreditProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PurchasedServiceCreditProto} PurchasedServiceCreditProto
     */
    PurchasedServiceCreditProto.fromObject = function fromObject(object) {
        if (object instanceof $root.PurchasedServiceCreditProto)
            return object;
        var message = new $root.PurchasedServiceCreditProto();
        if (object.serviceSku != null)
            message.serviceSku = String(object.serviceSku);
        if (object.serviceName != null)
            message.serviceName = String(object.serviceName);
        if (object.purchasePrice != null) {
            if (typeof object.purchasePrice !== "object")
                throw TypeError(".PurchasedServiceCreditProto.purchasePrice: object expected");
            message.purchasePrice = $root.space.kenko.proto.PriceProto.fromObject(object.purchasePrice);
        }
        return message;
    };

    /**
     * Creates a plain object from a PurchasedServiceCreditProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PurchasedServiceCreditProto
     * @static
     * @param {PurchasedServiceCreditProto} message PurchasedServiceCreditProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PurchasedServiceCreditProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.serviceSku = "";
            object.serviceName = "";
            object.purchasePrice = null;
        }
        if (message.serviceSku != null && message.hasOwnProperty("serviceSku"))
            object.serviceSku = message.serviceSku;
        if (message.serviceName != null && message.hasOwnProperty("serviceName"))
            object.serviceName = message.serviceName;
        if (message.purchasePrice != null && message.hasOwnProperty("purchasePrice"))
            object.purchasePrice = $root.space.kenko.proto.PriceProto.toObject(message.purchasePrice, options);
        return object;
    };

    /**
     * Converts this PurchasedServiceCreditProto to JSON.
     * @function toJSON
     * @memberof PurchasedServiceCreditProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PurchasedServiceCreditProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PurchasedServiceCreditProto
     * @function getTypeUrl
     * @memberof PurchasedServiceCreditProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PurchasedServiceCreditProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PurchasedServiceCreditProto";
    };

    return PurchasedServiceCreditProto;
})();

$root.PriceCategoryProto = (function() {

    /**
     * Properties of a PriceCategoryProto.
     * @exports IPriceCategoryProto
     * @interface IPriceCategoryProto
     * @property {string|null} [categoryId] PriceCategoryProto categoryId
     * @property {string|null} [displayName] PriceCategoryProto displayName
     * @property {space.kenko.proto.IPriceProto|null} [singleClassPrice] PriceCategoryProto singleClassPrice
     * @property {boolean|null} [archived] PriceCategoryProto archived
     */

    /**
     * Constructs a new PriceCategoryProto.
     * @exports PriceCategoryProto
     * @classdesc Represents a PriceCategoryProto.
     * @implements IPriceCategoryProto
     * @constructor
     * @param {IPriceCategoryProto=} [properties] Properties to set
     */
    function PriceCategoryProto(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PriceCategoryProto categoryId.
     * @member {string} categoryId
     * @memberof PriceCategoryProto
     * @instance
     */
    PriceCategoryProto.prototype.categoryId = "";

    /**
     * PriceCategoryProto displayName.
     * @member {string} displayName
     * @memberof PriceCategoryProto
     * @instance
     */
    PriceCategoryProto.prototype.displayName = "";

    /**
     * PriceCategoryProto singleClassPrice.
     * @member {space.kenko.proto.IPriceProto|null|undefined} singleClassPrice
     * @memberof PriceCategoryProto
     * @instance
     */
    PriceCategoryProto.prototype.singleClassPrice = null;

    /**
     * PriceCategoryProto archived.
     * @member {boolean} archived
     * @memberof PriceCategoryProto
     * @instance
     */
    PriceCategoryProto.prototype.archived = false;

    /**
     * Creates a new PriceCategoryProto instance using the specified properties.
     * @function create
     * @memberof PriceCategoryProto
     * @static
     * @param {IPriceCategoryProto=} [properties] Properties to set
     * @returns {PriceCategoryProto} PriceCategoryProto instance
     */
    PriceCategoryProto.create = function create(properties) {
        return new PriceCategoryProto(properties);
    };

    /**
     * Encodes the specified PriceCategoryProto message. Does not implicitly {@link PriceCategoryProto.verify|verify} messages.
     * @function encode
     * @memberof PriceCategoryProto
     * @static
     * @param {IPriceCategoryProto} message PriceCategoryProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PriceCategoryProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.categoryId != null && Object.hasOwnProperty.call(message, "categoryId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.categoryId);
        if (message.displayName != null && Object.hasOwnProperty.call(message, "displayName"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.displayName);
        if (message.singleClassPrice != null && Object.hasOwnProperty.call(message, "singleClassPrice"))
            $root.space.kenko.proto.PriceProto.encode(message.singleClassPrice, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.archived != null && Object.hasOwnProperty.call(message, "archived"))
            writer.uint32(/* id 100, wireType 0 =*/800).bool(message.archived);
        return writer;
    };

    /**
     * Encodes the specified PriceCategoryProto message, length delimited. Does not implicitly {@link PriceCategoryProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PriceCategoryProto
     * @static
     * @param {IPriceCategoryProto} message PriceCategoryProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PriceCategoryProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PriceCategoryProto message from the specified reader or buffer.
     * @function decode
     * @memberof PriceCategoryProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PriceCategoryProto} PriceCategoryProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PriceCategoryProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PriceCategoryProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.categoryId = reader.string();
                    break;
                }
            case 2: {
                    message.displayName = reader.string();
                    break;
                }
            case 3: {
                    message.singleClassPrice = $root.space.kenko.proto.PriceProto.decode(reader, reader.uint32());
                    break;
                }
            case 100: {
                    message.archived = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PriceCategoryProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PriceCategoryProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PriceCategoryProto} PriceCategoryProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PriceCategoryProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PriceCategoryProto message.
     * @function verify
     * @memberof PriceCategoryProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PriceCategoryProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.categoryId != null && message.hasOwnProperty("categoryId"))
            if (!$util.isString(message.categoryId))
                return "categoryId: string expected";
        if (message.displayName != null && message.hasOwnProperty("displayName"))
            if (!$util.isString(message.displayName))
                return "displayName: string expected";
        if (message.singleClassPrice != null && message.hasOwnProperty("singleClassPrice")) {
            var error = $root.space.kenko.proto.PriceProto.verify(message.singleClassPrice);
            if (error)
                return "singleClassPrice." + error;
        }
        if (message.archived != null && message.hasOwnProperty("archived"))
            if (typeof message.archived !== "boolean")
                return "archived: boolean expected";
        return null;
    };

    /**
     * Creates a PriceCategoryProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PriceCategoryProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PriceCategoryProto} PriceCategoryProto
     */
    PriceCategoryProto.fromObject = function fromObject(object) {
        if (object instanceof $root.PriceCategoryProto)
            return object;
        var message = new $root.PriceCategoryProto();
        if (object.categoryId != null)
            message.categoryId = String(object.categoryId);
        if (object.displayName != null)
            message.displayName = String(object.displayName);
        if (object.singleClassPrice != null) {
            if (typeof object.singleClassPrice !== "object")
                throw TypeError(".PriceCategoryProto.singleClassPrice: object expected");
            message.singleClassPrice = $root.space.kenko.proto.PriceProto.fromObject(object.singleClassPrice);
        }
        if (object.archived != null)
            message.archived = Boolean(object.archived);
        return message;
    };

    /**
     * Creates a plain object from a PriceCategoryProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PriceCategoryProto
     * @static
     * @param {PriceCategoryProto} message PriceCategoryProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PriceCategoryProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.categoryId = "";
            object.displayName = "";
            object.singleClassPrice = null;
            object.archived = false;
        }
        if (message.categoryId != null && message.hasOwnProperty("categoryId"))
            object.categoryId = message.categoryId;
        if (message.displayName != null && message.hasOwnProperty("displayName"))
            object.displayName = message.displayName;
        if (message.singleClassPrice != null && message.hasOwnProperty("singleClassPrice"))
            object.singleClassPrice = $root.space.kenko.proto.PriceProto.toObject(message.singleClassPrice, options);
        if (message.archived != null && message.hasOwnProperty("archived"))
            object.archived = message.archived;
        return object;
    };

    /**
     * Converts this PriceCategoryProto to JSON.
     * @function toJSON
     * @memberof PriceCategoryProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PriceCategoryProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PriceCategoryProto
     * @function getTypeUrl
     * @memberof PriceCategoryProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PriceCategoryProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PriceCategoryProto";
    };

    return PriceCategoryProto;
})();

$root.PackageProto = (function() {

    /**
     * Properties of a PackageProto.
     * @exports IPackageProto
     * @interface IPackageProto
     * @property {string|null} [id] PackageProto id
     * @property {string|null} [displayName] PackageProto displayName
     * @property {Array.<string>|null} [includedClassOrServiceIds] PackageProto includedClassOrServiceIds
     * @property {number|null} [classLimit] PackageProto classLimit
     * @property {number|null} [expirationDays] PackageProto expirationDays
     * @property {space.kenko.proto.IPriceProto|null} [price] PackageProto price
     * @property {boolean|null} [archived] PackageProto archived
     */

    /**
     * Constructs a new PackageProto.
     * @exports PackageProto
     * @classdesc Represents a PackageProto.
     * @implements IPackageProto
     * @constructor
     * @param {IPackageProto=} [properties] Properties to set
     */
    function PackageProto(properties) {
        this.includedClassOrServiceIds = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PackageProto id.
     * @member {string} id
     * @memberof PackageProto
     * @instance
     */
    PackageProto.prototype.id = "";

    /**
     * PackageProto displayName.
     * @member {string} displayName
     * @memberof PackageProto
     * @instance
     */
    PackageProto.prototype.displayName = "";

    /**
     * PackageProto includedClassOrServiceIds.
     * @member {Array.<string>} includedClassOrServiceIds
     * @memberof PackageProto
     * @instance
     */
    PackageProto.prototype.includedClassOrServiceIds = $util.emptyArray;

    /**
     * PackageProto classLimit.
     * @member {number} classLimit
     * @memberof PackageProto
     * @instance
     */
    PackageProto.prototype.classLimit = 0;

    /**
     * PackageProto expirationDays.
     * @member {number} expirationDays
     * @memberof PackageProto
     * @instance
     */
    PackageProto.prototype.expirationDays = 0;

    /**
     * PackageProto price.
     * @member {space.kenko.proto.IPriceProto|null|undefined} price
     * @memberof PackageProto
     * @instance
     */
    PackageProto.prototype.price = null;

    /**
     * PackageProto archived.
     * @member {boolean} archived
     * @memberof PackageProto
     * @instance
     */
    PackageProto.prototype.archived = false;

    /**
     * Creates a new PackageProto instance using the specified properties.
     * @function create
     * @memberof PackageProto
     * @static
     * @param {IPackageProto=} [properties] Properties to set
     * @returns {PackageProto} PackageProto instance
     */
    PackageProto.create = function create(properties) {
        return new PackageProto(properties);
    };

    /**
     * Encodes the specified PackageProto message. Does not implicitly {@link PackageProto.verify|verify} messages.
     * @function encode
     * @memberof PackageProto
     * @static
     * @param {IPackageProto} message PackageProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PackageProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.displayName != null && Object.hasOwnProperty.call(message, "displayName"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.displayName);
        if (message.includedClassOrServiceIds != null && message.includedClassOrServiceIds.length)
            for (var i = 0; i < message.includedClassOrServiceIds.length; ++i)
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.includedClassOrServiceIds[i]);
        if (message.classLimit != null && Object.hasOwnProperty.call(message, "classLimit"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.classLimit);
        if (message.expirationDays != null && Object.hasOwnProperty.call(message, "expirationDays"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.expirationDays);
        if (message.price != null && Object.hasOwnProperty.call(message, "price"))
            $root.space.kenko.proto.PriceProto.encode(message.price, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
        if (message.archived != null && Object.hasOwnProperty.call(message, "archived"))
            writer.uint32(/* id 100, wireType 0 =*/800).bool(message.archived);
        return writer;
    };

    /**
     * Encodes the specified PackageProto message, length delimited. Does not implicitly {@link PackageProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PackageProto
     * @static
     * @param {IPackageProto} message PackageProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PackageProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PackageProto message from the specified reader or buffer.
     * @function decode
     * @memberof PackageProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PackageProto} PackageProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PackageProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PackageProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.id = reader.string();
                    break;
                }
            case 2: {
                    message.displayName = reader.string();
                    break;
                }
            case 3: {
                    if (!(message.includedClassOrServiceIds && message.includedClassOrServiceIds.length))
                        message.includedClassOrServiceIds = [];
                    message.includedClassOrServiceIds.push(reader.string());
                    break;
                }
            case 4: {
                    message.classLimit = reader.int32();
                    break;
                }
            case 5: {
                    message.expirationDays = reader.int32();
                    break;
                }
            case 6: {
                    message.price = $root.space.kenko.proto.PriceProto.decode(reader, reader.uint32());
                    break;
                }
            case 100: {
                    message.archived = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PackageProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PackageProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PackageProto} PackageProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PackageProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PackageProto message.
     * @function verify
     * @memberof PackageProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PackageProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.displayName != null && message.hasOwnProperty("displayName"))
            if (!$util.isString(message.displayName))
                return "displayName: string expected";
        if (message.includedClassOrServiceIds != null && message.hasOwnProperty("includedClassOrServiceIds")) {
            if (!Array.isArray(message.includedClassOrServiceIds))
                return "includedClassOrServiceIds: array expected";
            for (var i = 0; i < message.includedClassOrServiceIds.length; ++i)
                if (!$util.isString(message.includedClassOrServiceIds[i]))
                    return "includedClassOrServiceIds: string[] expected";
        }
        if (message.classLimit != null && message.hasOwnProperty("classLimit"))
            if (!$util.isInteger(message.classLimit))
                return "classLimit: integer expected";
        if (message.expirationDays != null && message.hasOwnProperty("expirationDays"))
            if (!$util.isInteger(message.expirationDays))
                return "expirationDays: integer expected";
        if (message.price != null && message.hasOwnProperty("price")) {
            var error = $root.space.kenko.proto.PriceProto.verify(message.price);
            if (error)
                return "price." + error;
        }
        if (message.archived != null && message.hasOwnProperty("archived"))
            if (typeof message.archived !== "boolean")
                return "archived: boolean expected";
        return null;
    };

    /**
     * Creates a PackageProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PackageProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PackageProto} PackageProto
     */
    PackageProto.fromObject = function fromObject(object) {
        if (object instanceof $root.PackageProto)
            return object;
        var message = new $root.PackageProto();
        if (object.id != null)
            message.id = String(object.id);
        if (object.displayName != null)
            message.displayName = String(object.displayName);
        if (object.includedClassOrServiceIds) {
            if (!Array.isArray(object.includedClassOrServiceIds))
                throw TypeError(".PackageProto.includedClassOrServiceIds: array expected");
            message.includedClassOrServiceIds = [];
            for (var i = 0; i < object.includedClassOrServiceIds.length; ++i)
                message.includedClassOrServiceIds[i] = String(object.includedClassOrServiceIds[i]);
        }
        if (object.classLimit != null)
            message.classLimit = object.classLimit | 0;
        if (object.expirationDays != null)
            message.expirationDays = object.expirationDays | 0;
        if (object.price != null) {
            if (typeof object.price !== "object")
                throw TypeError(".PackageProto.price: object expected");
            message.price = $root.space.kenko.proto.PriceProto.fromObject(object.price);
        }
        if (object.archived != null)
            message.archived = Boolean(object.archived);
        return message;
    };

    /**
     * Creates a plain object from a PackageProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PackageProto
     * @static
     * @param {PackageProto} message PackageProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PackageProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.includedClassOrServiceIds = [];
        if (options.defaults) {
            object.id = "";
            object.displayName = "";
            object.classLimit = 0;
            object.expirationDays = 0;
            object.price = null;
            object.archived = false;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.displayName != null && message.hasOwnProperty("displayName"))
            object.displayName = message.displayName;
        if (message.includedClassOrServiceIds && message.includedClassOrServiceIds.length) {
            object.includedClassOrServiceIds = [];
            for (var j = 0; j < message.includedClassOrServiceIds.length; ++j)
                object.includedClassOrServiceIds[j] = message.includedClassOrServiceIds[j];
        }
        if (message.classLimit != null && message.hasOwnProperty("classLimit"))
            object.classLimit = message.classLimit;
        if (message.expirationDays != null && message.hasOwnProperty("expirationDays"))
            object.expirationDays = message.expirationDays;
        if (message.price != null && message.hasOwnProperty("price"))
            object.price = $root.space.kenko.proto.PriceProto.toObject(message.price, options);
        if (message.archived != null && message.hasOwnProperty("archived"))
            object.archived = message.archived;
        return object;
    };

    /**
     * Converts this PackageProto to JSON.
     * @function toJSON
     * @memberof PackageProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PackageProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PackageProto
     * @function getTypeUrl
     * @memberof PackageProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PackageProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PackageProto";
    };

    return PackageProto;
})();

module.exports = $root;
